export default {
  es: {
    enlaces: {
      home: "/inicio",
      finca: "/finca",
      la_tierra: "/finca/tierra",
      la_bodega: "/finca/bodega",
      proceso_cava: "/finca/bodega/elaboracion-del-cava",
      proceso_vino: "/finca/bodega/elaboracion-del-vino",
      la_almanzara: "/finca/almazara",
      proceso_aceite: "/finca/tierra/elaboracion-del-aceite",
      sala_azafran: "/finca/sala-de-azafran",
      queseria: "/finca/queseria",
      proceso_queso: "/finca/queseria/elaboracion-del-queso",
      proceso_azafran: "/finca/sala-de-azafran/elaboracion-del-azafran",
      productos: "/productos",
      vino: "/productos/vino",
      aceite: "/productos/aceite",
      azafran: "/productos/azafran",
      cava: "/productos/cava",
      queso: "/productos/queso",
      productos: "/productos",
      premios: "/premios",
      premio:
        "https://www.tripadvisor.es/Attraction_Review-g1437533-d15780377-Reviews-Bodegas_Aldonza-Munera_Province_of_Albacete_Castile_La_Mancha.html",
      beneficios: "/beneficios",
      experiencias: "/experiencias",
      vive_aldonza: "/experiencias/vive-aldonza",
      oleoturismo: "/experiencias/vive-aldonza/oleoturismo",
      degustacionQuesos: "/experiencias/vive-aldonza/degustacion-quesos",
      ruta_cervantina: "/experiencias/vive-aldonza/ruta-cervantina",
      enoturismo: "/experiencias/vive-aldonza/enoturismo",
      recetario: "/experiencias/vive-aldonza/recetario-y-ruta-gastronomica",
      escucha_aldonza: "/experiencias/escucha-aldonza",
      contacto: "/inicio/contacto",
      politica_proteccion: "/politica-de-proteccion-de-datos",
      politica_cookies: "/politica-de-cookies",
      datos_seguros: "/datos-seguros",
      aviso_legal: "/aviso-legal",
      mapa_web: "/mapa-web",
      contactoid: "contacto",
      experiencias_13: "https://tienda.aldonzagourmet.com/13-experiencias",
      mejor_bodega_CM:
        "https://blog.aldonzagourmet.com/2024/11/mejor-bodega-de-castilla-lamancha/"
    },
    vistas: {
      inicio: "Inicio",
      la_finca: "La finca",
      la_tierra: "La tierra",
      la_almazara: "La Almazara",
      la_bodega: "La Bodega",
      sala_azafran: "Sala de Azafrán",
      productos: "Productos",
      queseria: "Quesería",
      productos_aldonza: "Productos Aldonza",
      premios: "Premios",
      premio: "Premio",
      beneficios: "Beneficios",
      experiencias: "Enoturismo",
      oleoturismo: "Oleoturismo",
      degustacionQuesos: "El Ritual del Queso",
      maridaje: "Maridaje con vinos",
      vive_aldonza: "Vive Aldonza",
      las_catas: "Las catas:",
      experiencia_bodega: "Ya han vivido la experiencia:",
      ruta_cervantina: "Ruta Cervantina",
      enoturismo: "Enoturismo",
      recetario: "Recetario y ruta gastronómica",
      escucha_aldonza: "Escucha Aldonza",
      blog: "Blog",
      contacto: "Contacto",
      politica_proteccion: "Política de protección de datos",
      politica_cookies: "Política de cookies",
      mapa_web: "Mapa web",
      datos_seguros: "Datos seguros",
      aviso_legal: "Aviso legal",
      canal_etico: "Canal Ético"
    },
    home: {
      intro: {
        titulo_uno: "La",
        titulo_dos: "Experiencia",
        titulo_tres: "Aldonza",
        experiencia_aldonza: "Tu experiencia comienza",
        aqui: "aquí",
        tienda: "Tienda online",
        tarifas: "Tarifas de precios"
      },
      comienza: {
        titulo_uno: "Comienza",
        titulo_dos: "la",
        titulo_tres: "Experiencia",
        experiencia_aldonza: "Tu experiencia aldonza",
        cuerpo:
          "Apreciar la sutileza de cada movimiento que nos regala la naturaleza, es el origen de las sensaciones que te despertarán nuestros vinos, cavas, aceite de oliva virgen extra y azafrán."
      },
      la_finca: {
        titulo_uno: "La",
        titulo_dos: "finca",
        cuerpo:
          "El entorno es lo que marca la diferencia de nuestros productos. Te damos la bienvenida a la Dehesa de Navamarín.",
        aldonza_experience: "Aldonza Experience"
      },
      productos: {
        titulo: "Productos"
      },
      experiencia: {
        titulo_uno: "La",
        titulo_dos: "Experiencia",
        aldonza_experience: "Aldonza Experience",
        escucha_aldonza: {
          cuerpo:
            "Transpórtate a través de la música a lugares nuevos que te despertarán nuevas sensaciones. Simplemente escucha y ¡déjate llevar!"
        }
      },
      contacto: {
        titulo: "Contacto"
      }
    },
    blog: {
      titulo:
        "<span>La</span> <span>Experiencia</span> <span>continúa</span><span>...</span>",
      subtitulo: "El blog de aldonza",
      boton: "ver"
    },
    newsletter: {
      titulo: "Suscríbete a nuestra newsletter",
      cuerpo: "Actualidad y novedades en tu correo.",
      texto_comunicaciones:
        "Acepto recibir la Newsletter u otras comunicaciones de su entidad",
      boton: "Suscribirme",
      enviado: "¡Te has suscrito correctamente!"
    },
    otros_lugares: {
      titulo: "Otros lugares",
      lugares: {
        la_tierra: "La tierra",
        la_bodega: "La bodega",
        la_almanzara: "La Almazara",
        sala_azafran: "Sala de azafrán",
        queseria: "Quesería"
      }
    },
    la_tierra: {
      descubrir_proceso: "Descubrir la elaboración",
      la_tierra: {
        cuadro_uno: {
          titulo: "El entorno",
          texto:
            "La Dehesa de Navamarín es un paraje natural a más 1.200 metros de altitud situado al noroeste de la provincia de Albacete (España). Cuenta con 2.200 hectáreas de monte alto, medio y bajo, repartido entre encinas y plantas aromáticas. Enclave único con la mayor reserva mundial de Sabinas (Juniperus Sabina), ubicada entre las vertientes de los ríos Guadiana y Júcar."
        },
        cuadro_dos: {
          titulo: "La tierra",
          texto_uno:
            "<strong>Terreno: </strong>Fue ocupado hace 10.000 años por un glaciar que provocó una gran cantidad de cantos rodados, que impiden que el agua se evapore con facilidad.",
          texto_dos:
            "<strong>Suelo: </strong>La calidad de nuestros productos comienza en el suelo, óptimos para el cultivo. Se caracterizan por ser de consistencia caliza y permeabilidad media, con PH neutros o ligeramente alcalinos.",
          texto_tres:
            "<strong>Fauna: </strong>La Dehesa de Navamarín se ha convertido en el hábitat de numerosas especies autóctonas (ciervos, jabalíes y perdiz roja) y foráneas (muflón).  Los restos orgánicos de estos animales son abono natural para nuestros cultivos.",
          texto_cuatro:
            "<strong>Clima: </strong>Continental con inviernos fríos y veranos cálidos y muy secos. Condiciones climatológicas severas que evitan la proliferación de hongos y bacterias nocivas para los cultivos.  En el caso de la vid, el contraste de temperaturas mejora el desarrollo de los polifenoles (taninos y antocianos) en la fase de maduración.",
          texto_cinco:
            "<strong>Sabinas: </strong>Este árbol milenario, especie protegida de origen oriental, aporta a nuestros frutos propiedades exclusivas para la salud."
        },
        frutos: {
          titulo: "Los frutos",
          cuerpo:
            "La elevada cota de altitud y las severas condiciones climatológicas intervienen directamente en la calidad de nuestros frutos. Producimos diferentes varietales de uva, cultivo de aceitunas de las clases picual y arbequina y azafrán D.O.P La Mancha."
        },
        escalera: {
          vinedo: {
            titulo: "Viñedos",
            cuerpo:
              "La Dehesa de Navamarín tiene 75 hectáreas de viñedos productivos y otras 100 de reciente plantación. Cultivamos los varietales tintos Tempranillo (el clásico de nuestra región), Cabernet-Sauvignon, Merlot y Syrah, así como los varietales blancos Sauvignon-Blanc y Macabeo. Los viñedos de nuestros cavas están situados en la comarca catalana del Penedés, en el centro de producción de Sant Sadurní D´Anoia (Barcelona). En esta zona, conocida como Región del Cava y con D.O de vinos espumosos, cultivamos las varietales Xarel-lo, Macabeo y Parellada. También, uvas tintas de la variedad Trepat."
          },
          azafranal: {
            titulo: "Azafranal",
            cuerpo:
              "El terreno seleccionado para el cultivo de nuestro azafrán es un área de tierra seca, calcárea, aireada y plana. Tierra equilibrada en materia orgánica que reduce los riesgos de erosión. También es un suelo con relativa profundidad que permite la evacuación del agua para que el bulbo no resulte dañado. El azafrán suele agotar temporalmente el terreno cada 3 o 4 años, por lo que rotamos la zona de plantaciones para garantizar año tras año un azafrán de primera calidad."
          },
          olivos: {
            titulo: "Olivos",
            cuerpo:
              "Nuestros árboles siguen unos protocolos de mantenimiento totalmente estandarizados y regularizados. 75 hectáreas de olivos que producen dos variedades de oliva: Picual y Arbequina. La primera es la variedad más cultivada en España. Representa más del 50% de la producción y destaca por su sabor fuerte, con toque amargo y picante. La arbequina se caracteriza por su gran resistencia al frío y vigor muy reducido. Sabor dulce y suave."
          }
        }
      },
      la_almazara: {
        cuadro_uno: {
          titulo: "Instalaciones",
          texto:
            "Cuidamos el entorno natural sin olvidar la innovación y las nuevas tecnologías de análisis para garantizar un aceite de oliva virgen extra de máxima calidad. La tradición de la herencia de padres a hijos, el compromiso y el amor hacia nuestra tierra son los valores que promueven el desempeño diario del equipo Aldonza. Aldonza está certificada por las normativas <a href ='/static/pdf/certificado-IFS-es.pdf'download ><strong><u>IFS</u></strong></a>  y  <a href ='/static/pdf/certificado-BRC.pdf'download><strong><u>BRC.</u></strong></a>"
        },
        cuadro_dos: {
          titulo: "La almazara",
          texto:
            "<p>Estamos presentes en todo el proceso de elaboración de nuestro aceite de oliva virgen extra. Mimamos cada olivo y trabajamos con delicadeza el fruto en nuestra propia almazara equipada con sofisticada tecnología. Depósitos frescos y oscuros de acero inoxidable conservan los matices puros del aroma y sabor de la aceituna. También mantenemos un compromiso firme con el medio ambiente: nuestra maquinaría obtiene el sello de calidad medioambiental.</p><p>No sólo sabor, también salud. La planta industrial de Aldonza está diseñada para envasar garantizando la seguridad alimentaria tan importante en nuestros productos. Destaca nuestra capacidad logística. Servimos en tiempo a más de 20 países, ¡somos tu partner perfecto!</p>"
        },
        proceso: {
          titulo: "El proceso",
          cuerpo:
            "El método de elaboración tradicional convive con la modernidad, siempre con un mimo excepcional para obtener un aceite de oliva virgen extra de gran calidad."
        },
        sala_catas: {
          titulo: "Sala de catas",
          cuerpo:
            "Afrutado de aroma intenso en nariz; en boca es estable y con un punto justo de amargor y picante. Realizamos catas profesionales. El sabor del aceite de oliva virgen extra, en las jornadas de oleoturismo con Aldonza.",
          boton_large: "¡Descubrir!",
          boton_short: "¡Descubrir!"
        }
      },
      sala_azafran: {
        cuadro_uno: {
          titulo: "Nuestra cosecha",
          texto:
            "Sólo el azafrán cultivado en Castilla La Mancha tiene la <strong>Denominación de Origen Protegida La Mancha.</strong> Este sello de calidad es mundialmente reconocido por su triple garantía: características organolépticas óptimas (color, aroma y sabor), máxima seguridad alimentaria y procedencia España. Las condiciones climatológicas y el terreno, suelos calizos y alcalinos situados al noroeste de la provincia de Albacete, garantizan una cosecha excepcional con propiedades y sabor exclusivo."
        },
        cuadro_dos: {
          titulo: "Sala de azafrán",
          texto:
            "Desde el cultivo hasta su envasado, Aldonza cuenta con un equipo de profesionales cualificados que mantienen una decidida apuesta por la calidad y seguridad alimentaria del azafrán. En nuestros campos y modernas instalaciones, cultivamos, seleccionamos y envasamos artesanalmente el azafrán Aldonza. Nuestra empresa está certificada por las normativas <a href ='/static/pdf/certificado-IFS-es.pdf'download ><strong><u>IFS</u></strong></a>  y  <a href ='/static/pdf/certificado-BRC.pdf'download><strong><u>BRC.</u></strong></a>"
        },
        proceso: {
          titulo: "El proceso",
          cuerpo:
            "El proceso de elaboración del azafrán es tan delicado como los estigmas rojos de su flor. Mantenemos los valores tradicionales y realizamos un meticuloso trabajo en cada una de las fases del proceso."
        },
        sala: {
          titulo: "La sala",
          cuerpo:
            "El azafrán Aldonza pertenece a la cultura popular de nuestra tierra. Los secretos de su producción forman parte de las herencias que las familias castellano manchegas han pasado de generación en generación. Este proceso milenario se mantiene vivo en nuestra sala de azafrán."
        }
      },
      la_bodega: {
        cuadro_uno: {
          titulo: "Instalaciones",
          texto:
            "En el corazón de la tierra de Don Quijote, en el municipio de Munera situado al noroeste de la provincia de Albacete, elaboramos nuestro vino desde hace más de cuatro generaciones. Nuestra bodega y viñedos están integrados en un paraje de tradición y leyenda, en el que Miguel de Cervantes se basó para escribir varios capítulos de 'El Quijote'. Nuestros vinos, junto a la elaboración de otros productos tradicionales de La Mancha como el aceite de oliva y el azafrán, son fruto de la pasión y del trabajo bien hecho. Aldonza está certificada por las normativas <a href ='/static/pdf/certificado-IFS-es.pdf'download ><strong><u>IFS</u></strong></a>  y  <a href ='/static/pdf/certificado-BRC.pdf'download><strong><u>BRC.</u></strong></a>"
        },
        cuadro_dos: {
          titulo: "La bodega",
          texto:
            " <p>Bodega de tradición familiar que ha incorporado modernas instalaciones equipadas con sofisticada maquinaría. Tradición agrícola e innovación, una combinación perfecta para elaborar vinos que despiertan nuevas sensaciones.</p><p>Cuidamos cada detalle no sólo en la elaboración del vino, también en el diseño. Sorprende nuestro botellero al estilo 'Mondrian' y nuestra sala de barricas de roble francés y americano, situada en una cueva con cascada que cuenta con una exposición de las primeras máquinas con las que se molía la uva. Un espacio que envuelve por completo de la cultura del vino a todo a aquel nos visita.</p>"
        },
        proceso: {
          titulo: "La elaboración del vino",
          cuerpo:
            "Nuestro objetivo es extraer la grandeza y la calidad de la uva a través de un cuidado proceso de elaboración."
        },
        proceso_cava: {
          titulo: "La elaboración del cava",
          cuerpo:
            "Mantenemos vivo el método tradicional del cava. En la comarca catalana del Penedés (Barcelona), con Denominación de Origen Cava, se lleva a cabo la cosecha y la elaboración de nuestras cuatro variedades de vino espumoso."
        },
        sala_barricas: {
          titulo: "Sala de barricas",
          cuerpo:
            "El olor a madera, los aromas del vino, el sonido de una cascada y la luz tenue del ambiente te trasladarán por completo a otro lugar. Construida en una cueva situada en el subsuelo de la bodega, la sala de barricas Aldonza rememora la calidad de nuestros vinos. Puedes degustar nuestros productos, mientras disfrutas de un espacio único.",
          boton_large: "¡Descubre el Enoturismo!",
          boton_short: "¡Descubrir!"
        }
      },
      queseria: {
        cuadro_uno: {
          titulo: "Maestros artesanos",
          texto:
            " <p>Quesos Denominación de Origen Queso Manchego, preparados con leche de oveja.  Nos esforzamos a diario para ofrecer quesos de primera calidad, que transmitan el cariño de las manos que los fabrican. Se fusiona el método tradicional con la más alta tecnología para garantizar los controles de seguridad alimentaria exigidos, tanto en el ganado como en la calidad de la leche. <div class='certificados'><div><a class='link-certificados queso' href='/static/pdf/certificado-SAE.pdf' download >Certificado SAE 2021-0014</a></div></div></p>"
        },
        cuadro_dos: {
          titulo: "Variedades",
          texto:
            " <p>Aldonza Gourmet tiene tres variedades de quesos, curado, semicurado y en aceite de oliva virgen, todos ellos procedentes de leche de oveja de pura raza manchega. Exportamos a los cinco continentes el sabor de nuestros quesos, junto a la tradición y la cultura del queso 100% manchego. </p>"
        },
        proceso: {
          titulo: "La elaboración del queso",
          cuerpo: "Proceso tradicional exclusivo de Castilla La Mancha."
        }
      }
    },
    saber_mas: "Saber más",
    certificadoBRC: "Certificado BRC",
    certificadoIFS: "Certificado IFS",
    Certificados:
      "Empresa certificada por las normativas de calidad y seguridad alimentaria <a href ='/static/pdf/certificado-IFS-es.pdf'download > IFS</a> y <a href ='/static/pdf/certificado-BRC.pdf'download>BRC.</a>",
    Certificados2:
      "Empresa certificada por las normativas de calidad y seguridad alimentaria <a href ='/static/pdf/certificado-IFS-es.pdf'download > IFS</a> y <a href ='/static/pdf/certificado-BRC.pdf'download>BRC.</a>",
    slider_productos: {
      vino: {
        slug: "vino",
        titulo: "Vinos Aldonza",
        cuerpo:
          "Sabores con tradición, con leyenda. Vivirás una experiencia diferente con nuestras cuatro variedades de vino Aldonza. ¡Descúbrelas!",
        button: "Vino"
      },
      aceite: {
        slug: "aceite",
        titulo: "Aceite de Oliva Aldonza ",
        cuerpo:
          "Empezarás a sentir sólo con su aroma, la antesala a la textura y el sabor de un aceite de oliva virgen extra excepcional. Resultado de un cuidadoso proceso de elaboración.",
        button: "Aceite"
      },
      azafran: {
        slug: "azafran",
        titulo: "Azafrán Aldonza",
        cuerpo:
          "El delicado trabajo del milenario proceso manual de la monda del azafrán, se aprecia en la calidad de cada estigma. Azafrán Aldonza, con sello de calidad D.O.P La Mancha.",
        button: "Azafrán"
      },
      cava: {
        slug: "cava",
        titulo: "Cava Aldonza",
        cuerpo:
          "Refrescante desde el momento que las burbujas ascienden por la copa de cava. Te esperan sensaciones diferentes con cada una de nuestras cuatro variedades de vinos espumosos. ¡Siéntelas!",
        button: "Cava"
      },
      queso: {
        slug: "queso",
        titulo: "Queso Manchego DOP",
        cuerpo:
          "El auténtico sabor de La Mancha se fusiona con el espíritu de llevar la alimentación de nuestra tierra por todo el mundo. Denominación de Origen Queso Manchego.",
        button: "Queso"
      }
    },
    slider_proceso: {
      proceso_vino: {
        id: "proceso-del-vino",
        padre: "la_bodega",
        pasos: {
          vendimia: {
            titulo: "Vendimia",
            cuerpo:
              "<p>Cuando la uva alcanza su punto óptimo de maduración, iniciamos la vendimia, normalmente entre finales de agosto y principios de septiembre. Para evitar que las altas temperaturas afecten al fruto y a su proceso de fermentación, vendimiamos mediante el sistema tradicional de recolección manual y nocturna. La uva se traslada en cajas hasta la bodega y seleccionamos manualmente los mejores frutos para garantizar un vino de calidad.</p>"
          },
          fermentacion: {
            titulo: "Fermentación y prensado",
            cuerpo:
              "<p>Una vez que las uvas seleccionadas han sido despalilladas, empieza el proceso de fermentación en depósitos de acero totalmente informatizados. Prestamos especial atención al prensado del vino, fase en la que separamos el líquido de los restos sólidos de la uva.</p>"
          },
          crianza: {
            titulo: "Crianza",
            cuerpo:
              "<p>Nuestro equipo de enólogos determina el tiempo que cada añada pasará en barrica, siendo siempre un mínimo de seis meses. Es el momento en el que los tintos adquieren su personalidad en nuestras barricas de roble americano y francés que están situadas en el subsuelo de la bodega. La sala de barricas mantiene una temperatura y humedad equilibrada durante todo el año. Cuando el vino muestra todo su aroma y sabor, realizamos el coupage y respetamos el reposo de la botella el mismo tiempo que ha pasado en barrica.</p>"
          },
          etiquetado: {
            titulo: "Etiquetado",
            cuerpo:
              "<p>Nuestra dedicación y fidelidad por nuestra tierra y por los vinos que elaboramos queda sellada en la fase de etiquetado. Es nuestro departamento de logística el que cierra el proceso enviando nuestros vinos a los más de 20 países en los que se distribuye la marca Aldonza. Somos un equipo profesional, que controla y coordina todas las fases del proceso de elaboración de nuestro producto.</p>"
          }
        },
        boton: "Nuestro Vino"
      },
      proceso_cava: {
        id: "proceso-del-cava",
        padre: "la_bodega",
        pasos: {
          vendimia: {
            titulo: "Vendimia",
            cuerpo:
              "<p>Tras la cosecha de la uva (Xarel·lo, Macabeo, Chardonnay, Parellada y Trepat), se inicia el método tradicional de elaboración del cava en el prestigioso centro de producción de Sant Sadurní D'Anoia (Barcelona). Utilizamos sólo el mosto procedente de las primeras fracciones del prensado, el mosto flor.</p>"
          },
          tiraje: {
            titulo: "Tiraje",
            cuerpo:
              "<p>Es el proceso de llenado de botellas con vino base y con un compuesto de levaduras y azúcar. Estas provocarán la segunda fermentación dentro de la misma botella y producirán las burbujas tan características de este producto. La posterior crianza requiere un mínimo de 9 meses.</p>"
          },
          deguelle: {
            titulo: "Degüelle",
            cuerpo:
              "<p>En esta fase, extraemos la chapa de la botella y aspiramos la levadura que anteriormente ha sido congelada. Posteriormente, se añade el licor de expedición que es la cantidad de azúcar que determinará si el cava es Nature, Brut o Semi-dulce.</p>"
          },
          etiquetado: {
            titulo: "Etiquetado y logística",
            cuerpo:
              "<p>Estamos presentes en todas las etapas del proceso de elaboración del cava, supervisando y garantizando los más altos estándares de calidad en todas las fases.</p>"
          }
        },
        boton: "Nuestro Cava"
      },
      proceso_aceite: {
        id: "proceso-del-aceite",
        padre: "la_almanzara",
        pasos: {
          cosecha: {
            titulo: "Cosecha",
            cuerpo:
              "<p>Importante determinar el momento óptimo de recolección de la aceituna ya que la maduración está vinculada con el rendimiento, el grado de acidez y las características organolépticas del aceite. Esta es la base del éxito de la calidad de nuestro virgen extra, el minucioso seguimiento que hacemos al proceso de maduración de la oliva y que iniciamos los primeros días de noviembre. La cosecha suele empezar a finales de este mes o principios de diciembre.  Sólo recolectamos frutos sanos que no hayan caído del árbol al suelo.</p>"
          },
          recepcion: {
            titulo: "Recepción y limpieza",
            cuerpo:
              "<p>Trasladamos con delicadeza la oliva hasta nuestra almazara y comprobamos el estado sanitario de los frutos a través de un análisis que determina la composición de la aceituna y que optimizará su procesado. El paso previo a la molienda es eliminar todas las impurezas. La aceituna pasa por una máquina limpiadora que mediante ventilación en seco quita hojas, ramilletes, etc. Posteriormente, el fruto ingresa en una línea de lavado que elimina el resto de suciedad.</p>"
          },
          molienda: {
            titulo: "Molienda y batido",
            cuerpo:
              "<p>Durante la fase de molienda, creamos una papilla para descomponer la estructura física de la aceituna y poder llevar a cabo la fase de batido. El propósito del batido es favorecer la separación del aceite del resto de la aceituna. Sometemos la pasta de aceituna a la acción de un movimiento continuo a temperatura mayor a la del ambiente pero siempre inferior a 25 grados.</p>"
          },
          extraccion: {
            titulo: "Extracción y limpieza del aceite",
            cuerpo:
              "<p>Una vez batida la pasta de aceituna, separamos el aceite del resto de los componentes. Como todas las técnicas, esta también ha ido avanzando y, de la antigua presión de discos filtrantes de fibras naturales, hemos pasado a realizar la extracción mediante centrifugados automáticos, más rápidos y eficientes, también llamado decanter.</p><p>La pasta es sometida a la acción de una fuerza centrífuga que separa los distintos componentes según densidades. El aceite que sale del decanter contiene todavía impurezas sólidas y algo de agua. Utilizamos centrífugas verticales para separar estos componentes, máquinas mucho más veloces y precisas que reducen el tiempo de contacto del aceite con las impurezas y garantizan una separación más fiable.</p>"
          },
          almacenamiento: {
            titulo: "Almacenamiento y envasado",
            cuerpo:
              "<p>Una vez obtenido el aceite de oliva virgen extra, se almacena en depósitos de acero inoxidable para que se conserve en perfecto estado y esté protegido de circunstancias adversas como la luz, los olores externos, la temperatura exterior y hasta ruido. Antes de su embotellamiento, se realiza el filtro de tierras para conseguir un aceite más brillante y limpio. En la embotelladora controlamos las características organolépticas del aceite hasta el último momento, para asegurarnos que cumple las expectativas de nuestras normas de calidad.</p>"
          }
        },
        boton: "Nuestro Aceite"
      },
      proceso_azafran: {
        id: "sala-del-azafran",
        padre: "sala_azafran",
        pasos: {
          cosecha: {
            titulo: "Cosecha",
            cuerpo:
              "<p>La plantación de los bulbos se lleva a cabo durante los meses de junio a septiembre para que la rosa del azafrán llegue a su máximo esplendor en pleno otoño. Nuestro azafrán se cultiva en tierras favorables para su cosecha: secas, calcáreas, planas y sin arbolado. El suelo no es profundo y permite la evacuación del agua para que el bulbo no resulte dañado.</p>"
          },
          recoleccion: {
            titulo: "Recolección",
            cuerpo:
              "<p>El cantar y el silbido de los campesinos se escucha en nuestras plantaciones antes de que salga el sol. La recolección de la rosa del azafrán se realiza al amanecer para evitar que los estigmas pierdan sus propiedades con la luz solar. La campaña de recogida tiene lugar entre finales de octubre y principios de noviembre.</p>"
          },
          monda: {
            titulo: "Monda",
            cuerpo:
              "<p>Esta minuciosa labor es considerada una tradición milenaria. La rosa del azafrán llega a las casas todavía con el primer rocío de la mañana. La separación de los estigmas del resto de la flor se hace manual y recibe el nombre de monda o desbriznado. Se trata de la parte más delicada del proceso. Es muy importante que el estigma no se rompa para que llegue entero a la fase de tostado. Esta labor se realiza en un plazo de tiempo que no supera las doce horas desde su recogida en el campo.</p>"
          },
          tostado: {
            titulo: "Tostado",
            cuerpo:
              "<p>El azafrán se tuesta en ciazos y a fuego lento. Este proceso de secado o tostado de los estigmas se hace para que el azafrán se conserve en perfecto estado y mantenga todo su sabor. Es una etapa crucial ya que determina características del producto como la humedad, el poder colorante, el aroma y la establidad. </p>"
          },
          almacenamiento: {
            titulo: "Almacenamiento",
            cuerpo:
              "<p>El azafrán tostado se almacena rápidamente en envases que lo aíslan de la humedad y de la luz. También lo mantienen a una temperatura ambiental inferior a 25ºC. El envasado es manual.</p>"
          }
        },
        boton: "Nuestro Azafrán"
      },
      proceso_queso: {
        id: "proceso-del-queso",
        padre: "queseria",
        pasos: {
          Ordeño: {
            titulo: "Ordeño y cuajado",
            cuerpo:
              "<p>Justo después del ordeño de las ovejas, se refrigera la leche a una temperatura de 4 ºC para conservar todas sus propiedades. A continuación, se vierte la leche en cubas de cuajado y se eleva a una temperatura constante de 30ºC. Cuando la cuajada alcanza la consistencia adecuada, se realiza el corte y se pasa al moldeado del queso.</p>"
          },
          moldelado: {
            titulo: "Moldeado, prensado y salado ",
            cuerpo:
              "<p>Se introduce la cuajada en los moldes de manera artesanal y se coloca la placa de caseína, numerada y seriada, para identificar cada pieza de queso manchego. Posteriormente, se prensa el queso para eliminar totalmente  el suero y darle la forma definitiva. Tras el prensado, se extrae el producto del molde y se realiza el salado del queso. Durante el salado, los quesos regulan su proceso microbiano, potencian el sabor y generan la corteza externa.</p>"
          },
          maduracion: {
            titulo: "Maduración",
            cuerpo:
              "<p>La maduración de nuestros quesos es de 60 a 100 días para el semicurado y de 150 a 210 en el caso del curado. Las cámaras de maduración mantienen condiciones de temperatura y humedad controladas permitiendo la correcta maduración del Queso Manchego. </p>"
          }
        },
        boton: "Nuestros quesos"
      }
    },
    productos_banner: {
      title: "Productos",
      productos: {
        vino: "Vino",
        aceite: "Aceite",
        azafran: "Azafrán",
        cava: "Cava",
        queso: "Queso"
      }
    },
    tips_productos: {
      tipo_vino: "Tipo de vino:",
      tipo_uva: "Tipo de uva:",
      tipo_cava: "Cava:",
      elaboracion: "Elaboración:",
      gastronomia: "Gastronomía:",
      notas_cata: "Notas de cata:",
      premios: "Premios:",
      ingredientes: "Ingredientes:",
      caracteristicas: "Características:",
      maridaje: "Maridaje",
      descargar_ficha: "Descargar ficha en PDF",
      curacion: "Curación",
      apariencia: "Apariencia",
      valoresnutricionales: "Valores nutricionales",
      conservacion: "Conservación",
      alergenos: "Alérgenos",
      durabilidad: "Durabilidad"
    },
    productos: {
      vino: {
        slug: "vino",
        nombre: "Vino",
        intro_ficha: {
          titulo: "Despiertan sensaciones",
          cuerpo:
            "<p>Nuestro vino es la esencia de las peculiares características del terreno y del entorno donde se cultiva, la Dehesa de Navamarín. Es la dedicación y el alma de unas manos expertas. La huella de la tradición vinícola de la tierra de Don Quijote. Vinos con personalidad, elaborados a partir de varietales de uva francesa y española. Vinos con pasión, con alma. Vinos que despiertan sensaciones.</p>"
        },
        intro_productos:
          "<span>No busques el momento perfecto.<br>Solo busca el momento y hazlo perfecto</span>",
        productos: {
          navamarin: {
            id: "navamarin",
            nombre: "Navamarín",
            tipo_vino:
              "Tinto barrica Crianza mínima de 12 meses. Barrica de roble francés y americano.",
            tipo_uva: "Cabernet Sauvignon, Merlot, Syrah, Tempranillo",
            elaboracion:
              "Vino elaborado en la Dehesa de Navamarín, enclave con la reserva de Sabinas más grande de mundo que aporta al vino propiedades y aromas exclusivos. Cuidada selección de las uvas en producciones que no superan los 2 Kg. por cepa.  Coupage realizado ﬁnalizada la crianza en barrica.",
            graduacion: "13,5 - 14,5% Vol. (varía según añada).",
            cantidad: "750ml",
            servicio: "Entre 16º - 18º C.",
            gastronomia: "Buen maridaje con carnes, guisos, caza y quesos.",
            notas_cata: {
              texto:
                "Toques a frutos rojos y hierbas, con un matiz de tabaco. Con cuerpo. Taninos suaves y redondos, aromáticos al final. Perfecto para beber ahora o dejarlo para guarda.",
              autor: "James Suckling"
            },
            premios: [
              "navamarin-pswc-2011",
              "navamarin-berliner-2015",
              "navamarin-china-wine-2015",
              "navamarin-china-wine-2016",
              "navamarin-corea-wine-2015",
              "navamarin-corea-wine-2016",
              "navamarin-bruselas-2013",
              "navamarin-zarcillo-2007",
              "navamarin-testing-2014",
              "navamarin-wswa-2014",
              "navamarin-houston-2015",
              "navamarin-vinalies-2011",
              "navamarin-londres-2013",
              "navamarin-decanter-2013",
              "navamarin-mundus-2018",
              "navamarin-suckling-2018",
              "navamarin-suckling-2019",
              "navamarin-decanter-bronce-2019",
              "navamarin-mundus-2020",
              "navamarin-mundus-2021",
              "navamarin-penin-2023",
              "navamarin-bruselas-2022",
              "navamarin-londres-2022-2",
              "navamarin-bruxelles-2023",
              "navamarin-alemania-2026"
            ]
          },
          seleccion: {
            id: "seleccion",
            nombre: "Selección",
            tipo_vino:
              "Tinto barrica Crianza mínima de 9 meses. Barrica de roble americano y francés.",
            tipo_uva: "Cabernet Sauvignon, Merlot, Syrah, Tempranillo",
            elaboracion:
              "Elaborado a partir de una cuidada selección de uvas procedentes de cepas de escasa producción y recolectadas durante la noche en su momento óptimo de maduración. El coupage se realiza una vez finalizada la crianza en barrica para un mejor ensamblaje. Reposo en botella durante 12 meses en la oscuridad de nuestra cava.",
            graduacion: "13,5 - 14% Vol. (varía según añada).",
            cantidad: "750 ml",
            servicio: "Entre 16º - 18º C.",
            gastronomia: "Buen maridaje con carnes, guisos, caza y quesos.",
            notas_cata: {
              texto:
                "Color rojo cereza. Intenso en aromas a fruta roja madura con torrefactos, vainilla y frutos secos. Amplio en boca, con buen cuerpo y perfecto ensamblaje. Deja un final de boca largo, intenso y persistente.",
              autor: ""
            },
            premios: [
              "seleccion-pswc-2011",
              "seleccion-testing-2014",
              "seleccion-wswa-2014",
              "seleccion-burdeos-2008",
              "seleccion-vinalies-2009",
              "seleccion-vinalies-2012",
              "seleccion-decanter-2017",
              "seleccion-suckling-2019",
              "seleccion-decanter-bronce-2019",
              "seleccion-2022",
              "seleccion-neustadt-2025",
              "seleccion-mexico-2025"
            ]
          },
          clasico: {
            id: "clasico",
            nombre: "Clásico",
            tipo_vino:
              "Tinto barrica Crianza mínima de 6 meses. Barrica de roble francés y americano.",
            tipo_uva: "Cabernet Sauvignon, Merlot, Syrah, Tempranillo",
            elaboracion:
              "Elaboración tradicional que respeta el proceso clásico de elaboración del vino que antiguamente se hacía en la región de Castilla La Mancha. Cuidada selección de las uvas con mayor calidad. Tras la crianza, reposo en botella durante al menos seis meses antes de su comercialización.",
            graduacion: "13 - 14% Vol. (varía según añada).",
            cantidad: "750 ml",
            servicio: "Entre 16º - 18º C.",
            gastronomia:
              "Ideal para todo tipo de embutidos, carnes, estofados, arroces y pastas.",
            notas_cata: {
              texto:
                "Muy rico en frutas del bosque. En paladar sugiere aromas a regaliz rojo. Amplio en boca, con taninos finos. Perfecto para beber ahora",
              autor: "James Suckling"
            },
            premios: [
              "clasico-testing-2014",
              "clasico-wswa-2014",
              "clasico-houston-2015",
              "clasico-decanter-2017",
              "clasico-berliner-2018",
              "clasico-bacchus-2018",
              "clasico-suckling-2018",
              "clasico-suckling-2019",
              "clasico-cwsa-2018",
              "clasico-mundus-2021",
              "clasico-penin-2023",
              "clasico-neustadt-2025",
              "clasico-alemania-2026",
            ]
          },
          albo: {
            id: "albo",
            nombre: "Albo",
            tipo_vino: "Blanco Joven",
            tipo_uva: "Sauvignon Blanc, Macabeo",
            elaboracion:
              "Tras la vendimia, se realiza una ligera maceración con control de levaduras y temperaturas de fermentación, obteniendo riqueza de aromas y un exquisito sabor a frutas.",
            graduacion: "12 - 13% Vol. (varía según añada).",
            cantidad: "750 ml",
            servicio: "Entre 4º - 6º C.",
            gastronomia: "Ideal para acompañar mariscos, pescados y postres.",
            notas_cata: {
              texto:
                "Presencia limpia y brillante, con tono amarillo pálido. En nariz, es rico en aromas frutales (plátano, melocotón y maracuyá) y florales como el azahar y el jazmín, siendo sedoso en boca. Tiene una acidez equilibrada que le da frescura y postgusto largo y agradable.",
              autor: ""
            },
            premios: [
              "albo-berliner-2016",
              "albo-testing-2014",
              "albo-suckling-2019",
              "albo-neustadt-2025",
              "albo-mexico-2025"
            ]
          }
        },
        banner_premios: {
          titulo: "Vinos de premio",
          boton: "Ver todos los premios",
          premio: "navamarin-bruxelles-2023"
        },
        premios: {
          titulo:
            "Premios internacionales y críticas de prestigiosos sumillers.",
          premios: {
            "navamarin-pswc-2011": {
              titulo: "Aldonza Navamarín",
              posicion: "Segundo Premio",
              texto:
                "Añada 2006, premiado con la Medalla de Plata en Pro Wein PSWC en la edición 2011, Mainz (Alemania).",
              categoria: "Internacional",
              pais: "alemania",
              anyada: "2006",
              anyo: "2011"
            },
            "seleccion-pswc-2011": {
              titulo: "Aldonza Selección",
              posicion: "Segundo Premio",
              texto:
                "Añada 2006, premiado con la Medalla de Plata en Pro Wein PSWC en la edición 2011, Mainz (Alemania).",
              categoria: "Internacional",
              pais: "alemania",
              anyada: "2006",
              anyo: "2011"
            },
            "navamarin-berliner-2015": {
              titulo: "Aldonza Navamarín",
              posicion: "Primer Premio",
              texto:
                "Añada 2009, premiado con la Medalla de Oro en el Berliner Wein Trophy en la edición 2015, Berlín (Alemania).",
              categoria: "Internacional",
              pais: "alemania",
              anyada: "2009",
              anyo: "2015",
              doble: true
            },
            "albo-berliner-2016": {
              titulo: "Aldonza Albo",
              posicion: "Primer Premio",
              texto:
                "Añada 2015, premiado con la Medalla de Oro en el Berliner Wein Trophy en la edición 2016, Berlín (Alemania).",
              categoria: "Internacional",
              pais: "alemania",
              anyada: "2015",
              anyo: "2016",
              doble: true
            },
            "pisces-mondiales-2008": {
              titulo: "Aldonza Pisces",
              posicion: "Segundo Premio",
              texto:
                "Añada 2006, premiado con la Medalla de Plata en el Selections  Mondiales des Vins en la edición 2008, Québec (Canadá).",
              categoria: "Internacional",
              pais: "canada",
              anyada: "2006",
              anyo: "2008"
            },
            "navamarin-china-wine-2015": {
              titulo: "Aldonza Navamarín",
              posicion: "Primer Premio",
              texto:
                "Añada 2009, premiado con la Medalla de Oro en China Wine & Spirit Awards en la edición 2015, Hong Kong (China).",
              categoria: "Internacional",
              pais: "china",
              anyada: "2009",
              anyo: "2015"
            },
            "navamarin-china-wine-2016": {
              titulo: "Aldonza Navamarín",
              posicion: "Primer Premio",
              texto:
                "Añada 2010, premiado con la Medalla de Oro en China Wine & Spirit Awards en la edición 2016, Hong Kong (China).",
              categoria: "Internacional",
              pais: "china",
              anyada: "2010",
              anyo: "2016"
            },
            "navamarin-corea-wine-2015": {
              titulo: "Aldonza Navamarín",
              posicion: "Primer Premio",
              texto:
                "Añada 2009, premiado con la Medalla de Oro en el Asia WineTrophy en la edición 2015, Daejeon (Corea de Sur).",
              categoria: "Internacional",
              pais: "corea",
              anyada: "2009",
              anyo: "2015",
              doble: true
            },
            "navamarin-corea-wine-2016": {
              titulo: "Aldonza Clásico",
              posicion: "Segundo Premio",
              texto:
                "Añada 2008, premiado con la Medalla de Plata en el Asia WineTrophy en la edición 2016, Daejeon (Corea de Sur).",
              categoria: "Internacional",
              pais: "corea",
              anyada: "2008",
              anyo: "2016",
              doble: true
            },
            "navamarin-bruselas-2013": {
              titulo: "Aldonza Navamarín",
              posicion: "Primer Premio",
              texto:
                "Añada 2008, premiado con la Medalla de Oro en el Concurso Mundial de Bruselas en la edición 2013, Bratislava (Eslovaquia).",
              categoria: "Internacional",
              pais: "eslovaquina",
              anyada: "2008",
              anyo: "2013"
            },
            "pisces-ljubljana-2008": {
              titulo: "Aldonza Pisces",
              posicion: "Segundo Premio",
              texto:
                "Añada 2006 premiado con la Medalla de Plata en el Concurso Internacional Vino Ljubljana en la edición 2008, Ljubljana (Eslovenia).",
              categoria: "Internacional",
              pais: "eslovenia",
              anyada: "2006",
              anyo: "2008"
            },
            "pisces-bacchus-2006": {
              titulo: "Aldonza Pisces",
              posicion: "Segundo Premio",
              texto:
                "Añada 2004 premiado con el Bacchus Internacional de Plata en la edición 2006, Madrid (España).",
              categoria: "Internacional",
              pais: "espana",
              anyada: "2004",
              anyo: "2006"
            },
            "navamarin-zarcillo-2007": {
              titulo: "Aldonza Navamarín",
              posicion: "Primer Premio",
              texto:
                "Añada 2004 premiado con el Zarcillo de Oro en la edición 2007, Valladolid (España).",
              categoria: "Nacional",
              pais: "espana",
              anyada: "2004",
              anyo: "2007"
            },
            "pisces-bacchus-2008": {
              titulo: "Aldonza Pisces",
              posicion: "Segundo Premio",
              texto:
                "Añada 2006 premiado con el Bacchus Internacional de Plata en la edición 2008, Madrid (España).",
              categoria: "Internacional",
              pais: "espana",
              anyada: "2006",
              anyo: "2008"
            },
            "navamarin-testing-2014": {
              titulo: "Aldonza Navamarín",
              posicion: "Primer Premio",
              texto:
                "Añada 2007, premiado con la Medalla de Oro en 'Beverage Testing Institute' en la edición 2014, Chicago (Estados Unidos).",
              categoria: "Internacional",
              pais: "eeuu",
              anyada: "2007",
              anyo: "2014"
            },
            "seleccion-testing-2014": {
              titulo: "Aldonza Selección",
              posicion: "Primer Premio",
              texto:
                "Añada 2007, premiado con la Medalla de Oro en 'Beverage Testing Institute' en la edición 2014, Chicago (Estados Unidos).",
              categoria: "Internacional",
              pais: "eeuu",
              anyada: "2007",
              anyo: "2014"
            },
            "clasico-testing-2014": {
              titulo: "Aldonza Clásico",
              posicion: "Primer Premio",
              texto:
                "Añada 2007, premiado con la Medalla de Oro en 'Beverage Testing Institute' en la edición 2014, Chicago (Estados Unidos).",
              categoria: "Internacional",
              pais: "eeuu",
              anyada: "2007",
              anyo: "2014"
            },
            "albo-testing-2014": {
              titulo: "Aldonza Albo",
              posicion: "Primer Premio",
              texto:
                "Añada 2013, premiado con la Medalla de Oro en 'Beverage Testing Institute' en la edición 2014, Chicago (Estados Unidos).",
              categoria: "Internacional",
              pais: "eeuu",
              anyada: "2013",
              anyo: "2014"
            },
            "navamarin-wswa-2014": {
              titulo: "Aldonza Navamarín",
              posicion: "Primer Premio",
              texto:
                "Añada 2008, premiado con la Medalla de Oro Absoluto  en WSWA 71st Annual Convention & Exposition en la edición 2014, Las Vegas (Estados Unidos).",
              categoria: "Internacional",
              pais: "eeuu",
              anyada: "2008",
              anyo: "2014"
            },
            "clasico-wswa-2014": {
              titulo: "Aldonza Clásico",
              posicion: "Segundo Premio",
              texto:
                "Añada 2008, premiado con la Medalla de Plata en WSWA 71st Annual Convention & Exposition en la edición 2014, Las Vegas.",
              categoria: "Internacional",
              pais: "eeuu",
              anyada: "2008",
              anyo: "2014"
            },
            "seleccion-wswa-2014": {
              titulo: "Aldonza Selección",
              posicion: "Segundo Premio",
              texto:
                "Añada 2008, premiado con la Medalla de Plata en WSWA 71st Annual Convention & Exposition en la edición 2014, Las Vegas (Estados Unidos).",
              categoria: "Internacional",
              pais: "eeuu",
              anyada: "2008",
              anyo: "2014"
            },
            "navamarin-houston-2015": {
              titulo: "Aldonza Navamarín",
              posicion: "Tercer premio",
              texto:
                "Añada 2008, premiado con la Medalla de Bronce en 'Houston Livestock Show and Rodeo' en la edición 2015, Houston (Estados Unidos).",
              categoria: "Internacional",
              pais: "eeuu",
              anyada: "2008",
              anyo: "2015"
            },
            "clasico-houston-2015": {
              titulo: "Aldonza Clásico",
              posicion: "Tercer Premio",
              texto:
                "Añada 2007, premiado con la Medalla de Bronce en 'Houston Livestock Show and Rodeo' en la edición 2015, Houston (Estados Unidos).",
              categoria: "Internacional",
              pais: "eeuu",
              anyada: "2007",
              anyo: "2015"
            },
            "seleccion-burdeos-2008": {
              titulo: "Aldonza Selección",
              posicion: "Segundo Premio",
              texto:
                "Añada 2005 premiado con la Medalla de Plata en el Concurso Mundial del Vino en la edición 2008, Burdeos (Francia).",
              categoria: "Internacional",
              pais: "francia",
              anyada: "2005",
              anyo: "2008"
            },
            "seleccion-vinalies-2009": {
              titulo: "Aldonza Selección",
              posicion: "Segundo Premio",
              texto:
                "Añada 2006, premiado con la Medalla de Oro en el Vinalies Internationales, 2º Concurso más  importante a nivel mundial en su  edición 2009, París (Francia).",
              categoria: "Internacional",
              pais: "francia",
              anyada: "2006",
              anyo: "2009"
            },
            "navamarin-vinalies-2011": {
              titulo: "Aldonza Navamarín",
              posicion: "Segundo Premio",
              texto:
                "Añada 2007, premiado con la Medalla de Plata en el Vinalies Internationales en la edición 2011, París (Francia).",
              categoria: "Internacional",
              pais: "francia",
              anyada: "2007",
              anyo: "2011"
            },
            "navamarion-citadelles-2006": {
              titulo: "Aldonza Navamarín",
              posicion: "Segundo Premio",
              texto:
                "Añada 2006, premiado con la Medalla de Plata en Les Citadelles du Vin en la edición 2011, Burdeos (Francia). ",
              categoria: "Internacional",
              pais: "francia",
              anyada: "2006",
              anyo: "2011"
            },
            "seleccion-vinalies-2012": {
              titulo: "Aldonza Selección",
              posicion: "Segundo Premio",
              texto:
                "Añada 2007, premiado con la Medalla de Plata en el Vinalies Internationales en la edición 2012, París (Francia).",
              categoria: "Internacional",
              pais: "francia",
              anyada: "2007",
              anyo: "2012"
            },
            "pisces-tokio-2008": {
              titulo: "Aldonza Pisces",
              posicion: "Segundo Premio",
              texto:
                "Añada 2006 premiado con la Medalla de Plata en el Concurso Internacional más prestigioso de Asia edición 2008, Tokio (Japón).",
              categoria: "Internacional",
              pais: "japon",
              anyada: "2006",
              anyo: "2008"
            },
            "navamarin-londres-2013": {
              titulo: "Aldonza Navamarín",
              posicion: "Tercer Premio",
              texto:
                "Añada 2008, premiado con la Medalla de Bronce en el International Wine Challenge en la edición 2013, Londres  (Reino Unido).",
              categoria: "Internacional",
              pais: "uk",
              anyada: "2008",
              anyo: "2013"
            },
            "navamarin-decanter-2013": {
              titulo: "Aldonza Navamarín",
              posicion: "Vino recomendado",
              texto:
                "Añada 2008, vino recomendado en el Decanter World Wine Awards, Edición 2013, Londres (Reino Unido).",
              categoria: "Internacional",
              pais: "uk",
              anyada: "2008",
              anyo: "2013"
            },
            "pisces-decanter-2013": {
              titulo: "Aldonza Pisces",
              posicion: "Vino recomendado",
              texto:
                "Añada 2008, vino recomendado en el Decanter World Wine Awards, Edición 2013, Londres (Reino Unido).",
              categoria: "Internacional",
              pais: "uk",
              anyada: "2008",
              anyo: "2013"
            },
            "clasico-decanter-2017": {
              titulo: "Aldonza Clásico",
              posicion: "Vino recomendado",
              texto:
                "Añada 2011, vino recomendado en el Decanter Asia Wine Awards Edición 2017, Hong Kong (China).",
              categoria: "Internacional",
              pais: "china",
              anyada: "2011",
              anyo: "2017"
            },
            "seleccion-decanter-2017": {
              titulo: "Aldonza Selección",
              posicion: "Vino recomendado",
              texto:
                "Añada 2011, vino recomendado en el Decanter Asia Wine Awards Edición 2017, Hong Kong (China).",
              categoria: "Internacional",
              pais: "china",
              anyada: "2011",
              anyo: "2017"
            },
            "clasico-berliner-2018": {
              titulo: "Aldonza Clásico",
              posicion: "Primer Premio",
              texto:
                "Añada 2011, premiado con la Medalla de Oro en el Berliner Wein Trophy en la edición 2018, Berlín (Alemania)",
              categoria: "Internacional",
              pais: "alemania",
              anyada: "2011",
              anyo: "2018",
              doble: true
            },
            "navamarin-mundus-2018": {
              titulo: "Aldonza Navamarín",
              posicion: "Primer Premio",
              texto:
                "Añada 2012, premiado con la Medalla de Oro en el Gran Premio Internacional del vino Mundus Vini, en la edición de 2018, Berlín (Alemania)",
              categoria: "Internacional",
              pais: "alemania",
              anyada: "2012",
              anyo: "2018"
            },
            "clasico-bacchus-2018": {
              titulo: "Aldonza Clásico",
              posicion: "Segundo Premio",
              texto:
                "Añada 2011, premiado con el Bacchus Internacional de Plata en el  XVI Concurso Internacional de Vinos, en la edición de 2018, Madrid (España)",
              categoria: "Internacional",
              pais: "espana",
              anyada: "2011",
              anyo: "2018"
            },
            "navamarin-suckling-2018": {
              titulo: "Aldonza Navamarín",
              posicion: "90 Puntos",
              texto:
                "Añada 2012, puntuado por James Suckling (EEUU) en la Cata celebrada en la edición de 2018, en El Priorato (España)",
              categoria: "Internacional",
              pais: "eeuu",
              anyada: "2012",
              anyo: "2018"
            },
            "clasico-suckling-2018": {
              titulo: "Aldonza Clásico",
              posicion: "90 Puntos",
              texto:
                "Añada 2011, puntuado por James Suckling (EEUU) en la Cata celebrada en la edición de 2018, en El Priorato (España)",
              categoria: "Internacional",
              pais: "eeuu",
              anyada: "2011",
              anyo: "2018"
            },
            "clasico-cwsa-2018": {
              titulo: "Aldonza Clásico",
              posicion: "Primer Premio",
              texto:
                "Añada 2011, premiado con la Medalla de Oro en el China Wine & Spirits Award, en la edición de 2018, Hong Kong (China)",
              categoria: "Internacional",
              pais: "china",
              anyada: "2011",
              anyo: "2018"
            },
            "navamarin-decanter-bronce-2019": {
              titulo: "Aldonza Navamarín",
              posicion: "Tercer Premio",
              texto:
                "Añada 2012, premiado con la Medalla de Bronce en el Decanter World Wine Awards, en la edición de 2019, Londres (Reino Unido).",
              categoria: "Internacional",
              pais: "uk",
              anyada: "2012",
              anyo: "2019"
            },
            "seleccion-decanter-bronce-2019": {
              titulo: "Aldonza Selección",
              posicion: "Tercer Premio",
              texto:
                "Añada 2012, premiado con la Medalla de Bronce en el Decanter World Wine Awards, en la edición de 2019, Londres (Reino Unido).",
              categoria: "Internacional",
              pais: "uk",
              anyada: "2012",
              anyo: "2019"
            },
            "navamarin-suckling-2019": {
              titulo: "Aldonza Navamarín",
              posicion: "91 Puntos",
              texto:
                "Añada 2013, puntuado por James Suckling (EEUU) en la Cata celebrada en la edición de 2019, en La Rioja (España)",
              categoria: "Internacional",
              pais: "eeuu",
              anyada: "2013",
              anyo: "2019"
            },
            "clasico-suckling-2019": {
              titulo: "Aldonza Clásico",
              posicion: "90 Puntos",
              texto:
                "Añada 2014, puntuado por James Suckling (EEUU) en la Cata celebrada en la edición de 2019, en La Rioja (España)",
              categoria: "Internacional",
              pais: "eeuu",
              anyada: "2014",
              anyo: "2019"
            },
            "seleccion-suckling-2019": {
              titulo: "Aldonza Selección",
              posicion: "89 Puntos",
              texto:
                "Añada 2014, puntuado por James Suckling (EEUU) en la Cata celebrada en la edición de 2019, en La Rioja (España)",
              categoria: "Internacional",
              pais: "eeuu",
              anyada: "2014",
              anyo: "2019"
            },
            "albo-suckling-2019": {
              titulo: "Aldonza Albo",
              posicion: "87 Puntos",
              texto:
                "Añada 2018, puntuado por James Suckling (EEUU) en la Cata celebrada en la edición de 2019, en La Rioja (España)",
              categoria: "Internacional",
              pais: "eeuu",
              anyada: "2018",
              anyo: "2019"
            },
            "navamarin-mundus-2020": {
              titulo: "Aldonza Navamarín",
              posicion: "Medalla de Plata",
              texto:
                "Añada 2013, premiado con la Medalla de Plata en el Gran Premio Internacional del Vino Mundus Vini, en la edición de 2020, Neustadt (Alemania).",
              categoria: "Internacional",
              pais: "alemania",
              anyada: "2013",
              anyo: "2020"
            },
            "navamarin-mundus-2021": {
              titulo: "Aldonza Navamarín",
              posicion: "Medalla de Oro",
              texto:
                "Añada 2013, premiado con la Medalla de Oro en el Gran Premio Internacional de vino Mundus Vini, en la edición de 2021, Neustadt (Alemania).",
              categoria: "Internacional",
              pais: "alemania",
              anyada: "2013",
              anyo: "2021"
            },
            "clasico-mundus-2021": {
              titulo: "Aldonza Clásico",
              posicion: "Medalla de Oro",
              texto:
                "Añada 2015, premiado con la Medalla de Oro en el Gran Premio Internacional de vino Mundus Vini, en la edición de 2021, Neustadt (Alemania).",
              categoria: "Internacional",
              pais: "alemania",
              anyada: "2013",
              anyo: "2021"
            },

            "clasico-penin-2023": {
              titulo: "Aldonza Clásico",
              posicion: "Guía Peñín 2023",
              texto:
                "Añada 2015, puntuado según la Guía Peñín en la cata celebrada en febrero de 2022 en España. ",
              categoria: "Nacional",
              pais: "España",
              anyada: "2022",
              anyo: "2022"
            },
            "navamarin-penin-2023": {
              titulo: "Aldonza Navamarín",
              posicion: "Guía Peñín 2023",
              texto:
                "Añada 2013, puntuado según la Guía Peñín en la cata celebrada en febrero de 2022 en España.",
              categoria: "Nacional",
              pais: "España",
              anyada: "2022",
              anyo: "2022"
            },
            "navamarin-bruselas-2022": {
              titulo: "Aldonza Navamarín",
              posicion: "Gran Medalla de Oro 2022",
              texto:
                "Añada 2013, premiado con la Gran Medalla de Oro en el Concurso Mundial de Bruselas en la edición de 2022, celebrada en Cosenza (Italia).  ",
              categoria: "Internacional",
              pais: "Bruselas",
              anyada: "2022",
              anyo: "2022"
            },
            "navamarin-londres-2022-2": {
              titulo: "Aldonza Navamarín",
              posicion: "91 Puntos",
              texto:
                "Añada 2013, premiado con la Medalla de Plata en el Decanter World Wine Awards, en la edición de 2022, Londres (Reino Unido).",
              categoria: "Internacional",
              pais: "uk",
              anyada: "2013",
              anyo: "2022"
            },

            "navamarin-bruxelles-2023": {
              titulo: "Aldonza Navamarín",
              posicion: "91 Puntos",
              texto:
                "Añada 2014, premiado con la Medalla de Oro en el Concurso Mundial de Bruselas, en la edición de 2023, Istria (Croacia).",
              categoria: "Internacional",
              pais: "uk",
              anyada: "2014",
              anyo: "2023"
            },
            "seleccion-2022": {
              titulo: "Aldonza Selección",
              posicion: "91 Puntos",
              texto:
                "Añada 2015, premiado con la Medalla de Plata en el Concurso Mundial de Bruselas, en la edición de 2023, Istria (Croacia).",
              categoria: "Internacional",
              pais: "uk",
              anyada: "2015",
              anyo: "2023"
            },
            "albo-neustadt-2025": {
              titulo: "Aldonza Albo",
              posicion: "87 Puntos",
              texto:
                "Añada 2024, premiado con la Medalla de Oro en el Gran Premio Internacional del Vino Mundus Vini, en la edición de 2025, Neustadt (Alemania).",
              categoria: "Internacional",
              pais: "alemania",
              anyada: "2024",
              anyo: "2025"
            },
            "clasico-neustadt-2025": {
              titulo: "Aldonza Clásico",
              posicion: "87 Puntos",
              texto:
                "Añada 2022, premiado con la Medalla de Oro en el Gran Premio Internacional del Vino Mundus Vini, en la edición de 2025, Neustadt (Alemania).",
              categoria: "Internacional",
              pais: "alemania",
              anyada: "2022",
              anyo: "2025"
            },
            "seleccion-neustadt-2025": {
              titulo: "Aldonza Selección",
              posicion: "87 Puntos",
              texto:
                "Añada 2022, premiado con la Medalla de Plata en el Gran Premio Internacional del Vino Mundus Vini, en la edición de 2025, Neustadt (Alemania).",
              categoria: "Internacional",
              pais: "alemania",
              anyada: "2022",
              anyo: "2025"
            },
            "albo-mexico-2025": {
              titulo: "Aldonza Albo",
              posicion: "87 Puntos",
              texto:
                "Añada 2024, premiado con la Medalla de Plata en el Global Wine, en la edición de 2025, México.",
              categoria: "Internacional",
              pais: "mexico",
              anyada: "2024",
              anyo: "2025"
            },
            "seleccion-mexico-2025": {
              titulo: "Aldonza Selección",
              posicion: "89 Puntos",
              texto:
                "Añada 2022, premiado con la Medalla de Oro en el Global Wine, en la edición de 2025, México.",
              categoria: "Internacional",
              pais: "mexico",
              anyada: "2022",
              anyo: "2025"
            },
            "clasico-alemania-2026": {
              titulo: "Aldonza Clásico",
              posicion: "90 Puntos",
              texto:
                "Añada 2022, premiado con la Medalla de Oro en Mundus Vini en la edición de 2026, Alemania.",
              categoria: "Internacional",
              pais: "alemania",
              anyada: "2022",
              anyo: "2026"
            },
            "navamarin-alemania-2026": {
              titulo: "Aldonza Navamarín",
              posicion: "91 Puntos",
              texto:
                "Añada 2017, premiado con la Medalla de Plata en Mundus Vini en la edición de 2026, Alemania.",
              categoria: "Internacional",
              pais: "alemania",
              anyada: "2017",
              anyo: "2026"
            },
          }
        },
        banner_beneficios: {
          titulo:
            "¿Conoces los beneficios y las propiedades demostradas del vino?",
          boton: "Descubre los beneficios"
        },
        banner_experiencia: {
          titulo: "¿Quieres saber más?",
          boton: "Descubre el enoturismo",
          enlace: "enoturismo",
          reserva: "Haz tu reserva"
        },
        beneficios: {
          titulo: "Beneficios<br>y propiedades demostradas del vino",
          list: [
            {
              titulo: "Adelgaza",
              cuerpo:
                "El consumo de vino tinto activa la función de un gen que impide la formación de nuevas células de grasa y ayuda a movilizar las existentes."
            },
            {
              titulo: "Salud dental",
              cuerpo:
                "Determinados compuestos presentes en el vino frenan el crecimiento bucal de los estreptococos y bacterias vinculadas a las caries. También previene de gingivitis y dolores  de garganta."
            },
            {
              titulo: "Función cognitiva",
              cuerpo:
                "La elevada presencia de antioxidantes en el vino provoca impide que se endurezcan las arterias e inhibie la coagulación, mejorando el riego sanguíneo cerebral."
            },
            {
              titulo: "Placer",
              cuerpo:
                "Durante la degustación del vino se liberan endorﬁnas en dos áreas del cerebro, que provocan un incremento de la sensación de placer."
            },
            {
              titulo: "Ejercicio",
              cuerpo:
                "El resveratrol de la uva disminuye las consecuencias negativas de la vida sedentaria."
            },
            {
              titulo: "Limpiador bucal",
              cuerpo:
                "Tomado durante las comidas, el vino ayuda a percibir mejor los sabores. Esto se debe a sus propiedades astringentes, que evitan la excesiva sensación de grasa causada por alimentos como las carnes rojas y permiten degustar mejor la comida."
            },
            {
              titulo: "Anti cáncer",
              cuerpo:
                "El vino, concretamente el tinto, ayuda a reducir el riesgo el cáncer de pulmón en hombres. Además bloquea el crecimiento de las células responsables del cáncer de mama en mujeres. De nuevo, el resveratrol es el responsable de tal excepcional cualidad."
            },
            {
              titulo: "Corazón",
              cuerpo:
                "Una o dos copas al día del vino, contribuyen a aumentar los niveles de colesterol bueno en la sangre y previenen las complicaciones cardiovasculares."
            },
            {
              titulo: "Próstata",
              cuerpo:
                "Se ha demostrado que siete vasos de vino semanales después de cumplir los 40 años, reduce en más de la mitad los diagnósticos de cáncer de próstata."
            },
            {
              titulo: "Hábitos saludables",
              cuerpo:
                "Desde el punto de vista social, diferentes estadísticas indican que los enóﬁlos tienen hábitos alimenticios más saludables que los aﬁcionados a otras bebidas, como los consumidores de cerveza o de refrescos. Los aﬁcionados al vino tienden a consumir más aceitunas, frutas, verduras, quesos bajos en grasas, leche y carnes saludables."
            }
          ]
        }
      },
      aceite: {
        slug: "aceite",
        nombre: "Aceite",
        intro_productos: "<span>Haz que hoy sucedan cosas increíbles</span>",
        intro_ficha: {
          titulo: "Cuando amas lo que haces",
          cuerpo:
            "<p>Se obtiene un aceite de oliva virgen extra que expresa todas las cualidades aromáticas y el sabor de las varietales Picual y Arbequina. Con la confianza de las múltiples propiedades curativas que se atribuyen al virgen extra.</p> <p>Origen y pilar fundamental de la dieta mediterránea, el aceite de oliva virgen extra se utiliza desde la antigüedad, prueba de ello es el legado cultural que ha llegado hasta nuestros días sobre el olivo, su cultivo y su forma de elaboración. Muchas civilizaciones antiguas le dieron el nombre de oro líquido.</p>"
        },
        productos: {
          vidrio: {
            id: "vidrio",
            nombre: "Vidrio",
            descripcion:
              "Aceite de oliva virgen extra elaborado con olivas de las variedades Picual y Arbequina mediante el proceso mecánico de extracción en frío.",
            ingredientes:
              "100% Aceite de Oliva Virgen Extra. No contiene ningún tipo de aditivo alimentario.",
            notas_cata: {
              texto:
                "Aceite de gran personalidad, muy estable en el tiempo con sabor afrutado medio en el que destacan notas verdes de tomate, hierba fresca y aromas a frutos secos. Toque goloso de higo y platano. En boca es un aceite con paso muy suave y que resalta por su equilibrio de acidez y dulzor, terminando con un toque picante que persiste a su paso por la boca."
            },
            cantidades: ["750ml", "500ml", "250ml"],
            premios: [
              "granprestigio-mendoza-2016",
              "olivinus-mendoza-2016",
              "olivinusninos-mendoza-2016",
              "feria-habana-2016"
            ]
          },
          metal: {
            id: "metal",
            nombre: "Metal",
            descripcion:
              "Aceite de oliva virgen extra elaborado con olivas de las variedades Picual y Arbequina mediante el proceso mecánico de extracción en frío.",
            ingredientes:
              "100% Aceite de Oliva Virgen Extra. No contiene ningún tipo de aditivo alimentario.",
            notas_cata: {
              texto:
                "Aceite de gran personalidad, muy estable en el tiempo con sabor afrutado medio en el que destacan notas verdes de tomate, hierba fresca y aromas a frutos secos. Toque goloso de higo y platano. En boca es un aceite con paso muy suave y que resalta por su equilibrio de acidez y dulzor, terminando con un toque picante que persiste a su paso por la boca."
            },
            cantidades: ["1L", "5L"],
            premios: [
              "granprestigio-mendoza-2016",
              "olivinus-mendoza-2016",
              "olivinusninos-mendoza-2016",
              "feria-habana-2016"
            ]
          }
        },
        banner_premios: {
          titulo: "Aceite de premio",
          boton: "Ver todos los premios",
          premio: "granprestigio-mendoza-2016"
        },
        premios: {
          titulo: "Premios y reconocimientos",
          premios: {
            "granprestigio-mendoza-2016": {
              titulo: "Concurso Internacional de Aceite de Oliva",
              posicion: "",
              texto:
                "Gran Prestigio Oro Olivinus en el Concurso Internacional de Aceite ‘Olivinus 2016’, en Mendoza (Argentina). ",
              categoria: "Internacional",
              pais: "argentina",
              anyada: "",
              anyo: "2016"
            },
            "olivinus-mendoza-2016": {
              titulo: "Concurso Internacional de Aceite de Oliva",
              posicion: "",
              texto:
                "93 Puntos Olivinus en el Concurso Internacional de Aceite de Oliva ‘Olivinus 2016’, en Mendoza (Argentina). ",
              categoria: "Internacional",
              pais: "argentina",
              anyada: "",
              anyo: "2016"
            },
            "olivinusninos-mendoza-2016": {
              titulo: "Concurso Internacional de Aceite de Oliva",
              posicion: "",
              texto:
                "Concurso Olivinus Niños ‘Olivinus 2016’, seleccionado por los niños. En Mendoza (Argentina).",
              categoria: "Internacional",
              pais: "argentina",
              anyada: "",
              anyo: "2016"
            },
            "feria-habana-2016": {
              titulo: "Feria Internacional de la Habana",
              posicion: "",
              texto:
                "Premio a Calidad del Producto en 'FIHAV 2016' en La Habana (Cuba).",
              categoria: "Internacional",
              pais: "argentina",
              anyada: "",
              anyo: "2016",
              doble: true
            }
          }
        },
        banner_beneficios: {
          titulo:
            "¿Conoces los beneficios y las propiedades demostradas del aceite?",
          boton: "Descubre los beneficios"
        },
        banner_experiencia: {
          titulo: "¿Quieres saber más?",
          boton: "Descubre el oleoturismo",
          enlace: "oleoturismo"
        },
        beneficios: {
          titulo:
            "Beneficios y propiedades demostradas del<br>aceite de oliva virgen extra",
          list: [
            {
              titulo: "Osteoporosis",
              cuerpo:
                "El aceite de oliva virgen extra juega un papel importante en la prevención de la osteoporosis ya ayuda a la absorción de calcio por parte del sistema óseo."
            },
            {
              titulo: "Presión arterial",
              cuerpo:
                "Ayuda a disminuir drásticamente la presión arterial sistólica y la diastólica."
            },
            {
              titulo: "Obesidad",
              cuerpo:
                "El AOVE está totalmente indicado en dietas hipocalóricas para cocinar y para aliños, ya que su índice glucémico es mucho más bajo que el de otras grasas."
            },
            {
              titulo: "Estrés oxidativo",
              cuerpo:
                "Entre los aceites vegetales, el aceite de oliva virgen extra es el más alto en grasa monoinsaturada. A diferencia de otras grasas, ésta no se oxida en el cuerpo y contiene un porcentaje muy bajo en grasas poliinsaturadas. También es rico en Vitamina E."
            },
            {
              titulo: "Cáncer",
              cuerpo:
                "Está cientíﬁcamente probado que los ﬁtonutrientes del aceite de oliva virgen extra pueden reducir el riesgo de cáncer de mama. El escualeno y los lignanos son otros de los  componentes sobre los que se está estudiando sus posibles efectos sobre el cáncer."
            },
            {
              titulo: "Diabetes",
              cuerpo:
                "Los diabéticos encuentran en el consumo de aceite de oliva virgen extra un gran aliado contra su enfermedad porque les ayuda a reducir los niveles de glucosa e insulina en sangre."
            },
            {
              titulo: "Artritis",
              cuerpo:
                "El consumo regular de aceite de oliva virgen extra ayuda a reducir las probabilidades de desarrollar artritis reumatoide."
            },
            {
              titulo: "Colesterol",
              cuerpo:
                "El AOVE ayuda a disminuir el colesterol en la sangre, propiedad que puede evitar el desarrollo de enfermedades cardíacas. También contribuye a que el colesterol malo LDL, que incide directamente en el desarrollo de las enfermedades coronarias, no se oxide."
            },
            {
              titulo: "Alzehimer.",
              cuerpo: "Su consumo regular previene el deterioro cognitivo."
            }
          ]
        }
      },
      azafran: {
        slug: "azafran",
        nombre: "Azafrán",
        intro_productos:
          "<span>Pequeños detalles que marcan la diferencia</span>",
        productos: {
          caja: {
            id: "caja-1g",
            nombre: "Caja 1g",
            descripcion:
              "Azafrán Denominación de Origen Protegida La Mancha. Reconocimiento de calidad mundial que garantiza la máxima calidad en seguridad alimentaria, características organolépticas (color, aroma y sabor) y procedencia España (Castilla La Mancha).",
            caracteristicas:
              "Azafrán en hebras, nunca molido. Hebras flexibles y resistentes",
            maridaje:
              "Ideal como colorante, aromatizante y para dar sabor a cualquier comida. El azafrán alcanza su máximo exponente en la preparación de platos de cocina empleado como especia: asados de carne, pescados, sopas, mariscos y arroces.",
            peso: ["1g", "Caja de 12 unidades"],
            premios: {
              premios: []
            }
          }
        },
        intro_ficha: {
          titulo: "Azafrán de<br>La Mancha",
          cuerpo:
            "<p><strong>Oro rojo.</strong> Venerado desde tiempos remotos por antiguas civilizaciones como la egipcia o la griega, esta especia tan fina como delicada se ha convertido en la actualidad en ingrediente estrella de la cocina internacional por su aroma, sabor y color. El azafrán también es utilizado como fármaco por sus múltiples propiedades medicinales.</p><p>El azafrán Aldonza se produce en Castilla La Mancha (España), tierra que ha sido reconocida con el sello de calidad Denominación de <strong>Origen Protegida Azafrán de La Mancha.</strong> Un reconocimiento de calidad mundialmente reconocido por su triple garantía: procedencia España, características organolépticas óptimas y seguridad alimentaria.</p>"
        },
        banner_denominacion: {
          titulo: "Con denominación de origen",
          subtitulo: "Azafrán de la mancha",
          cuerpo: "Denominación de origen protegida La Mancha"
        },
        banner_beneficios: {
          titulo:
            "¿Conoces los beneficios y las propiedades demostradas del azafrán?",
          boton: "Descubre los beneficios"
        },
        banner_experiencia: {
          titulo: "¿Quieres saber más?",
          boton: "Descubre las experiencias Aldonza",
          enlace: "vive_aldonza"
        },
        beneficios: {
          titulo: "Beneficios<br>y propiedades demostradas del azafrán",
          list: [
            {
              titulo: "Digestión",
              cuerpo:
                "Por sus componentes aromáticos y amargos (picrocrocina), estimula el sistema digestivo y aumenta las secreciones salivales y gástricas. Además, el azafrán contiene crocetina (los pigmentos rojos) y ﬂuidiﬁca. El primero estimula la producción de bilis mientras que la ﬂuidiﬁca ayuda al proceso digestivo y evita que se produzcan piedras en la vésicula biliar."
            },
            {
              titulo: "Dolor menstrual",
              cuerpo:
                "El azafrán tiene un papel muy importante para tratar los síntomas premenstruales. Se ha demostrado que el azafrán favorece el ciclo menstrual, evita los cólicos uterinos y beneﬁcia el ﬂujo de la menstruación."
            },
            {
              titulo: "Antioxidante",
              cuerpo:
                "La crocina, componente principal del azafrán, es un poderoso antioxidante natural. Esta sustancia retrasa el envejecimiento de las células del cuerpo."
            },
            {
              titulo: "Memoria",
              cuerpo:
                "El azafrán mejora la memoria y las habilidades cognitivas. Es reconocido su efecto protector sobre enfermedades degenerativas como el Parkinson y el Alzheimer. También se recomienda como suplemento alimentario para aquellas personas que sufren estrés."
            },
            {
              titulo: "Visión",
              cuerpo:
                "El safranal, componente aromático del azafrán, ralentiza la degeneración de las células fotorreceptoras de los ojos, mejora la función de la retina y los vasos sanguíneos de la vista."
            },
            {
              titulo: "Enfermedades cardiovasculares.",
              cuerpo:
                "El azafrán es una especia aromática muy rica en antioxidantes, que actúa como preventivo de enfermedades cardiovasculares. Además, la crocetina, pigmento rojo del azafrán, contribuye a reducir el colesterol."
            },
            {
              titulo: "Diabetes",
              cuerpo:
                "Por su elevado poder antioxidante, el azafrán es un suplemento beneﬁcioso para personas con diabetes. El extracto de azafrán protege a este tipo de pacientes frente a la neuropatía diabética, daño que se produce en los nervios debido al exceso de azúcar en la sangre."
            },
            {
              titulo: "Anticancerígeno",
              cuerpo:
                "El azafrán contiene betacarotenos y ﬂavonoides que ayudan a retrasar el crecimiento tumoral, alargando la esperanza de vida."
            },
            {
              titulo: "Antidepresivo",
              cuerpo:
                "El azafrán, en casos de depresión leve y moderada, puede ser tan efectivo como algunos fármacos para la depresión."
            },
            {
              titulo: "Sedante",
              cuerpo:
                "El azafrán contiene sustancias aromáticas sedantes, que ayudan a combatir el nerviosismo y la ansiedad."
            }
          ]
        }
      },
      cava: {
        slug: "cava",
        nombre: "Cava",
        intro_productos:
          "<span>Después de grandes momentos,<br>quedan inolvidables recuerdos</span>",
        intro_ficha: {
          titulo: "Con personalidad",
          cuerpo:
            "<p>Del fruto de la viña se obtiene el mosto que después de dos fermentaciones se transformará en cava. Levaduras propias y seleccionadas con rigor que otorgan personalidad propia a nuestras cuatro variedades de vinos espumosos. </p><p>Cava con D.O. Vinos Espumosos, cultivado en la comarca del Penedés y elaborado en el centro de Sant Sandurní D'Anoia en Barcelona a partir de las variedades de uva Xarel·lo, Macabeo y Parellada. Mención especial para nuestro cava rosado, elaborado únicamente con uvas tintas de la variedad Trepat.</p>"
        },
        productos: {
          reserva: {
            id: "reserva",
            nombre: "Reserva",
            tipo_uva:
              "Chardonnay, Xarel-lo, Macabeo de viñedos propios de la D.O. Cava",
            tipo_cava: "Brut reserva especial",
            elaboracion:
              "Tras la recolección, el mosto se obtiene por prensa neumática o escurrido dinámico. Fermentación del mosto a una temperatura de 15ºC y seguimiento de la misma. Segunda fermentación y crianza mínima de 24 meses en caves.",
            graduacion: "11,5 - 12,5% Vol",
            cantidad: "750ml",
            servicio: "Entre 6º - 8º C.",
            gastronomia:
              "La gran personalidad de este cava resalta cualquier plato de la cocina internacional: carnes, pescados guisados, quesos, foies y ahumados y es excelente como aperitivo.",
            notas_cata: {
              texto:
                "Color amarillo paja y buena formación de burbujas que acaban en rosario. Destaca por su aroma a crianza, fruta madura y ﬂores. En boca es rodondo, armonioso, seco y de larga persistencia.",
              autor: ""
            },
            premios: [
              "brut-decanter-plata-2019",
              "brut-decanter-2022",
              "brut-decanter-2022-2",
              "brut-alemania-2026", 
              "brut-bos-2026"
            ]
          },
          nature: {
            id: "nature",
            nombre: "Brut Nature",
            tipo_uva: "Xarel-lo, Macabeo, Parellada",
            tipo_cava: "Brut Nature",
            elaboracion:
              "Tras la recolección de la uva, ésta se descarga por variedades y calidad. Posteriormente se obtiene el mosto por prensa neumática o escurrido dinámico. Fermentación del mosto por debajo de 19ºC de temperatura y seguimiento de la misma. Reposo y crianza en la cava entre 12 y 14 meses.",
            graduacion: "11,5 - 12,5 % Vol.",
            cantidad: "750ml",
            servicio: "Entre 6º - 8º C.",
            gastronomia:
              "Combina con aperitivos, frutos secos, marisco, carnes rojas y blancas. ",
            notas_cata: {
              texto:
                "Color amarillo pálido con leves reﬂejos dorados y con desprendimiento de burbujas que suben en rosario formando corona. Se distinguen aromas ﬂorales y melosos característicos de la crianza en botella. En la boca se presenta seco, agradable y redondo; con muy buena persistencia aromática.",
              autor: ""
            },
            premios: ["brut-nature-2025"]
          },
          rose: {
            id: "rose",
            nombre: "Brut - Rosé",
            tipo_uva: "Trepat",
            tipo_cava: "Brut - rosé",
            elaboracion:
              "Tras la vendimia, se realizada un derrapado y encubado de las uvas con una leve maceración hasta alcanzar su punto óptimo de color y el resto de características. Fermentación del mosto por debajo de 19ºC de temperatura. Reposo y crianza en la cava (mínimo 9 meses).",
            graduacion: "11 - 12% Vol",
            cantidad: "750ml",
            servicio: "Entre 6º - 8º C.",
            gastronomia:
              "Ideal para acompañar ensaladas, pastas, pescados azules, y maricos",
            notas_cata: {
              texto:
                "Color rosado intenso, vivo y brillante. Persistente y buen desprendimiento de pequeñas burbujas que suben en rosario formando una corona. La primera impresión es agradable y se distinguen aromas que recuerdan a pequeñas frutas rojas. Posteriormente, la impresión ﬁnal deja un gusto equilibrado, sabroso y muy afrutado.",
              autor: ""
            },
            premios: ""
          },
          brut: {
            id: "brut",
            nombre: "Brut",
            tipo_uva: "Xarel-lo, Macabeo, Parellada",
            tipo_cava: "Brut",
            elaboracion:
              "Tras la recolección de la uva, ésta se descarga por variedades y calidad. Posteriormente se obtiene el mosto por prensa neumática o escurrido dinámico. Fermentación del mosto por debajo de 19ºC de temperatura y seguimiento de la misma. Reposo y crianza en la cava entre 12 y 14 meses.",
            graduacion: "11 - 12% Vol",
            cantidad: "750ml",
            servicio: "Entre 6º - 8º C.",
            gastronomia:
              "Ideal para acompañar con jamón, carnes blancas y arroces.",
            notas_cata: {
              texto:
                "Color amarillo muy pálido con leves reﬂejos dorados y con buen desprendimiento de pequeñas burbujas que acaban formando una alegre corona. Aroma elegante, con notas afrutadas y con los matices própios de la crianza en botella. En boca genera un sabor agradable, con puntas dulces y recuerdos ﬁnales a manzana. Buena acidez y larga persistencia.",
              autor: ""
            },
            premios: ""
          }
        },
        premios: {
          titulo: "Premios y reconocimientos",
          premios: {
            "brut-decanter-plata-2019": {
              titulo: "Cava Brut-Reserva",
              posicion: "Segundo premio",
              texto:
                "Añada 2018, premiada con la Medalla de plata en el Decanter World Wine Awards, en la edición de 2019, Londres (Reino Unido).",
              categoria: "Internacional",
              pais: "uk",
              anyada: "2018",
              anyo: "2019"
            },
            "brut-decanter-2022": {
              titulo: "Cava Brut-Reserva",
              posicion: "92 Puntos",
              texto:
                "Añada 2021, premiado con la Medalla de Plata en el Decanter World Wine Awards, en la edición de 2022, Londres (Reino Unido).",
              categoria: "Internacional",
              pais: "uk",
              anyada: "2021",
              anyo: "2022"
            },
            "brut-decanter-2022-2": {
              titulo: "Cava Brut Reseva",
              posicion: "",
              texto:
                "Añada 2021, Medalla de Plata en el Concours Mondial de Bruxelles celebrado en Anadia (Portugal).",
              categoria: "Internacional",
              pais: "portugal",
              anyada: "2021",
              anyo: "2022"
            },
            "brut-nature-2025": {
              titulo: "Cava Brut Nature",
              posicion: "",
              texto:
                "Añada 2022, premiado con la Medalla de Oro en el Global Wine, en la edición de 2025, México.",
              categoria: "Internacional",
              pais: "mexico",
              anyada: "2022",
              anyo: "2025"
            },
            "brut-alemania-2026": {
              titulo: "Cava Brut Reseva",
              posicion: "",
              texto:
                "Premiado con la Medalla de Oro en Mundus Vini en la edición de 2026, Alemania.",
              categoria: "Internacional",
              pais: "alemania",
              anyada: "2022",
              anyo: "2026"
            },
            "brut-bos-2026": {
              titulo: "Cava Brut Reseva",
              posicion: "",
              texto:
                "Reconocido como el mejor cava de Mundus Vini en la edición de 2026, Alemania.",
              categoria: "Internacional",
              pais: "alemania",
              anyada: "2022",
              anyo: "2026"
            }
          }
        },
        banner_premios: {
          titulo: "Cava de premio",
          boton: "Ver todos los premios",
          premio: "brut-decanter-2022-2"
        },
        banner_beneficios: {
          titulo:
            "¿Conoces los beneficios y las propiedades demostradas del cava?",
          boton: "Descubre los beneficios"
        },
        banner_experiencia: {
          titulo: "¿Quieres saber más?",
          boton: "Descubre las experiencias Aldonza",
          enlace: "vive_aldonza"
        },
        beneficios: {
          titulo: "Beneficios<br>y propiedades demostradas del cava",
          list: [
            {
              titulo: "Aporta nutrientes",
              cuerpo:
                "El cava, como hemos citado al principio, se incluye entre las bebidas bajas en grasa que además contiene propiedades nutricionales. Destacamos su contenido en hierro, proteínas, calcio, potasio, yodo, trazas de zinc, carbohidratos, magnesio, sodio, vitamina B1, B2, B9, vitaminas B3 y B6, fósforo y azúcar."
            },
            {
              titulo: "Rejuvenece",
              cuerpo:
                "El cava se considera una fuente de juventud ya que contiene antioxidantes que estimulan la renovación celular y potencian la vitamina E. Estas propiedades rejuvenecen la piel, especialmente la de las mujeres."
            },
            {
              titulo: "Bueno para el corazón",
              cuerpo:
                "Gracias a sus altos niveles en polifenoles, reduce la presión arterial y previene el riesgo de enfermedades cardiovasculares o infartos."
            },
            {
              titulo: "Levanta el ánimo",
              cuerpo:
                "Algunos componentes de esta bebida levantan el ánimo. Este producto contiene oligoelementos naturales que mejoran nuestro estado de ánimo."
            },
            {
              titulo: "Potencia la memoria",
              cuerpo:
                "El consumo moderado de cava, una copa al día, es capaz de mejorar la memoria y de retrasar varias enfermedades degenerativas del cerebro, como la demencia senil. Estudios cientíﬁcos determinan que la clave de esta propiedad reside en el ácido fenólico."
            },
            {
              titulo: "Cuida tu peso",
              cuerpo:
                "El cava es una de las bebidas alcohólicas con menor contenido calórico. Una copa de Brut contiene menos de 12 gramos de azúcar residual por litro, es decir, entre 80 y 100 calorías, mientras que una cerveza o un combinado de ron, por citar algunos ejemplos, tienen más de 150 calorías."
            },
            {
              titulo: "Protege la piel",
              cuerpo:
                "El cava desintoxica la piel con antioxidantes y ácido tartárico, contribuyendo a equilibrar su tono y evitar rojeces. Para las personas con tendencia a tener la piel grasa, las propiedades antibacterianas de esta bebida ayudan a tenerla más sana y saludable."
            }
          ]
        }
      },
      queso: {
        slug: "queso",
        nombre: "Queso",
        intro_productos: "<span>Haz un paréntesis en tu día a día</span>",
        productos: {
          enaceite: {
            id: "enaceite",
            nombre: "En aceite",
            descripcion:
              "Queso en aceite de oliva elaborado con leche pasteurizada 100% de oveja manchega.",
            curacion: "Entre 150-210 días.",
            apariencia:
              "Consistencia: firme y compacta. Color: variable desde el blanco hasta el marfil - amarillento. Olor: láctico, acidificado intenso y persistente que evoluciona a matices picantes. Sabor: ligeramente ácido, fuerte y sabroso.",
            ingredientes:
              "Leche de oveja manchega pasteurizada, cuajo, fermentos lácticos, lisozima (derivado del huevo), cloruro de calcio, sal y aceite de oliva. Origen de la leche: España.",
            valoresnutricionales:
              "Valor Energético: 410 Kcal / 1715 Kj Grasas: 36 g A. G. saturadas: 18,70 g Hidratos de carbono: 0,50 g Azúcares: 0 g Proteínas: 24 g Sal: 1,60 g",
            conservacion: "Entre 2 y 7ºC.",
            alergenos: "Lactosa y lisozoma (derivado del huevo)",
            durabilidad: "1 año desde su elaboración. Se indica en cada envase",
            gastronomia:
              "Ideal para acompañar vinos tintos (Aldonza Selección y Aldonza Navamarín) y cava (Aldonza Brut Reserva).",
            notas_cata: {
              texto:
                "Sabor fuerte característico de queso de oveja, reforzado por el intenso sabor del aceite de oliva, con un retrogusto bastante picante."
            },
            premios: {
              premios: []
            }
          },

          semicurado: {
            id: "semicurado",
            nombre: "Semicurado",
            descripcion:
              "Queso semicurado elaborado con leche pasteurizada 100% de oveja manchega.",
            curacion: "Entre 60 - 100 días.",
            apariencia:
              "Consistencia: firme y compacta. Color: variable desde el blanco hasta el marfil - amarillento. Olor: láctico, acidificado intenso y persistente. Sabor: ligeramente ácido, fuerte y sabroso.",
            ingredientes:
              "Leche de oveja manchega pasteurizada, cuajo, fermentos lácticos, lisozima (derivado del huevo), cloruro de calcio y sal. Origen de la leche: España.",
            valoresnutricionales:
              "Valor Energético: 410 Kcal / 1715 Kj Grasas: 30 g A. G. saturadas: 18,90 g Hidratos de carbono: 0,50 g Azúcares: <0,50 g Proteínas: 26 g Sal: 1,60 g",
            conservacion: "Entre 2 y 7ºC.",
            alergenos: "Lactosa y lisozoma (derivado del huevo)",
            durabilidad: "1 año desde su elaboración. Se indica en cada envase",
            gastronomia:
              "Ideal para acompañar vinos blancos (Aldonza Albo), tintos jóvenes (Aldonza Clásico) y cavas rosados (Aldonza Brut - Rosé).",
            notas_cata: {
              texto:
                "Sabor suave. Textura bastante cremosa. Retrogusto muy peculiar graciasa la leche de oveja manchega. Equilibrado sabor láctico con toques ácidos al final."
            },
            premios: {
              premios: []
            }
          },

          curado: {
            id: "curado",
            nombre: "Curado",
            descripcion:
              "Queso curado elaborado con leche pasteurizada 100% de oveja manchega.",
            curacion: "Entre 150 - 210 días.",
            apariencia:
              "Consistencia: firme y compacta. Color: variable desde el blanco hasta el marfil - amarillento. Olor: láctico, acidificado intenso y persistente que evoluciona a matices picantes. Sabor: ligeramente ácido, fuerte y sabroso.",
            ingredientes:
              "Leche de oveja manchega pasteurizada, cuajo, fermentos lácticos, lisozima (derivado del huevo), cloruro de calcio y sal. Origen de la leche: España.",
            valoresnutricionales:
              "Valor Energético: 410 Kcal / 1715 Kj Grasas: 36 g A. G. saturadas: 18,70 g Hidratos de carbono: 0,50 g Azúcares: 0 g Proteínas: 24 g Sal: 1,60 g",
            conservacion: "Entre 2 y 7ºC.",
            alergenos: "Lactosa y lisozoma (derivado del huevo)",
            durabilidad: "1 año desde su elaboración. Se indica en cada envase",
            gastronomia:
              "Ideal para acompañar vinos tintos (Aldonza Selección y Aldonza Navamarín) y cava (Aldonza Brut Nature).",
            notas_cata: {
              texto:
                "Queso con mucho carácter, de sabor fuerte, penetrante, intenso, que evoluciona a matices ligeramente picantes al final."
            },
            premios: {
              premios: []
            }
          }
        },
        intro_ficha: {
          titulo: "100% manchego",
          cuerpo:
            "<p>Cada queso recibe el trato personalizado de las manos de nuestros queseros artesanos. Un mimo que se aprecia en el sabor, el aroma y la textura de cada bocado. Recréate con cualquiera de nuestras tres variedades: curado, semicurado y en aceite de oliva. Una experiencia más, irresistible a tu paladar.<br><a target='_blank' href='/static/pdf/certificado-SAE.pdf'><u>Certificado <strong>SAE 2021-0014</strong></u></a></p>"
        },
        banner_beneficios: {
          titulo:
            "¿Conoces los beneficios y las cualidades demostradas del queso?",
          boton: "Descubre los beneficios"
        },
        banner_experiencia: {
          titulo: "¿Quieres saber más?",
          boton: "Descubre las experiencias Aldonza",
          enlace: "vive_aldonza"
        },
        beneficios: {
          titulo: "Beneficios<br>y cualidades demostradas del queso",
          list: [
            {
              titulo: "Fuente de calcio",
              cuerpo:
                "El queso es una de las principales fuentes de calcio, mineral que regula procesos esenciales en nuestro organismo, como el transporte de oxígeno por los glóbulos rojos o la coagulación."
            },
            {
              titulo: "Salud bucodental",
              cuerpo:
                "Además de fortalecer nuestros dientes, reduce la placa bacteriana, estimula la producción de saliva y limpia nuestra boca de forma natural."
            },
            {
              titulo: "Protege la piel",
              cuerpo:
                "Posee gran contenido en vitamina B, favoreciendo el aspecto de nuestra piel."
            },
            {
              titulo: "Mejora la visión",
              cuerpo:
                "Contiene vitamina A y D que ayudan a mejorar la visión y el sistema inmunológico."
            },
            {
              titulo: "Recomendable en el embarazo",
              cuerpo:
                "Contiene ácido fólico, por lo que es muy recomendable tomarlo durante el embarazo, además favorece la producción de leche materna."
            },
            {
              titulo: "Previene enfermedades",
              cuerpo:
                "El queso rico en ácido linoleico conjugado (CLA) y en esfingolípidos, dos componentes de la leche grasa que ayudan a reducir el riesgo de cáncer y enfermedades del corazón."
            },
            {
              titulo: "Recupera masa corporal",
              cuerpo:
                "Es muy rico en proteínas y favorece la recuperación de la masa corporal. Es un alimento de gran ayuda para deportistas y reduce los riesgos de obesidad."
            }
          ]
        }
      }
    },
    banners_experiencia: {
      vive_aldonza: {
        id: "vive-aldonza",
        titulo: "Vive aldonza",
        titulo_intro_experiencia:
          '"No recordarás los días, si no las experiencias que vivas en cada momento"',
        titulo_vivir_experiencia:
          "¿Qué necesitas para vivir tu experiencia Aldonza?",
        tip_maleta:
          "Recuerda meter en <strong>la maleta</strong> todo lo que quieres que te acompañe durante la experiencia. ¡Hay que estar preparado!",
        tip_camara:
          "¡Una <strong>cámara de fotos</strong>! Imprescindible para inmortalizar cada uno de los momentos irrepetibles que vivirás con Aldonza.",
        tip_corazon:
          "<strong>Tu actitud</strong>, el ingrediente fundamental para que cada experiencia sea inolvidable. El camino sólo depende de ti.",
        elige: "Elige tu experiencia Aldonza"
      },
      enoturismo: {
        id: "enoturismo",
        titulo: "Enoturismo",
        cuerpo:
          "Ten preparada la cámara de fotos cuando desciendas a la cueva donde está ubicada nuestra sala de barricas. Una experiencia de enoturismo sensorial con degustación incluida. Visitas de lunes a domingo.",
        boton: "Vivir experiencia",
        titulo_intro_experiencia: "Conoce y visita nuestra bodega",
        la_visita_text: "La visita",
        reserva: "Comprar tus entradas",
        tips_bodega: [
          {
            titulo: "Localización",
            cuerpo:
              "Enoturismo en el corazón de la tierra de Don Quijote. Nuestra bodega se encuentra en el término municipal de Munera situado al noroeste de la provincia de Albacete."
          }
        ],
        la_visita: [
          {
            cuerpo:
              "Recorrido completo por nuestras instalaciones: bodega, almazara y sala de azafrán. Aprenderás cómo se elabora el vino, aceite de oliva virgen extra y azafrán."
          },
          {
            cuerpo:
              "Degustación de vino, cava y aceite de oliva virgen extra. ¡Una experiencia exquisita!"
          },
          {
            cuerpo:
              "Duración aproximada: 120 minutos. Accesible para personas con discapacidad."
          },
          {
            cuerpo: "Visítanos cualquier día de la semana (de lunes a domingo)."
          },
          {
            cuerpo: "¡Reserva tu experiencia de enoturismo con Aldonza Gourmet!"
          }
        ],
        video: {
          titulo: "Video/spot",
          cuerpo:
            "Sólo tienes que elegir la compañía. <strong>¿Familia, pareja o amigos?</strong> Enoturismo y oleoturismo de la mano. ¡Dale al play!"
        }
      },

      degustacionQuesos: {
        id: "degustacionQuesos",
        titulo: "El Ritual del Queso",
        cuerpo:
          "Activa todos los sentidos para saborear un trozo de queso. ¡Empieza el ritual de la degustación del queso!",
        boton: "Vivir experiencia",
        titulo_intro_experiencia: "El Ritual",
        productos: {
          vista: {
            id: "vista",
            nombre: "Vista",
            descripcion:
              "Es el sentido que evalúa la apariencia y estado del queso. Debemos examinar tanto la corteza exterior como la superficie del corte. Según la variedad, la corteza será lisa y cerosa, enmohecida, lavada o tratada, por ejemplo, con aceite de oliva virgen extra. El color es otro de los aspectos visuales que debemos tener en cuenta. Los quesos manchegos, elaborados con leche de oveja, suelen tener una tonalidad marfil. Con la vista también también podemos apreciar la textura. Por ejemplo, un queso estará más o menos agrietado según el tiempo de curado."
          },
          tacto: {
            id: "tacto",
            nombre: "Tacto",
            descripcion:
              "El examen táctil nos permite sentir la textura escamosa, harinosa y algo quebradiza, típica de los quesos manchegos curados. "
          },
          olfato: {
            id: "olfato",
            nombre: "Olfato",
            descripcion:
              "En nariz percibimos las sensaciones que los catadores y maestros queseros agrupan en familias. Se distinguen  impresiones lácticas, vegetales, afrutadas, de especias, etc."
          },
          gusto: {
            id: "gusto",
            nombre: "Gusto",
            descripcion:
              "¡Es el momento de apreciar los sabores y la textura de cada queso! Para la degustación en boca, lo ideal es masticar durante unos segundos sin respirar y, a continuación, liberar el aire poco a poco por la boca. Esto ayuda a detectar la intensidad y los sabores del queso; dulces, salados, ácidos, amargos, picantes y hasta otros matices que pueden tener una apreciación totalmente personal."
          },
          regusto: {
            id: "regusto",
            nombre: "Regusto",
            descripcion:
              "Al finalizar la degustación, queda el regusto, también conocido como gusto residual. En este instante, permanece una sensación olfato-gustativa distinta a cuando se saborea el queso por primera vez, con lo que los aromas y sabores pueden ser totalmente nuevos y singulares."
          }
        },
        maridaje: {
          id: "maridaje",
          titulo_catas: "Maridaje con vinos",
          cuerpo_catas:
            "<p> La acidez del vino nos facilita el paso de los quesos, además, los vinos limpian la boca y potencia el sabor del queso.</p>"
        }
      },

      oleoturismo: {
        id: "oleoturismo",
        titulo: "Oleoturismo",
        cuerpo:
          "Déjate seducir por el aroma de un buen virgen extra. Visita nuestra almazara, aprende el proceso de elaboración del aceite de oliva virgen extra y llénate de las propiedades del producto más tradicional de la dieta mediterránea.",
        boton: "Vivir experiencia",
        titulo_intro_experiencia: "Conoce y visita nuestra almazara",
        titulo_catas: "Nuestras catas de aceite",
        cuerpo_catas:
          "<p>Las catas de aceite de oliva se realizan en vasos opacos. El motivo es que el color de este producto no determina su calidad. ¿Lo sabías? Apúntate a una jornada de oleoturismo con Aldonza para descubrir mucho más sobre este producto.</p><p>En un entorno único, en el corazón de la tierra de Don Quijote, aprenderás cómo se elabora el aceite de oliva virgen extra, cómo funciona una almazara, cuáles son las principales variedades de aceituna y cómo se realiza una cata de aceite de oliva profesional. No te contamos más, ¡descúbrelo por ti mismo!</p>"
      },
      recetario: {
        id: "recetario",
        titulo: "Recetario y<br>Ruta Gastronómica",
        cuerpo:
          "<p>La mejor manera de saborear nuestros productos es cocinar con ellos. Tradicionales o innovadoras, elige la receta que más te apetezca de nuestro recetario.</p><p>Lo mejor de la cocina española, con productos Aldonza. Coge tu maleta y ven a disfrutar de la ruta gastronómica 'Tasting Spain'.</p>",
        boton: "Vivir experiencia",
        titulo_intro_experiencia:
          '"Una persona se convierte en cocinero cuando tiene cosas que decir a través de sus platos"',
        cuerpo_recetario:
          "<p>Aldonza tiene su propio recetario de platos saludables preparados con sus productos: aceite de oliva virgen extra, azafrán y vino. Tradicionales o innovadoras, todas nuestras recetas están disponibles en formato audiovisual. ¿Cuál te apetece cocinar hoy?</p><p>El equipo de Aldonza y los chefs del centro culinario HEB recorren los principales restaurantes y centros gastronómicos de España para preparar un nuevo recetario que fusionará la cocina española y texana. Revive con nuestros vídeos la ruta gastronómica 'Tasting Spain'.</p>",
        boton_recetario: "¡Consulta nuestro recetario!",
        boton_tasting: "¡Descubre tasting spain!",
        recetario: "Recetario",
        tasting_spain: "Tasting Spain",
        youtube: {
          titulo:
            "¿Quieres ver más recetas o no perderte alguna de nuestras rutas?",
          newsletter: "Suscríbete a nuestro canal de Youtube",
          boton: "Ir al canal de Youtube"
        }
      },
      ruta_cervantina: {
        id: "ruta-cervantina",
        titulo: "Ruta Cervatina",
        cuerpo:
          "Territorio plagado de historia y de leyendas, considerado ruta-vía cervantina preferente. Muchos son los rincones con encanto que rodean la Dehesa de Navamarín. Haz tu maleta y déjate seducir por la tierra de Don Quijote de La Mancha.",
        boton: "Vivir experiencia",
        cerrar: "Cerrar",
        leer_mas: "Leer más",
        tradicion: {
          titulo: "Tradicción literaria",
          cuerpo:
            "Miguel de Cervantes se inspiró en los territorios de la Dehesa de Navamarín para escribir dos capítulos de su obra más internacional 'Don Quijote de La Mancha'. Las historias que se relatan en 'Las bodas de Camacho' y en 'La Cueva de Montesinos' transcurren en nuestras tierras."
        },
        literatura: {
          cuerpo:
            "La influencia de esta obra universal en nuestros viñedos, olivares y azafranales, da nombre a nuestra marca. Aldonza Lorenzo, Dulcinea del Toboso en el libro, fue la doncella a la que amaba Don Quijote. En la actualidad, puedes visitar la herencia de esta obra literaria en el municipio de Munera."
        },
        naturaleza: {
          titulo: "Naturaleza",
          cuerpo:
            "En plena ruta cervantina, a unos 40 Km. de la Dehesa de Navamarín y en medio del extenso Campo de Montiel, nos encontramos con un oasis de agua y vegetación: el Parque Natural de las Lagunas de Ruidera, en cuyo punto más alto, la Cabeza de San Pedro se encuentran el Castillo de Rochafrida y la Cueva de Montesinos",
          more_cuerpo:
            "En una superficie de 4000 hectáreas se reparten dieciséis lagunas que escalonadamente forman cascadas y torrentes que van desde los primeros manantiales que emanan en la laguna Blanca hasta llegar a las lagunas bajas y el Pantano de Peñarroya. En primavera, el exuberante colorido de una abundante y variada vegetación recibe a un innumerable número de aves acuáticas. El agua alcanza en esta época su máximo caudal y fluye de una laguna a otra formando en algunos casos pequeñas cascadas.",
          more_uno:
            "Quien visita la Dehesa de Navamarín y las bodegas Aldonza, visita una tierra con significativa tradición literaria. Las célebres <strong>Bodas de Camacho</strong>, relatadas en los capítulos, XIX, XX, XXI de la obra 'El Quijote' de Cervantes, se celebraron en Munera. Hay varios estudios y casualidades que demuestran que los protagonistas, Camacho el Rico, Basilio el Pobre y La Bella Quiteria, eran de esta villa. Todavía se conserva en el municipio la hospedería donde sucedió este episodio, convertido hoy en un bonito Hostal en el que puedes degustar los productos Aldonza.",
          more_dos:
            "En honor a una de las protagonistas de este famoso episodio, se mandó construir en 1975 el Molino de la Bella Quiteria. Hoy en día, alberga en su interior un museo de mobiliario y menaje típico de La Mancha. Turismo rural situado dentro de la ruta-vía cervantina preferente.",
          more_tres:
            "Además, Munera también cuenta con el Museo Foto-Etnológico. Se trata de un antiguo molino de viento, construido en 1.861 y donado al Ayuntamiento para convertirlo en museo. Increíble, la sensación de pasear entre los clásicos molinos de viento de La Mancha."
        },
        historia: {
          titulo: "Historia",
          cuerpo:
            "La ruta cervatina no pasa por alto los espacios históricos situados en plena Sierra de Alcaraz y Campos de Montiel. El yacimiento arqueológico de Libisosa y el <strong>Museo Etnográfico de Tiriez</strong>, ubicados en el término de Lezuza, también forman parte de la historia de nuestras plantaciones y de la cultura manchega.",
          more_uno:
            "El Yacimiento Arqueológico de Libisosa esconde en diez hectáreas de terreno más de 2.800 años de historia. Ubicadas en el paraje de Lezuza conocido como el Cerro del Castillo, estas excavaciones se han convertido en uno de los enclaves más importantes de Castilla-La Mancha. Están ubicadas entre las cuencas de los ríos Guadiana y Júcar, terrenos con abundantes recursos hídricos, cinegéticos y forestales. En esta zona, la ganadería siempre desempeñó un papel relevante, junto al cultivo de cereal y amplías parcelas de vid. Este yacimiento, con alto valor geoestratégico para el comercio de la época, es un territorio rico en historia y en cultura agrícola.",
          more_dos:
            "El Museo Etnográfico de Tiriez está situado en esta pedanía, situada dentro del término municipal de Lezuza, en la provincia de Albacete. Se trata de un Ecomuseo que recrea edificios históricos y el entorno cultural de la comarca en la que se encuentran las instalaciones de Aldonza. Museo etnográfico en el que se reproducen distintos ambientes de la vida cotidiana de las gentes de la comarca del Campo de Montiel. Podrás ver herramientas de la apicultura, la agricultura, objetos de decoración de las casas, carros, etc. Por otro lado, en la sección llamada 'La vida en la aldea', se exponen oficios propios de antaño como la forja, la herrería, las tiendas, el horno, la escuela, la quesería o la propia iglesia del pueblo. También recoge actividades artesanas como el esparto y cuenta con un centro de interpretación del azafrán y con réplicas de los molinos del Río Lezuza."
        },
        legado: {
          titulo: "El legado catalán de Don Quijote",
          cuerpo:
            "Aldonza amplió su cartera de negocio incorporando el cava y lo hace porque existe un destacado vínculo entre Don Quijote de La Mancha y Cataluña. Ocho capítulos de su aventura transcurren en territorio catalán, siendo los más representativos 'La venida a Cataluña y el encuentro de los bandoleros', 'La visión del mar y el puerto' y 'La capital catalana'.",
          boton: "¡Descúbrelo!"
        }
      }
    },
    escucha: {
      intro: "Lo mejor de la vida no se planea, sucede",
      cuerpo_intro: "¿Qué necesitas para sentir y escuchar Aldonza?",
      tip_volumen:
        "Apetito para disfrutar y descubrir nuevas sensaciones a través de la música. ¡Activa el sonido y deja el volumen a tu gusto!",
      tip_cascos:
        "Tú eliges vivir la experiencia solo o en compañía. Las dos opciones son válidas para sumergirte en la experiencia auditiva que te propone Aldonza.",
      tip_dados:
        "¿Sabías que el sonido es un ingrediente que mejora las experiencias gastronómicas? Déjate llevar por la play list de Aldonza e intensifica cada sabor.",
      boton_escuchar: "Escuchar",
      spotify: {
        titulo: "Aldonza en Spotify",
        cuerpo:
          "¿Preparado? Estás a un clic de sumergirte en una experiencia que hará único este momento. Distintos ambientes elegidos especialmente para ti.",
        boton: "Escuchar lista"
      },
      comparte: {
        titulo: "Comparte tu experiencia Aldonza",
        cuerpo:
          "¡Queremos que disfrutes de cada #ExperienciaAldonza pero, sobre todo, que la compartas con nosotros!<br>Te esperamos en nuestras redes sociales."
      }
    },
    otras_experiencias: {
      titulo: "Otras Experiencias",
      lugares: {
        enoturismo: "Enoturismo",
        oleoturismo: "Oleoturismo",
        degustacionQuesos: "El Ritual del Queso",
        ruta_cervantina: "Ruta Cervantina",
        recetario: "Recetario"
      }
    },
    formulario: {
      vive_experiencia: "Vive la experiencia",
      solicita_visita: "",
      bodega: "Solicita tu visita a nuestra Bodega",
      almazara: "Solicita tu visita",
      queseria: "Solicita tu visita",
      nombre: "Nombre",
      nombre_apellidos: "Nombre y apellidos",
      apellidos: "Apellidos",
      email: "Email",
      mensaje: "Mensaje",
      introduce_mensaje: "Introduce tu mensaje",
      fecha_nacimiento: "Fecha de nacimiento",
      dia: "Día",
      mes: "Mes",
      anyo: "Año",
      area_interes: "Área de su interés",
      trabaja_actualmente: "¿Trabaja actualmente?",
      si: "Si",
      no: "No",
      carta_presentacion: "Carta de presentacion",
      meses: {
        Enero: "Enero",
        Febrero: "Febrero",
        Marzo: "Marzo",
        Abril: "Abril",
        Mayo: "Mayo",
        Junio: "Junio",
        Julio: "Julio",
        Agosto: "Agosto",
        Septiembre: "Septiembre",
        Octubre: "Octubre",
        Noviembre: "Noviembre",
        Diciembre: "Diciembre"
      },
      archivo_adjunto: "Adjuntar archivo",
      adjuntar_cv: "Adjuntar CV",
      introduce_mail: "Introduce tu email",
      pais: "País",
      telefono: "Teléfono",
      he_leido: "Consiento el uso de mis datos para los fines indicados en la",
      y_acepto: "política de privacidad",
      texto_newsletter: "Deseo suscribirme a la newsletter",
      enviar: "Enviar",
      enviado: "Enviado",
      recibido:
        "Lo hemos recibido. Nos pondremos en contacto contigo en la mayor brevedad posible.",
      concertar_visita:
        "Tambien puedes concertar tu visita por teléfono o email:",
      lunes_domingo: "De lunes a domingo",
      horario: "De 8:00 a 14:00 h. y de 15:30 a 18:00h",
      enlace_popup:
        "Pulsa aquí para consultar y aceptar la política de privacidad"
    },
    popupterminos: {
      titulo: "Información básica sobre protección de datos",
      titulo_dos: "Responsable del tratamiento",
      titulo_tres: "ALDONZA GOURMET S.A.U.",
      cuerpo: [
        {
          titulo: "Dirección del responsable",
          cuerpo:
            "Parque Empresarial Ajusa Nº1 – Crta. CM 332, Km 2,2, CP 02006, Albacete (España)"
        },
        {
          titulo: "Finalidad",
          cuerpo:
            "Sus datos serán usados para poder atender sus solicitudes y prestarle nuestros servicios."
        },
        {
          titulo: "Publicidad",
          cuerpo:
            "Solo le enviaremos publicidad con su autorización previa, que podrá facilitarnos mediante la casilla correspondiente establecida al efecto."
        },
        {
          titulo: "Legitimación",
          cuerpo:
            "Únicamente trataremos sus datos con su consentimiento previo, que podrá facilitarnos mediante la casilla correspondiente establecida al efecto."
        },
        {
          titulo: "Destinatarios",
          cuerpo:
            "Con carácter general, sólo el personal de nuestra entidad que esté debidamente autorizado podrá tener conocimiento de la información que le pedimos."
        },
        {
          titulo: "Derechos",
          cuerpo:
            "Tiene derecho a saber qué información tenemos sobre usted, corregirla y eliminarla, tal y como se explica en la información adicional disponible en nuestra página web."
        }
      ],
      titulo_mas: "Información adicional",
      texto_mas: "Más información en el apartado",
      datos_seguros: "SUS DATOS SEGUROS",
      texto_nuestra: "de nuestra página web.",
      acepto: "Acepto"
    },

    banner_contacto: {
      titulo: "¿Necesitas más información?",
      cuerpo:
        "Para cualquier consulta rellene el siguiente formulario, responderemos en la mayor brevedad posible:",
      boton: "Ver formulario"
    },
    banner_localizaciones: {
      titulo: "¿Dónde estamos?",
      cuerpo:
        "Para acceder a nuestras instalaciones, dirígete a cualquiera de estos dos puntos:",
      munera: "Crta. N-430  Km 462,3, 02612 Munera (Albacete)",
      lezuza: "<strong>Carretera CM-313</strong>, km 56, Lezuza (Albacete)."
    },
    banner_newsletter: {
      titulo: "¿Dónde estamos?",
      cuerpo: "Dirección: Crta. N-430  Km 462,3, 02612 Munera (Albacete)",
      email: "Email:",
      telefono: "Teléfono de contacto:"
    },
    cookie_banner: {
      texto:
        "Una cookie es un pequeño archivo de información que se guarda en su navegador cada vez que visita nuestra web. La utilidad de las cookies es guardar el historial de su actividad en nuestra para que, cuando la visite nuevamente, pueda identificarle y configurar su contenido en base a sus hábitos de navegación, identidad y preferencias. Pueden ser aceptadas, rechazadas, bloqueadas y borradas, según desee. En caso de que las rechace no podremos asegurarle el correcto funcionamiento de nuestra web. Más información en el apartado",
      politica: "política de cookies.",
      boton: "Acepto"
    },
    intros_legales: {
      politica_cookies: "Política de cookies",
      politica_privacidad: "Política de privacidad",
      datos_seguros: "Datos seguros",
      aviso_legal: "Aviso Legal",
      mapa_web: "Mapa web"
    },
    volver: "Volver",
    volver_a: "Volver a",
    aviso_legal: {
      terminos: "TÉRMINOS Y CONDICIONES",
      uno:
        "I.- La utilización, consulta y/o contratación de los servicios que se exponen en nuestra página Web www.aldonzagourmet.com supone por parte de los usuarios y/o clientes la aceptación plena y sin reservas de las Condiciones Generales de Contratación, que regulan la relación jurídica derivada de los procesos de contratación realizados entre los usuarios y/o clientes de la página Web www.aldonzagourmet.com propiedad de <strong>Aldonza Gourmet S.A.U</strong> (en adelante Aldonza Gourmet). Los Clientes aceptan las Condiciones Generales desde el instante que utilicen o adquieran cualquier producto. Este documento puede ser impreso para ser leído y almacenado por los Clientes, previamente a su aceptación.",
      dos:
        "II.- Las presentes Condiciones Generales, están sujetas en lo que resulte de aplicación a lo dispuesto a la Ley 7/1998, de 13 de abril, sobre Condiciones Generales de Contratación, al Real Decreto Legislativo 1/2007, de 16 de noviembre, por el que se aprueba el Texto Refundido de la Ley General para la Defensa de Consumidores y Usuarios y otras leyes complementarias, al Real Decreto 1906/1999, de 17 de diciembre de 1999, por el que se regula la Contratación Telefónica o Electrónica con condiciones generales, el Reglamento (UE) 2016/679 del Parlamento Europeo y del Consejo, de 27 de abril de 2016, relativo a la protección de las personas físicas en lo que respecta al tratamiento de datos personales y a la libre circulación de estos datos y por el que se deroga la Directiva 95/46/CE (Reglamento general de protección de datos), la Ley Orgánica 3/2018, de 5 de diciembre, de Protección de Datos Personales y garantía de los derechos digitales, la Ley 7/1996, de 15 de enero de Ordenación del Comercio Minorista, y a la Ley 34/2002 de 11 de julio, de Servicios de la Sociedad de la Información y de Comercio Electrónico.",
      tres:
        "III.- Modificación de las Condiciones Generales. Aldonza Gourmet podrá modificar las Condiciones Generales notificándolo a los Clientes con antelación suficiente, con el fin de mejorar los servicios y productos ofrecidos a través de Aldonza Gourmet. Mediante la modificación de las Condiciones Generales expuestas en la página Web de Aldonza Gourmet se entenderá por cumplido dicho deber de notificación. En todo caso, antes de utilizar los servicios o contratar productos, se pondrán consultar las Condiciones Generales.",
      cuatro:
        "IV.- Propiedad intelectual. Todos los contenidos de esta página Web (incluyendo el código fuente, imágenes, textos, gráficos, etc.) están protegidos por la normativa nacional e internacional vigente sobre propiedad intelectual, encontrándose todos los derechos reservados. Queda terminantemente prohibida la reproducción de cualquier contenido de la Web sin el consentimiento expreso de Aldonza Gourmet y de los poseedores de los derechos.",
      cuatro_dos:
        "Mediante la adquisición de un producto, Aldonza Gourmet no confiere al adquirente ningún derecho de alteración, explotación, reproducción, distribución o comunicación pública sobre el mismo, reservándose Aldonza Gourmet todos estos derechos. La cesión de los citados derechos precisará el previo consentimiento por escrito por parte de Aldonza Gourmet. La utilización no autorizada de la información contenida en esta Web, su reventa, así como la lesión de los derechos de propiedad intelectual o industrial dará lugar a las responsabilidades legalmente establecidas.",
      cinco:
        "V.- Uso del servicio y responsabilidades. Aldonza Gourmet no garantiza la disponibilidad permanente de los servicios, quedando exonerado por cualquier tipo de responsabilidad por posibles daños y perjuicios causados debido a la indisponibilidad del servicio por causas de fuerza mayor o errores en las redes telemáticas de transferencia de datos, ajenos a su voluntad. Aldonza Gourmet no se hace responsable del contenido de los enlaces a otras páginas Web que no sean titularidad suya y que, por tanto, no pueden ser controladas por ésta.",
      seis:
        "VI.- Protección de datos. En cumplimiento de lo dispuesto en el artículo 5 de la Ley Orgánica 15/1999, de 13 de diciembre, de Protección de Datos de Carácter Personal, y en la Ley 34/2002, de 11 de Julio, de Servicios de la Sociedad de la Información y de Comercio Electrónico, Aldonza Gourmet S.A.U (en adelante Aldonza Gourmet) le informa de que los datos de carácter personal proporcionados en los formularios de registro electrónico contenidos en este sitio, así como aquellos datos a los que Aldonza Gourmet acceda como consecuencia de su navegación; consulta, solicitud o contratación, o de cualquier transacción u operación realizada desde este sitio web, serán recogidos en un fichero que cumple con las exigencias de la legislación vigente aplicable y cuyo responsable es: Aldonza Gourmet S.A.U., Parque Empresarial Ajusa. Nº1 - Ctra. 332 Km 2.2. 02006 – Albacete - España. (info@aldonzagourmet.com)",
      seis_uno:
        "La finalidad de la recogida y tratamiento automatizado de los Datos Personales realizados a través de los formularios y contactos vía correo electrónico habilitados en este sitio Web, es para facilitar la prestación de servicios que Ajusa proporciona a través de estas páginas, así como para facilitarle información sobre las actividades y noticias que pudieran resultar de su interés.",
      seis_dos:
        "El envío de datos personales, mediante el uso de los formularios electrónicos de esta Web o, en su caso, el envío de mensajes de correo electrónico solicitando información o servicios, supone el consentimiento expreso del Usuario al tratamiento automatizado de los datos incluidos, así como al envío de comunicaciones vía electrónica con información acerca de nuestras actividades.",
      seis_tres:
        "Por lo tanto, el Usuario expresa su consentimiento expreso para que los Datos Personales sean incorporados al Fichero de Datos Personales y sean objeto de tratamiento automatizado por parte de Aldonza Gourmet con las finalidades antes indicadas. Asimismo, expresa la aceptación y autorización para que Aldonza Gourmet pueda ceder los Datos Personales, a las empresas que prestan servicios a Aldonza Gourmet, tales como bancos y aseguradoras.",
      seis_cuatro:
        "El Usuario garantiza que los datos personales facilitados a Aldonza Gourmet son veraces y se hace responsable de comunicar al mismo cualquier modificación de los mismos.",
      seis_cinco:
        "Aldonza Gourmet pone a disposición de los usuarios la dirección de correo electrónico info@aldonzagourmet.com y el teléfono 967 21 77 11, para que éstos revoquen el consentimiento prestado. Aldonza Gourmet declara que cumple la normativa vigente respecto a la protección de datos, en particular la Ley Orgánica 15/1999, de 13 de diciembre, de Protección de Datos de Carácter Personal y el Real Decreto 1720/2007, de 21 de diciembre, que desarrolla la citada ley orgánica, y pone a disposición de los Clientes los medios de contacto referidos en el párrafo anterior para que estos ejerzan los derechos de acceso, rectificación, cancelación y oposición garantizados por la legislación vigente.",
      seis_seis:
        "Aldonza Gourmet se compromete a tratar de forma absolutamente confidencial los datos de carácter personal y hacer uso de los mismos exclusivamente para las finalidades indicadas.",
      siete:
        "VII.- Comunicaciones electrónicas comerciales. Aldonza Gourmet pone a disposición de los usuarios, que previamente lo hayan solicitado, a través de formularios de suscripción habilitados al efecto, el servicio de envío de noticias, actividades e informaciones. El Usuario podrá darse de baja de este servicio en cualquier momento que lo considere oportuno mediante el envío de un correo electrónico a info@aldonzagourmet.com",
      ocho:
        "VIII. Información General. De conformidad con la ley 34/2.002, de 11 de julio, de Servicios de la Sociedad de la Información y de Comercio Electrónico, Aldonza Gourmet, manifiesta que ha procedido a cumplir con el deber de información en los términos que establece esta normativa, al efecto de permitir, tanto a los destinatarios del servicio como a los órganos competentes, el acceso de forma permanente, fácil, directa y gratuita a la siguiente información: Aldonza Gourmet S.A.U Parque Empresarial Ajusa. Nº1 - Ctra. CM-332 Km 2.2. 02006 - Albacete (España). www.aldonzagourmet.com. Teléfono: 967 21 77 11 Datos de inscripción en el Registro Mercantil de Albacete, Hoja nº 5031, Folio 222, Tomo 635, Libro 399, Sección 8. C.IF. Nº A-02203859.",
      nueve:
        "IX. Información sobre el uso de cookies. Este sitio Web utiliza cookies, pequeños ficheros de datos que se generan en el ordenador del Usuario y que nos permiten obtener la siguiente información: La fecha y hora de la última vez que el Usuario visitó nuestro Web, los contenidos que el Usuario escogió en su primera visita a nuestro Web, etc. Con la finalidad de realizar estadísticas globales de acceso. El Usuario consiente el uso de estas cookies, que en ningún caso permitirán su identificación, con la exclusiva finalidad de facilitar su navegación por las diferentes páginas del presente sitio Web. En cualquier caso, el Usuario podrá denegar o impedir la instalación de estas cookies modificando la configuración de su navegador.",
      diez:
        "X. Responsabilidad. El uso del Web se realizará bajo la única y exclusiva responsabilidad del Usuario. Dicha responsabilidad se extenderá al uso, por parte del usuario o de cualquier tercero, de cualquier contraseña o similares asignadas para el acceso al Web o a cualesquiera de sus servicios.",
      diez_uno:
        "Aldonza Gourmet no asume responsabilidad alguna derivada de los contenidos enlazados desde la Web, siempre que sean ajenos a la misma, ni garantiza la ausencia de virus u otros elementos en los mismos que puedan producir alteraciones en el sistema informático (hardware y software), en los documentos o los ficheros del usuario, excluyendo cualquier responsabilidad por los daños de cualquier clase causados al usuario por este motivo. Aldonza Gourmet rechaza toda responsabilidad que se derive de la mala utilización de los contenidos expuestos en estas páginas y se reserva el derecho a actualizarlos, eliminarlos, establecer limitaciones o restringir su acceso en cualquier momento, de manera temporal o permanente.",
      once:
        "XI.- Nulidad e ineficacia de las Cláusulas. Si cualquier cláusula incluida en estas Condiciones Generales fuese declarada nula o ineficaz total o parcialmente, tal nulidad o ineficacia afectará tan sólo a dicha disposición o a la parte de la misma que resulte nula o ineficaz, subsistiendo las Condiciones Generales en todo lo demás, teniéndose tal disposición, o la parte de la misma que resultase afectada, por no puesta.",
      doce:
        "XII.- Conflictos. Para cualquier controversia o conflicto suscitado, será de aplicación la legislación española, siendo competentes para la resolución de todos los conflictos derivados o relacionados con ella, los Juzgados y Tribunales de Albacete.",
      doce_uno:
        "El acceso a las páginas Web de este sitio, implica la aceptación de todas las condiciones expresadas en esta información legal. Aldonza Gourmet, podrá modificar sin previo aviso, la estructura y diseño del Web, así como cambiar o eliminar, los servicios, los contenidos y las condiciones de acceso de uso del Web y adaptarla a los cambios legislativos que se produzcan."
    },
    datos_seguros: {
      p1:
        "En Europa y en España existen normas de protección de datos pensadas para proteger su información personal de obligado cumplimiento para nuestra entidad.",
      p2:
        "Por ello, es muy importante para nosotros que entienda perfectamente qué vamos a hacer con los datos personales que le pedimos.",
      p3:
        "Así, seremos transparentes y le daremos el control de sus datos, con un lenguaje sencillo y opciones claras que le permitirán decidir qué haremos con su información personal.",
      p4:
        "Por favor, si una vez leída la presente información le queda alguna duda, no dude en preguntarnos.",
      p5: "Muchas gracias por su colaboración.",
      h21: "<strong>¿Quiénes somos?</strong>",
      p6: "Nuestra denominación: <strong>ALDONZA GOURMET S.A.U.</strong>",
      p7: "Nuestro CIF / NIF: <strong>A02203859</strong>",
      p8:
        "Nuestra actividad principal: <strong>Producción y comercialización de vino, aceite de oliva virgen extra, azafrán y cava.</strong> ",
      p9:
        "Nuestra dirección: <strong>Parque Empresarial Ajusa, nº1 – Crta. CM 332, Km 2,2 / CP:02006, Albacete (España)</strong>",
      p10: "Nuestro teléfono de contacto: <strong>967 21 77 11</strong>",
      p11:
        "Nuestra dirección de correo electrónico de contacto: <strong>info@aldonzagourmet.com</strong>",
      p12: "Nuestra página web: <strong>www.adonzagourmet.com</strong>",
      p13:
        "Para su confianza y seguridad, le informamos que somos una entidad inscrita en el siguiente Registro Mercantil /Registro Público Hoja nº 5031, Folio 222, Tomo 635, Libro 399, Sección 8 – CIF Nº A-02203859. ",
      h22: "<strong>¿Para qué vamos a usar sus datos? </strong>",
      p14:
        "Con carácter general, sus datos personales serán usados para poder relacionarnos con usted y poder prestarle nuestros servicios.",
      p15:
        "Asimismo, también pueden ser usados para otras actividades, como enviarle publicidad o promocionar nuestras actividades.",
      h23: "¿Por qué necesitamos usar sus datos?",
      p16:
        "Sus datos personales son necesarios para poder relacionarnos con usted y poder prestarle nuestros servicios. En este sentido, pondremos a su disposición una serie de casillas que le permitirán decidir de manera clara y sencilla sobre el uso de su información personal.",
      h24:
        "<strong>¿Quién va a conocer la información que le pedimos?</strong>",
      p17:
        "Con carácter general, sólo el personal de nuestra entidad que esté debidamente autorizado podrá tener conocimiento de la información que le pedimos.",
      p18:
        "De igual modo, podrán tener conocimiento de su información personal aquellas entidades que necesiten tener acceso a la misma para que podamos prestarle nuestros servicios.",
      p181:
        "Así por ejemplo, nuestro banco conocerá sus datos si el pago de nuestros servicios se realiza mediante tarjeta o transferencia bancaria.",
      p19:
        "Asimismo, tendrán conocimiento de su información aquellas entidades públicas o privadas a las cuales estemos obligados a facilitar sus datos personales con motivo del cumplimiento de alguna ley. Poniéndole un ejemplo, la Ley Tributaria obliga a facilitar a la Agencia Tributaria determinada información sobre operaciones económicas que superen una determinada cantidad.",
      p20:
        "En el caso de que, al margen de los supuestos comentados, necesitemos dar a conocer su información personal a otras entidades, le solicitaremos previamente su permiso a través de opciones claras que le permitirán decidir a este respecto.",
      h25: "<strong>¿Cómo vamos a proteger sus datos?</strong>",
      p21:
        "Protegeremos sus datos con medidas de seguridad eficaces en función de los riesgos que conlleve el uso de su información.",
      p22:
        "Para ello, nuestra entidad ha aprobado una Política de Protección de Datos y se realizan controles y auditorías anuales para verificar que sus datos personales están seguros en todo momento.",
      h26: "<strong>¿Enviaremos sus datos a otros países?</strong>",
      p23:
        "En el mundo hay países que son seguros para sus datos y otros que no lo son tanto. Así por ejemplo, la Unión Europea es un entorno seguro para sus datos. Nuestra política es no enviar su información personal a ningún país que no sea seguro desde el punto de vista de la protección de sus datos.",
      p24:
        "En el caso de que, con motivo de prestarle el servicio, sea imprescindible enviar sus datos a un país que no sea tan seguro como España, siempre le solicitaremos previamente su permiso y aplicaremos medidas de seguridad eficaces que reduzcan los riesgos del envío de su información personal a otro país.",
      h27:
        "<strong>¿Durante cuánto tiempo vamos a conservar sus datos?</strong>",
      p25:
        "Conservaremos sus datos durante nuestra relación y mientras nos obliguen las leyes. Una vez finalizados los plazos legales aplicables, procederemos a eliminarlos de forma segura y respetuosa con el medio ambiente. ",
      h28: "<strong>¿Cuáles son sus derechos de protección de datos?</strong>",
      p26:
        "En cualquier momento puede dirigirse a nosotros para saber qué información tenemos sobre usted, rectificarla si fuese incorrecta y eliminarla una vez finalizada nuestra relación, en el caso de que ello sea legalmente posible. ",
      p27:
        "También tiene derecho a solicitar el traspaso de su información a otra entidad. Este derecho se llama “portabilidad” y puede ser útil en determinadas situaciones.",
      p28:
        "Para solicitar alguno de estos derechos, deberá realizar una solicitud escrita a nuestra dirección, junto con una fotocopia de su DNI, para poder identificarle. ",
      p29:
        "En las oficinas de nuestra entidad disponemos de formularios específicos para solicitar dichos derechos y le ofrecemos nuestra ayuda para su cumplimentación.",
      p30:
        "Para saber más sobre sus derechos de protección de datos, puede consultar la página web de la Agencia Española de Protección de Datos (www.agpd.es).",
      h29:
        "<strong>¿Puede retirar su consentimiento si cambia de opinión en un momento posterior?</strong>",
      p31:
        "Usted puede retirar su consentimiento si cambia de opinión sobre el uso de sus datos en cualquier momento. ",
      p32:
        "Así, por ejemplo, si usted en su día estuvo interesado/a en recibir publicidad de nuestros productos o servicios, pero ya no desea recibir más publicidad, puede hacérnoslo constar a través del formulario de oposición al tratamiento disponible en las oficinas de nuestra entidad.",
      h210:
        "<strong>En caso de que entienda que sus derechos han sido desatendidos, ¿dónde puede formular una reclamación?</strong>",
      p33:
        "En caso de que entienda que sus derechos han sido desatendidos por nuestra entidad, puede formular una reclamación en la Agencia Española de Protección de Datos, a través de alguno de los medios siguientes:",
      p333: "o Sede electrónica: www.agpd.es",
      p34: "o Dirección postal:",
      p35: "Agencia Española de Protección de Datos ",
      p36: "C/ Jorge Juan, 6",
      p37: "28001-Madrid ",
      p38: "o Vía telefónica:",
      p39: "Telf. 901 100 099 ",
      p40: "Telf. 91 266 35 17",
      p41:
        "Formular una reclamación en la Agencia Española de Protección de Datos no conlleva ningún coste y no es necesaria la asistencia de abogado ni procurador. ",
      h211: "<strong>¿Elaboraremos perfiles sobre usted?</strong>",
      p42:
        "Nuestra política es no elaborar perfiles sobre los usuarios de nuestros servicios.",
      p43:
        "No obstante, pueden existir situaciones en las que, con fines de prestación del servicio, comerciales o de otro tipo, necesitemos elaborar perfiles de información sobre usted.",
      p44:
        "Un ejemplo pudiera ser la utilización de su historial de compras o servicios para poder ofrecerle productos o servicios adaptados a sus gustos o necesidades.",
      p45:
        "En tal caso, aplicaremos medidas de seguridad eficaces que protejan su información en todo momento de personas no autorizadas que pretendan utilizarla en su propio beneficio. ",
      h212: "<strong>¿Usaremos sus datos para otros fines?</strong>",
      p46:
        "Nuestra política es no usar sus datos para otras finalidades distintas a las que le hemos explicado. Si, no obstante, necesitásemos usar sus datos para actividades distintas, siempre le solicitaremos previamente su permiso a través de opciones claras que le permitirán decidir al respecto."
    },
    mejor_bodega_CM: "Elegida mejor bodega de Castilla La Mancha"
  },
  en: {
    enlaces: {
      home: "/home",
      finca: "/estate",
      la_tierra: "/estate/land",
      la_bodega: "/estate/winery",
      proceso_cava: "/estate/winery/cava-process",
      proceso_vino: "/estate/winery/wine-process",
      la_almanzara: "/estate/oil-mill",
      proceso_aceite: "/estate/land/oil-process",
      proceso_queso: "/estate/land/cheese-process",
      sala_azafran: "/estate/saffron-room",
      queseria: "/estate/dairy",
      proceso_azafran: "/estate/saffron-room/saffron-process",
      productos: "/products",
      vino: "/products/wine",
      aceite: "/products/olive-oil",
      azafran: "/products/saffron",
      queso: "/products/cheese",
      cava: "/products/cava",
      productos: "/products",
      premios: "/awards",
      beneficios: "/benefits",
      experiencias: "/experiences",
      vive_aldonza: "/experiences/experience-aldonza",
      oleoturismo: "/experiences/experience-aldonza/oleotourism",
      degustacionQuesos: "/experiences/experience-aldonza/cheese-tasting",
      ruta_cervantina: "/experiences/experience-aldonza/cervantes-route",
      enoturismo: "/experiences/experience-aldonza/oenotourism",
      recetario:
        "/experiences/experience-aldonza/recipe-book-and-gastronomy-route",
      escucha_aldonza: "/experiences/listen-to-aldonza",
      contacto: "/home/contact",
      politica_proteccion: "/data-protection-policy",
      politica_cookies: "/cookie-policy",
      datos_seguros: "/your-data-secure",
      aviso_legal: "/legal-notice",
      mapa_web: "/website",
      contactoid: "contact",
      experiencias_13: "https://tienda.aldonzagourmet.com/13-experiencias",
      mejor_bodega_CM:
        "https://blog.aldonzagourmet.com/2024/11/mejor-bodega-de-castilla-lamancha/"
    },
    vistas: {
      inicio: "Start",
      la_finca: "The Estate",
      la_tierra: "The Land",
      la_almazara: "The Oil Mill",
      la_bodega: "The Winery",
      sala_azafran: "Saffron Room",
      productos: "Products",
      queseria: "Cheese factory",
      productos_aldonza: "Aldonza Products",
      premios: "Awards",
      beneficios: "Benefits",
      experiencias: "Experiences",
      oleoturismo: "Oenotourism",
      degustacionQuesos: "The Cheese Ritual",
      vive_aldonza: "Experience Aldonza",
      las_catas: "Tasting:",
      experiencia_bodega: "People who have had the experience:",
      ruta_cervantina: "Cervantes Route",
      enoturismo: "Oenotourism",
      recetario: "Recipe book and gastronomy route",
      escucha_aldonza: "Listen to Aldonza",
      blog: "Blog",
      contacto: "Contact",
      politica_proteccion: "Privacy policy",
      politica_cookies: "Cookie policy",
      mapa_web: "Website",
      datos_seguros: "Secure Data",
      aviso_legal: "Legal Advise",
      canal_etico: "Ethical Channel"
    },
    home: {
      intro: {
        titulo_uno: "The",
        titulo_dos: "Aldonza",
        titulo_tres: "Experience",
        experiencia_aldonza: "Your experience begins",
        aqui: "Start",
        tienda: "Online Shop",
        tarifas: "Price rates"
      },
      comienza: {
        titulo_uno: "Start",
        titulo_dos: "the",
        titulo_tres: "Experience",
        experiencia_aldonza: "Your Aldonza experience",
        cuerpo:
          "Appreciating the subtlety of every movement nature gives us is the origin of the sensations that our wines, sparkling wines, extra virgin olive oil and saffron will awake in you."
      },
      la_finca: {
        titulo_uno: "The",
        titulo_dos: "estate",
        cuerpo:
          "The surroundings are what make the difference in our products. We welcome you to the Navamarín Pastureland.",
        aldonza_experience: "Aldonza Experience"
      },
      productos: {
        titulo: "Products"
      },
      experiencia: {
        titulo_uno: "The",
        titulo_dos: "Experience",
        aldonza_experience: "Aldonza Experience",
        escucha_aldonza: {
          cuerpo:
            "Transport yourself through music to new places that will awaken new sensations in you. Just listen and let yourself be carried away!"
        }
      },
      contacto: {
        titulo: "Contact"
      }
    },
    blog: {
      titulo:
        "<span>The</span> <span>Aldonza Experience</span> <span>continues</span><span>...</span>",
      subtitulo: "Aldonza’s blog",
      boton: "see"
    },
    newsletter: {
      titulo: "Subscribe to our newsletter",
      cuerpo: "News and updates in your email inbox.",
      texto_comunicaciones:
        "I agree to receive the Newsletter or other communications from your entity",
      boton: "Subscribe",
      enviado: "You subscribed correctly!"
    },
    otros_lugares: {
      titulo: "Other locations",
      lugares: {
        la_tierra: "The land",
        la_bodega: "The Winery",
        la_almanzara: "The Oil Mill",
        sala_azafran: "Saffron Room",
        queseria: "Cheese factory"
      }
    },
    la_tierra: {
      descubrir_proceso: "Discover the process",
      la_tierra: {
        cuadro_uno: {
          titulo: "The environment",
          texto:
            "The Navamarín Pastureland is a natural spot more than 1,200 metres high located in the north-east of the province of Albacete (Spain). It has 2,200 hectares of high, middle-height and low countryside, divided between ilex trees and aromatic plants. A unique nook with the best worldwide reserve of juniper trees (Juniperus Sabina), located between the banks of the Guadiana and Jucar rivers."
        },
        cuadro_dos: {
          titulo: "The Land",
          texto_uno:
            "<strong>Soil: </strong>10,000 years ago it was filled by a glacier that caused a large quantity of heaped-up pebbles, which prevent water from evaporating easily.",
          texto_dos:
            "<strong>Ground: </strong>The quality of our products begins in the ground, which is ideal for agriculture. It is characterised by its limestone composition and mid-range permeability, with neutral or slightly alkaline PHs.",
          texto_tres:
            "<strong>Wildlife: </strong>The Navamarín Pastureland has become the habitat of many local species (deer, wild boar and red partridge) and species originating elsewhere (mouflon).  The organic remains left by these animals are a natural fertiliser for our crops.",
          texto_cuatro:
            "<strong>Climate: </strong>Continental with cold winters and hot and very dry summers. Severe climatological conditions that prevent the proliferation of fungi and bacteria that may harm crops.  In the case of vines, the contrast in temperature improves the development of the polyphenols (tannins and anthocyanins) in the maturation stage.",
          texto_cinco:
            "<strong>Junipers: </strong>This tree, thousands of years old, a protected species of oriental origin, provides our fruits with exclusive healthful properties."
        },
        frutos: {
          titulo: "Fruit",
          cuerpo:
            "The high altitude and the severe climatological conditions have a direct impact on the quality of our fruit. We produce different varieties of grape, olive harvests of picual and arbequina and D.O.P. La Mancha saffron."
        },
        escalera: {
          vinedo: {
            titulo: "Vineyards",
            cuerpo:
              "The Navamarín Pastureland has 75 hectares of productive vineyards and another 100 of recent plantation. We cultivate the red varieties Tempranillo, the classic from our region, Cabernet-Sauvignon, Merlot and Syrah, as well as the white varieties Sauvignon-Blanc and Macabeo. The vineyards that provide the grapes for our sparkling wines are located in the Catalan region of Penedés, in the Sadurní D´Anoia (Barcelona) production centre. In this area, known as the Sparkling Wine Region and with D.O. for sparkling wine, we cultivate the Xarel-lo, Macabeo and Parellada varieties. Also, red grapes of the Trepat variety."
          },
          azafranal: {
            titulo: "The saffron fields",
            cuerpo:
              "The land chosen for growing our saffron is an area of dry, flat, aerated limestone soil. A soil with balanced organic material composition, which reduces the risks of erosion. It is also a relatively deep soil, which allows removal of water so that bulbs are not damaged. Saffron normally exhausts the soil every 3 or 4 years, so we rotate the planting area to guarantee saffron of the highest quality year after year."
          },
          olivos: {
            titulo: "Olives",
            cuerpo:
              "Our trees are kept with maintenance procedures that are entirely standardised and regularised. 75 hectares of olives that produce two varieties of olive: Picual and Arbequina. The first is the most widely grown variety in Spain. It represents more than 50% of production and is distinguished by its strong flavour, with a bitter, spicy note. Arbequina is characterised by its resistance to cold and low strength. Sweet and smooth flavour."
          }
        }
      },
      la_almazara: {
        cuadro_uno: {
          titulo: "Facilities",
          texto:
            "We take care of our natural surroundings, without forgetting innovation and new analytic technologies to ensure extra virgin olive oil of the highest quality. Tradition handed down from father to son, commitment to and love of our land are the values that promote the daily success of the Aldonza team.  Aldonza is certified by <a href ='/static/pdf/certificado-IFS.pdf'download ><strong><u>IFS</u></strong></a>  and  <a href ='/static/pdf/certificado-BRC.pdf'download><strong><u>BRC </u></strong> regulations.</a> "
        },
        cuadro_dos: {
          titulo: "The Oil Mill",
          texto:
            "<p>We are part of the whole process of manufacturing of our extra virgin olive oil. We take the greatest care of every single olive and process the fruit with delicacy in our own olive oil mill equipped with sophisticated technology. Fresh and dark stainless steel vats maintain the pure nuances of the aroma and flavour of the olives. We also remain firmly committed to the environment: our machinery has been given the environmental quality seal.</p><p>Not just good taste, but also health. The Aldonza industrial plant is designed to guarantee food safety, which is of the utmost importance in our products. Our logistics capacity stands out. We provide service on time to more than 20 countries. We’re your perfect partner!</p>"
        },
        proceso: {
          titulo: "The process",
          cuerpo:
            "The traditional processing method coexists with modernity, always with exceptional care taken to obtain extra virgin olive oil of the highest quality."
        },
        sala_catas: {
          titulo: "Tasting room",
          cuerpo:
            "Intense, fruity aroma in the nose; in the mouth it is stable and with a precise note of bitterness and spice. We offer professional tastings. The taste of extra virgin olive oil, in oenotourism days with Aldonza.",
          boton_large: "Discover!",
          boton_short: "Discover!"
        }
      },
      sala_azafran: {
        cuadro_uno: {
          titulo: "Our harvest",
          texto:
            "Only saffron grown in Castilla La Mancha bears the <strong>La Mancha Protected Origin Designation (D.O.P.).</strong> This seal of quality is recognised worldwide for its triple guarantee: top-level organoleptic characteristics (colour, aroma and flavour), maximum food safety and Spanish origin. The climatological conditions and the land, with alkaline limestone soil located in the north-west of the province of Albacete, ensure an exceptional harvest with exclusive properties and flavour."
        },
        cuadro_dos: {
          titulo: "Saffron room",
          texto:
            "From growing to bottling, Aldonza has a team of highly-trained professionals who are constantly aiming for the quality and food safety of saffron. In our fields and modern installations, we cultivate, select and artisanally bottle Aldonza saffron. Aldonza is certified by <a href ='/static/pdf/certificado-IFS.pdf'download ><strong><u>IFS</u></strong></a>  and  <a href ='/static/pdf/certificado-BRC.pdf'download><strong><u>BRC </u></strong> regulations.</a>"
        },
        proceso: {
          titulo: "The Process",
          cuerpo:
            "The process of creating saffron is as delicate as the red stamens of the saffron flower. We uphold traditional values and carry out meticulous work in each of the stages of the process."
        },
        sala: {
          titulo: "The room",
          cuerpo:
            "Aldonza saffron belongs to the folk culture of our region. The secrets of its production are part of the heritage that Spanish families from La Mancha have passed down from generation to generation. This process, thousands of years old, lives on in our saffron room."
        }
      },
      la_bodega: {
        cuadro_uno: {
          titulo: "Facilities",
          texto:
            "In the heart of the land of Don Quixote, in the municipality of Munera located in the north-west of the province of Albacete, we have been creating our wine for more than four generations. Our winery and vineyards are part of tradition and legend, from which Miguel de Cervantes drew his inspiration to write many chapters of 'El Quijote'. Aldonza is certified by <a href ='/static/pdf/certificado-IFS.pdf'download ><strong><u>IFS</u></strong></a>  and  <a href ='/static/pdf/certificado-BRC.pdf'download><strong><u>BRC </u></strong> regulations.</a> "
        },
        cuadro_dos: {
          titulo: "The Winery",
          texto:
            " <p>A winery in a family tradition that has incorporated modern facilities equipped with sophisticated machinery. Agricultural tradition and innovation, a perfect combination for developing wines that awake new sensations.</p><p>We take the greatest care over every detail not only in the development of the wine but also in design. Our wine rack has astonishing style "
        },
        proceso: {
          titulo: "The wine process",
          cuerpo:
            "Our goal is to extract the greatness and the high quality of grapes through a careful development process."
        },
        proceso_cava: {
          titulo: "The sparkling wine process",
          cuerpo:
            "We keep alive the traditional sparkling wine method. In the Catalan region of Penedés (Barcelona), with the Denominación de Origen Cava label, we harvest our grapes and prepare our four varieties of sparkling wine."
        },
        sala_barricas: {
          titulo: "Cask room",
          cuerpo:
            "The scent of wood, the aromas of the wine, the sound of a waterfall and the dim light all around will transport you entirely to another place. Built in a wine cellar located below ground in the winery, the Aldonza cask room recalls the quality of our wines. You can taste our products while you enjoy a unique space.",
          boton_large: "Discover Oenotourism!",
          boton_short: "Discover!"
        }
      },
      queseria: {
        cuadro_uno: {
          titulo: "Master craftsmen",

          texto:
            "<p>Designation of Origin Manchego Cheese, made from sheep's milk. Striving daily to offer top quality cheeses which convey the care and attention of the hands which make those cheeses. In addition to traditional methods, the latest technology is used to ensure compliance of the required food safety controls, both for the livestock as well as the quality of the milk.<div class='certificados'><div><a class='link-certificados queso' href='/static/pdf/certificado-SAE.pdf' download >Certificate SAE 2021-0014</a></div></div></p>"
        },
        cuadro_dos: {
          titulo: "Varieties",
          texto:
            "<p>Aldonza Gourmet offers three varieties of cheese, cured, semi-cured and in virgin olive oil, all of these cheeses made from purebred Manchego sheep's milk. Exporting the flavour of our cheeses to the five continents, together with the tradition and culture of a 100% Manchego cheese.</p> "
        },
        proceso: {
          titulo: "Cheese-making process",
          cuerpo: "Following the traditional Manchego cheese process."
        }
      }
    },
    saber_mas: "Know more",
    certificadoBRC: "Certificate BRC",
    certificadoIFS: "Certificate IFS",
    Certificados:
      "Aldonza is certified by <a href ='/static/pdf/certificado-IFS.pdf'download >IFS </a> and <a href ='/static/pdf/certificado-BRC.pdf'download>BRC</a> regulations.",
    Certificados2:
      "Company certified by <a href ='/static/pdf/certificado-IFS.pdf'download >IFS </a> and <a href ='/static/pdf/certificado-BRC.pdf'download>BRC</a> regulations.",
    slider_productos: {
      vino: {
        slug: "wine",
        titulo: "Aldonza wines",
        cuerpo:
          "Flavours with tradition, with a legend. You’ll have a different experience with our four varieties of Aldonza wine. Find out more!",
        button: "Wine"
      },
      aceite: {
        slug: "olive-oil",
        titulo: "Aldonza Olive Oil ",
        cuerpo:
          "You’ll begin to feel it with its aroma alone, the antechamber of the texture and flavour of an outstanding extra virgin olive oil. The result of a careful manufacturing process.",
        button: "Oil"
      },
      azafran: {
        slug: "saffron",
        titulo: "Aldonza saffron",
        cuerpo:
          "The delicate work of the manual process, thousand years old, of shucking saffron, can be seen in the quality of every stigma. Aldonza Saffron, with D.O.P. La Mancha seal of quality.",
        button: "Saffron"
      },
      cava: {
        slug: "cava",
        titulo: "Aldonza Cava",
        cuerpo:
          "Refreshing from the moment when the bubbles rise to the top of the glass of sparkling wine. Different sensations are waiting for you with each of our four varieties of sparkling wine. Experience them!",
        button: "Cava"
      },
      queso: {
        slug: "cheese",
        titulo: "PDO Manchego Cheese",
        cuerpo:
          "The authentic flavour of La Mancha merges with the spirit of taking the food of our land around the world.",
        button: "Cheese"
      }
    },
    slider_proceso: {
      proceso_vino: {
        id: "proceso-del-vino",
        padre: "la_bodega",
        pasos: {
          vendimia: {
            titulo: "Grape harvest",
            cuerpo:
              "<p>When the grape reaches its optimal maturity point, we begin the grape harvest, normally between the end of August and the beginning of September. To avoid high temperatures affecting the fruit and its process of fermentation, we harvest using the traditional system of manual collection at night. The grapes are brought in boxes to the estate and we manually select the best fruit to ensure a wine of the best quality.</p>"
          },
          fermentacion: {
            titulo: "Fermentation and pressing",
            cuerpo:
              "<p>Once the grapes selected have been removed from the stalk, the process of fermentation begins, in completely computerised steel vats. We pay special attention to the pressing of the wine, the stage when we separate the liquid from the solid remains of the grape.</p>"
          },
          crianza: {
            titulo: "Aging",
            cuerpo:
              "<p>Our team of oenologists determines the time that each vintage will spend in the cask. This is always a minimum of six months. This is the point when the red wines acquire their personality in our casks of American or French oak that are located below ground on the estate. The cask room has a balanced level of temperature and humidity throughout the year. When the wine is displaying all its aroma and flavour, we blend, and allow the wine to rest in bottles for the same amount of time it has been in the cask.</p>"
          },
          etiquetado: {
            titulo: "Labelling",
            cuerpo:
              "<p>Our devotion and loyalty to our land and to the wines we create is sealed in the labelling phase. Our logistics department closes the process, sending our wines to the more than 20 countries in which the Aldonza brand is distributed. We are a professional team that monitors and coordinates all the stages of the development process for our product.</p>"
          }
        },
        boton: "Our Wine"
      },
      proceso_cava: {
        id: "proceso-del-cava",
        padre: "la_bodega",
        pasos: {
          vendimia: {
            titulo: "Grape harves",
            cuerpo:
              "<p>After harvesting of the grapes (Xarel·lo, Macabeo, Chardonnay, Parellada and Trepat), there begins the traditional method of producing sparkling wine in the prestigious Sant Sadurní D production centre."
          },
          tiraje: {
            titulo: "'Tiraje'",
            cuerpo:
              "<p>This is the process of filling bottles with the base wine and with a composite of yeast and sugar. These cause the second fermentation in the same bottle and produce the bubbles that characterise this product. The subsequent maturation requires at least 9 months.</p>"
          },
          deguelle: {
            titulo: "'Degüelle'",
            cuerpo:
              "<p>In this phase, we remove the top from the bottle and draw up the yeast, which has congealed prior to this. Subsequently, the expedition liqueur is added. This is the quantity of sugar that will determine if the sparkling wine is Nature, Brut or Semi-sweet.</p>"
          },
          etiquetado: {
            titulo: "Labelling and logistics",
            cuerpo:
              "<p>We are present at all stages of the process of creating the sparkling wine, supervising and ensuring the highest quality standards in all stages.</p>"
          }
        },
        boton: "Our Sparkling Wine"
      },
      proceso_aceite: {
        id: "proceso-del-aceite",
        padre: "la_almanzara",
        pasos: {
          cosecha: {
            titulo: "Harvest",
            cuerpo:
              "<p>It is important to determine the optimal moment for gathering the olives, as maturation is linked to yield, degree of acidity and the organoleptic characteristics of the oil. This is the basis for the success of the high quality of our extra virgin olive oil, our meticulous monitoring of the olive’s maturation process, which we begin in the first days of November. The harvest usually starts at the end of this month or at the beginning of December.  We only harvest healthy fruit that has not fallen to the ground from the tree.</p>"
          },
          recepcion: {
            titulo: "Reception and cleaning",
            cuerpo:
              "<p>We gently transport the olives to our olive mill and verify the sanitary condition of the fruit through an analysis that determines the composition of the olive and will optimise its processing. The preliminary step towards the mill is removing all impurities. The olive is sent through a cleaning machine that uses dry ventilation to remove leaves, stems etc. Next, the fruit enters a washing line that removes any remaining dirt.</p>"
          },
          molienda: {
            titulo: "Milling and beating",
            cuerpo:
              "<p>During the milling phase, we create a mash to break down the physical structure of the olive and be able to carry out the beating phase. The aim of the beating is to promote separation of the oil from the rest of the olive. We subject the olive paste to the action of continuous movement at a temperature above that of the surroundings but always below 25 degrees.</p>"
          },
          extraccion: {
            titulo: "Extraction and purification of the oil",
            cuerpo:
              "<p>Once the olive paste has been beaten, we separate the oil from the rest of the components. Like all techniques, this one has also been advancing and, from the former pressure of filtering discs made of natural fibres, we have moved to extraction using automatic centrifugation, which is faster and more efficient and is also called decanter.</p><p>The paste is subjected to centrifugal force, which separates the various components according to their densities. On leaving the decanter, the oil still contains solid impurities and a certain amount of water. We use vertical centrifugation to separate these components, machines that are much faster and more precise and that reduce the time the oil spends in contact with the impurities and guarantee a more reliable separation.</p>"
          },
          almacenamiento: {
            titulo: "Storage and bottling",
            cuerpo:
              "<p>Once the extra virgin olive oil has been obtained, it is stored in stainless steel vats so that it will remain in perfect condition, protected from potentially damaging circumstances such as light, external odours, the external temperature and even noise. Before it is bottled, earth-filtering takes place fo create a brighter, cleaner oil. In the bottling process we check the organoleptic features of the oil up until the last moment, to ensure that it meets the expectations of our quality standards.</p>"
          }
        },
        boton: "Our Olive Oil"
      },
      proceso_queso: {
        id: "proceso-del-queso",
        padre: "queseria",
        pasos: {
          Ordeño: {
            titulo: "Milking and curdling",
            cuerpo:
              "<p>Immediately after milking the sheep, the milk is refrigerated at a temperature of 4 ºC to preserve all its properties. The milk is then poured into curdling vats and the temperature increased to a constant 30ºC. When the curd obtains the right level of consistency and firmness, it is then cut and the cheese shaped.</p> "
          },
          moldelado: {
            titulo: "Shaping, pressing and salting",
            cuerpo:
              "<p>The curd is placed into molds in the traditional artisanal manner and a numbered and serialised casein label is affixed, in order to identify each piece of Manchego cheese. The cheese is then pressed to completely drain the whey and give it its final shape. After pressing, the product is removed from the mold and the cheese is salted. During salting, the cheeses regulate their microbial process, enhance the flavour and the external rind is formed.</p>"
          },
          maduracion: {
            titulo: "Ripening",
            cuerpo:
              "<p>Our cheeses are aged for 60 to 100 days for semi-cured cheeses and 150 to 210 days for cured cheeses. Ripening chambers maintain controlled temperature and humidity conditions, allowing for the proper ripening of Manchego cheese.</p>"
          }
        },
        boton: "Our Cheese"
      },
      proceso_azafran: {
        id: "sala-del-azafran",
        padre: "sala_azafran",
        pasos: {
          cosecha: {
            titulo: "Harvest",
            cuerpo:
              "<p>The bulbs are planted during the months June to September so that the saffron flower will reach its greatest splendour in the middle of autumn. Our saffron is cultivated in lands that promote a good harvest: dry, with limestone soil, flat, and without tree growth. The soil is not deep and allows removal of water so that bulbs are not damaged.</p>"
          },
          recoleccion: {
            titulo: "Collection",
            cuerpo:
              "<p>The songs and whistling of the field workers can be heard on our plantations before the sun is up. The saffron flower harvest takes place at dawn to avoid the stigmas’ losing their properties from exposure to sunlight. The harvest takes place between the end of October and the beginning of November.</p>"
          },
          monda: {
            titulo: "Peeling",
            cuerpo:
              "<p>This meticulous work is considered a tradition going back thousands of years. The saffron flower arrives back at the houses with the first dew of the morning still on it. Separating the stigmas from the rest of the flower is done manually and is called peeling or unblading. This is the most delicate part of the process. It is very important for the stigma not to be broken so that it arrives whole at the roasting stage. This work is carried out during a period that does not exceed two hours from its gathering in the field.</p>"
          },
          tostado: {
            titulo: "Roasting",
            cuerpo:
              "<p>The saffron is roasted over a slow fire. The drying and roasting process of the stigmas is done to maintain the saffron in perfect condition and preserve all of its flavour. This is a crucial stage, since it determines characteristics of the product such as its moisture, colouring power, aroma and stability. </p>"
          },
          almacenamiento: {
            titulo: "Storage",
            cuerpo:
              "<p>The roasted saffron is quickly stored in packaging that keeps it away from moisture and light. It is also kept at an environmental temperature of less than 25ºC. The packaging is done by hand.</p></p>"
          }
        },
        boton: "Our Saffron"
      }
    },
    productos_banner: {
      title: "Products",
      productos: {
        vino: "Wine",
        aceite: "Oil",
        azafran: "Saffron",
        cava: "Sparkling-wine",
        queseria: "Cheese"
      }
    },
    tips_productos: {
      tipo_vino: "Type of wine:",
      tipo_uva: "Type of grape:",
      tipo_cava: "Sparkling wine:",
      elaboracion: "Creation:",
      gastronomia: "Gastronomy:",
      notas_cata: "Tasting marks:",
      premios: "Awards:",
      ingredientes: "Ingredients:",
      caracteristicas: "Features:",
      maridaje: "Goes well with",
      descargar_ficha: "Download file",
      curacion: "Curing",
      apariencia: "Appearance",
      conservacion: "Conservation",
      durabilidad: "Shelf life",
      alergenos: "Allergens",
      valoresnutricionales: "Nutrional Values"
    },
    productos: {
      vino: {
        slug: "vino",
        nombre: "Wine",
        intro_ficha: {
          titulo: "Awaken sensations",
          cuerpo:
            "<p>Our wine is the essence of the special characteristics of the land and the region where it is cultivated, the Navamarin Pastureland. It is the dedication and the soul of expert hands. The fingerprint of the vine-growing tradition of the lands of Don Quixote. Wines with personality, created from French and Spanish grape varieties. Wines with passion, with soul. Wines that awaken sensations.</p>"
        },
        intro_productos:
          "<span>Don’t wait for the perfect moment.<br>Simply look for the moment and make it perfect</span>",
        productos: {
          navamarin: {
            id: "navamarin",
            nombre: "Navamarín",
            tipo_vino:
              "Red wine cask Minimum aging of 12 months. Cask of French and American wood.",
            tipo_uva: "Cabernet Sauvignon, Merlot, Syrah, Tempranillo",
            elaboracion:
              "Wine created in the Navamarín Pastureland, a special nook with the largest juniper reserve in the world, which gives the wine exclusive properties and aromas. Careful selection of grapes in productions that do not exceed 2 Kg per vine.  Coupage is done once cask aging is finished.",
            graduacion: "13,5 - 14,5% Vol. (according to vintage).",
            cantidad: "750ml",
            servicio: "Between 16º - 18º C.",
            gastronomia: "Goes well with meats, stews, game and cheeses.",
            notas_cata: {
              texto:
                "Tons of sweet blackberries here, but also generous dry tannins that fill out the medium-to full-bodied palate nicely, then a long, dry and savory finish. Drink now or hold.",
              autor: "James Suckling"
            },
            premios: [
              "navamarin-pswc-2011",
              "navamarin-berliner-2015",
              "navamarin-china-wine-2015",
              "navamarin-china-wine-2016",
              "navamarin-corea-wine-2015",
              "navamarin-corea-wine-2016",
              "navamarin-bruselas-2013",
              "navamarin-zarcillo-2007",
              "navamarin-testing-2014",
              "navamarin-wswa-2014",
              "navamarin-houston-2015",
              "navamarin-vinalies-2011",
              "navamarin-londres-2013",
              "navamarin-decanter-2013",
              "navamarin-mundus-2018",
              "navamarin-suckling-2018",
              "navamarin-suckling-2019",
              "navamarin-decanter-bronce-2019",
              "navamarin-mundus-2020",
              "navamarin-mundus-2021",
              "navamarin-penin-2023",
              "navamarin-bruselas-2022",
              "navamarin-londres-2022-2",
              "navamarin-bruxelles-2023",
              "navamarin-alemania-2026"
            ]
          },
          selection: {
            id: "seleccion",
            nombre: "Selection",
            tipo_vino:
              "Red wine cask Minimum aging of 9 months. Cask of American and French wood.",
            tipo_uva: "Cabernet Sauvignon, Merlot, Syrah, Tempranillo",
            elaboracion:
              "Created on the basis of a careful selection of grapes from rare strains of vine and gathered during the night at their ideal maturation point. Coupage occurs once cask aging is finished, for a better blend. It remains in the bottle for 12 months in the darkness of our wine cellar.",
            graduacion: "13,5 - 14% Vol. (according to vintage).",
            cantidad: "750 ml",
            servicio: "Between 16º - 18º C.",
            gastronomia: "Good pairing with meats, stews, game and cheeses.",
            notas_cata: {
              texto:
                "Intensive red cherry colour of upper layer. Intense mature red fruit aromas with roasts, vanilla and dry fruits. Large in mouth, good body tasting and perfect assembly, it leaves intense long persistent end of mouth.",
              autor: ""
            },
            premios: [
              "seleccion-pswc-2011",
              "seleccion-testing-2014",
              "seleccion-wswa-2014",
              "seleccion-burdeos-2008",
              "seleccion-vinalies-2009",
              "seleccion-vinalies-2012",
              "seleccion-decanter-2017",
              "seleccion-suckling-2019",
              "seleccion-decanter-bronce-2019",
              "seleccion-2022",
              "seleccion-neustadt-2025",
              "seleccion-mexico-2025"
            ]
          },
          classic: {
            id: "clasico",
            nombre: "Classic",
            tipo_vino:
              "Red wine cask Minimum aging of 6 months. Cask of French and American wood.",
            tipo_uva: "Cabernet Sauvignon, Merlot, Syrah, Tempranillo",
            elaboracion:
              "Traditional development process that follows the classic method of making wine that was formerly used in the Castilla La Mancha region. Careful selection of the highest-quality grapes. During the aging period, it remains in the bottle for at least six months before being made available for purchase.",
            graduacion: "13 - 14% Vol. (according to vintage).",
            cantidad: "750 ml",
            servicio: "Between 16º - 18º C.",
            gastronomia:
              "Ideal for all types of sausage, meat, casseroles, rice and pasta dishes.",
            notas_cata: {
              texto:
                "Very rich red and dark fruit here with a palate that delivers red licorice flavors, amid supple, finegrained tannin. Drink now",
              autor: "James Suckling"
            },
            premios: [
              "clasico-testing-2014",
              "clasico-wswa-2014",
              "clasico-houston-2015",
              "clasico-decanter-2017",
              "clasico-berliner-2018",
              "clasico-bacchus-2018",
              "clasico-suckling-2018",
              "clasico-suckling-2019",
              "clasico-cwsa-2018",
              "clasico-mundus-2021",
              "clasico-penin-2023",
              "clasico-neustadt-2025",
              "clasico-alemania-2026"
            ]
          },
          albo: {
            id: "albo",
            nombre: "Albo",
            tipo_vino: "White Young",
            tipo_uva: "Sauvignon Blanc, Macabeo",
            elaboracion:
              "After harvesting, a slight maceration occurs with monitoring of yeast and fermentation temperatures, creating a richness of aromas and an exquisite fruit flavour.",
            graduacion: "12 - 13% Vol. (according to vintage)",
            cantidad: "750 ml",
            servicio: "Between 4º - 6º C.",
            gastronomia:
              "Ideal to accompany shellfish, fish and dessert dishes.",
            notas_cata: {
              texto:
                "Shining and clean presence with pale yellow tone. In nose it is rich in fruit aromas, banana, peach, maracuya and floral aromas such as orange blossom and jasmine. In mouth it is silky and well - balanced. A long soft, warming finish with flavours that go on and on.",
              autor: ""
            },
            premios: [
              "albo-berliner-2016",
              "albo-testing-2014",
              "albo-suckling-2019",
              "albo-neustadt-2025",
              "albo-mexico-2025"
            ]
          }
        },
        banner_premios: {
          titulo: "Award winning wines",
          boton: "All awards",
          premio: "navamarin-bruxelles-2023"
        },
        premios: {
          titulo:
            "International awards and critiques from prestigious sommeliers",
          premios: {
            "navamarin-pswc-2011": {
              titulo: "Aldonza Navamarín",
              posicion: "Second Prize",
              texto:
                "2006 vintage, awarded the Silver Medal at 2011’s Pro Wein PSWC, Mainz (Germany).",
              categoria: "International",
              pais: "Germany",
              anyada: "2006",
              anyo: "2011"
            },
            "seleccion-pswc-2011": {
              titulo: "Aldonza Selección",
              posicion: "Second Prize",
              texto:
                "2006 vintage, awarded the Silver Medal at 2011’s Pro Wein PSWC, Mainz (Germany).",
              categoria: "International",
              pais: "Germany",
              anyada: "2006",
              anyo: "2011"
            },
            "navamarin-berliner-2015": {
              titulo: "Aldonza Navamarín",
              posicion: "First Prize",
              texto:
                "2009 vintage, awarded the Gold Medal at the 2015 Berliner Wein Trophy, Berlin (Germany).",
              categoria: "International",
              pais: "Germany",
              anyada: "2009",
              anyo: "2015",
              doble: true
            },
            "albo-berliner-2016": {
              titulo: "Aldonza Albo",
              posicion: "First Prize",
              texto:
                "2015 vintage, awarded the Gold Medal at the 2016 Berliner Wein Trophy, Berlin (Germany).",
              categoria: "International",
              pais: "Germany",
              anyada: "2015",
              anyo: "2016",
              doble: true
            },
            "pisces-mondiales-2008": {
              titulo: "Aldonza Pisces",
              posicion: "Second Prize",
              texto:
                "2006 vintage, awarded the Silver Medal at the 2008 World Wine Selections, Quebec (Canada).",
              categoria: "International",
              pais: "canada",
              anyada: "2006",
              anyo: "2008"
            },
            "navamarin-china-wine-2015": {
              titulo: "Aldonza Navamarín",
              posicion: "First Prize",
              texto:
                "2009 vintage, awarded the Gold Medal at the 2015 China Wine Spirit Awards, Hong Kong (China).",
              categoria: "International",
              pais: "china",
              anyada: "2009",
              anyo: "2015"
            },
            "navamarin-china-wine-2016": {
              titulo: "Aldonza Navamarín",
              posicion: "First Prize",
              texto:
                "2010 vintage, awarded the Gold Medal at the 2016 China Wine Spirit Awards, Hong Kong (China).",
              categoria: "International",
              pais: "china",
              anyada: "2010",
              anyo: "2016"
            },
            "navamarin-corea-wine-2015": {
              titulo: "Aldonza Navamarín",
              posicion: "First Prize",
              texto:
                "2009 vintage, awarded the Gold Medal at the 2015 Asia Wine &amp, Daejeon (South Korea).",
              categoria: "International",
              pais: "korea",
              anyada: "2009",
              anyo: "2015",
              doble: true
            },
            "navamarin-corea-wine-2016": {
              titulo: "Aldonza Clásico",
              posicion: "Second Prize",
              texto:
                "2008 vintage, awarded the Silver Medal at the 2016 Asia WineTrophy, Daejeon (South Korea).",
              categoria: "International",
              pais: "korea",
              anyada: "2008",
              anyo: "2016",
              doble: true
            },
            "navamarin-bruselas-2013": {
              titulo: "Aldonza Navamarín",
              posicion: "First Prize",
              texto:
                "2008 vintage, awarded the Gold Medal at the 2013 Concours Mondial de Bruxelles, Bratislava (Slovakia).",
              categoria: "International",
              pais: "Slovakia",
              anyada: "2008",
              anyo: "2013"
            },
            "pisces-ljubljana-2008": {
              titulo: "Aldonza Pisces",
              posicion: "Second Prize",
              texto:
                "2006 vintage awarded the Silver Medal at the 2008 Ljubljana International Wine Competition, Ljubljana (Slovenia).",
              categoria: "International",
              pais: "Slovenia",
              anyada: "2006",
              anyo: "2008"
            },
            "pisces-bacchus-2006": {
              titulo: "Aldonza Pisces",
              posicion: "Second Prize",
              texto:
                "2004 vintage awarded the 2006 International Silver Bacchus, Madrid (Spain).",
              categoria: "International",
              pais: "Spain",
              anyada: "2004",
              anyo: "2006"
            },
            "navamarin-zarcillo-2007": {
              titulo: "Aldonza Navamarín",
              posicion: "First Prize",
              texto:
                "2004 vintage awarded the 2007 Golden Tendril in Valladolid (Spain).",
              categoria: "National",
              pais: "Spain",
              anyada: "2004",
              anyo: "2007"
            },
            "pisces-bacchus-2008": {
              titulo: "Aldonza Pisces",
              posicion: "Second Prize",
              texto:
                "2006 vintage awarded the 2008 International Silver Bacchus, Madrid (Spain).",
              categoria: "International",
              pais: "Spain",
              anyada: "2006",
              anyo: "2008"
            },
            "navamarin-testing-2014": {
              titulo: "Aldonza Navamarín",
              posicion: "First Prize",
              texto:
                "2007 vintage, awarded the Gold Medal at the 2014 'Beverage Testing Institute' in Chicago (United States).",
              categoria: "International",
              pais: "eeuu",
              anyada: "2007",
              anyo: "2014"
            },
            "seleccion-testing-2014": {
              titulo: "Aldonza Selección",
              posicion: "First Prize",
              texto:
                "2007 vintage, awarded the Gold Medal at the 2014 'Beverage Testing Institute' in Chicago (United States).",
              categoria: "International",
              pais: "eeuu",
              anyada: "2007",
              anyo: "2014"
            },
            "clasico-testing-2014": {
              titulo: "Aldonza Clásico",
              posicion: "First Prize",
              texto:
                "2007 vintage, awarded the Gold Medal at the 2014 'Beverage Testing Institute' in Chicago (United States).",
              categoria: "International",
              pais: "eeuu",
              anyada: "2007",
              anyo: "2014"
            },
            "albo-testing-2014": {
              titulo: "Aldonza Albo",
              posicion: "First Prize",
              texto:
                "2013 vintage, awarded the Gold Medal at the 2014'Beverage Testing Institute'in Chicago (United States).",
              categoria: "International",
              pais: "eeuu",
              anyada: "2013",
              anyo: "2014"
            },
            "navamarin-wswa-2014": {
              titulo: "Aldonza Navamarín",
              posicion: "First Prize",
              texto:
                "2008 vintage, awarded the Supreme Gold Medal at the WSWA 71st Annual Convention Exposition 2014, Las Vegas (United States).",
              categoria: "International",
              pais: "eeuu",
              anyada: "2008",
              anyo: "2014"
            },
            "clasico-wswa-2014": {
              titulo: "Aldonza Clásico",
              posicion: "Second Prize",
              texto:
                "2008 vintage, awarded the Supreme Gold Medal at the WSWA 71st Annual Convention Exposition 2014, Las Vegas (United States).",
              categoria: "International",
              pais: "eeuu",
              anyada: "2008",
              anyo: "2014"
            },
            "seleccion-wswa-2014": {
              titulo: "Aldonza Selección",
              posicion: "Second Prize",
              texto:
                "2008 vintage, awarded the Supreme Silver Medal at the WSWA 71st Annual Convention Exposition 2014, Las Vegas (United States).",
              categoria: "International",
              pais: "eeuu",
              anyada: "2008",
              anyo: "2014"
            },
            "navamarin-houston-2015": {
              titulo: "Aldonza Navamarín",
              posicion: "Third prize",
              texto:
                "2008 vintage, awarded the Bronze Medal at 'Houston Livestock Show and Rodeo' in the 2015 edition, Houston (Estados Unidos).",
              categoria: "International",
              pais: "eeuu",
              anyada: "2008",
              anyo: "2015"
            },
            "clasico-houston-2015": {
              titulo: "Aldonza Clásico",
              posicion: "Third prize",
              texto:
                "2007 vintage, awarded the Bronze Medal at 'Houston Livestock Show and Rodeo' in the 2015 edition, Houston (Estados Unidos).",
              categoria: "International",
              pais: "eeuu",
              anyada: "2007",
              anyo: "2015"
            },
            "seleccion-burdeos-2008": {
              titulo: "Aldonza Selección",
              posicion: "Second Prize",
              texto:
                "2005 vintage awarded the Silver Medal at the 2008 International Wine Challenge, Bordeaux (France).",
              categoria: "International",
              pais: "France",
              anyada: "2005",
              anyo: "2008"
            },
            "seleccion-vinalies-2009": {
              titulo: "Aldonza Selección",
              posicion: "Second Prize",
              texto:
                "2006 vintage awarded the Gold Medal at the 2009 Vinalies Internationales, 2nd most significant global competition, Paris (France). ",
              categoria: "International",
              pais: "France",
              anyada: "2006",
              anyo: "2009"
            },
            "navamarin-vinalies-2011": {
              titulo: "Aldonza Navamarín",
              posicion: "Second Prize",
              texto:
                "2007 vintage, awarded the Silver Medal at the 2011 Vinalies Internationales, Paris (France).",
              categoria: "International",
              pais: "France",
              anyada: "2007",
              anyo: "2011"
            },
            "navamarion-citadelles-2006": {
              titulo: "Aldonza Navamarín",
              posicion: "Second Prize",
              texto:
                "2006 vintage, awarded the Silver Medal at the 2011 Les Citadelles du Vin, Bordeaux (France).",
              categoria: "International",
              pais: "France",
              anyada: "2006",
              anyo: "2011"
            },
            "seleccion-vinalies-2012": {
              titulo: "Aldonza Selección",
              posicion: "Second Prize",
              texto:
                "2007 vintage, awarded the Silver Medal at the 2012 Vinalies Internationales, Paris (France).",
              categoria: "International",
              pais: "France",
              anyada: "2007",
              anyo: "2012"
            },
            "pisces-tokio-2008": {
              titulo: "Aldonza Pisces",
              posicion: "Second Prize",
              texto:
                "2006 vintage awarded the Silver Medal at the most prestigious International Competition in Asia, 2008 edition, Tokyo (Japan).",
              categoria: "International",
              pais: "Japan",
              anyada: "2006",
              anyo: "2008"
            },
            "navamarin-londres-2013": {
              titulo: "Aldonza Navamarín",
              posicion: "Third Prize",
              texto:
                "2008 vintage, awarded the Bronze Medal at the 2013  International Wine Challenge, London (United Kingdom).",
              categoria: "International",
              pais: "uk",
              anyada: "2008",
              anyo: "2013"
            },
            "navamarin-decanter-2013": {
              titulo: "Aldonza Navamarín",
              posicion: "Recommended wine",
              texto:
                "2008 vintage, recommended wine at the 2013 Decanter World Wine Awards, London (United Kingdom).",
              categoria: "International",
              pais: "uk",
              anyada: "2008",
              anyo: "2013"
            },
            "pisces-decanter-2013": {
              titulo: "Aldonza Pisces",
              posicion: "Recommended wine",
              texto:
                "2008 vintage, recommended wine at the 2013 Decanter World Wine Awards, London (United Kingdom).",
              categoria: "International",
              pais: "uk",
              anyada: "2008",
              anyo: "2013"
            },
            "clasico-decanter-2017": {
              titulo: "Aldonza Clásico",
              posicion: "Recommended wine",
              texto:
                "2011 vintage, recommended wine at the 2017 Decanter Asia Wine Awards, Hong Kong (China).",
              categoria: "International",
              pais: "china",
              anyada: "2011",
              anyo: "2017"
            },
            "seleccion-decanter-2017": {
              titulo: "Aldonza Selección",
              posicion: "Recommended wine",
              texto:
                "2011 vintage, recommended wine at the 2017 Decanter Asia Wine Awards, Hong Kong (China).",
              categoria: "International",
              pais: "China",
              anyada: "2011",
              anyo: "2017"
            },
            "clasico-berliner-2018": {
              titulo: "Aldonza Clásico",
              posicion: "First Prize",
              texto:
                "2011 vintage, awarded the Gold Medal at the 2018 Berliner Wein Trophy, Berlin (Germany).",
              pais: "Germany",
              anyada: "2011",
              anyo: "2018",
              doble: true
            },
            "navamarin-mundus-2018": {
              titulo: "Aldonza Navamarín",
              posicion: "First Prize",
              texto:
                "2012 vintage awarded the Gold Medal at the Grand International Wine Award Mundus Vini, 2018, Berlin (Germany).",
              categoria: "International",
              pais: "Germany",
              anyada: "2012",
              anyo: "2018"
            },
            "clasico-bacchus-2018": {
              titulo: "Aldonza Clásico",
              posicion: "Second Prize",
              texto:
                "2011 vintage awarded the International Silver Bacchus at the XVI International Wine Competition, 2018, Madrid (Spain).",
              categoria: "International",
              pais: "Spain",
              anyada: "2011",
              anyo: "2018"
            },
            "navamarin-suckling-2018": {
              titulo: "Aldonza Navamarín",
              posicion: "90 Points",
              texto:
                "2012 vintage, scored by James Suckling (USA) at the celebrated wine tasting in 2018 at El Priorato (Spain).",
              categoria: "International",
              pais: "eeuu",
              anyada: "2012",
              anyo: "2018"
            },
            "clasico-suckling-2018": {
              titulo: "Aldonza Clásico",
              posicion: "90 Points",
              texto:
                "2011 vintage, scored by James Suckling (USA) at the celebrated wine tasting in 2018 at El Priorato (Spain).",
              categoria: "International",
              pais: "eeuu",
              anyada: "2011",
              anyo: "2018"
            },
            "clasico-cwsa-2018": {
              titulo: "Aldonza Clásico",
              posicion: "First Prize",
              texto:
                "2011 vintage, awarded the Gold Medal at the 2018 China Wine Spirits Awards, Hong Kong (China).",
              categoria: "International",
              pais: "China",
              anyada: "2011",
              anyo: "2018"
            },
            "navamarin-decanter-bronce-2019": {
              titulo: "Aldonza Navamarín",
              posicion: "Third Prize",
              texto:
                "2012 vintage, winner of the Bronze Medal at the 2019 Decanter World Wine Awards, London (United Kingdom).",
              categoria: "International",
              pais: "uk",
              anyada: "2012",
              anyo: "2019"
            },
            "seleccion-decanter-bronce-2019": {
              titulo: "Aldonza Selección",
              posicion: "Third Prize",
              texto:
                "2012 vintage, winner of the Bronze Medal at the 2019 Decanter World Wine Awards, London (United Kingdom).",
              categoria: "International",
              pais: "uk",
              anyada: "2012",
              anyo: "2019"
            },
            "albo-suckling-2019": {
              titulo: "Aldonza Albo",
              posicion: "87 Points",
              texto:
                "2018 vintage, scored by James Suckling (USA) at the celebrated wine tasting in 2018 at La Rioja (Spain).",
              categoria: "International",
              pais: "eeuu",
              anyada: "2018",
              anyo: "2018"
            },
            "seleccion-suckling-2019": {
              titulo: "Aldonza Selección",
              posicion: "89 Points",
              texto:
                "2014 vintage, scored by James Suckling (USA) at the celebrated wine tasting in 2018 at La Rioja (Spain).",
              categoria: "International",
              pais: "eeuu",
              anyada: "2014",
              anyo: "2018"
            },
            "clasico-suckling-2019": {
              titulo: "Aldonza Clásico",
              posicion: "90 Points",
              texto:
                "2014 vintage, scored by James Suckling (USA) at the celebrated wine tasting in 2018 at La Rioja (Spain).",
              categoria: "International",
              pais: "eeuu",
              anyada: "2014",
              anyo: "2018"
            },
            "navamarin-suckling-2019": {
              titulo: "Aldonza Navamarín",
              posicion: "91 Points",
              texto:
                "2013 vintage, scored by James Suckling (USA) at the celebrated wine tasting in 2018 at La Rioja (Spain).",
              categoria: "International",
              pais: "eeuu",
              anyada: "2013",
              anyo: "2018"
            },
            "navamarin-mundus-2020": {
              titulo: "Aldonza Navamarín",
              posicion: "Second Prize",
              texto:
                "2013 vintage awarded the Silver Medal at the Grand International Wine Award Mundus Vuni, 2020, Neustadt (Germany)",
              categoria: "Internacional",
              pais: "alemania",
              anyada: "2020",
              anyo: "2020"
            },
            "navamarin-mundus-2021": {
              titulo: "Aldonza Navamarín",
              posicion: "Medalla de Oro",
              texto:
                "2013 vintage awarded the Gold Medal at the Grand International Wine Award Mundus Vini, 2021, Neustadt (Germany).",
              categoria: "Internacional",
              pais: "alemania",
              anyada: "2013",
              anyo: "2021"
            },
            "clasico-mundus-2021": {
              titulo: "Aldonza Clásico",
              posicion: "Medalla de Oro",
              texto:
                "2015 vintage awarded the Gold Medal at the Grand International Wine Award Mundus Vini, 2021, Neustadt (Germany).",
              categoria: "Internacional",
              pais: "alemania",
              anyada: "2013",
              anyo: "2021"
            },

            "clasico-penin-2023": {
              titulo: "Aldonza Clásico",
              posicion: "Guía Peñín 2023",
              texto:
                "2015 vintage, scored according to the Peñín Guide at the celebrated wine tasting in February 2022 in Spain.",
              categoria: "Nacional",
              pais: "España",
              anyada: "2022",
              anyo: "2022"
            },
            "navamarin-penin-2023": {
              titulo: "Aldonza Navamarín",
              posicion: "Guía Peñín 2023",
              texto:
                "2013 vintage, scored according to the Peñín Guide at the celebrated wine tasting in February 2022 in Spain.",
              categoria: "Nacional",
              pais: "España",
              anyada: "2022",
              anyo: "2022"
            },
            "navamarin-bruselas-2022": {
              titulo: "Aldonza Navamarín",
              posicion: "Grand Gold Medal 2022",
              texto:
                "2013 vintage, awarded the Grand Gold Medal in the Concours Mondial de Bruxelles in the edition of 2022 celebrated in Cosenza (Italy).  ",
              categoria: "Internacional",
              pais: "Bruselas",
              anyada: "2022",
              anyo: "2022"
            },
            "navamarin-londres-2022-2": {
              titulo: "Aldonza Navamarín",
              posicion: "91 Points",
              texto:
                "2013 vintage, winner of the Silver Medal at the 2022 Decanter World Wine Awards, London (United Kingdom).",
              categoria: "Internacional",
              pais: "uk",
              anyada: "2013",
              anyo: "2022"
            },
            "navamarin-bruxelles-2023": {
              titulo: "Aldonza Navamarín",
              posicion: "91 Puntos",
              texto:
                "2014 vintage, winner of the Gold Medal at the 2023 Concours Mondial de Bruxelles, Istria (Croatia). ",
              categoria: "Internacional",
              pais: "uk",
              anyada: "2014",
              anyo: "2023"
            },
            "seleccion-2022": {
              titulo: "Aldonza Selección",
              posicion: "91 Puntos",
              texto:
                "2015 vintage, winner of the Silver Medal at the 2023 Concours Mondial de Bruxelles, Istria (Croatia). ",
              categoria: "Internacional",
              pais: "uk",
              anyada: "2015",
              anyo: "2023"
            },
            "albo-neustadt-2025": {
              titulo: "Aldonza Albo",
              posicion: "87 Puntos",
              texto:
                "2024 vintage awarded the Gold Medal at the Grand International Wine Award Mundus Vini, 2025, Neustadt (Germany).",
              categoria: "Internacional",
              pais: "alemania",
              anyada: "2024",
              anyo: "2025"
            },
            "clasico-neustadt-2025": {
              titulo: "Aldonza Clásico",
              posicion: "87 Puntos",
              texto:
                "2022 vintage awarded the Gold Medal at the Grand International Wine Award Mundus Vini, 2025, Neustadt (Germany).",
              categoria: "Internacional",
              pais: "alemania",
              anyada: "2022",
              anyo: "2025"
            },
            "seleccion-neustadt-2025": {
              titulo: "Aldonza Selección",
              posicion: "87 Puntos",
              texto:
                "2022 vintage awarded the Silver Medal at the Grand International Wine Award Mundus Vini, 2025, Neustadt (Germany).",
              categoria: "Internacional",
              pais: "alemania",
              anyada: "2022",
              anyo: "2025"
            },
            "albo-mexico-2025": {
              titulo: "Aldonza Albo",
              posicion: "87 Puntos",
              texto:
                "2024 vintage awarded the Silver Medal at the Global Wine, 2025, Mexico.",
              categoria: "Internacional",
              pais: "mexico",
              anyada: "2024",
              anyo: "2025"
            },
            "seleccion-mexico-2025": {
              titulo: "Aldonza Selección",
              posicion: "89 Puntos",
              texto:
                "2022 vintage awarded the Gold Medal at the Global Wine, 2025, Mexico.",
              categoria: "Internacional",
              pais: "mexico",
              anyada: "2022",
              anyo: "2025"
            },
            "clasico-alemania-2026": {
              titulo: "Aldonza Clásico",
              posicion: "90 Puntos",
              texto:
                "2022 vintage awarded the Gold Medal at Mundus Vini, 2026, Germany.",
              categoria: "Internacional",
              pais: "alemania",
              anyada: "2022",
              anyo: "2026"
            },
            "navamarin-alemania-2026": {
              titulo: "Aldonza Navamarín",
              posicion: "91 Puntos",
              texto:
                "2017 vintage awarded the Silver Medal at Mundus Vini, 2026, Germany.",
              categoria: "Internacional",
              pais: "alemania",
              anyada: "2017",
              anyo: "2026"
            },
          }
        },
        banner_beneficios: {
          titulo: "Do you know the benefits and the proven qualities of wine?",
          boton: "Discover the benefits"
        },
        banner_experiencia: {
          titulo: "Want to know more?",
          boton: "Discover oenotourism",
          enlace: "enoturismo"
        },
        beneficios: {
          titulo: "Benefits<br>and proven qualities of wine",
          list: [
            {
              titulo: "Slimming",
              cuerpo:
                "The consumption of red wine activates the function of a gene that prevents the formation of new fat cells and helps to mobilise the ones already in existence."
            },
            {
              titulo: "Dental health",
              cuerpo:
                "Certain components of the wine halt the growth in the mouth of streptococci and bacteria linked to dental caries. It also prevents gingivitis and sore throats."
            },
            {
              titulo: "Cognitive function",
              cuerpo:
                "The high level of antioxidants in wine prevents hardening of the arteries and prevents clotting, lowering the risk of a bleed on the brain."
            },
            {
              titulo: "Enjoyment",
              cuerpo:
                "During the enjoyment of wine, endorphins are released in two areas of the brain, which cause an increased sensation of enjoyment."
            },
            {
              titulo: "Exercise",
              cuerpo:
                "The grape’s reservatrol reduces the negative consequences of a sedentary lifestyle."
            },
            {
              titulo: "Mouth cleaner",
              cuerpo:
                "When drunk while you are eating, wine helps you to perceive taste better. This is due to its astringent properties, which avoid the excessive feeling of greasiness caused by food such as red meat and allow you to taste and enjoy food to a greater extent."
            },
            {
              titulo: "Anti-cancer",
              cuerpo:
                "Wine, specifically red wine, helps to reduce the risk of lung cancer in men. It also blocks the growth of the cells that cause breast cancer in women. Once again, reservatrol is responsible for such exceptional quality."
            },
            {
              titulo: "Heart",
              cuerpo:
                "One or two glasses of wine per day contribute to increasing the levels of ‘good’ cholesterol in the blood and prevent cardiovascular complications."
            },
            {
              titulo: "Prostate",
              cuerpo:
                "It has been shown that seven glasses of wine per week after the age of 40 cut prostate cancer diagnoses by more than half."
            },
            {
              titulo: "Healthy lifestyle",
              cuerpo:
                "From the social point of view, various statistics demonstrate that wine lovers have healthier diets than aficionados of other drinks, such as consumers of beer or soda. Wine aficionados tend to consume more olives, fruit, vegetables, low-fat cheese, milk and healthy meat."
            }
          ]
        }
      },
      aceite: {
        slug: "aceite",
        nombre: "Olive Oil",
        intro_productos: "<span>Make incredible things happen today</span>",
        intro_ficha: {
          titulo: "When you love what you do",
          cuerpo:
            "<p>An extra virgin olive oil is obtained that expresses all the aromatic qualities and the flavour of the picual and arbequina varieties. With the confidence of the many health-giving properties that are attributed to extra virgin olive oil.</p> <p>The origin and a fundamental pillar of the Mediterranean diet, extra virgin olive oil has been in use since ancient times. This is demonstrated by the cultural legacy that has arrived at our day surrounding olives, their cultivation and methods of processing them. Many ancient civilisations called it liquid gold.</p>"
        },
        productos: {
          glass: {
            id: "vidrio",
            nombre: "Glass",
            descripcion:
              "Extra virgin olive oil made from Picual and Arbequina olives using the cold press process.",
            ingredientes:
              "100% Extra Virgin Olive Oil. Contains no additives of any kind.",
            notas_cata: {
              texto:
                "An oil with a big personality, very stable over time with a medium-range fruity flavour with green notes of tomato, fresh grass and scents of dry fruit. A sweet touch of fig and plantain. In the mouth it is a very smooth oil whose balance of acidity and sweetness stands out, finishing with a spicy touch that lingers as it moves through the mouth."
            },
            cantidades: ["750ml", "500ml", "250ml"],
            premios: [
              "granprestigio-mendoza-2016",
              "olivinus-mendoza-2016",
              "olivinusninos-mendoza-2016",
              "feria-habana-2016"
            ]
          },
          metal: {
            id: "metal",
            nombre: "Metal",
            descripcion:
              "Extra virgin olive oil made from Picual and Arbequina olives using the cold press process.",
            ingredientes:
              "100% Extra Virgin Olive Oil. Contains no additives of any kind.",
            notas_cata: {
              texto:
                "An oil with a big personality, very stable over time with a medium-range fruity flavour with green notes of tomato, fresh grass and scents of dry fruit. A sweet touch of fig and plantain. In the mouth it is a very smooth oil whose balance of acidity and sweetness stands out, finishing with a spicy touch that lingers as it moves through the mouth."
            },
            cantidades: ["1L", "5L"],
            premios: [
              "granprestigio-mendoza-2016",
              "olivinus-mendoza-2016",
              "olivinusninos-mendoza-2016",
              "feria-habana-2016"
            ]
          }
        },
        banner_premios: {
          titulo: "Award winning olive oil",
          boton: "All Awards",
          premio: "granprestigio-mendoza-2016"
        },
        premios: {
          titulo: "Awards and recommendations",
          premios: {
            "granprestigio-mendoza-2016": {
              titulo: "World Olive Oil Competition",
              posicion: "",
              texto:
                "Gran Prestigio Oro Olivinus at the ‘Olivinus 2016’ International Olive Oil Competition in Mendoza (Argentina).",
              categoria: "International",
              pais: "Argentina",
              anyada: "",
              anyo: "2016"
            },
            "olivinus-mendoza-2016": {
              titulo: "World Olive Oil Competition",
              posicion: "",
              texto:
                "93 Olivinus Points at the ‘Olivinus 2016’ International Olive Oil Competition in Mendoza (Argentina).",
              categoria: "International",
              pais: "Argentina",
              anyada: "",
              anyo: "2016"
            },
            "olivinusninos-mendoza-2016": {
              titulo: "World Olive Oil Competition",
              posicion: "",
              texto:
                "Children’s Olivinus Competition ‘Olivinus 2016’, selected by children in Mendoza (Argentina).",
              categoria: "International",
              pais: "Argentina",
              anyada: "",
              anyo: "2016"
            },
            "feria-habana-2016": {
              titulo: "International Fair of Havana",
              posicion: "",
              texto: "Product Quality Prize in 'FIHAV 2016' in Habana (Cuba).",
              categoria: "International",
              pais: "Argentina",
              anyada: "",
              anyo: "2016",
              doble: true
            }
          }
        },
        banner_beneficios: {
          titulo:
            "Do you know the benefits and the proven qualities of the oil?",
          boton: "Discover the benefits"
        },
        banner_experiencia: {
          titulo: "Do you want to know more?",
          boton: "Discover oleoturism",
          enlace: "oleoturismo"
        },
        beneficios: {
          titulo: "Benefits and proven qualities of<br>extra virgin olive oil",
          list: [
            {
              titulo: "Osteoporosis",
              cuerpo:
                "Extra virgin olive oil plays an important role in preventing osteoporosis, as it helps the bones to absorb calcium."
            },
            {
              titulo: "Blood pressure",
              cuerpo:
                "Helps significantly to decrease systolic and diastolic blood pressure."
            },
            {
              titulo: "Obesity",
              cuerpo:
                "Extra virgin olive oil is entirely recommended for low-calorie diets for cooking and for seasoning, as its glycaemic index is much lower than those of other fats."
            },
            {
              titulo: "Oxidative stress",
              cuerpo:
                "Out of all vegetable oils, extra virgin olive oil is the highest in monunsaturated fat. This is different to other fats: it does not oxidise in the body and contains a very low percentage of polyunsaturated fats. It is also high in Vitamin E."
            },
            {
              titulo: "Cancer",
              cuerpo:
                "It has been scientifically demonstrated that phytonutrients in olive oil can reduce the risk of breast cancer. Squalene and lignans are among the other components whose possible effects upon cancer are being studied."
            },
            {
              titulo: "Diabetes",
              cuerpo:
                "People with diabetes have a strong ally in the consumption of extra virgin olive oil, as this helps them to reduce the levels of glucose and insulin in their blood."
            },
            {
              titulo: "Arthritis",
              cuerpo:
                "Regular consumption of extra virgin olive oil helps to reduce the likelihood of developing rheumatoid arthritis."
            },
            {
              titulo: "Cholesterol",
              cuerpo:
                "Extra virgin olive oil helps to lower cholesterol levels in the blood, which can prevent the development of heart disease. It also contributes to preventing the oxidation of ‘bad’ LDL cholesterol, which has a direct effect on the development of coronary artery disease."
            },
            {
              titulo: "Alzheimer’s disease",
              cuerpo: "Regular consumption prevents cognitive decline."
            }
          ]
        }
      },
      azafran: {
        slug: "azafran",
        nombre: "Saffron",
        intro_productos: "<span>Small details make the difference</span>",
        productos: {
          box: {
            id: "caja-1g",
            nombre: "1g Box",
            descripcion:
              "Saffron, La Mancha Protected Origin Designation. Recognition of world-topping quality that ensures maximum quality in food safety, organoleptic characteristics (colour, flavour and taste) and Spanish origin (Castilla La Mancha).",
            caracteristicas:
              "Threaded saffron, never ground. Flexible and resilient threads",
            maridaje:
              "Ideal for colouring, flavouring and adding a special taste to any dish. Saffron reaches its greatest height in the preparation of food dishes where it is used as a spice: grilled meat, fish, soup, shellfish and rice.",
            peso: ["1g", "Box of 12 units"],
            premios: {
              premios: []
            }
          }
        },
        intro_ficha: {
          titulo: "Saffron from<br>La Mancha",
          cuerpo:
            "<p><strong>Red gold.</strong> Venerated since ancient times by ancient civilisations such as Egypt or Greece, this plant, as fine as it is delicate, has in our day become a star ingredient in international cuisine due to its aroma, flavour and colour. Saffron is also used in pharmacy for its many medicinal properties.</p><p>Aldonza saffron is produced in Castilla La Mancha (Spain), a part of the world that has been recognised with the award of the seal of quality Protected <strong>Origin Designation La Mancha Saffron.</strong> This seal of quality is globally recognised for its triple guarantee: top-level organoleptic characteristics and food safety.</p>"
        },
        banner_denominacion: {
          titulo: "With origin designation",
          subtitulo: "La Mancha saffron",
          cuerpo: "Protected origin designation"
        },
        banner_beneficios: {
          titulo:
            "Do you know the benefits and the proven qualities of saffron?",
          boton: "Discover its benefits"
        },
        banner_experiencia: {
          titulo: "Do you want to know more?",
          boton: "Discover the experiences Aldonza",
          enlace: "vive_aldonza"
        },
        beneficios: {
          titulo: "Benefits<br>and proven qualities of saffron",
          list: [
            {
              titulo: "Digestion",
              cuerpo:
                "Due to its aromatic and bitter components (picrococin), it stimulates the digestive system and increases salivary and gastric secretions. Moreover, saffron contains crocetin (the red pigments) and fluidifies. The first stimulates the production of bile while the fluidification helps the digestive process and prevents the formation of gallstones."
            },
            {
              titulo: "Menstrual cramps",
              cuerpo:
                "Saffron has a very important role in treating premenstrual symptoms. It has been demonstrated that saffron is good for the menstrual cycle, prevents uterine cramps and benefits menstrual flow."
            },
            {
              titulo: "Antioxidant",
              cuerpo:
                "Crocin, a main component of saffron, is a powerful natural antioxidant. This substance delays aging of the body’s cells."
            },
            {
              titulo: "Memory",
              cuerpo:
                "Saffron improves memory and cognitive abilities. Its protective effect against degenerative diseases such as Parkinson’s disease and Alzheimer. It is also recommended as a dietary supplement for persons suffering from stress."
            },
            {
              titulo: "Vision",
              cuerpo:
                "Safranal, an aromatic component of saffron, slows down the degeneration of photoreceptive cells in the eye, improves retinal function and the function of blood vessels related to vision."
            },
            {
              titulo: "Cardiovascular disease",
              cuerpo:
                "Saffron is an aromatic plant with a very high level of antioxidants, which helps to prevent cardiovascular disease. Moreover, crocetin, a red pigment in saffron, contributes to lowering cholesterol."
            },
            {
              titulo: "Diabetes",
              cuerpo:
                "Due to its high antioxidant power, saffron is a beneficial supplement for people with diabetes. Saffron extract protects patients in these categories from diabetic neuropathy, nerve damage caused by excess sugar in the bloodstream."
            },
            {
              titulo: "Anti-carcinogenic",
              cuerpo:
                "Saffron contains betacarotenes and flavonoids that help to slow down tumour growth, prolonging life expectancy."
            },
            {
              titulo: "Anti-depressant",
              cuerpo:
                "In cases of mild and moderate depression, saffron can be as effective as certain pharmaceutical drugs."
            },
            {
              titulo: "Relaxant",
              cuerpo:
                "Saffron contains relaxing aromatic substances, which help to combat nerves and anxiety."
            }
          ]
        }
      },
      cava: {
        slug: "cava",
        nombre: "Cava",
        intro_productos:
          "<span>After wonderful moments,<br>unforgettable memories are left</span>",
        intro_ficha: {
          titulo: "With personality",
          cuerpo:
            "<p>From the fruit of the vine the grape juice is extracted. After two fermentations, it will become sparkling wine. Our own yeast, selected with rigour, that gives each of our four varieties of sparkling wine its own personality. </p><p>Sparkling wine with D.O. Sparkling Wines, cultivated in the Penedés region and prepared at the Sant Sandurní D centre"
        },
        productos: {
          reserve: {
            id: "reserva",
            nombre: "Reserve",
            tipo_uva:
              "Chardonnay, Xarel-lo, Macabeo from vineyards of the D.O. Sparkling wine",
            tipo_cava: "Brut special reserve",
            elaboracion:
              "After harvesting, grape juice is obtained by using a pneumatic press or dynamic draining. Fermentation of the grape juice at 15ºC while it is monitored. Second fermentation and minimum aging of 24 months in wine cellars.",
            graduacion: "11,5 - 12,5% Vol",
            cantidad: "750ml",
            servicio: "Between 6º - 8º C.",
            gastronomia:
              "The big personality of this sparkling wine brings out any dish in global cuisine: meat, stewed fish, cheese, pates and smoked dishes and it is excellent as an aperitif.",
            notas_cata: {
              texto:
                "Pale yellow colour and strong bubble formation with the bubbles forming a crown. Stands out because of its scent of crianza, ripe fruit and flowers. In the mouth it is round, harmonious, dry and long.",
              autor: ""
            },
            premios: [
              "brut-decanter-plata-2019",
              "brut-decanter-2022",
              "brut-decanter-2022-2",
              "brut-alemania-2026", 
              "brut-bos-2026"
            ]
          },
          nature: {
            id: "nature",
            nombre: "Brut Nature",
            tipo_uva: "Xarel-lo, Macabeo, Parellada",
            tipo_cava: "Brut Nature",
            elaboracion:
              "Following the harvesting of the grapes, they are sorted by variety and quality. The grape juice is then extracted by pneumatic press or dynamic draining. Fermentation of the grape juice at under 19ºC while it is monitored. Resting and maturation in the wine cellar for between 12 and 14 months.",
            graduacion: "11,5 - 12,5 % Vol.",
            cantidad: "750ml",
            servicio: "Between 6º - 8º C.",
            gastronomia:
              "Pair with appetisers, dried fruit, shellfish, red and white meat.",
            notas_cata: {
              texto:
                "Pale yellow colour with slight golden highlights and with bubbles released that rise in a chain, forming a crown. Floral and sweet aromas can be distinguished; these are characteristic of bottle aging. In the mouth it is dry, pleasant and round, with an excellent aromatic persistence.",
              autor: ""
            },
            premios: ["brut-nature-2025"]
          },
          rose: {
            id: "rose",
            nombre: "Brut - Rosé",
            tipo_uva: "Trepat",
            tipo_cava: "Brut - rosé",
            elaboracion:
              "After the grape harvest, the grapes are skinned and placed into casks with slight maceration until they reach their optimal point with regard to colour and the rest of their characteristics. Fermentation of the grape juice at under 19ºC. Resting and maturation in the wine cellar (at least 9 months).",
            graduacion: "11 - 12% Vol",
            cantidad: "750ml",
            servicio: "Between 6º - 8º C.",
            gastronomia:
              "Ideal to accompany salad, pasta, oily fish, and shellfish.",
            notas_cata: {
              texto:
                "Intense, lively, bright pink colour.  Good length and strong release of small bubbles that rise in a chain, forming a crown. The first impression is pleasant, and aromas reminiscent of small red fruit can be distinguished. Subsequently, the final impression leaves a balanced, pleasant and very fruity taste.",
              autor: ""
            },
            premios: ""
          },
          brut: {
            id: "brut",
            nombre: "Brut",
            tipo_uva: "Xarel-lo, Macabeo, Parellada",
            tipo_cava: "Brut",
            elaboracion:
              "Following the harvesting of the grapes, they are sorted by variety and quality. The grape juice is then extracted by pneumatic press or dynamic draining. Fermentation of the grape juice at under 19ºC while it is monitored. Resting and maturation in the wine cellar for between 12 and 14 months.",
            graduacion: "11 - 12% Vol",
            cantidad: "750ml",
            servicio: "Between 6º - 8º C.",
            gastronomia: "Ideal to pair with ham, white meat and rice.",
            notas_cata: {
              texto:
                "Very pale yellow colour with golden glints and with plentiful release of small bubbles that form a bright crown. Elegant aroma, with fruity notes and with the qualities of its bottle maturation. In the mouth it creates a pleasant flavour, with sweet highlights and final notes reminiscent of apple. Good acidity and long persistence.",
              autor: ""
            },
            premios: ""
          }
        },
        premios: {
          titulo: "Awards and recommendations",
          premios: {
            "brut-decanter-plata-2019": {
              titulo: "Brut-Reserva sparkling wine",
              posicion: "Second Prize",
              texto:
                "2018 vintage, winner of the Silver Medal at the 2019 Decanter World Wine Awards, London (United Kingdom).",
              categoria: "International",
              pais: "uk",
              anyada: "2018",
              anyo: "2019"
            },
            "brut-decanter-2022": {
              titulo: "Cava Brut-Reserva",
              posicion: "92 Points",
              texto:
                "2021 vintage, winner of the Silver Medal at the 2022 Decanter World Wine Awards, London (United Kingdom).",
              categoria: "Internacional",
              pais: "uk",
              anyada: "2021",
              anyo: "2022"
            },
            "brut-decanter-2022-2": {
              titulo: "Brut-Reserva sparkling wine",
              posicion: "",
              texto:
                "2021 vintage, Silver Medal at the Concours Mondial de Bruxelles held in Anadia (Portugal).",
              categoria: "Internacional",
              pais: "portugal",
              anyada: "2021",
              anyo: "2022"
            },
            "brut-nature-2025": {
              titulo: "Cava Brut Nature",
              posicion: "",
              texto:
                "2022 vintage awarded the Gold Medal at the Global Wine, 2025, Mexico.",
              categoria: "Internacional",
              pais: "mexico",
              anyada: "2022",
              anyo: "2025"
            },
            "brut-alemania-2026": {
              titulo: "Cava Brut Reseva",
              posicion: "",
              texto:
                "Awarded the Gold Medal at Mundus Vini, 2026, Germany.",
              categoria: "Internacional",
              pais: "alemania",
              anyada: "2022",
              anyo: "2026"
            },
            "brut-bos-2026": {
              titulo: "Cava Brut Reseva",
              posicion: "",
              texto:
                "Recognized as the best cava at the 2026 Mundus Vini edition, Germany.",
              categoria: "Internacional",
              pais: "alemania",
              anyada: "2022",
              anyo: "2026"
            }
          }
        },
        banner_premios: {
          titulo: "Award winning sparkling wine",
          boton: "All Awards",
          premio: "brut-decanter-2022-2"
        },
        banner_beneficios: {
          titulo:
            "Do you know the benefits and the proven qualities of sparkling wine?",
          boton: "Discover the beneficts"
        },
        banner_experiencia: {
          titulo: "Do you want to know more?",
          boton: "Discover the experiences Aldonza",
          enlace: "vive_aldonza"
        },
        beneficios: {
          titulo: "Benefits and proven qualities of<br>sparkling wine",
          list: [
            {
              titulo: "Provision of nutrients",
              cuerpo:
                "Sparkling wine, as we mentioned at the beginning, is a low-fat beverage and also has nutritional properties. In particular, we can point out its iron, protein, calcium, potassium and iodine content, as well as traces of zinc, carbohydrates, magnesium, sodium, vitamin B1, B2, B9, vitamins B3 and B6, phosphorus and sugar."
            },
            {
              titulo: "Rejuvenation",
              cuerpo:
                "Sparkling wine is considered a fountain of youth as it contains antioxidants that stimulate cellular renovation and boost vitamin E. These properties rejuvenate the skin, especially women’s skin."
            },
            {
              titulo: "Good for the heart",
              cuerpo:
                "Thanks to its high levels of polyphenols, it reduces blood pressure and prevents the risk of cardiovascular disease or heart attacks."
            },
            {
              titulo: "Lifts the spirits",
              cuerpo:
                "Some components of this beverage lift the spirits. This product contains natural oligoelements that improve our state of mind."
            },
            {
              titulo: "Strengthens the memory",
              cuerpo:
                "Moderate consumption of sparkling wine, one glass per day, can improve memory and delay various degenerative brain diseases, such as senile dementia. Scientific studies determine that the key to this property is found in phenolic acid."
            },
            {
              titulo: "Watches your weight",
              cuerpo:
                "Sparkling wine is one of the lowest-calorie alcoholic drinks. A glass of Brut contains under 12 grammes of residual sugar per litre, that is, between 80 and 100 calories, while a beer or a mixed drink using rum, to mention some examples, have more than 150 calories."
            },
            {
              titulo: "Protects your skin",
              cuerpo:
                "Sparkling wine detoxes the skin with antioxidants and tartaric acid, contributing to balancing its tone and avoiding blotches. For those with a tendency towards greasy skin, the antibacterial properties of this beverage help to maintain the skin in a healthier state."
            }
          ]
        }
      },
      queso: {
        slug: "queso",
        nombre: "Cheese",
        intro_productos: "<span>Take a break from your everyday life</span>",
        productos: {
          enaceite: {
            id: "enaceite",
            nombre: "In olive oil",
            descripcion:
              "In olive oil cheese made from 100% pasteurised Manchegan sheep's milk.",
            curacion: "Between 150 and 210 days.",
            apariencia:
              "Consistency: firm and compact. Colour: variable from white to ivory-yellowish. Odour: Odour: lactic, intense and persistent acidified, evolving to spicy nuances. Flavour: slightly acidic, strong and tasty.",
            ingredientes:
              "Pasteurised Manchegan sheep's milk, rennet, lactic ferments, lysozyme (derived from egg), calcium chloride, salt and olive oil. Origin of the milk: Spain.",
            valoresnutricionales:
              "Energy value: 410 Kcal / 1715 Kj Fats: 36,00 g Saturated fats: 18,70 g Carbohydrates: 0,50 g Sugars: 0 g Proteins: 24 g Salt: 1,60 g",
            conservacion: "Between 2 and 7 oC.",
            alergenos: "Lactose and lysozyme (egg derivative).",
            durabilidad: "1 year after production. Indicated on each package.",
            gastronomia:
              "Ideal with red wines (Aldonza Selección and Aldonza Navamarín) and cava (Aldonza Brut Reserva).",
            notas_cata: {
              texto:
                "Strong flavour characteristic of sheep's cheese, reinforced by the intense flavour of the olive oil, with a rather spicy aftertaste."
            },
            premios: {
              premios: []
            }
          },

          semicurado: {
            id: "semicurado",
            nombre: "Semi-cured",
            descripcion:
              "Semi-cured cheese made from 100% pasteurised Manchegan sheep's milk.",
            curacion: "Between 60 and 100 days.",
            apariencia:
              "Consistency: firm and compact. Colour: variable from white to ivory-yellowish. Odour: lactic, intense and persistent acidified. Flavour: slightly acidic, strong and tasty.",
            ingredientes:
              "Pasteurised Manchegan sheep's milk, rennet, lactic ferments, lysozyme (derived from egg), calcium chloride and salt. Origin of the milk: Spain.",
            valoresnutricionales:
              "Energy value: 410 Kcal / 1715 Kj Fats: 30 g Saturated fats: 18,90 g Carbohydrates: 0,50 g Sugars: <0,50 g Proteins: 26 g Salt: 1,60 g",
            conservacion: "Between 2 and 7 oC.",
            alergenos: "Lactose and lysozyme (egg derivative).",
            durabilidad: "1 year after production. Indicated on each package.",
            gastronomia:
              "Ideal to accompany white wines (Aldonza Albo), young red wines (Aldonza Clásico) and rosé cavas (Aldonza Brut - Rosé).",
            notas_cata: {
              texto:
                "Strong flavour characteristic of sheep's cheese, reinforced by the intense flavour of the olive oil, with a rather spicy aftertaste."
            },
            premios: {
              premios: []
            }
          },

          curado: {
            id: "curado",
            nombre: "Cured",
            descripcion:
              "Cured cheese made from 100% pasteurised Manchegan sheep's milk.",
            curacion: "Between 150 and 210 days.",
            apariencia:
              "Consistency: firm and compact. Colour: variable from white to ivory-yellowish. Odour: Odour: lactic, intense and persistent acidified, evolving to spicy nuances. Flavour: slightly acidic, strong and tasty.",
            ingredientes:
              "Pasteurised Manchegan sheep's milk, rennet, lactic ferments, lysozyme (derived from egg), calcium chloride and salt. Origin of the milk: Spain.",
            valoresnutricionales:
              "Energy value: 410 Kcal / 1715 Kj Fats: 36 g Saturated fats: 18,70 g Carbohydrates: 0,50 g Sugars: 0 g Proteins: 24 g Salt: 1,60 g",
            conservacion: "Between 2 and 7 oC.",
            alergenos: "Lactose and lysozyme (egg derivative).",
            durabilidad: "1 year after production. Indicated on each package.",
            gastronomia:
              "Ideal with red wines (Aldonza Selección and Aldonza Navamarín) and cava (Aldonza Brut Nature).",
            notas_cata: {
              texto:
                "Cheese with a lot of character, with a strong, penetrating, intense flavour, which evolves into slightly spicy nuances at the end."
            },
            premios: {
              premios: []
            }
          }
        },
        intro_ficha: {
          titulo: "100% manchego",
          cuerpo:
            "<p>Each cheese is given personalised treatment from the hands of our artisan cheesemakers. A pampering which can be appreciated in the flavour, aroma and texture in every bite. Enjoy any of our three varieties: cured, semi-cured and in olive oil. Another irresistible experience for your palate. <br><a target='_blank' href='/static/pdf/certificado-SAE.pdf'><u>Certificate <strong>SAE 2021-0014</strong></u></a>  </p>"
        },
        banner_beneficios: {
          titulo:
            "Do you know the benefits and the proven qualities of cheese?",
          boton: "Discover the benefits"
        },
        banner_experiencia: {
          titulo: "Do you wnat to know more?",
          boton: "Discover the Aldonza experience",
          enlace: "vive_aldonza"
        },
        beneficios: {
          titulo: "Benefits<br> and proven qualities of cheese",
          list: [
            {
              titulo: "Source of calcium.",
              cuerpo:
                "Cheese is one of the main sources of calcium, a mineral that regulates essential processes in our organism, such as the transportation of oxygen by red blood cells or coagulation."
            },
            {
              titulo: "Strengthens bones.",
              cuerpo:
                "Calcium helps to form and strengthen bones, which is why it has a very positive effect in the fight against osteoporosis and other degenerative bone diseases."
            },
            {
              titulo: "Oral health.",
              cuerpo:
                "In addition to strengthening our teeth, it reduces bacterial plaque, stimulates the production of saliva and cleans our mouth in a natural way."
            },
            {
              titulo: "Protects the skin.",
              cuerpo:
                "It has a high vitamin B content, which improves the appearance of our skin."
            },
            {
              titulo: "Improves vision.",
              cuerpo:
                "Contains vitamin A and D which help to improve vision and the immune system."
            },
            {
              titulo: "Recommended during pregnancy.",
              cuerpo:
                "It contains folic acid, so it is highly recommended during pregnancy (always made from pasteurized milk) and it also favours the production of breast milk."
            },
            {
              titulo: "Prevents diseases.",
              cuerpo:
                "Cheese is rich in conjugated linoleic acid (CLA) and esfingolipids, two components of milk fat that help reduce the risk of cancer and heart disease."
            },
            {
              titulo: "Recovers body mass.",
              cuerpo:
                "It is very rich in protein and favours the recovery of body mass. It is a very helpful food for athletes and reduces the risk of obesity."
            }
          ]
        }
      }
    },
    banners_experiencia: {
      vive_aldonza: {
        id: "vive-aldonza",
        titulo: "Experience Aldonza",
        titulo_intro_experiencia:
          '"You won’t remember the days, you’ll remember the experiences you had every moment"',
        titulo_vivir_experiencia:
          "What do you need for your Aldonza experience??",
        tip_maleta:
          "Remember to pack your <strong>bag</strong> with everything you want with you during the experience. It’s important to be prepared!",
        tip_camara:
          "A <strong>camera for taking photos</strong>! A must for immortalising each of the unrepeatable moments you’ll experience with Aldonza.",
        tip_corazon:
          "<strong>Your attitude</strong>, the fundamental ingredient for making every experience unforgettable. The path depends only on you.",
        elige: "Choose your Aldonza experience"
      },
      enoturismo: {
        id: "enoturismo",
        titulo: "Oenotourism",
        cuerpo:
          "Have your camera at the ready when you go down into the wine cellar where are cask room is located. A sensory oenotourism experience with tasting included. Visits from Monday to Sunday.",
        boton: "Live the experience",
        titulo_intro_experiencia: "Get to know and visit our estate",
        la_visita_text: "The visit",
        reserva: "Get your tickets",
        tips_bodega: [
          {
            titulo: "Location",
            cuerpo:
              "Our estate is in the heart of the lands of Don Quixote, in the municipal district of Munera, located in the north-west of the province of Albacete. We are in the middle of the sierra of Alcaraz and Campos de Montiel, in a natural landscape located at 1,200 metres of altitude, the Navamarin Pastureland."
          }
        ],
        la_visita: [
          {
            cuerpo:
              "A complete tour of our facilities, estate, olive oil mill and saffron room. You’ll learn how wine, extra virgin olive oil and saffron are created."
          },
          {
            cuerpo:
              "We offer free tastings of wine, cava and extra virgin olive oil. It will be an exquisite experience!"
          },
          {
            cuerpo:
              "The approximate length of the visit is 120 minutes. Accessible for people with disabilities."
          },
          {
            cuerpo:
              "Visit us any day of the week (from Monday to Sunday). The timetable will be established with visitors."
          }
        ],
        video: {
          titulo: "Video/spot",
          cuerpo:
            "You only need to choose your company. <strong>Family, partner or friends?</strong> First-hand oenotourism and oenotourism. Come and play!"
        }
      },
      oleoturismo: {
        id: "oleoturismo",
        titulo: "Oleoturism",
        cuerpo:
          "Let yourself be drawn in by the aroma of a good extra virgin olive oil. Visit our oil press, learn about the process of creating extra virgin olive oil and find out about all the properties of the most traditional product in the Mediterranean diet.",
        boton: "Live Experience",
        titulo_intro_experiencia: "Get to know and visit our oil press",
        titulo_catas: "Our oil tastings",
        cuerpo_catas:
          "<p>Olive oil tastings are done with opaque glasses. The aim is for the colour of this product not to determine its quality. Did you know? Choose a date for an oenotourism day with Aldonza to discover much more about this product.</p><p>In unique surroundings, at the heart of the land of Don Quixote, you will learn how extra virgin olive oil is created, how an olive oil mill works, the main olive varieties and how a professional olive oil tasting occurs. We won’t tell you any more, discover it for yourself!</p>"
      },
      degustacionQuesos: {
        id: "degustacionQuesos",
        titulo: "The Cheese Ritual",
        cuerpo:
          "Stimulate all your senses to savour a piece of cheese and start the cheese tasting ritual!",
        boton: "LIVE THE EXPERIENCE",
        titulo_intro_experiencia: "El Ritual",
        la_visita_text: "Maridaje con vino",
        la_visita: [
          {
            cuerpo:
              "La acidez del vino nos facilita el paso de los quesos, además, los vinos nos limpian la boca y potencian el sabor del quesos. En nuestras visitas guiadas de enoturismo, que puedes reservar aquí, te enseñamos a degustar el auténtico queso manchego."
          }
        ],
        productos: {
          vista: {
            id: "vista",
            nombre: "Sight",
            descripcion:
              "This is the sense which discerns the appearance and condition of the cheese. The outer rind and the surface of the cut must be examined. Depending on the variety, the rind will be smooth and waxy, mouldy, washed or treated, for example, with extra virgin olive oil. Colour is another visual aspect to be taken into account. Manchego cheeses, made with sheep's milk, usually have an ivory colour. The texture can also be discerned using one’s sight. For example, a cheese will be more or less cracked depending on the curing time."
          },
          tacto: {
            id: "tacto",
            nombre: "Touch",
            descripcion:
              "Tactile examination enables one to feel the flaky, floury and somewhat brittle texture, typical of cured Manchego cheeses. "
          },
          olfato: {
            id: "olfato",
            nombre: "Smell",
            descripcion:
              "On the bouquet the sensations that tasters and master cheesemakers group into families is perceived. Lactic, vegetal, fruity, spicy etc. perceptions can be distinguished."
          },
          gusto: {
            id: "gusto",
            nombre: "Taste",
            descripcion:
              "This is the moment to appreciate the flavours and texture of each cheese! For the cheese tasting ritual on one’s palate, ideally the cheese must chewed for a few seconds without taking a breath and then gradually release the air through the mouth. This helps to identify the intensity and flavours of the cheese; sweet, salty, sour, bitter, spicy and even other nuances which can have an entirely personal appreciation."
          },
          regusto: {
            id: "regusto",
            nombre: "Aftertaste",
            descripcion:
              "At the end of the tasting, the aftertaste, also known as residual taste, remains. At this moment, a different olfactory-gustatory sensation remains to that when the cheese is tasted for the first time, so the aromas and flavours can be entirely new and unique."
          }
        },
        maridaje: {
          id: "maridaje",
          titulo_catas: "Wine pairings.",
          cuerpo_catas:
            "<p>The acidity of the wine makes it easier for the pleasant entry of the cheeses, and the wine similarly cleanses the palate and enhances the flavour of the cheese. </p>"
        }
      },

      recetario: {
        id: "recetario",
        titulo: "Recipe book and<br>Gastronomic Route",
        cuerpo:
          "<p>The best way of enjoying our products is to cook with them. Traditional or innovative, choose the recipe that appeals to you most from our recipe book.</p><p>The best of Spanish cuisine, with Aldonza products. Grab your bag and come enjoy the gastronomic route. ",
        boton: "Live Experience",
        titulo_intro_experiencia:
          '"A person becomes a cook when he or she has things to say via his or her dishes."',
        cuerpo_recetario:
          "<p>Aldonza has its own recipe book of healthy dishes prepared with its products: extra virgin olive oil, saffron and wine. Traditional or innovative, all our recipes are available in audiovisual format. What do you feel like cooking today?</p><p>The Aldonza team and the chefs from the HEB culinary centre search Spain’s best restaurants and centres of cuisine to prepare a new recipe book that will be a fusion of Spanish and Texan cuisine. Experience the gastronomic route all over again with our videos. ",
        boton_recetario: "Consult our recipe book!",
        boton_tasting: "Discover tasting spain!",
        recetario: "Recipe Book",
        tasting_spain: "Tasting Spain",
        youtube: {
          titulo:
            "Would you like to see more recipes or not lose sight of any of our routes?",
          newsletter: "Subscribe to our Youtube channel",
          boton: "Go to the Youtube channel"
        }
      },
      ruta_cervantina: {
        id: "ruta-cervantina",
        titulo: "Cervantes Route",
        cuerpo:
          "A region awash with history and legends, considered the best Cervantes-related route to take. There are many corners of enchantment surrounding the Navamarín Pastureland. Pack your bag and let yourself be drawn in by the land of Don Quixote de La Mancha.",
        boton: "Live Experience",
        cerrar: "Close",
        leer_mas: "Read more",
        tradicion: {
          titulo: "Literary tradition",
          cuerpo:
            "Miguel de Cervantes was inspired by the Navamarín Pastureland to write to chapters of his work most widely known around the world"
        },
        literatura: {
          cuerpo:
            "The influence of this universal work on our vineyards, our olive and saffron gardens, gives its name to our brand. Aldonza Lorenzo, Dulcinea del Toboso in the book, was the damsel Don Quixote loved. Today, you can see the heritage of this literary work in the municipality of Munera."
        },
        naturaleza: {
          titulo: "Nature",
          cuerpo:
            "In the middle of the Cervantes route, at 40 kilometres from the Navamarín Pastureland and in the middle of the extensive Campo de Montiel, we are in an oasis of water and vegetation: the Natural Park of the Ruidera Lagoons, at whose highest point, the Cabeza de San Pedro, are the Rochafrida Castle and the Montesinos Cave",
          more_cuerpo:
            "In a surface area of 4000 hectares there are sixteen lagoons that form a series of waterfalls and rapids from the first springs rising in the White lagoon to the lower lagoons and the Peñarroya Swamp. In spring, the exuberant colouring of an abundant and varied vegetation provides shelter to an innumerable number of water birds. Water flow reaches its maximum at this time and flows from one lagoon to another, forming small waterfalls in some cases.",
          more_uno:
            "To visit the Navamarín Pastureland and the Aldonza estate is to visit a land with a major literary tradition. The celebrated <strong>Camacho Weddings</strong>, described in chapters 19, 20 and 21 of the work ",
          more_dos:
            "In the honour of one of the main characters in this famous episode, the Bella Quiteria windmill was ordered to be constructed in 1975. Today it houses a furniture and museum displaying a historical household typical of La Mancha. Rural tourism within the route, the best of the Cervantes routes.",
          more_tres:
            "Moreover, Munera has a Photo-Ethnological Museum. It is a former windmill, built in 1861 and donated to the Council for conversion into a museum. The sensation of exploring the classic windmills of La Mancha is incredible."
        },
        historia: {
          titulo: "History",
          cuerpo:
            "The Cervantes route does not overlook the historical spaces located in the Sierra de Alcaraz and Campos de Montiel. The archaeological remains of Libisosa and the <strong>Ethnographic Museum of Tiriez</strong>, located in the Lezuza region, are also part of the history of our plantations and of the culture of La Mancha.",
          more_uno:
            "The Libisosa Archaeological Site conceals more than 2,800 years of history in ten hectares of land. Located in the Lezuza landscape known as the Cerro del Castillo, these excavations have become one of the most important enclaves in Castilla-La Mancha. They are located between the basins of the Guadiana and Jucar rivers, lands with abundant water, hunting and forest resources. In this area, livestock farming has always had an important role to play, together with the cultivation of grains and extensive plots of vines. This site, with its high geostrategic value for the trade of the time period, is an area rich in history and in farming culture.",
          more_dos:
            "The Tiriez Ethnographic Museum is located in this parish, situated in the Lezuza region, in the province of Albacete. It is an Ecomuseum that recreates historic buildings and the cultural environment of the region where Aldonza’s facilities are. An ethnographic museum with reproductions of various environments of daily living of the people of the Campo de Montiel region.  We can see tools used for apiculture, agriculture, house decoration objects, carts, etc. On the other side, in the section named "
        },
        legado: {
          titulo: "The Catalan legend of Don Quixote",
          cuerpo:
            "Aldonza is widening its business portfolio by including sparkling wine, and it is doing so because there is a special link between Don Quixote de La Mancha and Catalonia. Eight chapters of his adventures occur in Catalonia, and these are the most representative ones. ",
          boton: "Discover it!"
        }
      }
    },
    escucha: {
      intro: "The best things in life aren’t planned, they just happen",
      cuerpo_intro: "What do you need to feel and hear Aldonza?",
      tip_volumen:
        "A keenness to enjoy and discover new sensations through music. Activate the sound and turn the volume to the point you prefer!",
      tip_cascos:
        "You choose whether to have your experience alone or with others. Both options are a valid way of immersing yourself in the auditory experience that Aldonza is offering you.",
      tip_dados:
        "Did you know that sound is an ingredient that improves gastronomic experiences? Let yourself be carried away by the Aldonza playlist and intensify each flavour.",
      boton_escuchar: "Listen to",
      spotify: {
        titulo: "Aldonza on Spotify",
        cuerpo:
          "Ready? You’re one click away from immersing yourself in an experience that will make this moment unique. Different ambiences chosen especially for you.",
        boton: "Listen to the playlist"
      },
      comparte: {
        titulo: "Share your Aldonza experience",
        cuerpo:
          "We want you to enjoy every #AldonzaExperience but, above all, to share it with us!<br>We’re waiting for you on our social networks."
      }
    },
    otras_experiencias: {
      titulo: "Other Experiences",
      lugares: {
        enoturismo: "Enoturism",
        oleoturismo: "Oenotourism",
        degustacionQuesos: "The Cheese Ritual",
        ruta_cervantina: "Cervantine Route",
        recetario: "Recipe Book"
      }
    },
    formulario: {
      vive_experiencia: "Live the experience",
      solicita_visita: "",
      bodega: "Request your visit to our Winery",
      almazara: "Request your visit",
      nombre: "Name",
      nombre_apellidos: "Name and surname",
      apellidos: "Surname",
      email: "E-mail",
      mensaje: "Message",
      introduce_mensaje: "Enter your message",
      fecha_nacimiento: "Date of birth",
      dia: "Day",
      mes: "Month",
      anyo: "Year",
      area_interes: "Your area of interest",
      trabaja_actualmente: "Are you currently working?",
      si: "Yes",
      no: "No",
      carta_presentacion: "Business card",
      meses: {
        Enero: "January",
        Febrero: "February",
        Marzo: "March",
        Abril: "April",
        Mayo: "May",
        Junio: "June",
        Julio: "July",
        Agosto: "August",
        Septiembre: "September",
        Octubre: "October",
        Noviembre: "November",
        Diciembre: "December"
      },
      archivo_adjunto: "Add file",
      adjuntar_cv: "Add CV",
      introduce_mail: "Enter your email",
      pais: "Country",
      telefono: "Telephone",
      he_leido:
        "I consent to the use my data for the purposes indicated in the",
      y_acepto: "privacy policy",
      texto_newsletter: "I would like to subscribe to the newsletter",
      enviar: "Submit",
      enviado: "Send",
      recibido:
        "We have received your message. We will get in touch with you as soon as possible.",
      concertar_visita:
        "You can also organise your visit by telephone or email:",
      lunes_domingo: "From Monday to Sunday",
      horario: "From 8:00 to 14:00 and from 15:30 to 18:00",
      enlace_popup: "Click here to consult and accept the privacy policy"
    },
    popupterminos: {
      titulo: "BASIC DATA PROTECTION INFORMATION",
      titulo_dos: "DATA CONTROLLER",
      titulo_tres: "Aldonza Gourmet SAU ",
      cuerpo: [
        {
          titulo: "ADDRESS OF THE DATA CONTROLLER",
          cuerpo:
            "Parque Empresarial Ajusa, CM 332, km 2,2, calle 1, número 1., CP 02006, Albacete (Albacete)"
        },
        {
          titulo: "PURPOSE",
          cuerpo:
            "Your details will be used to process your requests and provide you with our services."
        },
        {
          titulo: "ADVERTISING",
          cuerpo:
            "We will only send you advertising if you authorize it in advance. You can do this by marking the corresponding box on the form."
        },
        {
          titulo: "LEGAL AUTHORITY",
          cuerpo:
            "We will only process your details with your prior consent. You can do this by marking the corresponding box on the form."
        },
        {
          titulo: "INTENDED RECIPIENTS",
          cuerpo:
            "Generally speaking, only duly authorized personnel at our company will be able to access the information we request from you."
        },
        {
          titulo: "RIGHTS",
          cuerpo:
            "You are entitled to know what information we hold about you, correct it and have it deleted, as explained in the additional information available on our web site."
        }
      ],
      titulo_mas: "ADDITIONAL INFORMATION",
      texto_mas: "Further information is available in the ",
      datos_seguros: "YOUR DATA SECURE",
      texto_nuestra: "section of our web site.",
      acepto: "Accept"
    },
    banner_contacto: {
      titulo: "Do you need more information?",
      cuerpo:
        "For any questions you may have, fill out the following form. We will get back to you as soon as possible:",
      boton: "See form"
    },
    banner_localizaciones: {
      titulo: "Where are we?",
      cuerpo: "To access our facilities, go to either of these two places:",
      munera: "Crta. N-430  Km 462,3, 02612 Munera (Albacete)",
      lezuza: "<strong>Carretera CM-313</strong>, km 56, Lezuza (Albacete)."
    },
    banner_newsletter: {
      titulo: "Where are we?",
      cuerpo: "Address: Crta. N-430  Km 462,3, 02612 Munera (Albacete)",
      email: "E-mail:",
      telefono: "Contact telephone number:"
    },
    cookie_banner: {
      texto:
        "A cookie is a small information file that is stored in your browser each time you visit our website. The use of cookies is to save the history of your activity in our so that, when you visit again, you can identify and configure your content based on your browsing habits, identity and preferences. They can be accepted, rejected, blocked and deleted, as desired. In case you reject them, we can not assure you the proper functioning of our website. More information in the cookies ",
      politica: "Privacy Policy",
      boton: "Accept"
    },
    intros_legales: {
      politica_cookies: "Cookies Policy",
      politica_privacidad: "Privacy Policy",
      datos_seguros: "Secure Data",
      aviso_legal: "Legal Advise",
      mapa_web: "web map"
    },
    volver: "Go back",
    volver_a: "Go back to",
    aviso_legal: {
      terminos: "TÉRMINOS Y CONDICIONES",
      uno:
        "I.- La utilización, consulta y/o contratación de los servicios que se exponen en nuestra página Web www.aldonzagourmet.com supone por parte de los usuarios y/o clientes la aceptación plena y sin reservas de las Condiciones Generales de Contratación, que regulan la relación jurídica derivada de los procesos de contratación realizados entre los usuarios y/o clientes de la página Web www.aldonzagourmet.com propiedad de <strong>Aldonza Gourmet S.A.U</strong> (en adelante Aldonza Gourmet). Los Clientes aceptan las Condiciones Generales desde el instante que utilicen o adquieran cualquier producto. Este documento puede ser impreso para ser leído y almacenado por los Clientes, previamente a su aceptación.",
      dos:
        "II.- Las presentes Condiciones Generales, están sujetas en lo que resulte de aplicación a lo dispuesto a la Ley 7/1998, de 13 de abril, sobre Condiciones Generales de Contratación, al Real Decreto Legislativo 1/2007, de 16 de noviembre, por el que se aprueba el Texto Refundido de la Ley General para la Defensa de Consumidores y Usuarios y otras leyes complementarias, al Real Decreto 1906/1999, de 17 de diciembre de 1999, por el que se regula la Contratación Telefónica o Electrónica con condiciones generales, el Reglamento (UE) 2016/679 del Parlamento Europeo y del Consejo, de 27 de abril de 2016, relativo a la protección de las personas físicas en lo que respecta al tratamiento de datos personales y a la libre circulación de estos datos y por el que se deroga la Directiva 95/46/CE (Reglamento general de protección de datos), la Ley Orgánica 3/2018, de 5 de diciembre, de Protección de Datos Personales y garantía de los derechos digitales, la Ley 7/1996, de 15 de enero de Ordenación del Comercio Minorista, y a la Ley 34/2002 de 11 de julio, de Servicios de la Sociedad de la Información y de Comercio Electrónico.",
      tres:
        "III.- Modificación de las Condiciones Generales. Aldonza Gourmet podrá modificar las Condiciones Generales notificándolo a los Clientes con antelación suficiente, con el fin de mejorar los servicios y productos ofrecidos a través de Aldonza Gourmet. Mediante la modificación de las Condiciones Generales expuestas en la página Web de Aldonza Gourmet se entenderá por cumplido dicho deber de notificación. En todo caso, antes de utilizar los servicios o contratar productos, se pondrán consultar las Condiciones Generales.",
      cuatro:
        "IV.- Propiedad intelectual. Todos los contenidos de esta página Web (incluyendo el código fuente, imágenes, textos, gráficos, etc.) están protegidos por la normativa nacional e internacional vigente sobre propiedad intelectual, encontrándose todos los derechos reservados. Queda terminantemente prohibida la reproducción de cualquier contenido de la Web sin el consentimiento expreso de Aldonza Gourmet y de los poseedores de los derechos.",
      cuatro_dos:
        "Mediante la adquisición de un producto, Aldonza Gourmet no confiere al adquirente ningún derecho de alteración, explotación, reproducción, distribución o comunicación pública sobre el mismo, reservándose Aldonza Gourmet todos estos derechos. La cesión de los citados derechos precisará el previo consentimiento por escrito por parte de Aldonza Gourmet. La utilización no autorizada de la información contenida en esta Web, su reventa, así como la lesión de los derechos de propiedad intelectual o industrial dará lugar a las responsabilidades legalmente establecidas.",
      cinco:
        "V.- Uso del servicio y responsabilidades. Aldonza Gourmet no garantiza la disponibilidad permanente de los servicios, quedando exonerado por cualquier tipo de responsabilidad por posibles daños y perjuicios causados debido a la indisponibilidad del servicio por causas de fuerza mayor o errores en las redes telemáticas de transferencia de datos, ajenos a su voluntad. Aldonza Gourmet no se hace responsable del contenido de los enlaces a otras páginas Web que no sean titularidad suya y que, por tanto, no pueden ser controladas por ésta.",
      seis:
        "VI.- Protección de datos. En cumplimiento de lo dispuesto en el artículo 5 de la Ley Orgánica 15/1999, de 13 de diciembre, de Protección de Datos de Carácter Personal, y en la Ley 34/2002, de 11 de Julio, de Servicios de la Sociedad de la Información y de Comercio Electrónico, Aldonza Gourmet S.A.U (en adelante Aldonza Gourmet) le informa de que los datos de carácter personal proporcionados en los formularios de registro electrónico contenidos en este sitio, así como aquellos datos a los que Aldonza Gourmet acceda como consecuencia de su navegación; consulta, solicitud o contratación, o de cualquier transacción u operación realizada desde este sitio web, serán recogidos en un fichero que cumple con las exigencias de la legislación vigente aplicable y cuyo responsable es: Aldonza Gourmet S.A.U., Parque Empresarial Ajusa. Nº1 - Ctra. 332 Km 2.2. 02006 – Albacete - España. (info@aldonzagourmet.com)",
      seis_uno:
        "La finalidad de la recogida y tratamiento automatizado de los Datos Personales realizados a través de los formularios y contactos vía correo electrónico habilitados en este sitio Web, es para facilitar la prestación de servicios que Ajusa proporciona a través de estas páginas, así como para facilitarle información sobre las actividades y noticias que pudieran resultar de su interés.",
      seis_dos:
        "El envío de datos personales, mediante el uso de los formularios electrónicos de esta Web o, en su caso, el envío de mensajes de correo electrónico solicitando información o servicios, supone el consentimiento expreso del Usuario al tratamiento automatizado de los datos incluidos, así como al envío de comunicaciones vía electrónica con información acerca de nuestras actividades.",
      seis_tres:
        "Por lo tanto, el Usuario expresa su consentimiento expreso para que los Datos Personales sean incorporados al Fichero de Datos Personales y sean objeto de tratamiento automatizado por parte de Aldonza Gourmet con las finalidades antes indicadas. Asimismo, expresa la aceptación y autorización para que Aldonza Gourmet pueda ceder los Datos Personales, a las empresas que prestan servicios a Aldonza Gourmet, tales como bancos y aseguradoras.",
      seis_cuatro:
        "El Usuario garantiza que los datos personales facilitados a Aldonza Gourmet son veraces y se hace responsable de comunicar al mismo cualquier modificación de los mismos.",
      seis_cinco:
        "Aldonza Gourmet pone a disposición de los usuarios la dirección de correo electrónico info@aldonzagourmet.com y el teléfono 967 21 77 11, para que éstos revoquen el consentimiento prestado. Aldonza Gourmet declara que cumple la normativa vigente respecto a la protección de datos, en particular la Ley Orgánica 15/1999, de 13 de diciembre, de Protección de Datos de Carácter Personal y el Real Decreto 1720/2007, de 21 de diciembre, que desarrolla la citada ley orgánica, y pone a disposición de los Clientes los medios de contacto referidos en el párrafo anterior para que estos ejerzan los derechos de acceso, rectificación, cancelación y oposición garantizados por la legislación vigente.",
      seis_seis:
        "Aldonza Gourmet se compromete a tratar de forma absolutamente confidencial los datos de carácter personal y hacer uso de los mismos exclusivamente para las finalidades indicadas.",
      siete:
        "VII.- Comunicaciones electrónicas comerciales. Aldonza Gourmet pone a disposición de los usuarios, que previamente lo hayan solicitado, a través de formularios de suscripción habilitados al efecto, el servicio de envío de noticias, actividades e informaciones. El Usuario podrá darse de baja de este servicio en cualquier momento que lo considere oportuno mediante el envío de un correo electrónico a info@aldonzagourmet.com",
      ocho:
        "VIII. Información General. De conformidad con la ley 34/2.002, de 11 de julio, de Servicios de la Sociedad de la Información y de Comercio Electrónico, Aldonza Gourmet, manifiesta que ha procedido a cumplir con el deber de información en los términos que establece esta normativa, al efecto de permitir, tanto a los destinatarios del servicio como a los órganos competentes, el acceso de forma permanente, fácil, directa y gratuita a la siguiente información: Aldonza Gourmet S.A.U Parque Empresarial Ajusa. Nº1 - Ctra. CM-332 Km 2.2. 02006 - Albacete (España). www.aldonzagourmet.com. Teléfono: 967 21 77 11 Datos de inscripción en el Registro Mercantil de Albacete, Hoja nº 5031, Folio 222, Tomo 635, Libro 399, Sección 8. C.IF. Nº A-02203859.",
      nueve:
        "IX. Información sobre el uso de cookies. Este sitio Web utiliza cookies, pequeños ficheros de datos que se generan en el ordenador del Usuario y que nos permiten obtener la siguiente información: La fecha y hora de la última vez que el Usuario visitó nuestro Web, los contenidos que el Usuario escogió en su primera visita a nuestro Web, etc. Con la finalidad de realizar estadísticas globales de acceso. El Usuario consiente el uso de estas cookies, que en ningún caso permitirán su identificación, con la exclusiva finalidad de facilitar su navegación por las diferentes páginas del presente sitio Web. En cualquier caso, el Usuario podrá denegar o impedir la instalación de estas cookies modificando la configuración de su navegador.",
      diez:
        "X. Responsabilidad. El uso del Web se realizará bajo la única y exclusiva responsabilidad del Usuario. Dicha responsabilidad se extenderá al uso, por parte del usuario o de cualquier tercero, de cualquier contraseña o similares asignadas para el acceso al Web o a cualesquiera de sus servicios.",
      diez_uno:
        "Aldonza Gourmet no asume responsabilidad alguna derivada de los contenidos enlazados desde la Web, siempre que sean ajenos a la misma, ni garantiza la ausencia de virus u otros elementos en los mismos que puedan producir alteraciones en el sistema informático (hardware y software), en los documentos o los ficheros del usuario, excluyendo cualquier responsabilidad por los daños de cualquier clase causados al usuario por este motivo. Aldonza Gourmet rechaza toda responsabilidad que se derive de la mala utilización de los contenidos expuestos en estas páginas y se reserva el derecho a actualizarlos, eliminarlos, establecer limitaciones o restringir su acceso en cualquier momento, de manera temporal o permanente.",
      once:
        "XI.- Nulidad e ineficacia de las Cláusulas. Si cualquier cláusula incluida en estas Condiciones Generales fuese declarada nula o ineficaz total o parcialmente, tal nulidad o ineficacia afectará tan sólo a dicha disposición o a la parte de la misma que resulte nula o ineficaz, subsistiendo las Condiciones Generales en todo lo demás, teniéndose tal disposición, o la parte de la misma que resultase afectada, por no puesta.",
      doce:
        "XII.- Conflictos. Para cualquier controversia o conflicto suscitado, será de aplicación la legislación española, siendo competentes para la resolución de todos los conflictos derivados o relacionados con ella, los Juzgados y Tribunales de Albacete.",
      doce_uno:
        "El acceso a las páginas Web de este sitio, implica la aceptación de todas las condiciones expresadas en esta información legal. Aldonza Gourmet, podrá modificar sin previo aviso, la estructura y diseño del Web, así como cambiar o eliminar, los servicios, los contenidos y las condiciones de acceso de uso del Web y adaptarla a los cambios legislativos que se produzcan."
    },
    datos_seguros: {
      p1:
        "En Europa y en España existen normas de protección de datos pensadas para proteger su información personal de obligado cumplimiento para nuestra entidad.",
      p2:
        "Por ello, es muy importante para nosotros que entienda perfectamente qué vamos a hacer con los datos personales que le pedimos.",
      p3:
        "Así, seremos transparentes y le daremos el control de sus datos, con un lenguaje sencillo y opciones claras que le permitirán decidir qué haremos con su información personal.",
      p4:
        "Por favor, si una vez leída la presente información le queda alguna duda, no dude en preguntarnos.",
      p5: "Muchas gracias por su colaboración.",
      h21: "<strong>¿Quiénes somos?</strong>",
      p6: "Nuestra denominación: <strong>ALDONZA GOURMET S.A.U.</strong>",
      p7: "Nuestro CIF / NIF: <strong>A02203859</strong>",
      p8:
        "Nuestra actividad principal: <strong>Producción y comercialización de vino, aceite de oliva virgen extra, azafrán y cava.</strong> ",
      p9:
        "Nuestra dirección: <strong>Parque Empresarial Ajusa, nº1 – Crta. CM 332, Km 2,2 / CP:02006, Albacete (España)</strong>",
      p10: "Nuestro teléfono de contacto: <strong>967 21 77 11</strong>",
      p11:
        "Nuestra dirección de correo electrónico de contacto: <strong>info@aldonzagourmet.com</strong>",
      p12: "Nuestra página web: <strong>www.adonzagourmet.com</strong>",
      p13:
        "Para su confianza y seguridad, le informamos que somos una entidad inscrita en el siguiente Registro Mercantil /Registro Público Hoja nº 5031, Folio 222, Tomo 635, Libro 399, Sección 8 – CIF Nº A-02203859. ",
      h22: "<strong>¿Para qué vamos a usar sus datos? </strong>",
      p14:
        "Con carácter general, sus datos personales serán usados para poder relacionarnos con usted y poder prestarle nuestros servicios.",
      p15:
        "Asimismo, también pueden ser usados para otras actividades, como enviarle publicidad o promocionar nuestras actividades.",
      h23: "¿Por qué necesitamos usar sus datos?",
      p16:
        "Sus datos personales son necesarios para poder relacionarnos con usted y poder prestarle nuestros servicios. En este sentido, pondremos a su disposición una serie de casillas que le permitirán decidir de manera clara y sencilla sobre el uso de su información personal.",
      h24:
        "<strong>¿Quién va a conocer la información que le pedimos?</strong>",
      p17:
        "Con carácter general, sólo el personal de nuestra entidad que esté debidamente autorizado podrá tener conocimiento de la información que le pedimos.",
      p18:
        "De igual modo, podrán tener conocimiento de su información personal aquellas entidades que necesiten tener acceso a la misma para que podamos prestarle nuestros servicios.",
      p181:
        "Así por ejemplo, nuestro banco conocerá sus datos si el pago de nuestros servicios se realiza mediante tarjeta o transferencia bancaria.",
      p19:
        "Asimismo, tendrán conocimiento de su información aquellas entidades públicas o privadas a las cuales estemos obligados a facilitar sus datos personales con motivo del cumplimiento de alguna ley. Poniéndole un ejemplo, la Ley Tributaria obliga a facilitar a la Agencia Tributaria determinada información sobre operaciones económicas que superen una determinada cantidad.",
      p20:
        "En el caso de que, al margen de los supuestos comentados, necesitemos dar a conocer su información personal a otras entidades, le solicitaremos previamente su permiso a través de opciones claras que le permitirán decidir a este respecto.",
      h25: "<strong>¿Cómo vamos a proteger sus datos?</strong>",
      p21:
        "Protegeremos sus datos con medidas de seguridad eficaces en función de los riesgos que conlleve el uso de su información.",
      p22:
        "Para ello, nuestra entidad ha aprobado una Política de Protección de Datos y se realizan controles y auditorías anuales para verificar que sus datos personales están seguros en todo momento.",
      h26: "<strong>¿Enviaremos sus datos a otros países?</strong>",
      p23:
        "En el mundo hay países que son seguros para sus datos y otros que no lo son tanto. Así por ejemplo, la Unión Europea es un entorno seguro para sus datos. Nuestra política es no enviar su información personal a ningún país que no sea seguro desde el punto de vista de la protección de sus datos.",
      p24:
        "En el caso de que, con motivo de prestarle el servicio, sea imprescindible enviar sus datos a un país que no sea tan seguro como España, siempre le solicitaremos previamente su permiso y aplicaremos medidas de seguridad eficaces que reduzcan los riesgos del envío de su información personal a otro país.",
      h27:
        "<strong>¿Durante cuánto tiempo vamos a conservar sus datos?</strong>",
      p25:
        "Conservaremos sus datos durante nuestra relación y mientras nos obliguen las leyes. Una vez finalizados los plazos legales aplicables, procederemos a eliminarlos de forma segura y respetuosa con el medio ambiente. ",
      h28: "<strong>¿Cuáles son sus derechos de protección de datos?</strong>",
      p26:
        "En cualquier momento puede dirigirse a nosotros para saber qué información tenemos sobre usted, rectificarla si fuese incorrecta y eliminarla una vez finalizada nuestra relación, en el caso de que ello sea legalmente posible. ",
      p27:
        "También tiene derecho a solicitar el traspaso de su información a otra entidad. Este derecho se llama “portabilidad” y puede ser útil en determinadas situaciones.",
      p28:
        "Para solicitar alguno de estos derechos, deberá realizar una solicitud escrita a nuestra dirección, junto con una fotocopia de su DNI, para poder identificarle. ",
      p29:
        "En las oficinas de nuestra entidad disponemos de formularios específicos para solicitar dichos derechos y le ofrecemos nuestra ayuda para su cumplimentación.",
      p30:
        "Para saber más sobre sus derechos de protección de datos, puede consultar la página web de la Agencia Española de Protección de Datos (www.agpd.es).",
      h29:
        "<strong>¿Puede retirar su consentimiento si cambia de opinión en un momento posterior?</strong>",
      p31:
        "Usted puede retirar su consentimiento si cambia de opinión sobre el uso de sus datos en cualquier momento. ",
      p32:
        "Así, por ejemplo, si usted en su día estuvo interesado/a en recibir publicidad de nuestros productos o servicios, pero ya no desea recibir más publicidad, puede hacérnoslo constar a través del formulario de oposición al tratamiento disponible en las oficinas de nuestra entidad.",
      h210:
        "<strong>En caso de que entienda que sus derechos han sido desatendidos, ¿dónde puede formular una reclamación?</strong>",
      p33:
        "En caso de que entienda que sus derechos han sido desatendidos por nuestra entidad, puede formular una reclamación en la Agencia Española de Protección de Datos, a través de alguno de los medios siguientes:",
      p333: "o Sede electrónica: www.agpd.es",
      p34: "o Dirección postal:",
      p35: "Agencia Española de Protección de Datos ",
      p36: "C/ Jorge Juan, 6",
      p37: "28001-Madrid ",
      p38: "o Vía telefónica:",
      p39: "Telf. 901 100 099 ",
      p40: "Telf. 91 266 35 17",
      p41:
        "Formular una reclamación en la Agencia Española de Protección de Datos no conlleva ningún coste y no es necesaria la asistencia de abogado ni procurador. ",
      h211: "<strong>¿Elaboraremos perfiles sobre usted?</strong>",
      p42:
        "Nuestra política es no elaborar perfiles sobre los usuarios de nuestros servicios.",
      p43:
        "No obstante, pueden existir situaciones en las que, con fines de prestación del servicio, comerciales o de otro tipo, necesitemos elaborar perfiles de información sobre usted.",
      p44:
        "Un ejemplo pudiera ser la utilización de su historial de compras o servicios para poder ofrecerle productos o servicios adaptados a sus gustos o necesidades.",
      p45:
        "En tal caso, aplicaremos medidas de seguridad eficaces que protejan su información en todo momento de personas no autorizadas que pretendan utilizarla en su propio beneficio. ",
      h212: "<strong>¿Usaremos sus datos para otros fines?</strong>",
      p46:
        "Nuestra política es no usar sus datos para otras finalidades distintas a las que le hemos explicado. Si, no obstante, necesitásemos usar sus datos para actividades distintas, siempre le solicitaremos previamente su permiso a través de opciones claras que le permitirán decidir al respecto."
    },
    mejor_bodega_CM: "Chosen as the best winery in Castilla-La Mancha"
  },
  ja: {
    enlaces: {
      home: "/ja-home",
      finca: "/ja-estate",
      la_tierra: "/ja-estate/land",
      la_bodega: "/ja-estate/winery",
      proceso_cava: "/ja-estate/winery/cava-process",
      proceso_vino: "/ja-estate/winery/wine-process",
      la_almanzara: "/ja-estate/oil-mill",
      queseria: "/ja-estate/dairy",
      proceso_aceite: "/ja-estate/land/oil-process",
      proceso_queso: "/ja-estate/land/cheese-process",
      sala_azafran: "/ja-estate/saffron-room",
      proceso_azafran: "/ja-estate/saffron-room/saffron-process",
      productos: "/ja-products",
      vino: "/ja-products/wine",
      aceite: "/ja-products/olive-oil",
      azafran: "/ja-products/saffron",
      cava: "/ja-products/cava",
      queso: "/ja-products/cheese",
      productos: "/ja-products",
      premios: "/ja-awards",
      beneficios: "/ja-benefits",
      experiencias: "/ja-experiences",
      vive_aldonza: "/ja-experiences/experience-aldonza",
      oleoturismo: "/ja-experiences/experience-aldonza/oleotourism",
      degustacionQuesos: "/ja-experiences/experience-aldonza/cheese-tasting",
      ruta_cervantina: "/ja-experiences/experience-aldonza/cervantes-route",
      enoturismo: "/ja-experiences/experience-aldonza/oenotourism",
      recetario:
        "/ja-experiences/experience-aldonza/recipe-book-and-gastronomy-route",
      escucha_aldonza: "/ja-experiences/listen-to-aldonza",
      contacto: "/ja-home/contact",
      politica_proteccion: "/ja-data-protection-policy",
      politica_cookies: "/ja-cookie-policy",
      datos_seguros: "/ja-your-data-secure",
      aviso_legal: "/ja-legal-notice",
      mapa_web: "/ja-website",
      contactoid: "ja-contact",
      mejor_bodega_CM:
        "https://blog.aldonzagourmet.com/2024/11/mejor-bodega-de-castilla-lamancha/"
    },
    vistas: {
      inicio: "Home",
      la_finca: "農園",
      la_tierra: "自然環境",
      la_almazara: "オリーブオイル搾油所",
      la_bodega: "ワイナリー",
      queseria: "チーズ工房 ",
      sala_azafran: "サフランルーム",
      productos: "当社製品",
      productos_aldonza: "アルドンサ製品",
      premios: "賞と表彰",
      beneficios: "便益",
      experiencias: "体験ツアー",
      oleoturismo: "オリーブ観光ツアー",
      degustacionQuesos: "チーズのテイスティング定番のやり方 ",
      vive_aldonza: "アルドンサを生きる",
      las_catas: "ワインの試飲",
      experiencia_bodega: "アルドンサ体験を体験してきた人々:",
      ruta_cervantina: "セルバンテスの道",
      enoturismo: "ワイン観光ツアー",
      recetario: "レシピ集",
      escucha_aldonza: "アルドンサを聞く",
      blog: "ブログ",
      contacto: "連絡先",
      politica_proteccion: "プライバシーポリシー",
      politica_cookies: "クッキーに関するポリシー",
      mapa_web: "Website",
      datos_seguros: "安全化されたデータ",
      aviso_legal: "法的通知"
    },
    home: {
      intro: {
        titulo_uno: "アルドンサ体験",
        titulo_dos: "",
        titulo_tres: "",
        experiencia_aldonza: "体験が始まります",
        aqui: "ホーム",
        tienda: "オンラインストア",
        tarifas: "価格レート"
      },
      comienza: {
        titulo_uno: "体験が始まります",
        titulo_dos: "",
        titulo_tres: "",
        experiencia_aldonza: "アルドンサ体験",
        cuerpo:
          "自然が与えてくれる繊細な変化を大切にすることが、当社のワイン、カバ、エキストラ・バージンオリーブオイル、サフランが目覚めさせる感覚を創り出す原点です。"
      },
      la_finca: {
        titulo_uno: "農",
        titulo_dos: "場",
        cuerpo:
          "この特別な環境が、他の製品との違いを生み出します。ラ・デエサ・デ・ナバマリンへようこそ。",
        aldonza_experience: "Aldonza Experience"
      },
      productos: {
        titulo: "当社製品"
      },
      experiencia: {
        titulo_uno: "",
        titulo_dos: "体験",
        aldonza_experience: "アルドンサを体験しよう！",
        escucha_aldonza: {
          cuerpo:
            "音楽を通して、新しい感覚を目覚めさせる新しい場所に行ってみましょう。聞いて、身を任せてください！"
        }
      },
      contacto: {
        titulo: "お問合せ"
      }
    },
    blog: {
      titulo: "体験は続く",
      subtitulo: "アルドンサのブログ",
      boton: "ver"
    },
    newsletter: {
      titulo: "ニュースレターを定期的に受け取る",
      cuerpo: "最新情報をメールで受け取る",
      texto_comunicaciones: "最新情報をメールで受け取る",
      boton: "登録する",
      enviado: "You subscribed correctly!"
    },
    otros_lugares: {
      titulo: "その他の場所",
      lugares: {
        la_tierra: "自然環境",
        la_bodega: "ワイナリー",
        la_almanzara: "オリーブオイル搾油所",
        sala_azafran: "サフランルーム",
        queseria: "チーズ工房 "
      }
    },
    la_tierra: {
      descubrir_proceso: "製造過程について知る",
      la_tierra: {
        cuadro_uno: {
          titulo: "環境",
          texto:
            "ラ・デエサ・デ・ナバマリン（La Dehesa de Navamarín）は、アルバセテ県（スペイン）の北西、標高1,200メートル以上の大自然の中に位置しています。グアディアナ川とフカル川の分水嶺に位置し、ビャクシン属サビナス樹の世界最大保護地区が広がる山に囲まれた、西洋ヒイラギ樫や香草が自生している山地の中に分布する2,200ヘクタールの土地を所有しています。"
        },
        cuadro_dos: {
          titulo: "ラ・ティエラ",
          texto_uno:
            "土地：このあたり一帯は、1万年前は氷河に覆われていたため、たくさんの大小の円い石が転がっており、土の水分が蒸発しにくくなっています。",
          texto_dos:
            "土壌：中性、またはアルカリ性よりのpH度の石灰質の土壌で水はけが良いのが特徴です。栽培に最適な土壌であるということが、アルドンサ製品の質に反映しています。",
          texto_tres:
            "野生動物：ラ・デエサ・デ・ナバマリンは、シカ、イノシシ、ヤマウズラといった多くの在来種動物や外来種動物（ムフロン）の生息地になっています。これらの動物の排泄物は、有機質肥料として役立っています。",
          texto_cuatro:
            "気候：寒い冬と暑くて非常に乾燥した夏の大陸性気候は、寒暖の差が激しい気象条件で、作物に有害な菌類や細菌の増殖が防げます。さらに、葡萄は、気温差が激しいと、熟成段階でポリフェノール（タンニンとアントシアニン）の生成が促されます。",
          texto_cinco:
            "サビナ：ジャクシン属の灌木。東洋起源の保護種であるこの千年樹がオリーブ園・葡萄園の周りに生えているため、収穫する果実の中に健康に有効な成分が多く含まれています。"
        },
        frutos: {
          titulo: "果実・産物",
          cuerpo:
            "栽培地の標高が高く厳しい気象条件は、作物の品質に直接大きな影響を及ぼします。アルドンサでは、さまざまな品種の葡萄、ピクアル種とアルベキーナ種のオリーブ、ラ・マンチャ地方原産地呼称保護制度認証章付きのサフランを栽培しています。"
        },
        escalera: {
          vinedo: {
            titulo: "葡萄園",
            cuerpo:
              "ラ・デエサ・デ・ナバマリンには、葡萄栽培専用に27ヘクタールの土地があり、この地方の代表的な赤ワイン用にテンプラニーリョ種、カベルネ・ソーヴィニヨン種、メルロー種、シラー種を、また、白ワイン用にソーヴィニヨン・ブラン種、マカベオ種を栽培しています。また、カバ（スペインのスパークリングワイン）は、カタルーニャ州のペネデス地方で栽培、サン・サドゥルニ・ダノイア醸造所（バルセロナ）で醸造しています。この地域は、原産地名称保護制度（D.O.）付きのカバ産地として広く知られており、そこでチャレロ種、マカベオ種、パレリャーダ種の葡萄と赤葡萄のトレパート種を栽培しています。"
          },
          azafranal: {
            titulo: "サフラン畑",
            cuerpo:
              "サフラン栽培には、風通しが良く、石灰質で乾燥した平地を選んでいます。土壌は、有機物のバランスもよく、侵食のリスクが少なく、球根を傷めないように水はけの良い適度な深さに作付けします。サフランを連作すると、地力が落ちるので、毎年高品質のサフランが採れるように、3，4年の輪栽式農法を採用しています。"
          },
          olivos: {
            titulo: "オリーブ園",
            cuerpo:
              "750ヘクタールあるオリーブ園では、ピクアル種とアルベキーナ種の2種類のオリーブが栽培されており、オリーブの木一本一本、規格標準化された手入れ方法によって管理されています。ピクアル種は、スペインで最も栽培されている品種で、全生産量の50％以上を占めます。味は苦味と辛みが少し効いた強い風味が特徴です。アルベキーナ種は、寒さに対する抵抗力が非常に高いが、樹勢がかなり弱いのが特徴です。味は、甘く滑らかです。"
          }
        }
      },
      la_almazara: {
        cuadro_uno: {
          titulo: "施設",
          texto:
            "最高品質のエキストラ・バージン・オリーブオイルを提供するために、常に自然環境を大切にしつつ、オリーブオイルの最新分析機械などの新技術を取り入れています。親から子へ代々と受け継がれた伝統、郷土愛に支えられ、アルドンサは日々努力しています. Aldonzaは、<a href ='/static/pdf/certificado-IFS.pdf'download ><strong><u>IFS</u></strong></a>および<a href ='/static/pdf/certificado-BRC.pdf'download><strong><u>BRC</u></strong></a>規制によって認定されています。"
        },
        cuadro_dos: {
          titulo: "搾油所",
          texto:
            "<p>エクストラ・バージン・オリーブオイルが出来るまで一貫して厳格な品質管理が出来るよう、オリーブの木一本一本を大切に育て、先端技術を備えた独自の搾油所で、搾油、瓶詰の製造過程全体を一括管理しています。搾油後は、遮光された涼しいステンレス製保存庫で、オリーブの持つ新鮮な風味を落とさないよう保存しています。また、環境保護に対する意識も高く、環境に優しい機械を使用しています。</p>"
        },
        proceso: {
          titulo: "エクストラ・バージン・オリーブオイルが出来るまで",
          cuerpo:
            "近代的な設備にも、伝統的なやり方を生かして。常に優れた品質のエキストラ・バージン・オリーブオイルが得られるよう、愛情をたっぷり注いで造っています。"
        },
        sala_catas: {
          titulo: "オリーブオイルのテイスティング",
          cuerpo:
            "フルーティーで強い香り。味は、丁度いい苦味と辛みがきいています。アルドンサのオリーブ観光ツアーで、プロのエキストラ・バージン・オリーブオイル・テイスティングを行ってみませんか。",
          boton_large: "発見する",
          boton_short: "発見する"
        }
      },
      sala_azafran: {
        cuadro_uno: {
          titulo: "収穫",
          texto:
            "カスティーリャ・ラ・マンチャで栽培されたサフランのみが、ラ・マンチャの原産地名称保護制度認証章を受けられます。色、香り、風味が最高であること、食品としての安全性、スペイン原産品という三点を世界的に保証しています。アルバセテ県の北西に位置し、寒暖の差が激しい気候と地形条件に恵まれ、サフラン栽培に適した石灰質のルカリ性土壌の畑で栽培されるからこそ、特性が多く、風味豊かな良質のサフランが採れます。"
        },
        cuadro_dos: {
          titulo: "サフランルーム",
          texto:
            "サフラン畑での栽培から始まり、近代的自社施設での梱包に終わるまで、アルドンサの専門チームがサフランの品質と安全管理を担っています。栽培、選別、梱包まで、一つ一つ手作業で丁寧に厳選しています。アルドンザは以下の基準で認証されている。<a href ='/static/pdf/certificado-IFS.pdf'download ><strong><u>IFS</u></strong></a> & <a href ='/static/pdf/certificado-BRC.pdf'download><strong><u>BRC.</u></strong></a>"
        },
        proceso: {
          titulo: "サフランが出来るまで",
          cuerpo:
            "サフランが出来るまでのプロセスは、その赤い雌蕊（柱頭）のようにとても繊細です。伝統に従い、全工程で細心の注意を払って作業を行います。"
        },
        sala: {
          titulo: "サフランルーム",
          cuerpo:
            "サフラン生産の秘密はカスティーリャ・ラ・マンチャの家庭で何世代にも亘って受け継がれてきた無形の遺産で、この郷土の大衆文化とも言えます。その何千年も受け継がれてきた知恵は、ここアルドンサのサフランの部屋で今でも生き続けています。"
        }
      },
      la_bodega: {
        cuadro_uno: {
          titulo: "施設",
          texto:
            "ドン・キホーテが活躍した地の中心部、アルバセテ県の北西に位置するムネラで、4世代以上に渡り代々ワイン造りを営んでいます。私たちのワイナリーと葡萄園では、ミゲル・デ・セルバンテスが「エル・キホーテ」の中で描いた伝統と伝説が未だ息づいています。オリーブオイルやサフランといった伝統的なラ・マンチャ特産品とともに、ワインは私たちの「ものづくり」への情熱の賜物です。알돈자는 다음 표준에 따라 인증되었습니다 <a href ='/static/pdf/certificado-IFS.pdf'download ><strong><u>IFS</u></strong></a> & <a href ='/static/pdf/certificado-BRC.pdf'download><strong><u>BRC.</u></strong></a> "
        },
        cuadro_dos: {
          titulo: "ワイナリー",
          texto:
            " <p>近代的な設備を備えながらも、伝統的な家族経営で行っているワイナリー。私達の官能を呼び覚ますワイン造りのため、伝統と近代技術が見事に組み合っています。</p>"
        },
        proceso: {
          titulo: "ワインが出来るまで",
          cuerpo:
            "良いワインは、良い葡萄から。ワイン造りに適した品質の良い葡萄のみを使い、心を込めてそのおいしさを最大限に引き出すことにこだわっています。"
        },
        proceso_cava: {
          titulo: "カバの出来るまで",
          cuerpo:
            "カタルーニャ州のペネデス地方（バルセロナ）で、伝統的なカバの醸造方法を守り継いで、原産地名称保護制度認証章付きのカバ、4種類のスパークリングワインを造っています。"
        },
        sala_barricas: {
          titulo: "樽貯蔵室",
          cuerpo:
            "木の薫りにワインの匂い、滝の音、屋内のぼんやりとした薄明かり。まるで別世界に迷い込んでしまったようです。ワイナリーの丁度地下に位置する洞窟に造られた樽貯蔵室を見ると、私たちのワインの品質の良さに納得せざるを得ないでしょう。他に類のない空間を楽しみながら、当社の製品を味わうことができます。",
          boton_large: "発見しよう！",
          boton_short: "発見しよう！"
        }
      },
      queseria: {
        cuadro_uno: {
          titulo: "チーズ作りの達人 ",
          texto:
            "<p>農業の伝統だけでなく、牧畜業の伝統にも後押しされ、羊乳を用いて作られるラ・マンチャの原産地呼称チーズ「ケソ・マンチェゴ」を製造しています。 作り手の愛情が伝わる、最高級のチーズを提供するため日々努力を重ねています。また、家畜だけでなく乳の品質に要求される食品の安全管理を確保するため、伝統的製法に最高のテクノロジーを取り入れています。<div class='certificados'><div><a class='link-certificados queso' href='/static/pdf/certificado-SAE.pdf' download >Certificate SAE 2021-0014</a></div></div></p> "
        },
        cuadro_dos: {
          titulo: "種類",
          texto:
            "アルドンサ・グルメでは、ハードタイプ、セミハードタイプ、エキストラバージンオリーブオイル漬けの3種類のチーズを製造していますが、いずれも純血マンチェガ種の羊の乳から作られています。これらのチーズの味わいを、100%マンチェゴチーズの伝統と文化と併せて五大陸に輸出しています。 "
        },
        proceso: {
          titulo: "チーズの製造",
          cuerpo: "マンチェゴチーズの伝統的製法を守っています。  "
        }
      }
    },
    saber_mas: "詳細を見る",
    certificadoBRC: "Certificate BRC",
    certificadoIFS: "Certificate IFS",
    Certificados:
      "Aldonza is certified by <a href ='/static/pdf/certificado-IFS.pdf'download >IFS </a> and <a href ='/static/pdf/certificado-BRC.pdf'download>BRC</a> regulations.",
    Certificados2:
      "Company certified by <a href ='/static/pdf/certificado-IFS.pdf'download >IFS </a> and <a href ='/static/pdf/certificado-BRC.pdf'download>BRC</a> regulations.",
    slider_productos: {
      vino: {
        slug: "vino",
        titulo: "アルドンサ・ワイン",
        cuerpo:
          "伝説と伝統が息づく風味を持つ4種類のアルドンサ・ワインでそれぞれ異なる体験をお楽しみください。",
        button: "ワイン"
      },
      aceite: {
        slug: "aceite",
        titulo: "アルドンサ・オリーブオイル",
        cuerpo:
          "特別なエキストラバージンオリーブオイルの香り、質感、そして風味をまず控え室から感じ始めるでしょう。入念な精製過程の賜物。",
        button: "オリーブオイル"
      },
      azafran: {
        slug: "azafran",
        titulo: "アルドンサ ・サフラン",
        cuerpo:
          "骨の折れるような手作業で進められる繊細なサフラン採取の仕事は、高品質として高く評価されている雌蕊一本一本に反映しています。アルドンサのサフランはラ・マンチャ原産地名称保護制度認証付きです。",
        button: "サフラン"
      },
      cava: {
        slug: "cava",
        titulo: "アルドンサ・ カバ",
        cuerpo:
          "シャンパン・グラスから気泡が上がってくる瞬間からさわやかが漂います。 4種類のスパークリングワインのそれぞれの違いを感じてお楽しみください。",
        button: "カバ（スパークリングワイン"
      },
      queso: {
        slug: "queso",
        titulo: "マンチェゴ・チーズ　DOP",
        cuerpo:
          "ラ・マンチャの本物の味が、私達の地域の特産物を世界中に広めるという精神と融合します。",
        button: "チーズ"
      }
    },
    slider_proceso: {
      proceso_vino: {
        id: "proceso-del-vino",
        padre: "la_bodega",
        pasos: {
          vendimia: {
            titulo: "収穫",
            cuerpo:
              "<p>葡萄がワイン造りに最適の糖度に成熟する（通常8月の終わりから9月の初め）と、収穫を開始します。高温によって葡萄の果実が傷み、発酵プロセスに影響が出ないように、伝統に従い、夜間に手摘みで収穫します。収穫された葡萄は直ぐに箱でワイナリーに運ばれ、最適な葡萄の実のみを手作業で厳しく選別します。</p>"
          },
          fermentacion: {
            titulo: "発酵と圧搾",
            cuerpo:
              "<p>選別された葡萄は除梗され、コンピューター制御されたスチールタンクに入れられ、発酵プロセスが始まります。発酵した液体から果皮と種子を取り除く圧搾には、特に注意が払われています。</p>"
          },
          crianza: {
            titulo: "熟成",
            cuerpo:
              "<p>醸造長を中心に、各年の収穫の質に応じ、樽の中で熟成させる期間（最低6か月以上）が決定されます。。ワイナリーの地下にある樽貯蔵室は、年間を通して温度と湿度のバランスが保たれており、そこでアメリカ製とフランス製のオーク樽の中に詰められた赤ワインが熟成し、それぞれの個性を得ていきます。それぞれのワインに望む芳香と風味が得られたら、澱引き・瓶詰めを行い、樽の中で熟成した期間と同じ期間瓶内でさらに熟成させます。</p>"
          },
          etiquetado: {
            titulo: "ラベリング",
            cuerpo:
              "<p>私たちの郷土愛とワイン造りに対する情熱は、ラベル付けの段階でも見て取れます。ワイン製造工程の最後の最後まで、品種管理・調整を厳しくしています。20か国以上にアルドンサのワインを届けている配送部門から送り出されると、私たちのワイン製造プロセスが完了します。</p>"
          }
        },
        boton: "私たちのワイン"
      },
      proceso_cava: {
        id: "proceso-del-cava",
        padre: "la_bodega",
        pasos: {
          vendimia: {
            titulo: "収穫",
            cuerpo:
              "<p>葡萄（チャレロ種、マカベオ種、パレリャーダ種、トレパット種）の収穫後、由緒あるサン・サドゥルニ・ダノイア（バルセロナ）の醸造所で、昔からの伝統的な方法に乗っ取り、カバ造りが始まります。エル・モスト・フロールと呼ばれる一番搾りで得られるモストのみを使用して造ります。</p>"
          },
          tiraje: {
            titulo: "ティラへ（瓶詰め）",
            cuerpo:
              "<p>こでは、ベースワインに酵母とショ糖の混合物を注入して、ボトルに充填します。そうすることによって、ボトル内で2度目の発酵が始まり、カバ独特のきめの細かい泡が生成されます。最低9か月置いて、瓶内二次発酵を行います。</p>"
          },
          deguelle: {
            titulo: "デグエル（澱抜き）",
            cuerpo:
              "<p>この工程では、まずボトルを逆さまにし、ボトルの口を冷凍させ、栓を抜き、凍った澱を取り除きます。その後、ベースワインとショ糖が加えられます。このショ糖の量によって、カバがナトゥーレ、ブルット、セミスイートになるか（辛口か甘口か）が決定します。</p>"
          },
          etiquetado: {
            titulo: "ラベル張りと配送",
            cuerpo:
              "<p>常に最高の品質を維持するのにこだわり、カバ造りのすべての工程で、品質管理を厳重に行っております。</p>"
          }
        },
        boton: "当社のカバ"
      },
      proceso_aceite: {
        id: "proceso-del-aceite",
        padre: "la_almanzara",
        pasos: {
          cosecha: {
            titulo: "収穫",
            cuerpo:
              "<p>オリーブオイルの酸度、風味、採油量が左右されるので、オリーブの熟度を見極め、最適な収穫時期を決定することがとても重要です。これがエキストラ・バージン・オリーブオイルの品質を決定づけるものであり、オリーブが熟れ始める11月の初めから、オリーブの熟れ具合を徹底的に監視しています。収穫は通常、11月末から12月初旬に始まり、まだ地面に落ちていない健康的な果だけを収穫します。</p>"
          },
          recepcion: {
            titulo: "工場への収集と洗浄",
            cuerpo:
              "<p>収穫したオリーブを傷つけない様に工場に集め、そこでオリーブの組成を分析し、果実の衛生状態を確認します。オリーブ果実は、粉砕工程に進む前に、まず、扇風機で葉、小枝などの不純物が取り除かれ、次に、洗浄機に通され、汚れなどがきれいに取り除かれます。このようにして、すべての不純物が除去されます。</p>"
          },
          molienda: {
            titulo: "粉砕とペースト化",
            cuerpo:
              "<p>粉砕工程では、オリーブ果実を細かく粉砕し、常に25度以下の室温で休みなく攪拌し、採油しやすいようにペースト状にします。</p>"
          },
          extraccion: {
            titulo: "オイルの搾油と純化",
            cuerpo:
              "<p>オリーブのペーストが出来たら、残りの成分からオイルを分離します。他の工程と同様、搾油技術が進歩し、昔ながらの天然繊維フィルターを使った搾圧機から、デカンターとも呼ばれる高速で効率的な遠心分離機によるオイルの抽出を開始しました。ペーストは、密度に応じて異なる成分を分離する遠心力の作用を受け、液体（オイル）と個体（搾りかす）に分けられます。しかしながら、デカンターから出たオイルには、まだ個体の不純物と水が含まれているので、さらに高速で高精度の垂直遠心分離機を使用して、オイルと不純物の接触時間を短縮し、より純粋なオイルの抽出を行います。</p>"
          },
          almacenamiento: {
            titulo: "保存と梱包",
            cuerpo:
              "<p>エキストラ・バージン・オリーブオイルは、光・外部の匂い・外気温・騒音などの悪条件によって劣化するのを防ぐために、冷暗所のステンレススチールタンクに保管します。瓶詰めする前に、フィルター機で濾過し、さらに明るい色のきれいなオイルにします。瓶詰め機では、最後の瞬間までオイルの風味官能特性をコントロールし、自社が設定した品質基準に合っているか確かめます。</p>"
          }
        },
        boton: "私たちの油"
      },

      proceso_queso: {
        id: "proceso-del-queso",
        padre: "queseria",
        pasos: {
          Ordeño: {
            titulo: "搾乳・凝乳",
            cuerpo:
              "羊の乳を搾ったらすぐに、すべての成分を生かすため乳を4度に冷却。その後、凝固タンクに羊乳を入れて温め、30度に保ちます。凝固してカード（凝乳状態のもの）が適切な固さになったらカットし、チーズの型詰めに移ります。  "
          },
          moldelado: {
            titulo: "成型・圧搾・加塩 ",
            cuerpo:
              "カードを手作業で型に詰めたら、連番が記載されたカゼインプレートを上に置き、マンチェゴチーズを一つ一つ識別します。その後、チーズに圧力をかけ、ホエイ（乳精）を完全に取り除いて最終的な形にしていきます。 圧搾後、型から取り出したらチーズの加塩を行います。この加塩の間、チーズは微生物による発酵プロセスを調整し、その味わいを深め、外皮を形成していきます。"
          },
          maduracion: {
            titulo: "熟成",
            cuerpo:
              "チーズの熟成は、セミハードは60～100日間、ハードタイプの場合は150～210日間行われます。 熟成庫は温度や湿度の状態を一定に保ち、マンチェゴチーズをうまく熟成できるようにしています。"
          }
        },
        boton: "私たちのチーズ"
      },
      proceso_azafran: {
        id: "sala-del-azafran",
        padre: "sala_azafran",
        pasos: {
          cosecha: {
            titulo: "作付",
            cuerpo:
              "<p>球根の植え付けは6月から9月にかけて行われ、秋たけなわの頃サフランの花が一斉に開花し始めます。サフラン栽培に適した、日当たりが良く水はけの良い粘土石灰質土壌の畑に、球根を痛めないように、浅めに植え付けを行います。</p>"
          },
          recoleccion: {
            titulo: "収穫",
            cuerpo:
              "<p>10月の終わりから11月の初めには、日の出前から、花摘み人が口ずさむ歌や口笛が農園から聞こえてきます。サフランの雌蕊は、日光を浴びると色や味の質が落ちてしまうので、夜明け前に花を採取します。</p>"
          },
          monda: {
            titulo: "モンダ（雌蕊採取)",
            cuerpo:
              "<p>何千年もの昔から今も変わらぬ方法で行われています。まだ朝露が乾ききらぬ間に、摘み取られたサフランの花が作業所に運ばれてきます。そして、モンダと呼ばれる雌蕊（柱頭）だけを花の付け根から注意深く一本一本壊れないように抜き取る繊細な作業が行われます。新鮮さを保つため、花を摘んでから12時間以内に終わらせないといけません。</p>"
          },
          tostado: {
            titulo: "焙煎",
            cuerpo:
              "<p>サフランを弱火の網の上で炙ります。一本一本綺麗なままの形で、風味が失われないように気を付けながら焙じます。着色力、芳香、安定性などの製品特性を決定する重要な工程です。</p>"
          },
          almacenamiento: {
            titulo: "保存",
            cuerpo:
              "<p>乾燥したサフランは、水分や光から守る容器に手作業ですばやく入れられ、室内温度が25ºC以下の場所で保管されます。</p>"
          }
        },
        boton: "Our Saffron"
      }
    },
    productos_banner: {
      title: "当社製品",
      productos: {
        vino: "ワイン",
        aceite: "エキストラ・バージン・オリーブオイル",
        azafran: "サフラン",
        cava: "カバ（スパークリングワイン"
      }
    },
    tips_productos: {
      tipo_vino: "ワインの種類",
      tipo_uva: "ぶどう",
      tipo_cava: "Sparkling wine:",
      elaboracion: "醸造",
      gastronomia: "相性の合う料理",
      notas_cata: "ソムリエ評",
      premios: "賞品",
      ingredientes: "原材料と栄養成分表示",
      caracteristicas: "商品特徴",
      maridaje: "お薦めマリアージュ",
      descargar_ficha: "ダウンロードする",
      curacion: "熟成",
      apariencia: "見た目",
      conservacion: "保存",
      durabilidad: "製造から1年。各包装に記載されています。",
      alergenos: "乳糖とリゾチーム(卵由来)",
      valoresnutricionales: "栄養価"
    },
    productos: {
      vino: {
        slug: "vino",
        nombre: "ワイン",
        intro_ficha: {
          titulo: "五感を目覚めさせる",
          cuerpo:
            "<p>私たちのワインは、ラ・デエサ・デ・ナバマリンという栽培環境で育った独特の特性を持っています。それはワイン造りに携わる専門家の情熱の結晶。ドン・キホーテの地に残るワインの伝統文化の痕跡。フランス品種とスペイン品種の葡萄から作られた個性のあるワイン。情熱と魂のこもったワイン。それは、センセーショナルなワインです。</p>"
        },
        intro_productos:
          "「完璧な瞬間を探すのではなく、瞬間を見つけて、その瞬間を完璧にしよう。」",
        productos: {
          navamarin: {
            id: "navamarin",
            nombre: "Navamarín",
            tipo_vino:
              "樽熟成赤ワイン フレンチオーク樽とアメリカオー ク樽で最低12ヶ月熟成。",
            tipo_uva: "カベルネ・ソーヴィニョン メルロ シラー テンプラニーリョ",
            elaboracion:
              "ラ・デエサ・デ・ナバマリンで醸造。世界 最大のサビナ保護地区があり、ワインに独 特の特性とアロマを与えている。 葡萄の木一本当たり2㎏を超えないよう生産 された葡萄を丁寧に選果。 樽熟成後コラージュ。 ",
            graduacion: "13,5 - 14,5%",
            cantidad: "750ml",
            servicio: "16º ~ 18º C",
            gastronomia: "肉料理、煮込み料理、ジビエ料理、チーズ",
            notas_cata: {
              texto:
                "ベリー系果実味とタバコに似た香草の味。フルボディ。渋みは柔 らかで丸い。後味はアロマが効いている。購入時に飲むのも保存 するのにも最適",
              autor: "ジェームズ・サックリング2019"
            },
            premios: [
              "navamarin-pswc-2011",
              "navamarin-berliner-2015",
              "navamarin-china-wine-2015",
              "navamarin-china-wine-2016",
              "navamarin-corea-wine-2015",
              "navamarin-corea-wine-2016",
              "navamarin-bruselas-2013",
              "navamarin-zarcillo-2007",
              "navamarin-testing-2014",
              "navamarin-wswa-2014",
              "navamarin-houston-2015",
              "navamarin-vinalies-2011",
              "navamarin-londres-2013",
              "navamarin-decanter-2013",
              "navamarin-mundus-2018",
              "navamarin-suckling-2018",
              "navamarin-suckling-2019",
              "navamarin-decanter-bronce-2019",
              "navamarin-mundus-2020",
              "navamarin-mundus-2021",
              "navamarin-penin-2023",
              "navamarin-bruselas-2022",
              "navamarin-londres-2022-2",
              "navamarin-bruxelles-2023"
            ]
          },
          selection: {
            id: "seleccion",
            nombre: "Selection",
            tipo_vino:
              "樽熟成赤ワイン フレンチオーク樽とアメリカオー ク樽で最低9ヶ月熟成。",
            tipo_uva:
              "カベルネ・ソーヴィニョン  メルロ シラー  テンプラニーリョ ",
            elaboracion:
              "生産量を限定した葡萄株で出来た葡萄を丁 寧に選果し、よく熟れた葡萄を夜のうちに 収穫。 最高のアッサンブラージュのために、樽の 中で熟成完了後、コラージュ。 当社の薄暗い洞窟内で最低12ヶ月瓶内で熟 成。",
            graduacion: "13,5 - 14%",
            cantidad: "750 ml",
            servicio: "Between 16º - 18º C.",
            gastronomia: "肉料理、煮込み料理、ジビエ料理、チーズ",
            notas_cata: {
              texto:
                "色はダークチェリーの赤。 よく熟したベリー系果実の香りが 強く、焙じた香、バニラ、ナッツ類の香り。口の中で広がるフ ルボディで完璧なアサンブラージュ。強い後味が長く続く。",
              autor: "ジェームズ・サックリング2019"
            },
            premios: [
              "seleccion-pswc-2011",
              "seleccion-testing-2014",
              "seleccion-wswa-2014",
              "seleccion-burdeos-2008",
              "seleccion-vinalies-2009",
              "seleccion-vinalies-2012",
              "seleccion-decanter-2017",
              "seleccion-suckling-2019",
              "seleccion-decanter-bronce-2019",
              "seleccion-2022"
            ]
          },
          classic: {
            id: "clasico",
            nombre: "Classic",
            tipo_vino:
              "樽熟成赤ワイン フレンチオーク樽とアメリカオー ク樽で最低6ヶ月熟成。",
            tipo_uva:
              "テンプラニーリョ メルロ カベルネ・ソーヴィニョン  シラー メルロ",
            elaboracion:
              "カスティーリャ・ラ・マンチャ地方で行わ れていた伝統的なワイン醸造方法を継承し ています。 高品質の葡萄を丁寧に選果し、樽の中で熟 成した後も、出荷までに最低6ヶ月瓶内で熟 成させます。",
            graduacion: "13 - 14%",
            cantidad: "750 ml",
            servicio: "Between 16º - 18º C.",
            gastronomia:
              "シャルキュトリ全般、肉、肉煮込み料理、 米料理、パスタ ",
            notas_cata: {
              texto:
                "ベリー系果実味たっぷり。口の中では、紅甘草の香りも。味は口 の中で広がり、ほんのりとした渋みも。今が飲み頃。",
              autor: "ジェームズ・サックリング2019"
            },
            premios: [
              "clasico-testing-2014",
              "clasico-wswa-2014",
              "clasico-houston-2015",
              "clasico-decanter-2017",
              "clasico-berliner-2018",
              "clasico-bacchus-2018",
              "clasico-suckling-2018",
              "clasico-suckling-2019",
              "clasico-cwsa-2018",
              "clasico-mundus-2021",
              "clasico-penin-2023"
            ]
          },
          albo: {
            id: "albo",
            nombre: "Albo",
            tipo_vino: "白ワイン、ヌーボー",
            tipo_uva: "ソーヴィニョン・ブラン マカベオ",
            elaboracion:
              "収穫後、酵母と発酵温度を管理し、軽くス キンコンタクトを行い、香り豊かで果実味 の強いワインが出来ます。",
            graduacion: "12 – 13%",
            cantidad: "750 ml",
            servicio: "Between 4º - 6º C.",
            gastronomia: "魚介類やデザート",
            notas_cata: {
              texto:
                "透き通った暖かい黄色。 果実（バナナ、黄桃、パッションフルーツ）の香りとジャスミン と檸檬の花の香りがし、舌触りはなめらか。 爽やかな酸味が続き、後味が良い。",
              autor: "ジェームズ・サックリング2019"
            },
            premios: [
              "albo-berliner-2016",
              "albo-testing-2014",
              "albo-suckling-2019"
            ]
          }
        },
        banner_premios: {
          titulo: "受賞ワイン",
          boton: "すべての賞を見る",
          premio: "navamarin-bruxelles-2023"
        },
        premios: {
          titulo: "国際的な賞と権威あるソムリエの批評",
          premios: {
            "navamarin-pswc-2011": {
              titulo: "Aldonza Navamarín",
              posicion: "第2位",
              texto:
                "2015年度の中国ワイン＆スピリ ッツ・アワード（香港、中国） で、2009年ヴィンテージが金 賞を獲得",
              categoria: "カテゴリー:国際",
              pais: "Germany",
              anyada: "2006",
              anyo: "2011"
            },
            "seleccion-pswc-2011": {
              titulo: "Aldonza Selección",
              posicion: "第2位",
              texto:
                "2011年度のプロ・ワイン ＰＳＷＣ（マインツ、ド イツ）で、2006年ヴィ ンテージが銀賞を獲得。",
              categoria: "カテゴリー:国際",
              pais: "Germany",
              anyada: "2006",
              anyo: "2011"
            },
            "navamarin-berliner-2015": {
              titulo: "Aldonza Navamarín",
              posicion: "第1位",
              texto:
                "2015年度のベルリン・ワ イン・トロフィー（ベル リン、ドイツ）で、2009 年ヴィンテージが金賞を 獲得。",
              categoria: "カテゴリー:国際",
              pais: "Germany",
              anyada: "2009",
              anyo: "2015",
              doble: true
            },
            "albo-berliner-2016": {
              titulo: "Aldonza Albo",
              posicion: "第1位",
              texto:
                "2016年度のベルリン・ワ イン・トロフィー（ベル リン、ドイツ）で、2015 年ヴィンテージが金賞を 獲得。",
              categoria: "カテゴリー:国際",
              pais: "Germany",
              anyada: "2015",
              anyo: "2016",
              doble: true
            },
            "pisces-mondiales-2008": {
              titulo: "Aldonza Pisces",
              posicion: "第2位",
              texto:
                "2008年度のワイン・ワール ド・セレクション（ケベッ ク、カナダ）で、2006年ヴ ィンテージが銀賞を獲得。",
              categoria: "カテゴリー:国際",
              pais: "canada",
              anyada: "2006",
              anyo: "2008"
            },
            "navamarin-china-wine-2015": {
              titulo: "Aldonza Navamarín",
              posicion: "第1位",
              texto:
                "2015年度の中国ワイン＆スピリ ッツ・アワード（香港、中国） で、2009年ヴィンテージが金 賞を獲得。",
              categoria: "カテゴリー:国際",
              pais: "china",
              anyada: "2009",
              anyo: "2015"
            },
            "navamarin-china-wine-2016": {
              titulo: "第1位",
              posicion: "First Prize",
              texto:
                "2016年度の中国ワイン＆スピリ ッツ・アワード（香港、中国） で、2010年ヴィンテージが金メ ダルを獲得。",
              categoria: "カテゴリー:国際",
              pais: "china",
              anyada: "2010",
              anyo: "2016"
            },
            "navamarin-corea-wine-2015": {
              titulo: "Aldonza Navamarín",
              posicion: "第1位",
              texto:
                "2015年度のアジア・ワイン・ トロフィー（テジョン広域、 韓国）で、2009年ヴィンテ ージが金賞を獲得",
              categoria: "カテゴリー:国際",
              pais: "korea",
              anyada: "2009",
              anyo: "2015",
              doble: true
            },
            "navamarin-corea-wine-2016": {
              titulo: "Aldonza Clásico",
              posicion: "第2位",
              texto:
                "2016年度のアジア・ワイン・ トロフィー（テジョン広域市、 韓国）で、2008年ヴィンテー ジが銀賞を獲得。",
              categoria: "カテゴリー:国際",
              pais: "korea",
              anyada: "2008",
              anyo: "2016",
              doble: true
            },
            "navamarin-bruselas-2013": {
              titulo: "Aldonza Navamarín",
              posicion: "第1位",
              texto:
                "2013年度のブリュッセル世 界コンクール（ブラティス ラバ、スロバキア）で、 2008年ヴィンテージが金賞 を獲得。",
              categoria: "カテゴリー:国際",
              pais: "Slovakia",
              anyada: "2008",
              anyo: "2013"
            },
            "pisces-ljubljana-2008": {
              titulo: "Aldonza Pisces",
              posicion: "第2位",
              texto:
                "2008年度のリュブリャナ・ ワイン国際コンクール（リュ ブリャナ、スロベニア）で、 2006年ヴィンテージが銀賞 を獲得。",
              categoria: "カテゴリー:国際",
              pais: "Slovenia",
              anyada: "2006",
              anyo: "2008"
            },
            "pisces-bacchus-2006": {
              titulo: "Aldonza Pisces",
              posicion: "第2位",
              texto:
                "2006年度マドリッド（スペ イン）で、2004年ヴィンテ ージが国際バッカス銀賞を獲 得。",
              categoria: "カテゴリー:国際",
              pais: "Spain",
              anyada: "2004",
              anyo: "2006"
            },
            "navamarin-zarcillo-2007": {
              titulo: "Aldonza Navamarín",
              posicion: "第1位 ",
              texto:
                "2007年度バリャドリード（スペ イン）で、2004年ヴィンテージ がサルシーリョ金賞を獲得。",
              categoria: "カテゴリー:国内",
              pais: "Spain",
              anyada: "2004",
              anyo: "2007"
            },
            "pisces-bacchus-2008": {
              titulo: "Aldonza Pisces",
              posicion: "第2位",
              texto:
                "2008年度マドリッド（スペ イン）で、2006年ヴィンテ ージが国際バッカス銀賞を獲 得。",
              categoria: "カテゴリー:国際",
              pais: "Spain",
              anyada: "2006",
              anyo: "2008"
            },
            "navamarin-testing-2014": {
              titulo: "Aldonza Navamarín",
              posicion: "第1位",
              texto:
                "2014年度のベバリッジ・テーステ ィング・インスティテュート（シ カゴ、アメリカ合衆国）で、 2007年ヴィンテージが金賞を獲 得。",
              categoria: "カテゴリー:国際",
              pais: "eeuu",
              anyada: "2007",
              anyo: "2014"
            },
            "seleccion-testing-2014": {
              titulo: "Aldonza Selección",
              posicion: "第1位",
              texto:
                "2014年度のベバリッジ・テー スティング・インスティテュー ト（シカゴ、アメリカ合衆国） で、2007年ヴィンテージが金 賞を獲得。",
              categoria: "カテゴリー:国際",
              pais: "eeuu",
              anyada: "2007",
              anyo: "2014"
            },
            "clasico-testing-2014": {
              titulo: "Aldonza Clásico",
              posicion: "第1位",
              texto:
                "2014年度のベバリッジ・テー スティング・インスティテュ ート（シカゴ、アメリカ合衆 国）で、2007年ヴィンテージ が金賞を獲得。 ",
              categoria: "カテゴリー:国際",
              pais: "eeuu",
              anyada: "2007",
              anyo: "2014"
            },
            "albo-testing-2014": {
              titulo: "Aldonza Albo",
              posicion: "第1位",
              texto:
                "2014年度のベバリッジ・テー スティング・インスティテュ ート（シカゴ、アメリカ合衆 国）で、2013年ヴィンテージ が金賞を獲得。 ",
              categoria: "カテゴリー:国際",
              pais: "eeuu",
              anyada: "2013",
              anyo: "2014"
            },
            "navamarin-wswa-2014": {
              titulo: "Aldonza Navamarín",
              posicion: "第1位 ",
              texto:
                "2014年度の第71回ＷＳＷＡ年次 総会＆博覧会（ラスベガス、ア メリカ合衆国）で、2008年ヴ ィンテージが最高金賞を獲得。 ",
              categoria: "カテゴリー:国際",
              pais: "eeuu",
              anyada: "2008",
              anyo: "2014"
            },
            "clasico-wswa-2014": {
              titulo: "Aldonza Clásico",
              posicion: "第2位",
              texto:
                "2014年度の第71回ＷＳＷＡ 年次総会＆博覧会（ラスベガ ス、アメリカ合衆国）で、 2008年ヴィンテージが銀賞 を獲得。",
              categoria: "カテゴリー:国際",
              pais: "eeuu",
              anyada: "2008",
              anyo: "2014"
            },
            "seleccion-wswa-2014": {
              titulo: "Aldonza Selección",
              posicion: "第2位",
              texto:
                "2014年度の第71回ＷＳＷＡ年次総会 ＆博覧会（ラスベガス、アメリカ合 衆国）で、2008年ヴィンテージが 銀賞を獲得。",
              categoria: "カテゴリー:国際",
              pais: "eeuu",
              anyada: "2008",
              anyo: "2014"
            },
            "navamarin-houston-2015": {
              titulo: "Aldonza Navamarín",
              posicion: "第3位",
              texto:
                "2015年度のヒューストン家畜 ショー＆ロデオ（ヒュースト ン、アメリカ合衆国）で、 2008年ヴィンテージが銅賞を 獲得",
              categoria: "カテゴリー:国際",
              pais: "eeuu",
              anyada: "2008",
              anyo: "2015"
            },
            "clasico-houston-2015": {
              titulo: "Aldonza Clásico",
              posicion: "第3位",
              texto:
                "2015年度のヒューストン家畜ショ ー＆ロデオ（ヒューストン、アメ リカ合衆国）で、2007年ヴィン テージが銅メダルを獲得。 ",
              categoria: "カテゴリー:国際",
              pais: "eeuu",
              anyada: "2007",
              anyo: "2015"
            },
            "seleccion-burdeos-2008": {
              titulo: "Aldonza Selección",
              posicion: "第2位",
              texto:
                "2008年度のワイン国際コン クール（ブルゴーニュ、フラ ンス）で、2005年ヴィンテー ジが銀賞を獲得。",
              categoria: "カテゴリー:国際",
              pais: "France",
              anyada: "2005",
              anyo: "2008"
            },
            "seleccion-vinalies-2009": {
              titulo: "Aldonza Selección",
              posicion: "第2位",
              texto:
                "2009年度世界的に最も重要なワ イン国際大会ヴィナリス・インタ ーナショナル第２回コンクール（ パリ、フランス）で金賞を獲得。",
              categoria: "カテゴリー:国際",
              pais: "France",
              anyada: "2006",
              anyo: "2009"
            },
            "navamarin-vinalies-2011": {
              titulo: "Aldonza Navamarín",
              posicion: "第2位",
              texto:
                "2009年度世界的に最も重要な ワイン国際大会ヴィナリス・イ ンターナショナル第２回コンク ール（パリ、フランス）で金賞 を獲得。",
              categoria: "カテゴリー:国際",
              pais: "France",
              anyada: "2007",
              anyo: "2011"
            },
            "navamarion-citadelles-2006": {
              titulo: "Aldonza Navamarín",
              posicion: "第2位",
              texto:
                "2011年度のシタデル・ド・ ヴァン（ボルドー、フラン ス）で、2006年ヴィンテー ジが銀メダルを獲得。 ",
              categoria: "カテゴリー:国際",
              pais: "France",
              anyada: "2006",
              anyo: "2011"
            },
            "seleccion-vinalies-2012": {
              titulo: "Aldonza Selección",
              posicion: "第2位",
              texto:
                "2012年度のワイン国際大会ヴ ィナリス・インターナショナ ル（パリ、フランス）で、 2007年ヴィンテージが銀メダ ルを獲得。",
              categoria: "カテゴリー:国際",
              pais: "France",
              anyada: "2007",
              anyo: "2012"
            },
            "pisces-tokio-2008": {
              titulo: "Aldonza Pisces",
              posicion: "第2位",
              texto:
                "2008年度のアジアで最も権威 のある国際コンクール（東京、 日本）で、2006年ヴィンテー ジが銀メダルを獲得。",
              categoria: "カテゴリー:国際",
              pais: "Japan",
              anyada: "2006",
              anyo: "2008"
            },
            "navamarin-londres-2013": {
              titulo: "Aldonza Navamarín",
              posicion: "第3位",
              texto:
                "2013年度のインターナショナル・ワイン・チャレンジ（ロンドン、英国）で、2008年ヴィンテージが銅メダルを獲得。",
              categoria: "カテゴリー:国際",
              pais: "uk",
              anyada: "2008",
              anyo: "2013"
            },
            "navamarin-decanter-2013": {
              titulo: "Aldonza Navamarín",
              posicion: "Recommended wine",
              texto:
                "2013年度のデキャンタ・ワー ルド・ワイン・アワード（ロ ンドン、英国）で、2008年ヴ ィンテージが推奨ワインの座 を獲得。   ",
              categoria: "カテゴリー:国際",
              pais: "uk",
              anyada: "2008",
              anyo: "2013"
            },
            "pisces-decanter-2013": {
              titulo: "Aldonza Pisces",
              posicion: "Recommended wine",
              texto:
                "2013年度のデキャンタ・ワー ルド・ワイン・アワード（ロン ドン、英国）で、2008年ヴィ ンテージが推奨ワインの座を獲 得。 ",
              categoria: "カテゴリー:国際",
              pais: "uk",
              anyada: "2008",
              anyo: "2013"
            },
            "clasico-decanter-2017": {
              titulo: "Aldonza Clásico",
              posicion: "Recommended wine",
              texto:
                "2017年度のデキャンタ・アジ ア・ワイン・アワード（香港、 中国）で、2011年ヴィンテージ が推奨ワインの座を獲得。",
              categoria: "カテゴリー:国際",
              pais: "china",
              anyada: "2011",
              anyo: "2017"
            },
            "seleccion-decanter-2017": {
              titulo: "Aldonza Selección",
              posicion: "Recommended wine",
              texto:
                "2017年度のデキャンタ・アジ ア・ワイン・アワード（香港、 中国）で、2011年ヴィンテージ が推奨ワインの座を獲得。",
              categoria: "カテゴリー:国際",
              pais: "China",
              anyada: "2011",
              anyo: "2017"
            },
            "clasico-berliner-2018": {
              titulo: "Aldonza Clásico",
              posicion: "第1位",
              texto:
                "2018年度のベルリン・ワイン・ トロフィー（ベルリン、ドイツ） で、2011年ヴィンテージが金賞を 獲得。",
              categoria: "カテゴリー:国際",
              pais: "Germany",
              anyada: "2011",
              anyo: "2018",
              doble: true
            },
            "navamarin-mundus-2018": {
              titulo: "Aldonza Navamarín",
              posicion: "第1位",
              texto:
                "2018年度の世界ワイン国際大 賞ムンドゥス・ヴィニ（ベルリ ン、ドイツ）で、2012年ヴィン テージが金賞を獲得。",
              categoria: "カテゴリー:国際",
              pais: "Germany",
              anyada: "2012",
              anyo: "2018"
            },
            "clasico-bacchus-2018": {
              titulo: "Aldonza Clásico",
              posicion: "第2位",
              texto:
                "2018年度の第16回ワイン国際コ ンクール（マドリッド、スペイ ン）で、2011年ヴィンテージが 国際バッカス銀賞を獲得。",
              categoria: "カテゴリー:国際",
              pais: "Spain",
              anyada: "2011",
              anyo: "2018"
            },
            "navamarin-suckling-2018": {
              titulo: "Aldonza Navamarín",
              posicion: "90 Points",
              texto:
                "22018年度のワインテイスティン グ（エル・プリオラート、スペ イン）でのジェームズ・サック リング（アメリカ合衆国）によ る2012年ヴィンテージの評価点 数。",
              categoria: "カテゴリー:国際",
              pais: "eeuu",
              anyada: "2012",
              anyo: "2018"
            },
            "clasico-suckling-2018": {
              titulo: "Aldonza Clásico",
              posicion: "90 Points",
              texto:
                "2018年度のワインテイスティン グ（エル・プリオラート、スペ イン）でのジェームズ・サック リング（アメリカ合衆国）によ る2011年ヴィンテージの評価。",
              categoria: "カテゴリー:国際",
              pais: "eeuu",
              anyada: "2011",
              anyo: "2018"
            },
            "clasico-cwsa-2018": {
              titulo: "Aldonza Clásico",
              posicion: "第1位 ",
              texto:
                "2018年度の中国ワイン＆スピリ ッツ賞（香港、中国）で、2011 年ヴィンテージが金メダルを獲 得。",
              categoria: "カテゴリー:国際",
              pais: "China",
              anyada: "2011",
              anyo: "2018"
            },
            "navamarin-decanter-bronce-2019": {
              titulo: "Aldonza Navamarín",
              posicion: "第3位",
              texto:
                "2019年度のデキャンタ・ワール ド・ワイン・アワード（ロンド ン、英国）で、2012年ヴィンテ ージが銅メダルを獲得。",
              categoria: "カテゴリー:国際",
              pais: "uk",
              anyada: "2012",
              anyo: "2019"
            },
            "seleccion-decanter-bronce-2019": {
              titulo: "Aldonza Selección",
              posicion: "第3位",
              texto:
                "2019年度のデカンター世界ワイ ン賞（ロンドン、英国）で、 2012年ヴィンテージが銅メダル を獲得",
              categoria: "カテゴリー:国際",
              pais: "uk",
              anyada: "2012",
              anyo: "2019"
            },
            "albo-suckling-2019": {
              titulo: "Aldonza Albo",
              posicion: "87 Points",
              texto:
                "2019年度のワインテイスティング （ラ・リオハ、スペイン）でのジ ェームズ・サックリング（アメリ カ合衆国）による2018年ヴィンテ ージの評価点数。",
              categoria: "カテゴリー:国際",
              pais: "eeuu",
              anyada: "2018",
              anyo: "2018"
            },
            "seleccion-suckling-2019": {
              titulo: "Aldonza Selección",
              posicion: "89 Points",
              texto:
                "2019年度のワインテイスティ ング（ラ・リオハ、スペイン） でのジェームズ・サックリング （アメリカ合衆国）による 2014年ヴィンテージの評価点 数。",
              categoria: "カテゴリー:国際",
              pais: "eeuu",
              anyada: "2014",
              anyo: "2018"
            },
            "clasico-suckling-2019": {
              titulo: "Aldonza Clásico",
              posicion: "90 Points",
              texto:
                "2019年度のワインテイスティ ング（ラ・リオハ、スペイン） でのジェームズ・サックリング （アメリカ合衆国）による 2014年ヴィンテージの評価点 数。",
              categoria: "カテゴリー:国際",
              pais: "eeuu",
              anyada: "2014",
              anyo: "2018"
            },
            "navamarin-suckling-2019": {
              titulo: "Aldonza Navamarín",
              posicion: "91 Points",
              texto:
                "2019年度のワインテイスティ ング（ラ・リオハ、スペイン） でのジェームズ・サックリング （アメリカ合衆国）による 2014年ヴィンテージの評価点 数。",
              categoria: "カテゴリー:国際",
              pais: "eeuu",
              anyada: "2013",
              anyo: "2018"
            },
            "navamarin-mundus-2020": {
              titulo: "Aldonza Navamarín",
              posicion: "Second Prize",
              texto:
                "2020年度の世界ワイン国際大賞ムンドゥス・ヴィニ（ドイツ）で、20013年ヴィンテージが銀メダルを獲得。",
              categoria: "Internacional",
              pais: "alemania",
              anyada: "2020",
              anyo: "2020"
            },
            "navamarin-mundus-2021": {
              titulo: "Aldonza Navamarín",
              posicion: "Medalla de Oro",
              texto:
                "2013年度の世界ワイン国際大 賞ムンドゥス・ヴィニ（ベルリ ン、ドイツ）で、2021年ヴィン テージが金賞を獲得。",
              categoria: "Internacional",
              pais: "alemania",
              anyada: "2013",
              anyo: "2021"
            },
            "clasico-mundus-2021": {
              titulo: "Aldonza Clásico",
              posicion: "Medalla de Oro",
              texto:
                "2015年度の世界ワイン国際大 賞ムンドゥス・ヴィニ（ベルリ ン、ドイツ）で、2021年ヴィン テージが金賞を獲得。",
              categoria: "Internacional",
              pais: "alemania",
              anyada: "2013",
              anyo: "2021"
            },
            "clasico-penin-2023": {
              titulo: "Aldonza Clásico",
              posicion: "Guía Peñín 2023",
              texto:
                "2015年ヴィンテージ、スペインで2022年2月に開催された有名なワインテイスティングでペニンガイドに従って採点されました。",
              categoria: "Nacional",
              pais: "España",
              anyada: "2022",
              anyo: "2022"
            },
            "navamarin-penin-2023": {
              titulo: "Aldonza Navamarín",
              posicion: "Guía Peñín 2023",
              texto:
                "2013年ヴィンテージ、スペインで2022年2月に開催された有名なワインテイスティングでペニンガイドに従って採点されました。",
              categoria: "Nacional",
              pais: "España",
              anyada: "2022",
              anyo: "2022"
            },
            "navamarin-bruselas-2022": {
              titulo: "Aldonza Navamarín",
              posicion: "Gran Medalla de Oro 2022",
              texto:
                "ヴィンテージ2013, コゼンツァ（イタリア）で開催された2022年版の第29回ブリュッセル世界コンテストでグランドゴールドメダルを受賞。",
              categoria: "Internacional",
              pais: "Bruselas",
              anyada: "2022",
              anyo: "2022"
            },
            "navamarin-londres-2022-2": {
              titulo: "Aldonza Navamarín",
              posicion: "91点",
              texto:
                "ヴィンテージ2013は、2022年版、ロンドン（イギリス）のデカンターワールドワインアワードで銀メダルを受賞しました。",
              categoria: "Internacional",
              pais: "uk",
              anyada: "2013",
              anyo: "2022"
            },
            "navamarin-bruxelles-2023": {
              titulo: "Aldonza Navamarín",
              posicion: "91 Puntos",
              texto:
                "2014 ヴィンテージ、イストリア (クロアチア) の 2023 年モンディアル・ド・ブリュッセルコンクールで金賞を受賞。",
              categoria: "Internacional",
              pais: "uk",
              anyada: "2014",
              anyo: "2023"
            },
            "seleccion-2022": {
              titulo: "Aldonza Selección",
              posicion: "91 Puntos",
              texto:
                "2015 ヴィンテージ、イストリア (クロアチア) の 2023 年モンディアル・ド・ブリュッセルコンクールで銀メダルを受賞。",
              categoria: "Internacional",
              pais: "uk",
              anyada: "2015",
              anyo: "2023"
            }
          }
        },
        banner_beneficios: {
          titulo: "ワインのメリットと実証された健康効果を知っていますか？",
          boton: "健康効果を知る"
        },
        banner_experiencia: {
          titulo: "もっと知る",
          boton: "ワイン観光について知る",
          enlace: "enoturismo"
        },
        beneficios: {
          titulo: "ワインの実証された特性と健康効果",
          list: [
            {
              titulo: "",
              cuerpo:
                "痩身: 赤ワインを摂取すると、新しい脂肪細胞の形成を抑え、既存の脂肪細胞の流動性を高める遺伝子機 能を活性化します。"
            },
            {
              titulo: "",
              cuerpo:
                "歯の健康: ワインに含まれる特定の成分が、虫歯に関係するバクテリアレンサ球菌の口腔内増加を抑え、 歯周病や喉の痛みを予防します。"
            },
            {
              titulo: "",
              cuerpo:
                "認知機能: ワイン中に抗酸化物質が多く含まれるため、血管硬化と血液凝固を抑制し、脳への血流を改善 します。 "
            },
            {
              titulo: "",
              cuerpo:
                "快楽気分: ワインを楽しんでいる間、脳の2つの部分でエンドルフィンが放出され、快楽気分が上昇され ます。"
            },
            {
              titulo: "",
              cuerpo:
                "運動: 葡萄に含まれるレスベラトロールは座りがちな生活がもたらす悪い影響を軽減します。 "
            },
            {
              titulo: "",
              cuerpo:
                "口腔清掃: 食事中にワインを飲むと、色々な味を美味しく感じられます。ワインの渋み成分が、赤身の肉 等に含まれる脂っぽさを減らし、食べ物のおいしさをより良く感じられます。"
            },
            {
              titulo: "",
              cuerpo:
                "抗癌効果: ワインの中でも特に赤ワインが、男性の肺癌を発生する危険性を軽減します。また女性では、 乳癌を引き起こす細胞の増殖を抑えます。ここでも、レスベラトロールがこのような効果をもたらしてい ます。 "
            },
            {
              titulo: "",
              cuerpo:
                "心臓: 毎日1～2杯のワインを飲むと、血中良玉コレステロール量が増え、心血管合併症を予防します。"
            },
            {
              titulo: "",
              cuerpo:
                "前立腺:40歳を過ぎてから1週間に7杯ワインを飲むと、前立腺癌と診断される確率が半分以下に減少しま す。"
            },
            {
              titulo: "",
              cuerpo:
                "健康的な習慣: ワインを楽しむ人は、ビールやソフトドリンクをよく飲む人たちよりも健康的な食習慣が あるという様々な統計結果が出ています つまり、オリーブ、果物、野菜、低脂肪チーズ、牛乳や健康に いい肉を摂る傾向にあります。"
            }
          ]
        }
      },
      aceite: {
        slug: "aceite",
        nombre: "エキストラ・バージン・オリーブオイル",
        intro_productos:
          "「今日信じられないことが起こるようなことをしなさい。」",
        intro_ficha: {
          titulo: "好きなことに夢中になっている時",
          cuerpo:
            "<p>ピクアル種とアルベキーナ種の持つ香りと風味を閉じ込めたまま、ぎゅっと搾りだエキストラ・バージン・オリーブオイル。エキストラ・バージンが持つ複数の治癒特性に自信を持って。</p>"
        },
        productos: {
          glass: {
            id: "vidrio",
            nombre: "ガラスボトル",
            descripcion:
              "オリーブの果汁を搾るのに最適な熟度まで熟したオリーブを収穫し、機械で冷 圧搾し、エキストラ・バージンオリーブを抽出しています。",
            ingredientes:
              "エクストラ・バージンオリーブオイル100％食品添加物なし ",
            notas_cata: {
              texto:
                "非常に個性のあるオイルで、ナッツ系の香りがし、未熟トマトとフレッシュハー ブのような果実味が長く続く。イチジクとバナナのような甘さが感じられる。舌 触りが滑らかで、酸味と甘みのバランスが程よくとれており、後味として辛みが 残る。"
            },
            cantidades: ["750ml", "500ml", "250ml"],
            premios: [
              "granprestigio-mendoza-2016",
              "olivinus-mendoza-2016",
              "olivinusninos-mendoza-2016",
              "feria-habana-2016"
            ]
          },
          metal: {
            id: "metal",
            nombre: "缶",
            descripcion:
              "オリーブの果汁を搾るのに最適な熟度まで熟したオリーブを収穫し、機械で冷 圧搾し、エキストラ・バージンオリーブを抽出しています。",
            ingredientes:
              "エクストラ・バージンオリーブオイル100％食品添加物なし ",
            notas_cata: {
              texto:
                "非常に個性のあるオイルで、ナッツ系の香りがし、未熟トマトとフレッシュハー ブのような果実味が長く続く。イチジクとバナナのような甘さが感じられる。舌 触りが滑らかで、酸味と甘みのバランスが程よくとれており、後味として辛みが 残る。"
            },
            cantidades: ["1L", "5L"],
            premios: [
              "granprestigio-mendoza-2016",
              "olivinus-mendoza-2016",
              "olivinusninos-mendoza-2016",
              "feria-habana-2016"
            ]
          }
        },
        banner_premios: {
          titulo: "受賞オリーブオイル",
          boton: "すべての賞を見る",
          premio: "granprestigio-mendoza-2016"
        },
        premios: {
          titulo: "賞と表彰",
          premios: {
            "granprestigio-mendoza-2016": {
              titulo: "World Olive Oil Competition",
              posicion: "",
              texto:
                "オリーブオイル国際コンクール 「国際Olivinus 2016」（メン ドッサ、アルゼンチン）で特別 最高金賞獲得。",
              categoria: "カテゴリー:国際",
              pais: "Argentina",
              anyada: "",
              anyo: "2016"
            },
            "olivinus-mendoza-2016": {
              titulo: "World Olive Oil Competition",
              posicion: "",
              texto:
                "オリーブオイル国際コンクール 「国際Olivinus 2016」（メンド ッサ、アルゼンチン）で93点取 得。",
              categoria: "カテゴリー:国際",
              pais: "Argentina",
              anyada: "",
              anyo: "2016"
            },
            "olivinusninos-mendoza-2016": {
              titulo: "World Olive Oil Competition",
              posicion: "",
              texto:
                "オリビヌス子供コンクール「国 際Olivinus 2016」（メンドッ サ、アルゼンチン）で、子供た ちに選ばれる。",
              categoria: "カテゴリー:国際",
              pais: "Argentina",
              anyada: "",
              anyo: "2016"
            },
            "feria-habana-2016": {
              titulo: "International Fair of Havana",
              posicion: "",
              texto:
                "「ＦＩＨＡＶ2016」（ラ・ハバ ナ、キューバ）で商品品質賞を 獲得。",
              categoria: "カテゴリー:国際",
              pais: "Argentina",
              anyada: "",
              anyo: "2016",
              doble: true
            }
          }
        },
        banner_beneficios: {
          titulo:
            "エキストラバージンオリーブオイルのメリットと実証された健康効果を知っていますか？",
          boton: "メリットを知る"
        },
        banner_experiencia: {
          titulo: "もっと知る",
          boton: "オリーブオイル観光ツアーについて知る",
          enlace: "oleoturismo"
        },
        beneficios: {
          titulo:
            "エキストラ・バージンオリーブオイルの実証された特性と健康効果 ",
          list: [
            {
              titulo: "",
              cuerpo:
                "関節炎: エキストラ・バージンオリーブオイルを定期的に摂取すると関節リウマチ発症が抑制されます。"
            },
            {
              titulo: "",
              cuerpo:
                "骨粗鬆症: エクストラ・バージンオリーブオイルは、骨へのカルシウムの吸収を助け、骨粗鬆症予防の重 要な役割を果たします。"
            },
            {
              titulo: "",
              cuerpo:
                "糖尿病: エキストラ・バージンオリーブオイルを摂取すると、血糖値と血圧を下げ、糖尿病対策になりま す。."
            },
            {
              titulo: "",
              cuerpo: "血圧: 最高血圧と最低血圧を著しく下げます。"
            },
            {
              titulo: "",
              cuerpo:
                "肥満: 他のオイルに比べ血糖指数がかなり低いので、低カロリー食の料理や味付けに勧められています。"
            },
            {
              titulo: "",
              cuerpo:
                "酸化ストレス: 植物性オイルの中では、エクストラ・バージンオリーブオイルが、モノ不飽和脂肪酸の含 有量が最多です。他の脂肪と異なり、体内で酸化せず、また、多価不飽和脂肪酸量の割合が非常に低いこ とです。ビタミンEを豊富に含んでいます"
            },
            {
              titulo: "",
              cuerpo:
                "癌: エクストラ・バージンオリーブオイルの植物栄養素が、乳癌の発癌危険性を低めることが科学的に証 明されています。スクワランとリグナンもまた、抗癌効果の可能性がある他の成分として研究中です。"
            },
            {
              titulo: "",
              cuerpo:
                "コレステロール: エキストラ・バージンオリーブは、血中コレステロール値を低下させ、心臓病に罹る率 が低くなります。悪玉コレステロール（LDL）が酸化しないので、冠状動脈性心疾患を直接的に引き起こ しません。 "
            },
            {
              titulo: "",
              cuerpo:
                "アルツハイマー型認知症: 定期的に摂取すると認知機能の低下を防ぎます。"
            }
          ]
        }
      },
      azafran: {
        slug: "azafran",
        nombre: "サフラン",
        intro_productos: "「大きな違いを生む小さなディーテール」",
        productos: {
          box: {
            id: "caja-1g",
            nombre: "1g入箱",
            descripcion:
              "世界で認められている品質の高さ。食品の安全性、官能特性（色・香・風味）、スペイン、カスティーリャ・ラ・マンチャ 産の点において一級品であることを保証しています。",
            caracteristicas:
              "純度 物質的特徴 化学敵特徴 官能特性（サフラン）官能特性（水抽出） ",
            maridaje:
              "様々な料理の着色料、香料、風味付けに。 肉のオーブン料理、魚料理、スープ、甲殻類、米料理のスパイスとして最高。",
            peso: ["1g", "12ユニットの箱"],
            premios: {
              premios: []
            }
          }
        },
        intro_ficha: {
          titulo: "ラ・マンチャ産サフラン",
          cuerpo:
            "<p>紅金：太古の昔、エジプトやギリシャなどの古代文明の間で、大変貴重がられてていたこの繊細なスパイスは、今日では、芳香・風味・色において、スパイスの王様と呼ばれ、色々な国の料理に使われています。また、サフランは多くの薬効成分を含み、薬としても使用されています。</p><p>カスティーリャ・ラ・マンチャで栽培されたサフランのみが、ラ・マンチャの原産地名称保護制度認証章を受けられます。アルドンサのサフランはその原産地名称保護制度認証書を受けており、スペイン原産品であること、風味官能特性が最高であること、食品としての安全性、という三点における保証が世界的に認められています。</p>"
        },
        banner_denominacion: {
          titulo: "原産地名称付き",
          subtitulo: "ラ・マンチャ産サフラン",
          cuerpo: "原産地名称保護制度"
        },
        banner_beneficios: {
          titulo: "サフランのメリットと実証された健康効果を知っていますか？",
          boton: "メリットを知る"
        },
        banner_experiencia: {
          titulo: "もっと知る",
          boton: "アルドンザ体験について知る",
          enlace: "vive_aldonza"
        },
        beneficios: {
          titulo: "サフランの実証された特性と健康効果",
          list: [
            {
              titulo: "",
              cuerpo:
                "消化: 香と苦みの成分（ピクロクロシン）が消化器官を刺激し、唾液と胃液の分泌を増加させます。また、 サフランはクロセチン（赤色素）を含み、機能を活発化させます。まず胆汁の生産を刺激し、消化を助け、 胆嚢に胆石が出来るのを妨げます。"
            },
            {
              titulo: "",
              cuerpo:
                "生理痛: サフランは月経前緊張症候群を和らげるのに重要な役割を果たします。サフランは子宮痙攣を防ぎ 月経血の排出に役立つと認められています。"
            },
            {
              titulo: "",
              cuerpo:
                "抗酸化作用: サフランの主要成分であるクロセチンは天然の抗酸化物質であり、体内の細胞が老化するのを 遅くします。"
            },
            {
              titulo: "",
              cuerpo:
                "記憶力: サフランは記憶力と認知能力を向上させ、また、ストレスに悩む人の栄養補助食品として勧められ てもいます。"
            },
            {
              titulo: "",
              cuerpo:
                "視力: サフランのアロマ成分であるサフラナールは目の視細胞が変性するのを遅らせ、網膜及び血管の機能 を改善します。"
            },
            {
              titulo: "",
              cuerpo:
                "心血管疾患: サフランは、抗酸化物質に富んだ芳香香辛料で、心血管疾患を予防します。紅色素であるクロ セチンはコレステロールを低下させる働きもあります。"
            },
            {
              titulo: "",
              cuerpo:
                "糖尿病: 高い抗酸化作用のあるサフランは、糖尿病患者にとって有益な栄養補助食品です。サフランの抽出 成分は、糖尿病患者を糖尿病性神経障害、つまり過剰な血糖値によって引き起こされる弊害から守ってくれ ます。"
            },
            {
              titulo: "",
              cuerpo:
                "抗癌作用: サフランには腫瘍の生成を抑えるベータカロチンとフラボノイドが含まれており、寿命の延命作 用があります。 "
            },
            {
              titulo: "",
              cuerpo:
                "抗うつ効果: 軽いうつ状態の人には、あるいくつかの抗うつ薬と同様の効果が認められます。"
            },
            {
              titulo: "",
              cuerpo:
                "鎮静作用: 緊張状態や不安状態に効く鎮静効果のある芳香成分が含まれています。"
            }
          ]
        }
      },
      cava: {
        slug: "cava",
        nombre: "カバ（スパークリングワイン)",
        intro_productos: "「大いなる瞬間の後には、忘れられない思い出が残る」",
        intro_ficha: {
          titulo: "色々な個性",
          cuerpo:
            "<p>葡萄果実からモストが得られ、2回の発酵を経て、カバになります。独自に厳選された酵母によって、それぞれの個性ある 4種類の独特なスパークリングワインが出来ます。</p><p>D.O.（スペインの原産地呼称統制制度）付きのカバは、ペネデス地方で栽培されたチャレロ種、マカベオ種、パレリャーダ種という葡萄のみを使用して、バルセロナ県のサン・サンドゥルニー・ダノイア醸造所で造られました。。トレパット品種の赤葡萄のみで造られたロゼ・カバもあります。</p>"
        },
        productos: {
          reserve: {
            id: "reserva",
            nombre: "Reserve",
            tipo_uva:
              "シャルドネ チャレロ マカベオ（カバの原産地呼称統制制度認定証付き葡萄園産）",
            tipo_cava: "ブルット・レゼルバ・エスペシアル",
            elaboracion:
              "収穫後、一番搾りのフリーラン ジュースのモストを搾汁。 常時15℃でモストを発酵させ、 洞窟内で最低24ヶ月第二次発酵 と熟成。",
            graduacion: "11,5 - 12,5% Vol",
            cantidad: "750ml",
            servicio: "6º ~ 8º C",
            gastronomia:
              "強い個性のあるこのカバは様 々な国際料理に。肉料理、魚 料理、煮込み料理、チーズ、 フォアグラ、燻製。また、前 菜としても最適。",
            notas_cata: {
              texto: "",
              autor: ""
            },
            premios: [
              "brut-decanter-plata-2019",
              "brut-decanter-2022",
              "brut-decanter-2022-2"
            ]
          },
          nature: {
            id: "nature",
            nombre: "Brut Nature",
            tipo_uva: "チャレロ マカベオ パレリャーダ",
            tipo_cava: "ブルット・ナチュレ（Brut Nature）",
            elaboracion:
              "葡萄の収穫後、種類と質に応じて選果 し、その後、一番搾りのフリーランジ ュースのモストを搾汁します。常時19 ℃以下でモストを発酵し、洞窟内で12 ヶ月から14ヶ月熟成させます。",
            graduacion: "11,5 - 12,5 %",
            cantidad: "750ml",
            servicio: "6º ~ 8º C",
            gastronomia: "前菜、ナッツ類、甲殻類、赤身肉と白 身肉 ",
            notas_cata: {
              texto:
                "黄金がかかった淡い黄色。全体に輪になって泡が上っていき、 水面で泡冠が出来る。花の香りがし、瓶内発酵独特のまろやか さ。すっきりとしたまろやかな辛口で、しっかりとした香り。",
              autor: ""
            },
            premios: ""
          },
          rose: {
            id: "rose",
            nombre: "Brut - Rosé",
            tipo_uva: "トレパート",
            tipo_cava: "ブルット・ロゼ（Brut-Rosé）",
            elaboracion:
              "収穫後、マセレーション法で葡萄を破 砕し、望む色と特性が得られるまで軽 く発酵させる。その後、19℃以下でモ ストのみを発酵。洞窟内で熟成（最低 9ヶ月）。",
            graduacion: "11 - 12%",
            cantidad: "750ml",
            servicio: "6º ~ 8º C",
            gastronomia: "サラダ、パスタ、青魚、甲殻類",
            notas_cata: {
              texto:
                "艶やかな強い濃いピンク、 きめの細かい泡が全体的に数珠の様に続けて出来、泡冠を作 る。飲み心地良さが第一印象で、小さなベリー系の果実を思 い起こす香。そして、旨みがありフルーツの後味が印象的。",
              autor: ""
            },
            premios: ""
          },
          brut: {
            id: "brut",
            nombre: "Brut",
            tipo_uva: "チャレロ マカベオ パレリャーダ",
            tipo_cava: "ブルット（Brut）",
            elaboracion:
              "葡萄の収穫後、種類と質に応じて選果 し、その後、一番搾りのフリーランジ ュースのモストを搾汁します。 常時19℃以下でモストを発酵し、洞窟 内で12ヶ月から14ヶ月熟成させます。",
            graduacion: "11 - 12% Vol",
            cantidad: "750ml",
            servicio: "6º ~ 8º C",
            gastronomia: "生ハム、白身肉、米料理",
            notas_cata: {
              texto:
                "黄金がかかったとても淡い薄黄色。きめ細やかな泡が全体に 出来、美しい泡冠を形成する。瓶内発酵独特のフルーティー で優雅な香り。軽やかな味わいで、ほんのり甘く林檎のよう な後味が残る。酸味が丁度良く、後味が長く残る。",
              autor: ""
            },
            premios: ""
          }
        },
        premios: {
          titulo: "入賞カバと評価",
          premios: {
            "brut-decanter-plata-2019": {
              titulo: "Brut-Reserva sparkling wine",
              posicion: "第2位",
              texto:
                "2019年度、デキャンタ・ワール ド・ワイン・アワード（ロンド ン、英国）で、銀賞を獲得。",
              categoria: "カテゴリー:国際",
              pais: "uk",
              anyada: "2018",
              anyo: "2019"
            },
            "brut-decanter-2022": {
              titulo: "Cava Brut-Reserva",
              posicion: "92点",
              texto:
                "ヴィンテージ2021は、2022年版、ロンドン（イギリス）のデカンターワールドワインアワードで銀メダルを受賞しました。",
              categoria: "Internacional",
              pais: "uk",
              anyada: "2021",
              anyo: "2022"
            },
            "brut-decanter-2022-2": {
              titulo: "Brut-Reserva sparkling wine",
              posicion: "",
              texto:
                "ヴィンテージ2021、アナディア（ポルトガル）で開催されたコンクールモンディアルデブリュッセルでの銀メダル。",
              categoria: "Internacional",
              pais: "portugal",
              anyada: "2021",
              anyo: "2022"
            }
          }
        },
        banner_premios: {
          titulo: "入賞カバ",
          boton: "すべての賞を見る",
          premio: "brut-decanter-2022-2"
        },
        banner_beneficios: {
          titulo: "カバのメリットと実証された健康効果を知っていますか？",
          boton: "メリットを見る"
        },
        banner_experiencia: {
          titulo: "もっと知る",
          boton: "アルドンザ体験を知る",
          enlace: "vive_aldonza"
        },
        beneficios: {
          titulo: "カバの実証された特性と健康効果",
          list: [
            {
              titulo: "",
              cuerpo:
                "肌の保護効果: カバに含まれる抗酸化物質と酒石酸が皮膚を浄化し、肌のトーンのバランスを良くし皮膚が 赤くなるのを防ぎます。脂性肌の人はカバの持つ抗菌性によって、さらに健康的な肌になります。"
            },
            {
              titulo: "",
              cuerpo:
                "記憶力の向上: カバを適度に摂取（一日一杯）すると、記憶力を向上させ、認知症などの脳の変性疾患の進 行を遅らせます。このような効果のあるカバの有効成分はフェノール酸だと様々な研究で示されています。"
            },
            {
              titulo: "",
              cuerpo:
                "体重管理:  カバは低カロリーのアルコール飲料の一つです。1ℓ当たりの残留糖分は12ｇ以下で、Brut一杯 当たり80～100カロリーです。他の飲み物を例にとると、ビールやラム酒のカクテルは150カロリー以上も あります。 "
            },
            {
              titulo: "",
              cuerpo:
                "心臓に優しい:  ポリフェノール含量量が高いため、カバの適度な摂取は血圧を下げ、心血管疾患や心臓発 作の危険性を減少させる効果があります。 "
            },
            {
              titulo: "",
              cuerpo:
                "気分向上効果: カバのある特定成分には気分を向上させる効果があります。カバのある特定成分には気分を 向上させる効果があります。また、精神状態を向上させる天然の微量元素が含まれています。"
            },
            {
              titulo: "",
              cuerpo:
                "若返り効果: 細胞の再生を活性化し、ビタミンＥを強化する抗酸化物質が含まれているので、若さの源と考 えられています。この成分は特に女性の肌を若返らせます。"
            },
            {
              titulo: "",
              cuerpo:
                "栄養素満点: 最初に述べたように、低脂質飲料であることに加え、栄養素を豊富に備えています。鉄分、タ ンパク質、カルシウム、カリウム、ヨウ素に加え、微量ながらも亜鉛、炭水化物、マグネシウム、ナトリ ウム、B1、B2、B9、B3、B6、リン、糖分を含みます。"
            }
          ]
        }
      },
      queso: {
        slug: "queso",
        nombre: "チーズ",
        intro_productos: "<span>「日常でちょっとした息抜きを」 </span>",
        productos: {
          enaceite: {
            id: "enaceite",
            nombre: "オリーブオイル漬け",
            descripcion:
              "低温殺菌された100%マンチェガ種羊乳で作られた熟成チーズ。",
            curacion: "150~210日",
            apariencia:
              "固さ: 固く、ずっしりとしている。 色: 白からアイボリー、黄色がかっているものまで。 香り: 乳酸、強く、持続的な酸味が辛いニュアンスに変わります。 風味: 軽く酸味があり、強く、美味しい。",
            ingredientes:
              "低温殺菌されたマンチェガ羊乳、凝乳、乳酸発酵物、リゾチーム(卵由来)、 塩化カルシウム、塩、オリーブオイル。 羊乳の原産地:スペイン。",
            valoresnutricionales:
              "カロリー: 410 Kcal / 1715 Kj 脂肪分: 36 g 飽和脂肪酸: 18,70 g 炭水化物: 0,50 g 糖分: 0 g タンパク質: 24 g ナトリウム: 1,60 g",
            conservacion: "2~7 oC",
            alergenos: "乳糖とリゾチーム(卵由来)",
            durabilidad: "製造から1年。各包装に記載されています。",
            gastronomia:
              "赤ワイン(Aldonza SelecciónおよびAldonza Navamarín)、カバ(Aldonza Brut Reserva)に合わせるのに理想的です。",
            notas_cata: {
              texto:
                "羊乳チーズ特有の強い風味がオリーブオイルの強い風味で高められ、やや辛い後味 があります。"
            },
            premios: {
              premios: []
            }
          },

          semicurado: {
            id: "semicurado",
            nombre: "セミクラード(半熟成)",
            descripcion:
              "低温殺菌された100%マンチェガ種羊乳で作られた熟成チーズ。",
            curacion: "60~100日",
            apariencia:
              "固さ: 固く、ずっしりとしている。 色: 白からアイボリー、黄色がかっているものまで。 香り: 乳酸、強く、持続的な酸味が辛いニュアンスに変わります。 風味: 軽く酸味があり、強く、美味しい。",
            ingredientes:
              "低温殺菌されたマンチェガ羊乳、凝乳、乳酸発酵物、リゾチーム(卵由来)、 塩化カルシウム、塩。 羊乳の原産地:スペイン。",
            valoresnutricionales:
              "カロリー: 410 Kcal / 1715 Kj 脂肪分: 30 g  飽和脂肪酸: 18,90 g 炭水化物: 0,50 g 糖分: <0,50 g タンパク質: 26 g 塩分: 1,60 g",
            conservacion: "2~7 oC",
            alergenos: "乳糖とリゾチーム(卵由来)",
            durabilidad: "製造から1年。各包装に記載されています。",
            gastronomia:
              "白ワイン(Aldonza Albo)、若い赤ワイン(Aldonza Clásico)やロゼのカ バ(Aldonza Brut - Rosé)にぴったりです。",
            notas_cata: {
              texto:
                "強い風味で酸味があり、美味しい。マンチェガ種の羊乳の独特な後味。乳酸菌の風味 と熟成したチーズの強さのバランスが絶妙な、クリーミーな触感。"
            },
            premios: {
              premios: []
            }
          },

          curado: {
            id: "curado",
            nombre: "クラード(熟成)",
            descripcion:
              "低温殺菌された100%マンチェガ種羊乳で作られた熟成チーズ。",
            curacion: "150~210日",
            apariencia:
              "固さ: 固く、ずっしりとしている。 色: 白からアイボリー、黄色がかっているものまで。 香り: 乳酸、強く、持続的な酸味が辛いニュアンスに変わります。 風味: 軽く酸味があり、強く、美味しい。",
            ingredientes:
              "低温殺菌されたマンチェガ羊乳、凝乳、乳酸発酵物、リゾチーム(卵由来)、 塩化カルシウム、塩。 羊乳の原産地:スペイン。",
            valoresnutricionales:
              "カロリー: 410 Kcal / 1715 Kj 脂肪分: 36 g 飽和脂肪酸: 18,70 g 炭水化物: 0,50 g 糖分: 0 g タンパク質: 24 g 塩分: 1,60 g",
            conservacion: "2~7 oC",
            alergenos: "乳糖とリゾチーム(卵由来)",
            durabilidad: "製造から1年。各包装に記載されています。",
            gastronomia:
              "赤ワイン(Aldonza SelecciónおよびAldonza Navamarín)、カバ(Aldonza Brut Nature)に合わせるのに理想的です。",
            notas_cata: {
              texto:
                "個性豊かなチーズで、力強く、浸透する、強烈な味わいで、最後は、やや辛いニュアン スへと変わります。"
            },
            premios: {
              premios: []
            }
          }
        },
        intro_ficha: {
          titulo: "マンチェゴ100%",
          cuerpo:
            "<p>チーズはそれぞれチーズ職人の手により、個別に仕上げていきます。一口ごとの味わい、香り、食感に感じられる丹精込めた愛情……。ハード、セミハード、オリーブイル漬けの3種類、どれをとってもお楽しみいただけます。もうひとつの体験、たまらない美味しさ。<br><a target='_blank' href='/static/pdf/certificado-SAE.pdf'><u>Certificate <strong>SAE 2021-0014</strong></u></a>  </p>"
        },
        banner_beneficios: {
          titulo:
            "Do you know the benefits and the proven qualities of cheese?",
          boton: "Discover the benefits"
        },
        banner_experiencia: {
          titulo: "Do you wnat to know more?",
          boton: "Discover the Aldonza experience",
          enlace: "vive_aldonza"
        },
        beneficios: {
          titulo: "Benefits<br> and proven qualities of cheese",
          list: [
            {
              titulo: "Source of calcium.",
              cuerpo:
                "Cheese is one of the main sources of calcium, a mineral that regulates essential processes in our organism, such as the transportation of oxygen by red blood cells or coagulation."
            },
            {
              titulo: "Strengthens bones.",
              cuerpo:
                "Calcium helps to form and strengthen bones, which is why it has a very positive effect in the fight against osteoporosis and other degenerative bone diseases."
            },
            {
              titulo: "Oral health.",
              cuerpo:
                "In addition to strengthening our teeth, it reduces bacterial plaque, stimulates the production of saliva and cleans our mouth in a natural way."
            },
            {
              titulo: "Protects the skin.",
              cuerpo:
                "It has a high vitamin B content, which improves the appearance of our skin."
            },
            {
              titulo: "Improves vision.",
              cuerpo:
                "Contains vitamin A and D which help to improve vision and the immune system."
            },
            {
              titulo: "Recommended during pregnancy.",
              cuerpo:
                "It contains folic acid, so it is highly recommended during pregnancy (always made from pasteurized milk) and it also favours the production of breast milk."
            },
            {
              titulo: "Prevents diseases.",
              cuerpo:
                "Cheese is rich in conjugated linoleic acid (CLA) and esfingolipids, two components of milk fat that help reduce the risk of cancer and heart disease."
            },
            {
              titulo: "Recovers body mass.",
              cuerpo:
                "It is very rich in protein and favours the recovery of body mass. It is a very helpful food for athletes and reduces the risk of obesity."
            }
          ]
        }
      }
    },
    banners_experiencia: {
      vive_aldonza: {
        id: "vive-aldonza",
        titulo: "Vアルドンザを生きる",
        titulo_intro_experiencia:
          "「思い出すのは、思い出の日ではなく、生きている瞬間瞬間の経験である。」",
        titulo_vivir_experiencia: "アルドンサ体験ツアーに必要なもの",
        tip_maleta:
          "体験ツアーに持って行きたい物は全て忘れずにスーツケースに詰め込んでください。準備万端で臨みましょう！",
        tip_camara:
          "写真を撮るためのカメラ！ アルドンサで体験する他にはない瞬間を永遠のものにするために不可欠です。",
        tip_corazon:
          "あなたの心構え。それぞれの経験を忘れられないものにするために必要不可欠な要素。そうなるかどうかはあなた次第です。",
        elige: "お好きなアルドンサ体験ツアーを選んでください"
      },
      enoturismo: {
        id: "enoturismo",
        titulo: "ワイン観光ツアー",
        cuerpo:
          "樽貯蔵室がある洞窟に降りるときは、カメラを用意してください。すべてのアルドンサ製品の試飲が出来る、センセーショナルなワイン観光体験ツアー。月曜日から日曜日まで訪問します。",
        boton: "体験してみよう",
        titulo_intro_experiencia: "ワイナリー見学",
        la_visita_text: "見学ツアー",
        tips_bodega: [
          {
            titulo: "場所",
            cuerpo:
              "ドン・キホーテの故郷の中心、アルバセテ県の北西にある町、ムネラ。その近郊、アルカラス山脈とカンポス・デ・モンティエルの間に位置する標高1,200メートルにあるラ・デエサ・デ・ナバマリンに広がる大自然の中に、私たちのワイナリーはあります。"
          }
        ],
        la_visita: [
          {
            cuerpo:
              "ワイナリー、オリーブオイル搾油所、サフランルームの全施設を巡るツアー。ワイン、エキストラ・バージンオリーブオイル、サフランのそれぞれの製造工程を学びます。"
          },
          {
            cuerpo:
              "（赤ワイン）ナバマリン、セレクシオン、クラシック、（白ワイン）アルボという私達の全種ワインとカバを無料で試飲できます。エキストラ・バージンオリーブオイルの試飲も含まれています。非常に貴重な体験になります！"
          },
          {
            cuerpo:
              "ツアーの遂行時間は約60分です。身体障害者の方もご参加出来ます。"
          },
          {
            cuerpo:
              "月曜日から日曜日のいつでもお越し出来ます。ただし、訪問時間は事前に予約が必要です。"
          },
          {
            cuerpo: "（月曜日～日曜日）"
          }
        ],
        video: {
          titulo: "ビデオ/スポット",
          cuerpo:
            "家族と？カップルで？友達と？一緒に訪れる相手を選ぶだけです。ワイン観光ツアーとオリーブ園観光ツアー。再生を押してください！"
        }
      },
      oleoturismo: {
        id: "oleoturismo",
        titulo: "オリーブオイル観光ツアー",
        cuerpo:
          "良質のエキストラ・バージンオリーブオイルの香りに包まれてみましょう。搾油所を訪れ、エキストラ・バージンオリーブオイルの搾油工程を学び、地中海料理に欠かせない伝統的な調味料の特性をご堪能ください。",
        boton: "体験してみよう",
        titulo_intro_experiencia: "オリーブオイル搾油所見学",
        titulo_catas: "オリーブオイルのテイスティング",
        cuerpo_catas:
          "<p>オリーブオイルのテイスティングは濃い色の不透明なコップで行われます。その理由は、オリーブオイルの色を見て品質を決めるわけではなく、純粋に味で決めるためです。知っていましたか。アルドンサでオリーブオイル観光ツアーに参加して、オリーブオイルについてさらに詳しく学びましょう。</p><p>ドン・キホーテの地の中心部であるという特別な環境で、エキストラバージンオリーブオイルの製造方法、搾油所の仕組み、オリーブの主な品種、プロのオリーブオイルのテイスティングがどのように行われるかが学べます。これ以上詳しいことは参加してご自身の目で確かめてください！</p>"
      },
      degustacionQuesos: {
        id: "degustacionQuesos",
        titulo: "チーズのテイスティング定番のやり方 ",
        cuerpo:
          "まずはチーズを味わうために五感覚を意識。では、チーズのテイスティングセレモニーを始めましょう！",
        boton: "Vivir experiencia",
        titulo_intro_experiencia: "El Ritual",
        maridaje: {
          id: "maridaje",
          titulo_catas: "ワインとのマリアージュ。",
          cuerpo_catas:
            "<p>ワインの酸味によりチーズが食べやすくなるほか、ワインは口をすっきりさせ、チーズの味わいを高めてくれます。ご提供しているワインツーリズムのガイドツアーでは、本場マンチェゴチーズの味わい方をお教えしております。なお、こちらからご予約いただけます。</p>"
        },
        productos: {
          vista: {
            id: "vista",
            nombre: "外観",
            descripcion:
              "チーズの見た目や状態を評価する視覚。外皮だけでなく、カットの表面もよく観察してください。種類によって、外皮は平らだったり、ロウのようだったり、カビが生えていたり、ウォッシュや、例えばエクストラ･バージンオリーブオイルで加工がされていたりします。色は、また別の考慮すべき視覚的要素です。マンチェゴチーズは羊乳で作られており、アイボリー色をしていることが多いのが特徴。視覚により、他にもテクスチャを確認することもできます。例えば、熟成期間によって、チーズにヒビが多く入っていたり、少なかったりします。"
          },
          tacto: {
            id: "tacto",
            nombre: "触覚 ",
            descripcion:
              "触覚評価では、うろこのような感じ、粉っぽさ、ハードタイプのマンチェゴチーズによくある、若干のもろさを感じることができます "
          },
          olfato: {
            id: "olfato",
            nombre: "嗅覚 ",
            descripcion:
              "香りをかぐと、テイスターやチーズ職人がいくつかの系統にまとめている感覚を感じ取ることができます。乳製品や野菜のような感じ、フルーティ、スパイシーな香りが際立ちます。"
          },
          gusto: {
            id: "gusto",
            nombre: "味覚 ",
            descripcion:
              "各チーズの味と食感を楽しむ番です！口に含んでテイスティングをする場合、数秒間、息をせずに噛んでみたら、引き続き少しずつ口から息を吐き出すのが理想的な方法です。こうすることにより、チーズの濃厚さや味――甘さ、塩気、酸味、苦味、辛さに加え、完全に個人的な評価となるその他のニュアンスまでも――を感じやすくなります。"
          },
          regusto: {
            id: "regusto",
            nombre: "後味 ",
            descripcion:
              "テイスティングの締めくくりは、後味。余韻としても知られています。このひと時、最初にチーズを味わった時とは異なる嗅覚と味覚が残っています。そのため、アロマや味わいは全く新しく独特な感じかもしれません。"
          }
        }
      },

      recetario: {
        id: "recetario",
        titulo: "レシピとグルメ巡り",
        cuerpo:
          "<p>実際に料理してみると、私達の製品の品質の良さが良く分かります。伝統的な料理、斬新的な料理、私たちのレシピ集の中から一番気になるレシピを選んでください。</p><p>アルドンザ製品を使用したスペイン料理の最高峰。スーツケースを持って、グルメ巡り「テイスティング・スペイン」をお楽しみください。</p>",
        boton: "体験してみよう",
        titulo_intro_experiencia:
          "「料理を通して人に何か伝えたいことがある人は、料理人になる。」",
        cuerpo_recetario:
          "<p>アルドンサのエキストラバージンオリーブオイル、サフラン、ワインを使ったヘルシーな料理のレシピ集があります。スペイン伝統料理または斬新的料理、色々なレシピを映像で紹介しています。さて、今日は何の料理を作りますか？</p><p>スペインの主要なレストランとグルメ処を巡り、アルドンサとHEB料理センターのシェフが共同で、スペイン料理とテキサス料理を融合する新しいレシピ本を作りました。私たちのビデオで美食ルート「テイスティングスペイン」を追体験してください。</p>",
        boton_recetario: "レシピ集を見る",
        boton_tasting: "テイスティング・スペインについて知る",
        recetario: "レシピ集",
        tasting_spain: "テイスティングスペイン",
        youtube: {
          titulo:
            "レシピをもっと知りたいですか？レストラン巡りを見逃したくないですか？",
          newsletter: "YouTubeチャンネルに登録する",
          boton: "YouTubeチャンネルに移動"
        }
      },
      ruta_cervantina: {
        id: "ruta-cervantina",
        titulo: "セルバンテスの道",
        cuerpo:
          "ラ・デエサ・デ・ナバマリンは、セルバンテスの道が通り、セルバンテスゆかりの地に取り囲まれた、歴史と伝説に満ちた魅力的な町です。さあ、荷造りして、ドン・キホーテ・デ・ラ・マンチャの世界に足を踏み出しましょう。",
        boton: "体験してみよう",
        cerrar: "閉じる",
        leer_mas: "続きを読む",
        tradicion: {
          titulo: "文学の伝統",
          cuerpo:
            "ミゲル・デ・セルバンテスは、ラ・デエサ・デ・ナバマリンの地に触発され、世界に名の知れた作品「ドン・キホーテ・デ・ラ・マンチャ」の中にある2章を執筆しました。 「カマチョの結婚式」と「モンテシノスの洞窟」で語られる物語は、この地が舞台です。ドゥルシネア・デル・トボーソとして登場するアルドンサ・ロレンソは、ドン・キホーテの想い姫でした。葡萄園、オリーブ園、サフラン畑を有す当社の名の由来は、ここから来ています。現在、ムネラでこの文学作品の遺産を訪れることができます。"
        },
        literatura: {
          cuerpo:
            "直営葡萄園、オリーブ畑、サフラン畑を有する当社の名は、この普遍的な傑作にちなんで付いています。本の中でドゥルシネア・デル・トボソと呼ばれているアルドンサ・ロレンソはドン・キホーテが慕った想い姫でありました。この文学作品の遺産をムネラの町で訪れることが出来ます。"
        },
        naturaleza: {
          titulo: "自然",
          cuerpo:
            "セルバンテスの道に沿って、ラ・デエサ・デ・ナバマリンから約40km、広大なカンポ・デ・モンティエルの真ん中に、水と緑のオアシスがあります。ルイデラ湖群国立公園です。そこの最も高い頂、カベサ・デ・サンペドロ（聖ペドロの頭）に、ロシャフリダ城とモンテシーノス洞窟があります。",
          more_cuerpo:
            "4000ヘクタールある国立公園に、大小16の湖が分布しています。山から水が湧き出て、ブランカ湖に集まり、勢いよく流れる滝や急流を形成しつつ、下流の湖やペニャロヤ貯水池に達します、春には、多種多様の植物で色とりどりに色付き、無数の水鳥の棲みかとなります。また、水量は最大に達し、所によっては、たくさんの小さな滝を形成しつつ、湖から湖へと流れていきます。",
          more_uno:
            "ラ・デエサ・デ・ナバマリンとアルドンサのワイナリーを訪れると、スペイン文学の重要な伝統が残る地を訪れたことになります。セルバンテスの作品「エル・キホーテ」の章XIX、XX、XXIで描かれている有名なカマチョの結婚式は、ムネラで執り行われました。主登場人物の金持ちカマチョ、貧乏者バシリオ、美しきキテリアがこの町出身であることを示す、いくつかの証拠と研究があります。このエピソードの舞台となった旅籠は、この町に現在でも残っており、アルドンザ製品を味わうことができる美しいホステルとなっています。",
          more_dos:
            "この有名なエピソードのキテリアに捧げるべく、1975年にモリーノ・デ・ラ・ベイヤ・キテリア（美しきキテリアの風車小屋）が建てられました。現在、ラ・マンチャ地方特有の家具や家庭用品の数々が展示してあります。セルバンテスの道に位置する農村観光できます。また、 1861年に建てらた古い風車小屋が、ムネラの町に寄付され、現在、写真民族博物館として使われています。そこでは、ラ・マンチャの昔の風車の間を歩くような感覚に襲われます。。",
          more_tres:
            "また、 1861年に建てらた古い風車小屋が、ムネラの町に寄付され、現在、写真民族博物館として使われています。そこでは、ラ・マンチャの昔の風車の間を歩くような感覚に襲われます。"
        },
        historia: {
          titulo: "歴史",
          cuerpo:
            "セルバンテスの道はアルカラス山脈やカンポス・デ・モンティエルといった高地は通らないので、セルバンテスの道から外れるものの、レスサ内にあるリビソサ遺跡やティリエス民族学博物館でも、ラ・マンチャの植物生態系や歴史文化を学ぶことができます。",
          more_uno:
            "リビソサ遺跡は、セロ・デル・カスティージョとして知られているレスサに位置し、10ヘクタールの土地にローマ植民地時代の跡を残す2,800年以上の歴史を持つ遺跡です。ここの発掘は、カスティーリャ・ラ・マンチャの最も重要な発見の1つになりました。グアディアナ川とフカル川の二つの流域の間に位置し、水、森林資源が豊富で、狩猟が盛んな地域です。穀物や大規模な葡萄の栽培とともに、家畜飼育が盛んで、非常に栄えました。当時、交易路が交差する場で地政学的にも有利で、農業と交易で栄えた歴史が深い地域です。",
          more_dos:
            "ティリエス民族学博物館は、アルバセテ県のレスサにあり、アルドンサの施設がある地域の歴史建造物や文化環境が再現されてある民族学博物館です。カンポ・デ・モンティエル地域の人々の日常生活が再現されており、養蜂や農業で使う道具、家の装飾品、車などを見ることができます。また、「村での生活」と呼ばれるセクションでは、鋳造所、鍛冶屋、店、オーブン、学校、チーズ工場、村の教会など、昔の人々の営みが展示されています。また、エスパルト（わら細工に似た工芸品）などの工芸品、レスサ川の水車製粉所のレプリカなどが展示されており、また、この地域のサフラン文化が紹介されています。"
        },
        legado: {
          titulo: "ドン・キホーテのカタルーニャ遺産",
          cuerpo:
            "ドン・キホーテ・デ・ラ・マンチャとカタルーニャの間に実は繋がりがあります。そのため、アルドンサは、カバも取り扱うことで、カタルーニャとの繋がりを求め、ビジネスを拡大しました。ドン・キホーテの冒険の8つの章はカタルーニャの地で繰り広げられました。その最も代表的なものは「カタルーニャへの到来と盗賊との出会い」、「港と海を望む」、「カタルーニャの首都」です。",
          boton: "発見する"
        }
      }
    },
    escucha: {
      intro:
        "人生のいいところは、計画していくのではなく、自然に起こっていくことだ。",
      cuerpo_intro: "アルドンサを感じて聴くのに必要なもの",
      tip_volumen:
        "音楽を通して新しい感覚を楽しみ、発見したいと思うこと。サウンドをオンにし、好みのボリュームに設定しましょう！",
      tip_cascos:
        "体験を一人で、または誰かと一緒かを選択します。どちらのオプションでも、アルドンサが提案する聴覚体験に浸ることが出来ます。",
      tip_dados:
        "心地のいい音が美食体験をよくすることをご存知ですか？ アルドンサのプレイリストに任せて、おいしい味を楽しんでください。",
      boton_escuchar: "リストを聴く",
      spotify: {
        titulo: "スポティ・アルドンザ",
        cuerpo:
          "準備は整っていますか？ワンクリックで、この瞬間をユニークなものにする体験ができます。あなたのために特に選ばれたそれぞれの雰囲気。",
        boton: "リストを聴く"
      },
      comparte: {
        titulo: "アルドンサ体験を共有する",
        cuerpo:
          "すべてのアルドンサ体験を楽しんでいただけましたか。そしてそれを私たちと共有してください！ソーシャルネットワークで共有しましょう！"
      }
    },
    otras_experiencias: {
      titulo: "その他の体験ツアー",
      lugares: {
        enoturismo: "ワイン観光ツアー",
        oleoturismo: "オリーブオイル観光ツアー",
        degustacionQuesos: "チーズのテイスティング定番のやり方 ",
        ruta_cervantina: "セルバンテスの道",
        recetario: "レシピ集"
      }
    },
    formulario: {
      vive_experiencia: "体験してみよう",
      solicita_visita: "",
      bodega: "ワイナリーへの見学ツアーを申し込む",
      almazara: "搾油所見学ツアーを申し込む",
      nombre: "Name",
      nombre_apellidos: "氏名",
      apellidos: "Surname",
      email: "Eメール",
      mensaje: "メッセージ",
      introduce_mensaje: "メッセージを入力してください",
      meses: {
        Enero: "January",
        Febrero: "February",
        Marzo: "March",
        Abril: "April",
        Mayo: "May",
        Junio: "June",
        Julio: "July",
        Agosto: "August",
        Septiembre: "September",
        Octubre: "October",
        Noviembre: "November",
        Diciembre: "December"
      },
      archivo_adjunto: "Add file",
      introduce_mail: "メールアドレスを入力してください",
      telefono: "電話番号",
      he_leido: "同意します",
      y_acepto: "プライバシーポリシーを読み、",
      texto_newsletter: "お知らせと新情報を受け取る",
      enviar: "送信",
      enviado: "Send",
      recibido:
        "We have received your message. We will get in touch with you as soon as possible.",
      concertar_visita:
        "電話またはメールで見学ツアーを申し込むこともできます。",
      lunes_domingo: "月曜日から日曜日まで",
      horario: "8:00 ～14:00 と 15:30 ～ 18:00",
      enlace_popup: "ここをクリックしてプライバシーポリシーを確認し、同意します"
    },
    popupterminos: {
      titulo: "BASIC DATA PROTECTION INFORMATION",
      titulo_dos: "DATA CONTROLLER",
      titulo_tres: "Aldonza Gourmet SAU ",
      cuerpo: [
        {
          titulo: "ADDRESS OF THE DATA CONTROLLER",
          cuerpo:
            "Parque Empresarial Ajusa, CM 332, km 2,2, calle 1, número 1., CP 02006, Albacete (Albacete)"
        },
        {
          titulo: "PURPOSE",
          cuerpo:
            "Your details will be used to process your requests and provide you with our services."
        },
        {
          titulo: "ADVERTISING",
          cuerpo:
            "We will only send you advertising if you authorize it in advance. You can do this by marking the corresponding box on the form."
        },
        {
          titulo: "LEGAL AUTHORITY",
          cuerpo:
            "We will only process your details with your prior consent. You can do this by marking the corresponding box on the form."
        },
        {
          titulo: "INTENDED RECIPIENTS",
          cuerpo:
            "Generally speaking, only duly authorized personnel at our company will be able to access the information we request from you."
        },
        {
          titulo: "RIGHTS",
          cuerpo:
            "You are entitled to know what information we hold about you, correct it and have it deleted, as explained in the additional information available on our web site."
        }
      ],
      titulo_mas: "ADDITIONAL INFORMATION",
      texto_mas: "Further information is available in the ",
      datos_seguros: "YOUR DATA SECURE",
      texto_nuestra: "section of our web site.",
      acepto: "Accept"
    },

    banner_contacto: {
      titulo: "コンタクトを取る",
      cuerpo:
        "ご不明な点がございましたら、次のフォームにご記入ください。できるだけ早く回答いたします",
      boton: "フォームを見る"
    },
    banner_localizaciones: {
      titulo: "お問合せ",
      cuerpo: "To access our facilities, go to either of these two places:",
      munera: "Crta. N-430  Km 462,3, 02612 Munera (Albacete)",
      lezuza: "<strong>Carretera CM-313</strong>, km 56, Lezuza (Albacete)."
    },
    banner_newsletter: {
      titulo: "お問合せ先",
      cuerpo: "所在地: Crta. N-430  Km 462,3, 02612 Munera (Albacete)",
      email: "Eメール:",
      telefono: "電話番号:"
    },
    cookie_banner: {
      texto:
        "A cookie is a small information file that is stored in your browser each time you visit our website. The use of cookies is to save the history of your activity in our so that, when you visit again, you can identify and configure your content based on your browsing habits, identity and preferences. They can be accepted, rejected, blocked and deleted, as desired. In case you reject them, we can not assure you the proper functioning of our website. More information in the cookies ",
      politica: "Privacy Policy",
      boton: "Accept"
    },
    intros_legales: {
      politica_cookies: "Cookies Policy",
      politica_privacidad: "Privacy Policy",
      datos_seguros: "Secure Data",
      aviso_legal: "Legal Advise",
      mapa_web: "web map"
    },
    volver: "戻る",
    volver_a: "戻る",
    aviso_legal: {
      terminos: "TÉRMINOS Y CONDICIONES",
      uno:
        "I.- La utilización, consulta y/o contratación de los servicios que se exponen en nuestra página Web www.aldonzagourmet.com supone por parte de los usuarios y/o clientes la aceptación plena y sin reservas de las Condiciones Generales de Contratación, que regulan la relación jurídica derivada de los procesos de contratación realizados entre los usuarios y/o clientes de la página Web www.aldonzagourmet.com propiedad de <strong>Aldonza Gourmet S.A.U</strong> (en adelante Aldonza Gourmet). Los Clientes aceptan las Condiciones Generales desde el instante que utilicen o adquieran cualquier producto. Este documento puede ser impreso para ser leído y almacenado por los Clientes, previamente a su aceptación.",
      dos:
        "II.- Las presentes Condiciones Generales, están sujetas en lo que resulte de aplicación a lo dispuesto a la Ley 7/1998, de 13 de abril, sobre Condiciones Generales de Contratación, al Real Decreto Legislativo 1/2007, de 16 de noviembre, por el que se aprueba el Texto Refundido de la Ley General para la Defensa de Consumidores y Usuarios y otras leyes complementarias, al Real Decreto 1906/1999, de 17 de diciembre de 1999, por el que se regula la Contratación Telefónica o Electrónica con condiciones generales, el Reglamento (UE) 2016/679 del Parlamento Europeo y del Consejo, de 27 de abril de 2016, relativo a la protección de las personas físicas en lo que respecta al tratamiento de datos personales y a la libre circulación de estos datos y por el que se deroga la Directiva 95/46/CE (Reglamento general de protección de datos), la Ley Orgánica 3/2018, de 5 de diciembre, de Protección de Datos Personales y garantía de los derechos digitales, la Ley 7/1996, de 15 de enero de Ordenación del Comercio Minorista, y a la Ley 34/2002 de 11 de julio, de Servicios de la Sociedad de la Información y de Comercio Electrónico.",
      tres:
        "III.- Modificación de las Condiciones Generales. Aldonza Gourmet podrá modificar las Condiciones Generales notificándolo a los Clientes con antelación suficiente, con el fin de mejorar los servicios y productos ofrecidos a través de Aldonza Gourmet. Mediante la modificación de las Condiciones Generales expuestas en la página Web de Aldonza Gourmet se entenderá por cumplido dicho deber de notificación. En todo caso, antes de utilizar los servicios o contratar productos, se pondrán consultar las Condiciones Generales.",
      cuatro:
        "IV.- Propiedad intelectual. Todos los contenidos de esta página Web (incluyendo el código fuente, imágenes, textos, gráficos, etc.) están protegidos por la normativa nacional e internacional vigente sobre propiedad intelectual, encontrándose todos los derechos reservados. Queda terminantemente prohibida la reproducción de cualquier contenido de la Web sin el consentimiento expreso de Aldonza Gourmet y de los poseedores de los derechos.",
      cuatro_dos:
        "Mediante la adquisición de un producto, Aldonza Gourmet no confiere al adquirente ningún derecho de alteración, explotación, reproducción, distribución o comunicación pública sobre el mismo, reservándose Aldonza Gourmet todos estos derechos. La cesión de los citados derechos precisará el previo consentimiento por escrito por parte de Aldonza Gourmet. La utilización no autorizada de la información contenida en esta Web, su reventa, así como la lesión de los derechos de propiedad intelectual o industrial dará lugar a las responsabilidades legalmente establecidas.",
      cinco:
        "V.- Uso del servicio y responsabilidades. Aldonza Gourmet no garantiza la disponibilidad permanente de los servicios, quedando exonerado por cualquier tipo de responsabilidad por posibles daños y perjuicios causados debido a la indisponibilidad del servicio por causas de fuerza mayor o errores en las redes telemáticas de transferencia de datos, ajenos a su voluntad. Aldonza Gourmet no se hace responsable del contenido de los enlaces a otras páginas Web que no sean titularidad suya y que, por tanto, no pueden ser controladas por ésta.",
      seis:
        "VI.- Protección de datos. En cumplimiento de lo dispuesto en el artículo 5 de la Ley Orgánica 15/1999, de 13 de diciembre, de Protección de Datos de Carácter Personal, y en la Ley 34/2002, de 11 de Julio, de Servicios de la Sociedad de la Información y de Comercio Electrónico, Aldonza Gourmet S.A.U (en adelante Aldonza Gourmet) le informa de que los datos de carácter personal proporcionados en los formularios de registro electrónico contenidos en este sitio, así como aquellos datos a los que Aldonza Gourmet acceda como consecuencia de su navegación; consulta, solicitud o contratación, o de cualquier transacción u operación realizada desde este sitio web, serán recogidos en un fichero que cumple con las exigencias de la legislación vigente aplicable y cuyo responsable es: Aldonza Gourmet S.A.U., Parque Empresarial Ajusa. Nº1 - Ctra. 332 Km 2.2. 02006 – Albacete - España. (info@aldonzagourmet.com)",
      seis_uno:
        "La finalidad de la recogida y tratamiento automatizado de los Datos Personales realizados a través de los formularios y contactos vía correo electrónico habilitados en este sitio Web, es para facilitar la prestación de servicios que Ajusa proporciona a través de estas páginas, así como para facilitarle información sobre las actividades y noticias que pudieran resultar de su interés.",
      seis_dos:
        "El envío de datos personales, mediante el uso de los formularios electrónicos de esta Web o, en su caso, el envío de mensajes de correo electrónico solicitando información o servicios, supone el consentimiento expreso del Usuario al tratamiento automatizado de los datos incluidos, así como al envío de comunicaciones vía electrónica con información acerca de nuestras actividades.",
      seis_tres:
        "Por lo tanto, el Usuario expresa su consentimiento expreso para que los Datos Personales sean incorporados al Fichero de Datos Personales y sean objeto de tratamiento automatizado por parte de Aldonza Gourmet con las finalidades antes indicadas. Asimismo, expresa la aceptación y autorización para que Aldonza Gourmet pueda ceder los Datos Personales, a las empresas que prestan servicios a Aldonza Gourmet, tales como bancos y aseguradoras.",
      seis_cuatro:
        "El Usuario garantiza que los datos personales facilitados a Aldonza Gourmet son veraces y se hace responsable de comunicar al mismo cualquier modificación de los mismos.",
      seis_cinco:
        "Aldonza Gourmet pone a disposición de los usuarios la dirección de correo electrónico info@aldonzagourmet.com y el teléfono 967 21 77 11, para que éstos revoquen el consentimiento prestado. Aldonza Gourmet declara que cumple la normativa vigente respecto a la protección de datos, en particular la Ley Orgánica 15/1999, de 13 de diciembre, de Protección de Datos de Carácter Personal y el Real Decreto 1720/2007, de 21 de diciembre, que desarrolla la citada ley orgánica, y pone a disposición de los Clientes los medios de contacto referidos en el párrafo anterior para que estos ejerzan los derechos de acceso, rectificación, cancelación y oposición garantizados por la legislación vigente.",
      seis_seis:
        "Aldonza Gourmet se compromete a tratar de forma absolutamente confidencial los datos de carácter personal y hacer uso de los mismos exclusivamente para las finalidades indicadas.",
      siete:
        "VII.- Comunicaciones electrónicas comerciales. Aldonza Gourmet pone a disposición de los usuarios, que previamente lo hayan solicitado, a través de formularios de suscripción habilitados al efecto, el servicio de envío de noticias, actividades e informaciones. El Usuario podrá darse de baja de este servicio en cualquier momento que lo considere oportuno mediante el envío de un correo electrónico a info@aldonzagourmet.com",
      ocho:
        "VIII. Información General. De conformidad con la ley 34/2.002, de 11 de julio, de Servicios de la Sociedad de la Información y de Comercio Electrónico, Aldonza Gourmet, manifiesta que ha procedido a cumplir con el deber de información en los términos que establece esta normativa, al efecto de permitir, tanto a los destinatarios del servicio como a los órganos competentes, el acceso de forma permanente, fácil, directa y gratuita a la siguiente información: Aldonza Gourmet S.A.U Parque Empresarial Ajusa. Nº1 - Ctra. CM-332 Km 2.2. 02006 - Albacete (España). www.aldonzagourmet.com. Teléfono: 967 21 77 11 Datos de inscripción en el Registro Mercantil de Albacete, Hoja nº 5031, Folio 222, Tomo 635, Libro 399, Sección 8. C.IF. Nº A-02203859.",
      nueve:
        "IX. Información sobre el uso de cookies. Este sitio Web utiliza cookies, pequeños ficheros de datos que se generan en el ordenador del Usuario y que nos permiten obtener la siguiente información: La fecha y hora de la última vez que el Usuario visitó nuestro Web, los contenidos que el Usuario escogió en su primera visita a nuestro Web, etc. Con la finalidad de realizar estadísticas globales de acceso. El Usuario consiente el uso de estas cookies, que en ningún caso permitirán su identificación, con la exclusiva finalidad de facilitar su navegación por las diferentes páginas del presente sitio Web. En cualquier caso, el Usuario podrá denegar o impedir la instalación de estas cookies modificando la configuración de su navegador.",
      diez:
        "X. Responsabilidad. El uso del Web se realizará bajo la única y exclusiva responsabilidad del Usuario. Dicha responsabilidad se extenderá al uso, por parte del usuario o de cualquier tercero, de cualquier contraseña o similares asignadas para el acceso al Web o a cualesquiera de sus servicios.",
      diez_uno:
        "Aldonza Gourmet no asume responsabilidad alguna derivada de los contenidos enlazados desde la Web, siempre que sean ajenos a la misma, ni garantiza la ausencia de virus u otros elementos en los mismos que puedan producir alteraciones en el sistema informático (hardware y software), en los documentos o los ficheros del usuario, excluyendo cualquier responsabilidad por los daños de cualquier clase causados al usuario por este motivo. Aldonza Gourmet rechaza toda responsabilidad que se derive de la mala utilización de los contenidos expuestos en estas páginas y se reserva el derecho a actualizarlos, eliminarlos, establecer limitaciones o restringir su acceso en cualquier momento, de manera temporal o permanente.",
      once:
        "XI.- Nulidad e ineficacia de las Cláusulas. Si cualquier cláusula incluida en estas Condiciones Generales fuese declarada nula o ineficaz total o parcialmente, tal nulidad o ineficacia afectará tan sólo a dicha disposición o a la parte de la misma que resulte nula o ineficaz, subsistiendo las Condiciones Generales en todo lo demás, teniéndose tal disposición, o la parte de la misma que resultase afectada, por no puesta.",
      doce:
        "XII.- Conflictos. Para cualquier controversia o conflicto suscitado, será de aplicación la legislación española, siendo competentes para la resolución de todos los conflictos derivados o relacionados con ella, los Juzgados y Tribunales de Albacete.",
      doce_uno:
        "El acceso a las páginas Web de este sitio, implica la aceptación de todas las condiciones expresadas en esta información legal. Aldonza Gourmet, podrá modificar sin previo aviso, la estructura y diseño del Web, así como cambiar o eliminar, los servicios, los contenidos y las condiciones de acceso de uso del Web y adaptarla a los cambios legislativos que se produzcan."
    },
    mejor_bodega_CM: "Chosen as the best winery in Castilla-La Mancha"
  },
  ko: {
    enlaces: {
      home: "/ko-home",
      finca: "/ko-estate",
      la_tierra: "/ko-estate/land",
      la_bodega: "/ko-estate/winery",
      proceso_cava: "/ko-estate/winery/cava-process",
      proceso_vino: "/ko-estate/winery/wine-process",
      la_almanzara: "/ko-estate/oil-mill",
      proceso_aceite: "/ko-estate/land/oil-process",
      proceso_queso: "/ko-estate/land/cheese-process",
      sala_azafran: "/ko-estate/saffron-room",
      queseria: "/ko-estate/dairy",
      proceso_azafran: "/ko-estate/saffron-room/saffron-process",
      productos: "/ko-products",
      vino: "/ko-products/wine",
      aceite: "/ko-products/olive-oil",
      azafran: "/ko-products/saffron",
      queso: "/ko-products/cheese",
      cava: "/ko-products/cava",
      productos: "/ko-products",
      premios: "/ko-awards",
      beneficios: "/ko-benefits",
      experiencias: "/ko-experiences",
      vive_aldonza: "/ko-experiences/experience-aldonza",
      oleoturismo: "/ko-experiences/experience-aldonza/oleotourism",
      degustacionQuesos: "/ko-experiences/experience-aldonza/cheese-tasting",
      ruta_cervantina: "/ko-experiences/experience-aldonza/cervantes-route",
      enoturismo: "/ko-experiences/experience-aldonza/oenotourism",
      recetario:
        "/ko-experiences/experience-aldonza/recipe-book-and-gastronomy-route",
      escucha_aldonza: "/ko-experiences/listen-to-aldonza",
      contacto: "/ko-home/contact",
      politica_proteccion: "/ko-data-protection-policy",
      politica_cookies: "/ko-cookie-policy",
      datos_seguros: "/ko-your-data-secure",
      aviso_legal: "/ko-legal-notice",
      mapa_web: "/ko-website",
      contactoid: "contact",
      experiencias_13: "https://tienda.aldonzagourmet.com/13-experiencias",
      mejor_bodega_CM:
        "https://blog.aldonzagourmet.com/2024/11/mejor-bodega-de-castilla-lamancha/"
    },
    vistas: {
      inicio: "홈",
      la_finca: "농장",
      la_tierra: "토양",
      la_almazara: "올리브 유 밀",
      la_bodega: "T와이너리",
      sala_azafran: "사프란 룸",
      productos: "제품",
      queseria: "Q그것은 것",
      productos_aldonza: "알돈자 제품",
      premios: "Awards",
      beneficios: "Benefits",
      experiencias: "체험하기",
      oleoturismo: "올리브 유 관광",
      degustacionQuesos: "치즈 치즈 시음",
      vive_aldonza: "알돈자 체험",
      las_catas: "Tasting:",
      experiencia_bodega: "이미 경험한 바 있다",
      ruta_cervantina: "세르반테스 루트",
      enoturismo: "와인 관광",
      recetario: "레시피 북",
      escucha_aldonza: "알돈자 듣기",
      blog: "알돈자 블로그",
      contacto: "연락처",
      politica_proteccion: "Privacy policy",
      politica_cookies: "Cookie policy",
      mapa_web: "Website",
      datos_seguros: "Secure Data",
      aviso_legal: "Legal Advise"
    },
    home: {
      intro: {
        titulo_uno: "",
        titulo_dos: "",
        titulo_tres: "알돈자 체험 (Aldonza)",
        experiencia_aldonza: "당신의 체험",
        aqui: "여기에서 시작하세요.",
        tienda: "온라인 매장",
        tarifas: "가격 요금"
      },
      comienza: {
        titulo_uno: "",
        titulo_dos: "",
        titulo_tres: "체험이 시작됩니다. ",
        experiencia_aldonza: "당신의 알돈자 체험",
        cuerpo:
          "자연이 우리에게 선사하는 그 변화의 미묘함을 감상하듯 저희의 와인, 까바 (sparkling wine), 엑스트라 버진 올리브 유 및 사프란은 당신의 감각을 깨워주는 근원이 될 것입니다."
      },
      la_finca: {
        titulo_uno: "농장",
        titulo_dos: "(Finca)",
        cuerpo:
          "저희 제품이 타사 제품과 차별되는 점은 바로 주변환경이라고 볼 수 있습니다. 나바마린 초원(La Dehesa de Navamarín)에 오신 것을 환영합니다.",
        aldonza_experience: "알돈자 체험 (Aldonza)"
      },
      productos: {
        titulo: "제품"
      },
      experiencia: {
        titulo_uno: "",
        titulo_dos: "알돈자 방문",
        aldonza_experience: "알돈자 체험 (Aldonza)",
        escucha_aldonza: {
          cuerpo:
            "음악을 들으면서 당신의 감각을 깨워 줄 새로운 장소로 이동해 보세요. 음악이 자연스럽게 당신을 데려가 줄 것입니다."
        }
      },
      contacto: {
        titulo: "연락처"
      }
    },
    blog: {
      titulo: "체험 계속하기",
      subtitulo: "알돈자 블로그",
      boton: "see"
    },
    newsletter: {
      titulo: "뉴스레터 구독",
      cuerpo: "이메일로 뉴스와 새로운 정보 받아 보기",
      texto_comunicaciones: "알돈자 뉴스와 업데이트를 수신하고 싶습니다.",
      boton: "뉴스레터 구독",
      enviado: "You subscribed correctly!"
    },
    otros_lugares: {
      titulo: "Other locations",
      lugares: {
        la_tierra: "토양",
        la_bodega: "와이너리 (LA BODEGA)",
        la_almanzara: "올리브유 밀 (THE OLIVE OIL MILL)",
        sala_azafran: "사프란 룸 (SAFFRON ROOM)",
        queseria: "Q그것은 것"
      }
    },
    la_tierra: {
      descubrir_proceso: "프로세스 알아보기",
      la_tierra: {
        cuadro_uno: {
          titulo: "주변환경",
          texto:
            "나바마린 초원은(La Dehesa de Navamarín) 스페인의 알바세떼 (Albacete) 지방의 북서쪽에 위치한 해발 1.200미터 이상의 자연 지역입니다. 2.200헥타르의 고산, 중산, 저산으로 되어 있으며, 참나무 (Oak)숲 지역과 아로마 식물지역으로 나뉘어져 있습니다. 구아디아나 (Guadiana) 와 후까르 (Júcar) 강의 경사면 사이에 위치한 세계에서 가장 큰 향나무(Sabinas: Juniperus Sabina) 보호 구역이 있는 독특한 지역입니다."
        },
        cuadro_dos: {
          titulo: "토양",
          texto_uno:
            "<strong>지면.</strong>0.000년 전 빙하로 인해 생성된 수많은 자갈들로 하여금 주변의 수분이 쉽게 증발하는 것을 막아 줍니다.",
          texto_dos:
            "<strong>바닥.</strong> 저희 품질은 농작물 재배에 최적인 토양에서 시작됩니다. Ph 중성 또는 약 알칼리성 성향의 석회암 토양으로 그 성분이 일관적이고 중간 범위의 투과성을 갖는 것이 특징입니다.",
          texto_tres:
            "<tr>동물군.</tr>마린 초원은(La Dehesa de Navamarín) 수많은 토착종 (사슴, 멧돼지, 붉은 자고) 과 외래종인 무플론 (mouflon)의 서식지로 이러한 동물들의 유기물은 우리 작물의  천연 비료로 사용되고 있습니다.",
          texto_cuatro:
            "<strong>기후.</strong> 추운 겨울과 고온의 매우 건조한 여름의 대륙. 작물에 해로운 곰팡이와 박테리아의 증식을 막아 주는 혹독한 기후조건. 포도나무의 경우 이렇게 상반된 온도조건이 작물성숙 단계에서 폴리페놀(탄닌과 안토시아닌)의 발달을 향상시켜줍니다.",
          texto_cinco:
            "<strong>향나무.</strong> 동양에서 기원된 천 여년 된 이 향나무들은 보호종의 일종으로 저희 과일재배가 건강에 좋은 독점적인 특성을 갖도록 기여해 주는 역할을 해줍니다."
        },
        frutos: {
          titulo: "과일",
          cuerpo:
            "높은 고도와 혹독한 기후 조건이 저희 과일의 품질에 직접적인 영향을 미칩니다. 저희는 다양한 포도 품종, 삐꾸알 (picual) 및 아르베끼나(arbequina) 같은 종의  올리브 그리고 사프란은  원산지 보호 명칭 (PDO La Mancha)인증을 보유 하고 있습니다."
        },
        escalera: {
          vinedo: {
            titulo: "포도원",
            cuerpo:
              "나바마린 초원에는 (La Dehesa de Navamarín) 독특하고 뛰어난 특성을 지닌 4개의 구획으로 분포된 포도나무 재배 전용지가 27헥타르에 이르고 있습니다. 저희 농장에서는 뗌쁘라니요 적색 (tintos Tempranillo) 품종과 이 지역의 전통 재배종인 까베르네 소비뇽(Cabernet-Sauvignon), 메를로(Merlot),시라 (Syrah), 그리고 백색 소비뇽 블랑과 (blancos Sauvignon-Blanc) 마까베오 (Macabeo) 품종을 재배합니다. 우리 까바의 포도원은 까딸루냐 주의 뻬네데스 (Penedés)에 위치 해 있고 저희 생산 센터인 산 사두르니 다노이아 (Sant Sadurní D'Anoia)는 바로셀로나 지방에 위치하고 있습니다. 이 지역은 까바(cava)와 원산지 명칭 보호가 인증된 스파클링 와인 재배지로 유명하며 저희 농장에서는 뜨레팟(Trepat) 품종의 적포도와 샤렐로(Xarel-lo), 마까베오 (Macabeo) 및 빠레야다 (Parellada) 품종을 재배합니다."
          },
          azafranal: {
            titulo: "사프란 농장",
            cuerpo:
              "저희 사프란 재배지는 건조하고 석회질이며 통풍이 잘되는 평평한 땅입니다. 침식의 위험이 적은 유기 물질로 균형 잡힌 토양이며 또한 구근이 손상되지 않게 수분이 잘 빠져 나갈 수 있도록 적당한 토양의 높이를 유지합니다. 사프란은 3~4년마다 일시적으로 땅을 고갈시키는 경향이 있습니다. 그래서 저희 농장은 최고 품질의 사프란을 보장하기 위해 몇 년마다 그 재배지를 순환합니다."
          },
          olivos: {
            titulo: "올리브 농장",
            cuerpo:
              "저희 포도나무들은 완전히 표준화 되고 정규화 된 프로토콜에 따라 유지 및 관리가 되고 있습니다.  삐꾸알(picual) 및 아르베끼나(arbequina) 올리브 유 재배 면적은 750헥타르에 이르고 있으며 삐꾸알(picual)종은 스페인에서 가장 많이 재배되는 품종으로 생산량의 50% 이상을 차지하고 있고 약간의 쓴 맛과 매운 맛이 그 특징이라고 볼 수 있습니다. 한편 아르베끼나(arbequina)종은 추위에 대한 저항력이 크고 달콤하고 부드러운 맛이 그 특징이라고 볼 수 있습니다."
          }
        }
      },
      la_almazara: {
        cuadro_uno: {
          titulo: "시설",
          texto:
            "최고 품질의 엑스트라버진 올리브 유를 보장하기 위해 혁신과 새로운 분석기술을 잊지 않으며 농장주변의 자연환경을 돌봅니다. 부모로부터 자녀에게 물려주는 전통, 우리 땅에 대한 헌신과 사랑은 알돈자 팀의 그날그날의 성과를 높여주는 가치 촉진재라고 할 수 있습니다. 알돈자는 다음 표준에 따라 인증되었습니다. <a href ='/static/pdf/certificado-IFS.pdf'download ><strong><u>IFS</u></strong></a> & <a href ='/static/pdf/certificado-BRC.pdf'download><strong><u>BRC.</u></strong></a>"
        },
        cuadro_dos: {
          titulo: "올리브 유 밀 (OIL MILL)",
          texto:
            "<p>저희는 엑스트라버진 올리브 유의 생산과정 전반에 걸쳐 참여를 하고 있습니다. 정교한 기술을 갖춘 저희 자체 오일공장에서 올리브 하나하나를 정성껏 손질하고 섬세하게 가공합니다. 신선하고 어두운 스테인리스 스틸 침전물은 올리브 향과 그 풍미의 순수한 뉘앙스를 보존해 주는 역할을 합니다.  또한 저희는 자연환경에 대한 확고한 약속을 유지합니다. 그래서 저희 생산 기계장비도 환경 품질인증을 받았습니다.</p><p>맛 뿐만 아니라 건강까지. 알돈자 생산산업 공장에서 당사 제품은 식품 안전보장에 맞춰 포장되게 되어 있습니다. 물류역량에서도 돋보일 정도로 저희 제품은 약속시간에 맞춰 20개 이상의 국가에 제공되고 있습니다. 저희 회사는 당신의 완벽한 파트너로 안성맞춤임을 장담합니다!</p>"
        },
        proceso: {
          titulo: "생산과정",
          cuerpo:
            "전통적인 생산방식과 현대성이 공존하여 생산이 이루어지고 항상 고품질의 엑스트라버진 올리브 유를 얻기 위해 각별한 주의를 기울입니다."
        },
        sala_catas: {
          titulo: "시음실",
          cuerpo:
            "코를 강렬하게 자극 하는 과일 향; 그 맛은 적당하게 쓴맛과 매운맛이 안정적으로 조합되어 있습니다. 이제 전문적인 시음을 진행합니다. 알돈자의 에코튜리즘 프로그램에서 엑스트라버진 올리브 유의 맛을 시음해 보세요.",
          boton_large: "방문 알아보기",
          boton_short: "방문 알아보기"
        }
      },
      sala_azafran: {
        cuadro_uno: {
          titulo: "수확",
          texto:
            "까스띠야 라 만차 지방에서 재배된 사프란만이 라 만차 원산지보호 인증을 받습니다. 이 품질 인증은 최적의 관능적 특성(색상, 향 및 풍미), 최고의 식품 안전성 및 스페인 원산지의 3가지 보증으로 전 세계적으로 인정받고 있습니다. 알바세떼(Albacete)주의 북서쪽에 위치한 기상조건과 지형, 석회암 및 알칼리성 토양은 독점적인 특성과 풍미를 지닌 탁월한 수확을 보장합니다."
        },
        cuadro_dos: {
          titulo: "사프란 룸",
          texto:
            "재배에서 포장에 이르기까지 알돈자는 사프란의 품질과 식품안전에 대한 확고한 약속을 유지하기 위해 자격을 갖춘 전문가팀으로 구성되어 있습니다. 농장에서뿐만 아니라 저희의 모던화된 생산시설에서도 저희는 알돈자 사프란을 손으로 직접 재배, 선택 및 포장합니다. 알돈자는 다음 표준에 따라 인증되었습니다. <a href ='/static/pdf/certificado-IFS.pdf'download ><strong><u>IFS</u></strong></a> & <a href ='/static/pdf/certificado-BRC.pdf'download><strong><u>BRC.</u></strong></a>"
        },
        proceso: {
          titulo: "생산과정",
          cuerpo:
            "사프란 생산 과정은 꽃의 붉은 암술머리처럼 섬세합니다. 전통적인 가치를 유지하고 각 생산단계에서 세심하게 작업을 수행합니다."
        },
        sala: {
          titulo: "사프란 룸",
          cuerpo:
            "알돈자 사프란은 저희 고장의 대중문화이며 그 생산의 비밀은 까스띠야 라 만차( Castilian La Mancha)의 가족이 대대로 물려준 유산의  하나라고 할 수 있습니다. 천 여년에 걸쳐 유지해 온 이러한 전통방식은 저희 사프란룸에서 체험 하실 수 있습니다."
        }
      },
      la_bodega: {
        cuadro_uno: {
          titulo: "시설",
          texto:
            "<p>알바세떼(Albacete)지방의 북서쪽에 위치한 돈끼호떼로 알려진 무네라(Munera)시의 중심부에서 저희는 4대를 걸쳐 와인을 만들고 있습니다. 저희 와이너리와 포도원은 작가 미겔 데 세르반떼스가(Miguel de Cervantes) '돈끼호떼'의 여러 장에 걸쳐 묘사하고 있는 전통과 전설의 장소로도 알려져 있습니다. 올리브 유 및 사프란과 같은 라 만차의(La Mancha)기타 전통 제품들뿐만 아니라 저희 와인은 저희 농장원들의 열정과 제품의 완벽을 추구하는 노력의 결과라고 볼 수 있습니다.</p> 알돈자는 다음 표준에 따라 인증되었습니다. <a href ='/static/pdf/certificado-IFS.pdf'download ><strong><u>IFS</u></strong></a> & <a href ='/static/pdf/certificado-BRC.pdf'download><strong><u>BRC.</u></strong></a>"
        },
        cuadro_dos: {
          titulo: "와이너리",
          texto:
            "<p>정교한 기계를 갖춘 현대적인 시설이 갖춰진 가족 전통의 와이너리. 농업 전통과 혁신, 당신의 감각을 깨워주는 와인을 생산하기 위한 완벽한 조합.</p><p>저희는 와인 양조뿐만 아니라 디자인에서도 모든 세부사항을 관리합니다. '몬드리안'(Mondrian)스타일의 와인병걸이와 폭포도 있는 동굴에는 프랑스 산 및 미국 산 오크 배럴룸과 포도 갈이에 사용 한 최초의 기계가 전시되어 있어 당신을 놀라게 할 것입니다. 와인의 문화로 찾아 오는 모든 사람을 흡힙하는 공간이라고 할 수 있습니다."
        },
        proceso: {
          titulo: "와인 생산 과정",
          cuerpo:
            "저희의 목표는 신중한 생산공정을 통해 포도의 위대함과 최상의 품질을 추출 하자는 것입니다."
        },
        proceso_cava: {
          titulo: "까바 (Cava; Sparkling wine) 생산 과정",
          cuerpo:
            "저희는 까바의 전통적인 생산방법을 유지하고 있으며  까딸루냐 지방의 뻬네데스(바르셀로나)에서는 4가지 종류의 원산지 명칭 스파클링 와인 (Denomination of Origin)을 수확하고 생산합니다."
        },
        sala_barricas: {
          titulo: "배럴 룸",
          cuerpo:
            "나무의 향기, 와인의 향기, 폭포 소리와 주변의 희미한 빛은 당신을 완전히 다른 세상으로 데려다 줄 것입니다. 와이너리 지하에 위치한 와인 저장고에 있는 배럴 룸은 알돈자 와인의 품질을 반영한다고 할 수 있습니다. 이 독특한 공간을 즐기면서 저희 제품을 맛보실 수 있습니다.",
          boton_large: "방문 알아보기",
          boton_short: "방문 알아보기"
        }
      },
      queseria: {
        cuadro_uno: {
          titulo: "장인",

          texto:
            "<p>농업과 가축에 대한 우리의 전통은 양젖으로 만든 퀘소 만체고산 치즈를 생산하도록 촉발했습니다.<br>만드는 손의 사랑을 전하는 최고 품질의 치즈를 제공하기 위해 매일 노력하고 있습니다. 우리는 가축과 우유 품질 모두에서 필요한 식품 안전 관리를 보장하기 위해 전통적인 방법에 최고의 기술을 추가합니다.</p>"
        },
        cuadro_dos: {
          titulo: "품종",
          texto:
            "<p>Aldonza Gourmet은 경화, 반 경화 및 엑스트라 버진 올리브 오일의 세 가지 치즈를 만들고 있으며 모두 순종 Manchego 양 우유로 만듭니다. 100% 만체고 치즈의 전통과 문화와 함께 우리 치즈의 풍미를 5대륙으로 수출하고 있습니다.</p> "
        },
        proceso: {
          titulo: "치즈 만들기",
          cuerpo: "우리는 Manchego 치즈의 전통적인 과정을 따릅니다."
        }
      }
    },
    saber_mas: "더 알아보기",
    certificadoBRC: "Certificate BRC",
    certificadoIFS: "Certificate IFS",
    Certificados:
      "Aldonza is certified by <a href ='/static/pdf/certificado-IFS.pdf'download >IFS </a> and <a href ='/static/pdf/certificado-BRC.pdf'download>BRC</a> regulations.",
    Certificados2:
      "Company certified by <a href ='/static/pdf/certificado-IFS.pdf'download >IFS </a> and <a href ='/static/pdf/certificado-BRC.pdf'download>BRC</a> regulations.",
    slider_productos: {
      vino: {
        slug: "wine",
        titulo: "알돈자 와인",
        cuerpo:
          "전통과 전설이 깃든 맛, 4종류의 다양한 와인으로 색다른 경험을 하실 수 있습니다. 더 자세히 발견해 보세요.",
        button: "알돈자 와인"
      },
      aceite: {
        slug: "olive-oil",
        titulo: "알돈자 올리브 유",
        cuerpo:
          "저희의 아주 특별한 엑스트라 버진 올리브 유의 향기 만으로도 벌써 그 질감과 풍미의 서곡을 느끼기 시작할 것입니다. 그 이유는 바로 정교화 된 생산공정 과정의 결과라고 볼 수 있습니다.",
        button: "알돈자 올리브 유"
      },
      azafran: {
        slug: "saffron",
        titulo: "알돈자 사프란",
        cuerpo:
          "수작업으로 행해지는 사프란 암술머리 분리작업은 천 여년 전통의 섬세한 작업으로 사프란 암술머리 하나하나에서 그 품질이 높이 평가됩니다. 알돈자 사프란은 원산지 보호 명칭 (PDO La Mancha) 인증서를 보유 하고 있습니다.",
        button: "알돈자 사프란"
      },
      cava: {
        slug: "cava",
        titulo: "알돈자 까바 (sparkling wine)",
        cuerpo:
          "까바 잔에서 거품이 올라오는 순간부터 상쾌해 집니다. 4가지 종류의 스파클링 와인의 각각 다른 감각이 여러분을 기다립니다. 그들을 느껴보세요!",
        button: "알돈자 까바 (sparkling wine)"
      },
      queso: {
        slug: "cheese",
        titulo: "Q그것은 것",
        cuerpo:
          "라만차의 진정한 맛은 우리 땅의 음식을 전 세계로 가져간다는 정신과 결합됩니다. 원산지 만체고 치즈의 명칭.",
        button: "Q그것은 것"
      }
    },
    slider_proceso: {
      proceso_vino: {
        id: "proceso-del-vino",
        padre: "la_bodega",
        pasos: {
          vendimia: {
            titulo: "포도 수확.",
            cuerpo:
              "포도가 최적의 숙성점에 도달하면 보통 8월말에서 9월초 사이에 수확을 시작합니다. 고온이 과일과 그 발효과정에 영향을 미치는 것을 방지하기 위해 전통적인 수작업 및 야간수확 시스템을 사용하여 수확합니다. 포도는 상자에 담아 와이너리로 운송되며 고 품질 와인을 보장하기 위해 최고상태의 과일을 사람이 직접 선택합니다."
          },
          fermentacion: {
            titulo: "발효 및 압착.",
            cuerpo:
              "<p>엄선된 포도의 줄기가 제거되면 발효과정은 완전히 컴퓨터화 된 강철탱크에서 시작됩니다. 저희는 포도의 고형 찌꺼기에서 액체를 분리하는 단계에서 이뤄지는 와인 압착에 특별한 주의를 기울입니다.</p>"
          },
          crianza: {
            titulo: "배럴 숙성 및 병 숙성.",
            cuerpo:
              "<p>우리 양조전문가 팀은 그 해 수확된 포도액(cada añada)이 배럴에서 보낼 시간을 결정하는데 그 최소 기간은 항상 6개월로 정합니다. 이 숙성 기간이 지하에 위치한 아메리카 산 오크 배럴과 프렌치 산 오크 배럴에서 레드와인의 개성이 물씬 풍기게 해 주는 시기입니다. 배럴룸은 일년 내내 최적의 온도와 습도를 유지합니다. 와인이 모든 향과 풍미가 갖춰지면 쿠파주(coupage: 등급이 다른 두 가지 이상의 포도주를 섞는 행위)를 실행하고 배럴에서 보낸 시간과 동일한 시간동안 와인 병에서 숙성하는 시간이 존중됩니다</p>"
          },
          etiquetado: {
            titulo: "라벨링.",
            cuerpo:
              "<p>저희의 토양과 저희가 생산하고 있는 와인에 대한 헌신과 충실도는 라벨링 단계에서 함께 봉인된다고 할 수 있습니다. 물류부서에서 알돈자 브랜드가 유통되고 있는 20개국 이상에 우리 와인을 보냄으로써 생산 프로세스가 완료됩니다. 저희는 저희 제품의 제조공정의 모든 단계를 통제하고 운영하는 전문 팀입니다.</p>"
          }
        },
        boton: "알돈자 와인"
      },
      proceso_cava: {
        id: "proceso-del-cava",
        padre: "la_bodega",
        pasos: {
          vendimia: {
            titulo: "포도 수확",
            cuerpo:
              "<p>포도(사렐로, 마까베오, 빠레야다, 뜨레빳)를 수확한 후, 까바를 만드는 전통적인 방법은 유명한 산 사두르니 다노이아(Sant Sadurní D'Anoia 바르셀로나)생산센터에서 시작됩니다. 저희는 프레싱의 첫 번째 부분에서 추출된 포도액만을 사용합니다.</p>"
          },
          tiraje: {
            titulo: "2차 발효.",
            cuerpo:
              "<p> 이것은 베이스 와인과 이스트와 설탕의 혼합물로 병을 채우는 과정입니다. 이후 같은 병 안에서 2차 발효를 일으키고 이 제품의 특징인 기포를 생성합니다. 후속 노화에는 최소 9개월이 필요합니다</p>"
          },
          deguelle: {
            titulo: "병의 뚜껑 열기 (Degüelle).",
            cuerpo:
              "<p>이 단계에서는 병에서 뚜껑을 열어서 병 안에 침전되어 있는 효모를 제거 합니다. 이후에 'Expedition Liqueur' (특정 스파클링 와인을 만드는 데 사용되는 와인과 설탕의 혼합물)을 첨가 하는데 당분의 양에따라 천연 까바(Nature), 브뤼(Brut) 또는 세미 스위트(Semi-dulce)인지가 결정됩니다.</p>"
          },
          etiquetado: {
            titulo: "라벨링 및 물류.",
            cuerpo:
              "<p>저희는 카바 생산공정의 모든 단계에 참여하여 모든 단계에서 최고 품질 표준에 맞도록 감독하고 보장합니다.</p>"
          }
        },
        boton: "알돈자 까바 (sparkling wine)"
      },
      proceso_aceite: {
        id: "proceso-del-aceite",
        padre: "la_almanzara",
        pasos: {
          cosecha: {
            titulo: "추수",
            cuerpo:
              "<p>숙성은 수확량, 산도 및 오일의 관능적 특성과 관련이 있으므로 최적의 올리브 수확시점을 결정하는 것이 중요합니다. 이러한 케어가 저희 엑스트라버진 올리브 유의 성공 비결이며 매년 11월 초에 올리브의 숙성 과정에 대한 세심한 후속조치를 시작합니다. 수확은 보통 11월 말이나 12월 초에 시작됩니다. 나무에서 땅으로 떨어지지 않은 신선한 열매만을 모읍니다.</p>"
          },
          recepcion: {
            titulo: "올리브 제분소 도착 및 세정 과정",
            cuerpo:
              "<p>올리브를 정밀하게 제분소로 운반한 뒤 올리브의 성분을 결정하고 가공을 최적화하기 위한 분석을 통해 열매의 건강상태를 확인합니다. 분쇄 전 단계는 모든 불순물을 제거하는 것입니다. 최종적으로 올리브는 건조환기를 통해 잎, 꽃다발 등을 제거하는 세정기계를 거칩니다.</p>"
          },
          molienda: {
            titulo: "그라인딩 및 쉐이킹",
            cuerpo:
              "<p>갈기 단계에서 올리브의 물리적 구조를 분해하고 치는 단계를 수행하여 올리브 페이스트를 만듭니다. 쉐이킹의 목적은 올리브로부터 기름이 잘 분리되도록 하는 것입니다.  올리브 페이스트는 주변 온도보다는 높고 그렇지만 항상 25도 미만의 온도에서 연속적으로 움직이는 동작을 하도록 합니다.</p>"
          },
          extraccion: {
            titulo: "오일 추출 및 오일 세정",
            cuerpo:
              "<p>올리브 페이스트를 치고 나서 나머지 부분에서 오일을 분리합니다. 저희 생산 과정의 모든 기술이 그렇듯이 이 기술도 현재는 훨씬 발전된 방식을 따르고 있습니다. 이전의 전통적인 방식인 천연섬유 필터 디스크의 압력으로 작업했던 것을 현재는디켄터라 불리는 더 빠르고 더 효율적인 자동원심분리기로 추출을 하고 있습니다. 페이스트는 원심력의 작용에 의해 밀도에 따라 각각 분리됩니다. 디캔터에서 나오는 오일에는 여전히 고체 불순물과 약간의 물이 포함되어 있습니다. 이러한 물질을 훨씬 빠르고 정밀하게 분리시켜 주는 기계인 수직원심분리기를 사용하여 오일과 불순물의 접촉시간을 줄이고 보다 안정적인 분리를 보장합니다.</p>"
          },
          almacenamiento: {
            titulo: "보관 및 포장",
            cuerpo:
              "<p>엑스트라버진 올리브 유는 이렇게 생산된 후 스테인리스스틸 탱크에 보관하여 빛, 외부 냄새, 외부 온도, 소음 등의 악조건으로부터 보호하여 완벽한 상태를 유지합니다. 병입 전에 더 밝고 깨끗한 오일을 얻기 위해 접지필터를 수행합니다.병입공정에서 우리는 마지막 순간까지 오일의 관능적 특성을 관리하며 품질에 있어서 그가 지정하고 있는 표준의 기대치를 충족하는지 다시 한번 확인합니다.</p>"
          }
        },
        boton: "엑스트라버진 올리브 유"
      },
      proceso_queso: {
        id: "proceso-del-queso",
        padre: "queseria",
        pasos: {
          Ordeño: {
            titulo: "착유 및 응고",
            cuerpo:
              "<p>양의 젖을 짜낸 직후 우유의 모든 특성을 보존하기 위해 우유를 4ºC의 온도에서 냉장 보관합니다. 다음으로 우유를 응고 통에 붓고 30ºC의 일정한 온도로 올립니다. 커드가 적절한 농도에 도달하면 커드를 자르고 치즈 성형으로 넘어갑니다.</p> "
          },
          moldelado: {
            titulo: "성형, 압착 및 염장",
            cuerpo:
              "<p>우리는 장인의 방식으로 몰드에 커드를 넣고 번호가 매겨지고 일련 번호가 매겨진 카제인 플레이트를 놓아 만체고 치즈의 각 조각을 식별합니다. 그런 다음 치즈를 눌러 유청을 완전히 제거하고 최종 모양을 만듭니다. 압축 후 금형에서 제품을 추출하고 치즈에 소금을 뿌립니다. 소금에 절이는 동안 치즈는 미생물 과정을 조절하고 풍미를 향상시키며 외부 껍질을 생성합니다.</p>"
          },
          maduracion: {
            titulo: "성숙",
            cuerpo:
              "<p>우리 치즈의 숙성 기간은 반 경화의 경우 60~100일, 경화의 경우 150~210일입니다. 당사의 숙성 챔버는 제어된 온도 및 습도 조건을 유지하여 만체고 치즈의 올바른 숙성을 허용합니다.</p>"
          }
        },
        boton: "Our Cheese"
      },
      proceso_azafran: {
        id: "sala-del-azafran",
        padre: "sala_azafran",
        pasos: {
          cosecha: {
            titulo: "추수",
            cuerpo:
              "<p>사프란꽃이 가을에 만개하도록 구근은 6월에서부터 9월 사이에 심습니다. 저희 사프란은 수확 하기에 유리한 건조하고 석회질이며 평평하고 나무가 없는 땅에서 재배됩니다. 토양이 그리 깊지 않아서 근구가 손상되지 않도록 물이 용이하게 빠져나가는 조건을 갖추고 있습니다.</p>"
          },
          recoleccion: {
            titulo: "수확",
            cuerpo:
              "<p>농부들의 노래와 휘파람 소리는 해가 뜨기 전에 저희 농장에 울려 퍼집니다. 사프란꽃은 햇빛에 의해 암술머리가 그 속성이 잃지 않도록 새벽에 수확됩니다. 수확철은 10월 말에서 11월 초 사이입니다.</p>"
          },
          monda: {
            titulo: "암술머리 분리 작업",
            cuerpo:
              "<p>이 세심한 작업은 고대부터 이루어진 전통 방식인데 사프란꽃은 아침 첫 이슬을 머금은 채 수확되어 도착됩니다. 꽃의 나머지 부분에서 암술머리를 분리하는 것을 직접 손으로 하는데 이 작업은 일명 '몬다(monda)' 또는 데스브리즈나도 '(desbriznado)'라고 합니다. 이 작업이 제일 힘들고 섬세한 작업이라고 할 수 있으며 암술머리가 손상되지 않고 로스팅 단계에 도달 하도록 하는 것이 매우 중요합니다. 이 작업은 현장에서 수집한 후 12시간을 초과하지 않는 기간에 수행됩니다.</p>"
          },
          tostado: {
            titulo: "로스팅 단계",
            cuerpo:
              "<p>사프란은 덩어리로 저열로 구워집니다. 암술머리를 말리거나 굽는 과정은 사프란이 완벽한 상태로 보존되도록 하기 위해서고 최고의 풍미가 유지되도록 하기 위한 것입니다. 습도, 착색력, 향, 안정성 등 제품의 특성을 결정 짓는 중요한 단계입니다.</p>"
          },
          almacenamiento: {
            titulo: "저장",
            cuerpo:
              "<p>구워 진 사프란은 습기와 빛이 차단되는 용기에 재빨리 보관됩니다. 또한 25ºC 미만의 실 온도에서 보관되며 포장은 수동으로 이루어 집니다</p>"
          }
        },
        boton: "알돈자 사프란"
      }
    },
    productos_banner: {
      title: "알돈자 제품",
      productos: {
        vino: "와인",
        aceite: "엑스트라버진 올리브 유",
        azafran: "사프란",
        cava: "까바 (Cava; Sparkling Wine)",
        queseria: "Q그것은 것"
      }
    },
    tips_productos: {
      tipo_vino: "와인의 종류:",
      tipo_uva: "포도의 종류:",
      tipo_cava: "발포성 포도주:",
      elaboracion: "창조:",
      gastronomia: "요리법:",
      notas_cata: "테이스팅 마크:",
      premios: "수상:",
      ingredientes: "성분:",
      caracteristicas: "특징:",
      maridaje: "잘 어울린다:",
      descargar_ficha: "파일 다운로드",
      curacion: "경화 기간",
      apariencia: "모습:",
      conservacion: "보존:",
      durabilidad: "유통 기한:",
      alergenos: "알레르겐:",
      valoresnutricionales: "영양가 에너지가:"
    },
    productos: {
      vino: {
        slug: "vino",
        nombre: "와인",
        intro_ficha: {
          titulo: "당신의 감성을 깨워준다.",
          cuerpo:
            "<p>알돈자 와인은 그 주변환경인 나바마린 초원(La Dehesa de Navamarín)이라는 토양에서 재배됨으로써 거기에서만 얻을 수 있는 특성을 가지고 있습니다. 또한 숙련된 손길과 영혼의 덕이라고도 볼 수 있습니다.  돈키호테 땅에 위치한 와인전통의 발자취인 알돈자 와인은 프랑스 산 및 스페인 산 포도 품종으로 생산되는 개성 있는 와인, 열정과 영혼이 담긴 와인 그리고 우리의 감성을 깨워주는 와인이라고 보실 수 있습니다.</p>"
        },
        intro_productos:
          "<span>완벽한 순간을 찾지 말고 그저 한 순간을 찾고 그 순간을 완벽하게 만드세요.</span>",
        productos: {
          navamarin: {
            id: "navamarin",
            nombre: "Navamarín",
            tipo_vino:
              "카베르네 소비뇽 | 메를로 | 템프라니요 | 시라 (Cabernet Sauvignon | Merlot | Tempranillo | Syrah)",
            tipo_uva: "프랑스 산 및 미국 산 오크 배럴에서 최소 12개월 숙성",
            elaboracion:
              "세계에서 가장 큰 주니퍼 보호 구역이 있는 특별한 구석인 나바마린 목초지(Navamarín Pastureland)에서 생산된 와인으로, 와인에 고유한 특성과 향을 부여합니다. 포도나무당 2kg을 초과하지 않는 생산에서 신중하게 포도를 선택합니다. Coupage는 Cask Aging이 완료되면 수행됩니다.",
            graduacion: "알코올 농도 13,5 - 14,5% | 16º - 18ºC",
            cantidad: "750ml",
            servicio: "Between 16º - 18º C.",
            gastronomia:
              "고기류, 스튜요리 (한국 요리의 찌개와 조림의 중간 성격을 지닌 음식),사냥 동물의 고기 및 치즈와 잘 어울립니다.",
            notas_cata: {
              texto:
                "아름다운 체리 빛, 바닐라나 견과류를 갖 볶아 낸듯 한 , 잘 익은 붉은 과일의 강렬한 아로마. 입안 가득 퍼지는 그 짙은 맛은 우리몸에 완벽한하게 스며들어 오랫동안 지속됩니다.",
              autor: "James Suckling"
            },
            premios: [
              "navamarin-pswc-2011",
              "navamarin-berliner-2015",
              "navamarin-china-wine-2015",
              "navamarin-china-wine-2016",
              "navamarin-corea-wine-2015",
              "navamarin-corea-wine-2016",
              "navamarin-bruselas-2013",
              "navamarin-zarcillo-2007",
              "navamarin-testing-2014",
              "navamarin-wswa-2014",
              "navamarin-houston-2015",
              "navamarin-vinalies-2011",
              "navamarin-londres-2013",
              "navamarin-decanter-2013",
              "navamarin-mundus-2018",
              "navamarin-suckling-2018",
              "navamarin-suckling-2019",
              "navamarin-decanter-bronce-2019",
              "navamarin-mundus-2020",
              "navamarin-mundus-2021",
              "navamarin-penin-2023",
              "navamarin-bruselas-2022",
              "navamarin-londres-2022-2",
              "navamarin-bruxelles-2023"
            ]
          },
          selection: {
            id: "seleccion",
            nombre: "Selection",
            tipo_vino: "프랑스 산 및 미국 산 오크 배럴에서 최소 9개월 숙성",
            tipo_uva:
              "카베르네 소비뇽 | 메를로 | 템프라니요 | 시라 (Cabernet Sauvignon | Merlot | Tempranillo | Syrah)",
            elaboracion:
              "희귀한 포도 품종에서 엄선한 포도를 기반으로 만들어지며 이상적인 숙성 지점에서 밤에 수확합니다. 더 나은 블렌딩을 위해 캐스크 숙성이 끝나면 쿠파주가 발생합니다. 그것은 우리 와인 저장고의 어둠 속에서 12개월 동안 병에 남아 있습니다.",
            graduacion: "알코올 농도 13,5 - 14%",
            cantidad: "750 ml",
            servicio: "16º - 18º C.",
            gastronomia: "고기, 스튜, 게임 및 치즈와 잘 어울립니다.",
            notas_cata: {
              texto:
                "고기류, 스튜요리 (한국 요리의 찌개와 조림의 중간 성격을 지닌 음식),사냥 동물의 고기 및 치즈와 잘 어울립니다.",
              autor: ""
            },
            premios: [
              "seleccion-pswc-2011",
              "seleccion-testing-2014",
              "seleccion-wswa-2014",
              "seleccion-burdeos-2008",
              "seleccion-vinalies-2009",
              "seleccion-vinalies-2012",
              "seleccion-decanter-2017",
              "seleccion-suckling-2019",
              "seleccion-decanter-bronce-2019",
              "seleccion-2022"
            ]
          },
          classic: {
            id: "clasico",
            nombre: "Classic",
            tipo_vino: "프랑스 산 및 미국 산 오크 배럴에서 최소 6개월 숙성",
            tipo_uva:
              "카베르네 소비뇽 | 메를로 | 템프라니요 | 시라 (Cabernet Sauvignon | Merlot | Tempranillo | Syrah)",
            elaboracion:
              "이전에 카스티야 라만차 지역에서 사용되었던 고전적인 와인 제조 방법을 따르는 전통적인 개발 과정입니다. 최고 품질의 포도를 신중하게 선택합니다. 숙성 기간 동안 최소 6개월 동안 병에 보관되어 구매 가능합니다.",
            graduacion: "알코올 농도 13 - 14%",
            cantidad: "750 ml",
            servicio: "16º - 18º C.",
            gastronomia:
              "염장 발효고기 (살라미, 살치촌, 초리조...), 스튜요리, 쌀요리 및 파스타에 이상적입니다.",
            notas_cata: {
              texto:
                "숲속 야생과일의 농축미가 두드러지는 가운데, 입에서는 붉은 감초의 향이 느껴집니다. 입 안에서는 부드러운 탄닌감과 함께 길게 이어지는 우아한 여운을 남긴다.",
              autor: "James Suckling"
            },
            premios: [
              "clasico-testing-2014",
              "clasico-wswa-2014",
              "clasico-houston-2015",
              "clasico-decanter-2017",
              "clasico-berliner-2018",
              "clasico-bacchus-2018",
              "clasico-suckling-2018",
              "clasico-suckling-2019",
              "clasico-cwsa-2018",
              "clasico-mundus-2021",
              "clasico-penin-2023"
            ]
          },
          albo: {
            id: "albo",
            nombre: "Albo",
            tipo_vino: "백 포도주(White Wine)",
            tipo_uva: "소비뇽 블랑 |마카뷰 (Sauvignon Blanc | Macabeo)",
            elaboracion:
              "수확 후 효모와 발효 온도를 모니터링하면서 약간의 침용이 일어나 풍부한 향과 절묘한 과일 풍미를 만들어냅니다.",
            graduacion: "알코올 농도 12 - 13% | 4º - 6ºC",
            cantidad: "750 ml",
            servicio: "Between 4º - 6º C.",
            gastronomia:
              "해산물 요리, 생선 요리 및 디저트를 곁들이면 완벽합니다.",
            notas_cata: {
              texto:
                "옅은 노란색 톤으로 깨끗하고 밝은 빛, 과일향(바나나, 복숭아, 패션 프루트)과 꽃향(오렌지 꽃과 자스민)이 강렬하게 우리 코를 자극합니다.적당히 균형에 맞는산도로하여 신선함과 쾌적한 뒷맛을 길게 유지 해 줍니다.",
              autor: ""
            },
            premios: [
              "albo-berliner-2016",
              "albo-testing-2014",
              "albo-suckling-2019"
            ]
          }
        },
        banner_premios: {
          titulo: "수상 와인",
          boton: "모든 상 보기",
          premio: "navamarin-bruxelles-2023"
        },
        premios: {
          titulo: "권위있는 소믈리에로부터의 국제 수상 및 리뷰. (sumillers)",
          premios: {
            "navamarin-pswc-2011": {
              titulo: "Aldonza Navamarín",
              posicion: "Second Prize",
              texto:
                "2006 vintage, awarded the Silver Medal at 2011’s Pro Wein PSWC, Mainz (Germany).",
              categoria: "International",
              pais: "Germany",
              anyada: "2006",
              anyo: "2011"
            },
            "seleccion-pswc-2011": {
              titulo: "Aldonza Selección",
              posicion: "Second Prize",
              texto:
                "2006 vintage, awarded the Silver Medal at 2011’s Pro Wein PSWC, Mainz (Germany).",
              categoria: "International",
              pais: "Germany",
              anyada: "2006",
              anyo: "2011"
            },
            "navamarin-berliner-2015": {
              titulo: "Aldonza Navamarín",
              posicion: "First Prize",
              texto:
                "2009 vintage, awarded the Gold Medal at the 2015 Berliner Wein Trophy, Berlin (Germany).",
              categoria: "International",
              pais: "Germany",
              anyada: "2009",
              anyo: "2015",
              doble: true
            },
            "albo-berliner-2016": {
              titulo: "Aldonza Albo",
              posicion: "First Prize",
              texto:
                "2015 vintage, awarded the Gold Medal at the 2016 Berliner Wein Trophy, Berlin (Germany).",
              categoria: "International",
              pais: "Germany",
              anyada: "2015",
              anyo: "2016",
              doble: true
            },
            "pisces-mondiales-2008": {
              titulo: "Aldonza Pisces",
              posicion: "Second Prize",
              texto:
                "2006 vintage, awarded the Silver Medal at the 2008 World Wine Selections, Quebec (Canada).",
              categoria: "International",
              pais: "canada",
              anyada: "2006",
              anyo: "2008"
            },
            "navamarin-china-wine-2015": {
              titulo: "Aldonza Navamarín",
              posicion: "First Prize",
              texto:
                "2009 vintage, awarded the Gold Medal at the 2015 China Wine Spirit Awards, Hong Kong (China).",
              categoria: "International",
              pais: "china",
              anyada: "2009",
              anyo: "2015"
            },
            "navamarin-china-wine-2016": {
              titulo: "Aldonza Navamarín",
              posicion: "First Prize",
              texto:
                "2010 vintage, awarded the Gold Medal at the 2016 China Wine Spirit Awards, Hong Kong (China).",
              categoria: "International",
              pais: "china",
              anyada: "2010",
              anyo: "2016"
            },
            "navamarin-corea-wine-2015": {
              titulo: "Aldonza Navamarín",
              posicion: "First Prize",
              texto:
                "2009 vintage, awarded the Gold Medal at the 2015 Asia Wine &amp, Daejeon (South Korea).",
              categoria: "International",
              pais: "korea",
              anyada: "2009",
              anyo: "2015",
              doble: true
            },
            "navamarin-corea-wine-2016": {
              titulo: "Aldonza Clásico",
              posicion: "Second Prize",
              texto:
                "2008 vintage, awarded the Silver Medal at the 2016 Asia WineTrophy, Daejeon (South Korea).",
              categoria: "International",
              pais: "korea",
              anyada: "2008",
              anyo: "2016",
              doble: true
            },
            "navamarin-bruselas-2013": {
              titulo: "Aldonza Navamarín",
              posicion: "First Prize",
              texto:
                "2008 vintage, awarded the Gold Medal at the 2013 Concours Mondial de Bruxelles, Bratislava (Slovakia).",
              categoria: "International",
              pais: "Slovakia",
              anyada: "2008",
              anyo: "2013"
            },
            "pisces-ljubljana-2008": {
              titulo: "Aldonza Pisces",
              posicion: "Second Prize",
              texto:
                "2006 vintage awarded the Silver Medal at the 2008 Ljubljana International Wine Competition, Ljubljana (Slovenia).",
              categoria: "International",
              pais: "Slovenia",
              anyada: "2006",
              anyo: "2008"
            },
            "pisces-bacchus-2006": {
              titulo: "Aldonza Pisces",
              posicion: "Second Prize",
              texto:
                "2004 vintage awarded the 2006 International Silver Bacchus, Madrid (Spain).",
              categoria: "International",
              pais: "Spain",
              anyada: "2004",
              anyo: "2006"
            },
            "navamarin-zarcillo-2007": {
              titulo: "Aldonza Navamarín",
              posicion: "First Prize",
              texto:
                "2004 vintage awarded the 2007 Golden Tendril in Valladolid (Spain).",
              categoria: "National",
              pais: "Spain",
              anyada: "2004",
              anyo: "2007"
            },
            "pisces-bacchus-2008": {
              titulo: "Aldonza Pisces",
              posicion: "Second Prize",
              texto:
                "2006 vintage awarded the 2008 International Silver Bacchus, Madrid (Spain).",
              categoria: "International",
              pais: "Spain",
              anyada: "2006",
              anyo: "2008"
            },
            "navamarin-testing-2014": {
              titulo: "Aldonza Navamarín",
              posicion: "First Prize",
              texto:
                "2007 vintage, awarded the Gold Medal at the 2014 'Beverage Testing Institute' in Chicago (United States).",
              categoria: "International",
              pais: "eeuu",
              anyada: "2007",
              anyo: "2014"
            },
            "seleccion-testing-2014": {
              titulo: "Aldonza Selección",
              posicion: "First Prize",
              texto:
                "2007 vintage, awarded the Gold Medal at the 2014 'Beverage Testing Institute' in Chicago (United States).",
              categoria: "International",
              pais: "eeuu",
              anyada: "2007",
              anyo: "2014"
            },
            "clasico-testing-2014": {
              titulo: "Aldonza Clásico",
              posicion: "First Prize",
              texto:
                "2007 vintage, awarded the Gold Medal at the 2014 'Beverage Testing Institute' in Chicago (United States).",
              categoria: "International",
              pais: "eeuu",
              anyada: "2007",
              anyo: "2014"
            },
            "albo-testing-2014": {
              titulo: "Aldonza Albo",
              posicion: "First Prize",
              texto:
                "2013 vintage, awarded the Gold Medal at the 2014'Beverage Testing Institute'in Chicago (United States).",
              categoria: "International",
              pais: "eeuu",
              anyada: "2013",
              anyo: "2014"
            },
            "navamarin-wswa-2014": {
              titulo: "Aldonza Navamarín",
              posicion: "First Prize",
              texto:
                "2008 vintage, awarded the Supreme Gold Medal at the WSWA 71st Annual Convention Exposition 2014, Las Vegas (United States).",
              categoria: "International",
              pais: "eeuu",
              anyada: "2008",
              anyo: "2014"
            },
            "clasico-wswa-2014": {
              titulo: "Aldonza Clásico",
              posicion: "Second Prize",
              texto:
                "2008 vintage, awarded the Supreme Gold Medal at the WSWA 71st Annual Convention Exposition 2014, Las Vegas (United States).",
              categoria: "International",
              pais: "eeuu",
              anyada: "2008",
              anyo: "2014"
            },
            "seleccion-wswa-2014": {
              titulo: "Aldonza Selección",
              posicion: "Second Prize",
              texto:
                "2008 vintage, awarded the Supreme Silver Medal at the WSWA 71st Annual Convention Exposition 2014, Las Vegas (United States).",
              categoria: "International",
              pais: "eeuu",
              anyada: "2008",
              anyo: "2014"
            },
            "navamarin-houston-2015": {
              titulo: "Aldonza Navamarín",
              posicion: "Third prize",
              texto:
                "2008 vintage, awarded the Bronze Medal at 'Houston Livestock Show and Rodeo' in the 2015 edition, Houston (Estados Unidos).",
              categoria: "International",
              pais: "eeuu",
              anyada: "2008",
              anyo: "2015"
            },
            "clasico-houston-2015": {
              titulo: "Aldonza Clásico",
              posicion: "Third prize",
              texto:
                "2007 vintage, awarded the Bronze Medal at 'Houston Livestock Show and Rodeo' in the 2015 edition, Houston (Estados Unidos).",
              categoria: "International",
              pais: "eeuu",
              anyada: "2007",
              anyo: "2015"
            },
            "seleccion-burdeos-2008": {
              titulo: "Aldonza Selección",
              posicion: "Second Prize",
              texto:
                "2005 vintage awarded the Silver Medal at the 2008 International Wine Challenge, Bordeaux (France).",
              categoria: "International",
              pais: "France",
              anyada: "2005",
              anyo: "2008"
            },
            "seleccion-vinalies-2009": {
              titulo: "Aldonza Selección",
              posicion: "Second Prize",
              texto:
                "2006 vintage awarded the Gold Medal at the 2009 Vinalies Internationales, 2nd most significant global competition, Paris (France). ",
              categoria: "International",
              pais: "France",
              anyada: "2006",
              anyo: "2009"
            },
            "navamarin-vinalies-2011": {
              titulo: "Aldonza Navamarín",
              posicion: "Second Prize",
              texto:
                "2007 vintage, awarded the Silver Medal at the 2011 Vinalies Internationales, Paris (France).",
              categoria: "International",
              pais: "France",
              anyada: "2007",
              anyo: "2011"
            },
            "navamarion-citadelles-2006": {
              titulo: "Aldonza Navamarín",
              posicion: "Second Prize",
              texto:
                "2006 vintage, awarded the Silver Medal at the 2011 Les Citadelles du Vin, Bordeaux (France).",
              categoria: "International",
              pais: "France",
              anyada: "2006",
              anyo: "2011"
            },
            "seleccion-vinalies-2012": {
              titulo: "Aldonza Selección",
              posicion: "Second Prize",
              texto:
                "2007 vintage, awarded the Silver Medal at the 2012 Vinalies Internationales, Paris (France).",
              categoria: "International",
              pais: "France",
              anyada: "2007",
              anyo: "2012"
            },
            "pisces-tokio-2008": {
              titulo: "Aldonza Pisces",
              posicion: "Second Prize",
              texto:
                "2006 vintage awarded the Silver Medal at the most prestigious International Competition in Asia, 2008 edition, Tokyo (Japan).",
              categoria: "International",
              pais: "Japan",
              anyada: "2006",
              anyo: "2008"
            },
            "navamarin-londres-2013": {
              titulo: "Aldonza Navamarín",
              posicion: "Third Prize",
              texto:
                "2008 vintage, awarded the Bronze Medal at the 2013  International Wine Challenge, London (United Kingdom).",
              categoria: "International",
              pais: "uk",
              anyada: "2008",
              anyo: "2013"
            },
            "navamarin-decanter-2013": {
              titulo: "Aldonza Navamarín",
              posicion: "Recommended wine",
              texto:
                "2008 vintage, recommended wine at the 2013 Decanter World Wine Awards, London (United Kingdom).",
              categoria: "International",
              pais: "uk",
              anyada: "2008",
              anyo: "2013"
            },
            "pisces-decanter-2013": {
              titulo: "Aldonza Pisces",
              posicion: "Recommended wine",
              texto:
                "2008 vintage, recommended wine at the 2013 Decanter World Wine Awards, London (United Kingdom).",
              categoria: "International",
              pais: "uk",
              anyada: "2008",
              anyo: "2013"
            },
            "clasico-decanter-2017": {
              titulo: "Aldonza Clásico",
              posicion: "Recommended wine",
              texto:
                "2011 vintage, recommended wine at the 2017 Decanter Asia Wine Awards, Hong Kong (China).",
              categoria: "International",
              pais: "china",
              anyada: "2011",
              anyo: "2017"
            },
            "seleccion-decanter-2017": {
              titulo: "Aldonza Selección",
              posicion: "Recommended wine",
              texto:
                "2011 vintage, recommended wine at the 2017 Decanter Asia Wine Awards, Hong Kong (China).",
              categoria: "International",
              pais: "China",
              anyada: "2011",
              anyo: "2017"
            },
            "clasico-berliner-2018": {
              titulo: "Aldonza Clásico",
              posicion: "First Prize",
              texto:
                "2011 vintage, awarded the Gold Medal at the 2018 Berliner Wein Trophy, Berlin (Germany).",
              pais: "Germany",
              anyada: "2011",
              anyo: "2018",
              doble: true
            },
            "navamarin-mundus-2018": {
              titulo: "Aldonza Navamarín",
              posicion: "First Prize",
              texto:
                "2012 vintage awarded the Gold Medal at the Grand International Wine Award Mundus Vini, 2018, Berlin (Germany).",
              categoria: "International",
              pais: "Germany",
              anyada: "2012",
              anyo: "2018"
            },
            "clasico-bacchus-2018": {
              titulo: "Aldonza Clásico",
              posicion: "Second Prize",
              texto:
                "2011 vintage awarded the International Silver Bacchus at the XVI International Wine Competition, 2018, Madrid (Spain).",
              categoria: "International",
              pais: "Spain",
              anyada: "2011",
              anyo: "2018"
            },
            "navamarin-suckling-2018": {
              titulo: "Aldonza Navamarín",
              posicion: "90 Points",
              texto:
                "2012 vintage, scored by James Suckling (USA) at the celebrated wine tasting in 2018 at El Priorato (Spain).",
              categoria: "International",
              pais: "eeuu",
              anyada: "2012",
              anyo: "2018"
            },
            "clasico-suckling-2018": {
              titulo: "Aldonza Clásico",
              posicion: "90 Points",
              texto:
                "2011 vintage, scored by James Suckling (USA) at the celebrated wine tasting in 2018 at El Priorato (Spain).",
              categoria: "International",
              pais: "eeuu",
              anyada: "2011",
              anyo: "2018"
            },
            "clasico-cwsa-2018": {
              titulo: "Aldonza Clásico",
              posicion: "First Prize",
              texto:
                "2011 vintage, awarded the Gold Medal at the 2018 China Wine Spirits Awards, Hong Kong (China).",
              categoria: "International",
              pais: "China",
              anyada: "2011",
              anyo: "2018"
            },
            "navamarin-decanter-bronce-2019": {
              titulo: "Aldonza Navamarín",
              posicion: "Third Prize",
              texto:
                "2012 vintage, winner of the Bronze Medal at the 2019 Decanter World Wine Awards, London (United Kingdom).",
              categoria: "International",
              pais: "uk",
              anyada: "2012",
              anyo: "2019"
            },
            "seleccion-decanter-bronce-2019": {
              titulo: "Aldonza Selección",
              posicion: "Third Prize",
              texto:
                "2012 vintage, winner of the Bronze Medal at the 2019 Decanter World Wine Awards, London (United Kingdom).",
              categoria: "International",
              pais: "uk",
              anyada: "2012",
              anyo: "2019"
            },
            "albo-suckling-2019": {
              titulo: "Aldonza Albo",
              posicion: "87 Points",
              texto:
                "2018 vintage, scored by James Suckling (USA) at the celebrated wine tasting in 2018 at La Rioja (Spain).",
              categoria: "International",
              pais: "eeuu",
              anyada: "2018",
              anyo: "2018"
            },
            "seleccion-suckling-2019": {
              titulo: "Aldonza Selección",
              posicion: "89 Points",
              texto:
                "2014 vintage, scored by James Suckling (USA) at the celebrated wine tasting in 2018 at La Rioja (Spain).",
              categoria: "International",
              pais: "eeuu",
              anyada: "2014",
              anyo: "2018"
            },
            "clasico-suckling-2019": {
              titulo: "Aldonza Clásico",
              posicion: "90 Points",
              texto:
                "2014 vintage, scored by James Suckling (USA) at the celebrated wine tasting in 2018 at La Rioja (Spain).",
              categoria: "International",
              pais: "eeuu",
              anyada: "2014",
              anyo: "2018"
            },
            "navamarin-suckling-2019": {
              titulo: "Aldonza Navamarín",
              posicion: "91 Points",
              texto:
                "2013 vintage, scored by James Suckling (USA) at the celebrated wine tasting in 2018 at La Rioja (Spain).",
              categoria: "International",
              pais: "eeuu",
              anyada: "2013",
              anyo: "2018"
            },
            "navamarin-mundus-2020": {
              titulo: "Aldonza Navamarín",
              posicion: "Second Prize",
              texto:
                "2013 vintage awarded the Silver Medal at the Grand International Wine Award Mundus Vuni, 2020, Neustadt (Germany)",
              categoria: "Internacional",
              pais: "alemania",
              anyada: "2020",
              anyo: "2020"
            },
            "navamarin-mundus-2021": {
              titulo: "Aldonza Navamarín",
              posicion: "Medalla de Oro",
              texto:
                "2013 vintage awarded the Gold Medal at the Grand International Wine Award Mundus Vini, 2021, Neustadt (Germany).",
              categoria: "Internacional",
              pais: "alemania",
              anyada: "2013",
              anyo: "2021"
            },
            "clasico-mundus-2021": {
              titulo: "Aldonza Clásico",
              posicion: "Medalla de Oro",
              texto:
                "2015 vintage awarded the Gold Medal at the Grand International Wine Award Mundus Vini, 2021, Neustadt (Germany).",
              categoria: "Internacional",
              pais: "alemania",
              anyada: "2013",
              anyo: "2021"
            },

            "clasico-penin-2023": {
              titulo: "Aldonza Clásico",
              posicion: "Guía Peñín 2023",
              texto:
                "2015 vintage, scored according to the Peñín Guide at the celebrated wine tasting in February 2022 in Spain.",
              categoria: "Nacional",
              pais: "España",
              anyada: "2022",
              anyo: "2022"
            },
            "navamarin-penin-2023": {
              titulo: "Aldonza Navamarín",
              posicion: "Guía Peñín 2023",
              texto:
                "2013 vintage, scored according to the Peñín Guide at the celebrated wine tasting in February 2022 in Spain.",
              categoria: "Nacional",
              pais: "España",
              anyada: "2022",
              anyo: "2022"
            },
            "navamarin-bruselas-2022": {
              titulo: "Aldonza Navamarín",
              posicion: "Grand Gold Medal 2022",
              texto:
                "2013 vintage, awarded the Grand Gold Medal in the Concours Mondial de Bruxelles in the edition of 2022 celebrated in Cosenza (Italy).  ",
              categoria: "Internacional",
              pais: "Bruselas",
              anyada: "2022",
              anyo: "2022"
            },
            "navamarin-londres-2022-2": {
              titulo: "Aldonza Navamarín",
              posicion: "92 Points",
              texto:
                "2021 vintage, winner of the Silver Medal at the 2022 Decanter World Wine Awards, London (United Kingdom).",
              categoria: "Internacional",
              pais: "Bruselas",
              anyada: "2022",
              anyo: "2022"
            },
            "navamarin-bruxelles-2023": {
              titulo: "Aldonza Navamarín",
              posicion: "91 Puntos",
              texto:
                "2014 vintage, winner of the Gold Medal at the 2023 Concours Mondial de Bruxelles, Istria (Croatia). ",
              categoria: "Internacional",
              pais: "uk",
              anyada: "2014",
              anyo: "2023"
            },
            "seleccion-2022": {
              titulo: "Aldonza Selección",
              posicion: "91 Puntos",
              texto:
                "2015 vintage, winner of the Silver Medal at the 2023 Concours Mondial de Bruxelles, Istria (Croatia). ",
              categoria: "Internacional",
              pais: "uk",
              anyada: "2015",
              anyo: "2023"
            }
          }
        },
        banner_beneficios: {
          titulo: "와인의 검증된 이점과 품질을 알고 계십니까?",
          boton: "와인의 이점을 발견하십시오."
        },
        banner_experiencia: {
          titulo: "더 알고 싶으십니까?",
          boton: "와인 관광 알아보기",
          enlace: "enoturismo"
        },
        beneficios: {
          titulo: "Benefits<br>and proven qualities of wine",
          list: [
            {
              titulo: "Slimming",
              cuerpo:
                "The consumption of red wine activates the function of a gene that prevents the formation of new fat cells and helps to mobilise the ones already in existence."
            },
            {
              titulo: "Dental health",
              cuerpo:
                "Certain components of the wine halt the growth in the mouth of streptococci and bacteria linked to dental caries. It also prevents gingivitis and sore throats."
            },
            {
              titulo: "Cognitive function",
              cuerpo:
                "The high level of antioxidants in wine prevents hardening of the arteries and prevents clotting, lowering the risk of a bleed on the brain."
            },
            {
              titulo: "Enjoyment",
              cuerpo:
                "During the enjoyment of wine, endorphins are released in two areas of the brain, which cause an increased sensation of enjoyment."
            },
            {
              titulo: "Exercise",
              cuerpo:
                "The grape’s reservatrol reduces the negative consequences of a sedentary lifestyle."
            },
            {
              titulo: "Mouth cleaner",
              cuerpo:
                "When drunk while you are eating, wine helps you to perceive taste better. This is due to its astringent properties, which avoid the excessive feeling of greasiness caused by food such as red meat and allow you to taste and enjoy food to a greater extent."
            },
            {
              titulo: "Anti-cancer",
              cuerpo:
                "Wine, specifically red wine, helps to reduce the risk of lung cancer in men. It also blocks the growth of the cells that cause breast cancer in women. Once again, reservatrol is responsible for such exceptional quality."
            },
            {
              titulo: "Heart",
              cuerpo:
                "One or two glasses of wine per day contribute to increasing the levels of ‘good’ cholesterol in the blood and prevent cardiovascular complications."
            },
            {
              titulo: "Prostate",
              cuerpo:
                "It has been shown that seven glasses of wine per week after the age of 40 cut prostate cancer diagnoses by more than half."
            },
            {
              titulo: "Healthy lifestyle",
              cuerpo:
                "From the social point of view, various statistics demonstrate that wine lovers have healthier diets than aficionados of other drinks, such as consumers of beer or soda. Wine aficionados tend to consume more olives, fruit, vegetables, low-fat cheese, milk and healthy meat."
            }
          ]
        }
      },
      aceite: {
        slug: "aceite",
        nombre: "엑스트라버진 올리브 유",
        intro_productos: "<span>오늘 놀라운 일이 일어나도록 하십시오'</span>",
        intro_ficha: {
          titulo: "본인이 하는 일을 사랑할 때",
          cuerpo:
            "<p>최상의 아로마와 풍미를 갖춘 엑스트라버진 삐꾸알 (picual) 및 아르베끼나(arbequina) 올리브 유가 탄생 됩니다. 엑스트라버진 올리브 유는 여러 치유 효과가 있다고 알려져 있습니다.지중해식 식단의 기원이자 기둥이 되어 온 엑스트라버진 올리브 유는 고대부터 사용되어 왔으며, 이를 증명하는 것은 현재까지 이어 온 올리브나무,그 재배 및 그 제조 방법이며 이것은 우리 시대의 문화적 유산으로 간주되고 있습니다. 또한 여러 고대문명에서는 이를 액체로 된 금이라고도 불렀습니다.</p>"
        },
        productos: {
          glass: {
            id: "vidrio",
            nombre: "Glass",
            descripcion:
              "엑스트라 버진 올리브 유. 올리브 품종: 삐꾸알 (Picual ) 및 아르베끼나 (Arbequina)",
            ingredientes:
              "최적의 숙성 상태에 이를 때 수확한 올리브를 기계적으로 냉간 추출하여 짜낸 엑스트라 버진 올리브 유. 저온 추출, 신속한 여과 후 포장까지 품질이 손상되지 않도록 자동화 창고에 보관 및 보존됩니다. 100% 엑스트라 버진 올리브 유. 식품 첨가물이 전혀 포함되지  않습니다.",
            notas_cata: {
              texto:
                "훌륭한 개성을 지닌 오일로, 시간이 지나도 토마토의 녹색 노트, 신선한 허브 및 중간 정도의 과일 맛이 안정적으로 지속되며 견과류의 향이 두드러집니다. 무화과와 바나나의 달콤한 터치. 입에서 목으로 부드럽게 삼켜지고 그 산도와 단맛의 균형은 입안을 통과할 때  매운 터치로 마무리를 해 주며 그 여운이 오래 지속 됩니다."
            },
            cantidades: ["750ml", "500ml", "250ml"],
            premios: [
              "granprestigio-mendoza-2016",
              "olivinus-mendoza-2016",
              "olivinusninos-mendoza-2016",
              "feria-habana-2016"
            ]
          },
          metal: {
            id: "metal",
            nombre: "Metal",
            descripcion:
              "엑스트라 버진 올리브 유. 올리브 품종: 삐꾸알 (Picual ) 및 아르베끼나 (Arbequina)",
            ingredientes:
              "최적의 숙성 상태에 이를 때 수확한 올리브를 기계적으로 냉간 추출하여 짜낸 엑스트라 버진 올리브 유. 저온 추출, 신속한 여과 후 포장까지 품질이 손상되지 않도록 자동화 창고에 보관 및 보존됩니다. 100% 엑스트라 버진 올리브 유. 식품 첨가물이 전혀 포함되지  않습니다.",
            notas_cata: {
              texto:
                "훌륭한 개성을 지닌 오일로, 시간이 지나도 토마토의 녹색 노트, 신선한 허브 및 중간 정도의 과일 맛이 안정적으로 지속되며 견과류의 향이 두드러집니다. 무화과와 바나나의 달콤한 터치. 입에서 목으로 부드럽게 삼켜지고 그 산도와 단맛의 균형은 입안을 통과할 때  매운 터치로 마무리를 해 주며 그 여운이 오래 지속 됩니다."
            },
            cantidades: ["1L", "5L"],
            premios: [
              "granprestigio-mendoza-2016",
              "olivinus-mendoza-2016",
              "olivinusninos-mendoza-2016",
              "feria-habana-2016"
            ]
          }
        },
        banner_premios: {
          titulo: "수상 올리브 유",
          boton: "모든 상 보기",
          premio: "granprestigio-mendoza-2016"
        },
        premios: {
          titulo: "수상 및 영예",
          premios: {
            "granprestigio-mendoza-2016": {
              titulo: "World Olive Oil Competition",
              posicion: "",
              texto:
                "Gran Prestigio Oro Olivinus at the ‘Olivinus 2016’ International Olive Oil Competition in Mendoza (Argentina).",
              categoria: "International",
              pais: "Argentina",
              anyada: "",
              anyo: "2016"
            },
            "olivinus-mendoza-2016": {
              titulo: "World Olive Oil Competition",
              posicion: "",
              texto:
                "93 Olivinus Points at the ‘Olivinus 2016’ International Olive Oil Competition in Mendoza (Argentina).",
              categoria: "International",
              pais: "Argentina",
              anyada: "",
              anyo: "2016"
            },
            "olivinusninos-mendoza-2016": {
              titulo: "World Olive Oil Competition",
              posicion: "",
              texto:
                "Children’s Olivinus Competition ‘Olivinus 2016’, selected by children in Mendoza (Argentina).",
              categoria: "International",
              pais: "Argentina",
              anyada: "",
              anyo: "2016"
            },
            "feria-habana-2016": {
              titulo: "International Fair of Havana",
              posicion: "",
              texto: "Product Quality Prize in 'FIHAV 2016' in Habana (Cuba).",
              categoria: "International",
              pais: "Argentina",
              anyada: "",
              anyo: "2016",
              doble: true
            }
          }
        },
        banner_beneficios: {
          titulo: "장점 및 입증된 품질",
          boton: "엑스트라 버진 올리브 오일"
        },
        banner_experiencia: {
          titulo: "더 알고 싶으십니까?",
          boton: "올리브 유 관광 알아보기",
          enlace: "oleoturismo"
        },
        beneficios: {
          titulo: "장점 및 입증된 품질 엑스트라 버진 올리브 오일",
          list: [
            {
              titulo: "",
              cuerpo:
                "엑스트라 버진 올리브 유는 혈당 지수가 다른 지방보다 훨씬 낮기 때문에 요리와 드레싱을 위한 저칼로리 식단에 권장되어 있으며 식물성 기름 중 단일 불포화지방 함량이 가장 높은 오일입니다. 다른 지방과 달리 체내에서 산화되지 않고 또한 고도 불포화지방 비율이 매우 낮습니다."
            },
            {
              titulo: "",
              cuerpo:
                "또한 비타민 E가 풍부합니다. 오일의 식물성 영양소는 유방암의 위험을 줄일 수 있습니다. 콜레스테롤을 낮춰줌으로써 심장질환 발병을 예방 해 주고 이러한 오일의 규칙적인 섭취는 인지기능 저하를 예방합니다."
            }
          ]
        }
      },
      azafran: {
        slug: "azafran",
        nombre: "사프란",
        intro_productos:
          "<span>평범한 것으로부터 차별이 되게 해주는 작은 것들'</span>",
        productos: {
          box: {
            id: "caja-1g",
            nombre: "1g 상자",
            descripcion:
              "사프란 원산지 명칭 보호 라만차. 식품안전, 관능적 특성(색상, 향 및 풍미) 및 스페인 원산지(Castilla La Mancha)에서 최고 품질을 보장하는 세계적인 인증.",
            caracteristicas:
              "사프란은 고온과 강한 추위를 잘 견디는 대륙성 기후 지역에서 재배됩니다.",
            maridaje:
              "착색제, 향료 또는 다른 여러가지 음식의 맛을 내는 데 이상적입니다. 구운 고기, 생선요리, 수프, 해산물 요리 및 쌀요리의 향신료로는 최고의 제품이라고 할 수 있습니다.",
            peso: ["1g", "디스플레이 상자 12g"],
            premios: {
              premios: []
            }
          }
        },
        intro_ficha: {
          titulo: "라 만차 (La Mancha)지역의 사프란",
          cuerpo:
            "<p><strong>레드 골드 (Red Gold).</strong> 이집트나 그리스와같은 고대 문명이 숭배해 온 이 섬세한 향신료는 그 향, 맛 및 색상으로 인해 이제 국제요리의 스타재료가 되었습니다. 사프란은 또한 다양한 의약적 특성을 갖추고 있어 건강치료 약물로도 사용되고 있습니다.</p><p>알돈자 사프란은 라 만차 사프란 원산지보호 지정 (La Mancha Saffron Protected Designation of Origin)으로부터 품질 인증을 받았고 까스띠야 라 만차 (Castilla La Mancha, 스페인)에서 생산되고 있습니다. 이 인증은 다음의 3 종목에서 국제적으로 그 품질을 보증하는 것으로 첫째는 그 원산지가 스페인이라는 것 둘째는 이 제품이 최고 최적의 관능적 특성을 갖고 있다는 점 그리고 마지막으로 식품으로서 그 안전성이 보장되어 있다는 점입니다.</p>"
        },
        banner_denominacion: {
          titulo: "원산지 표시",
          subtitulo: "La Mancha saffron",
          cuerpo: "원산지 명칭 보호 인증"
        },
        banner_beneficios: {
          titulo: "사프란의 장점과 입증된 품질",
          boton: "엑스트라 버진 올리브 오일"
        },
        banner_experiencia: {
          titulo: "더 알고 싶으십니까?",
          boton: "알돈자 경험 알아보기",
          enlace: "vive_aldonza"
        },
        beneficios: {
          titulo: "사프란의 장점과 입증된 품질",
          list: [
            {
              titulo: "",
              cuerpo:
                "향기롭고 쓴 성분(피크로크로신)으로 인해 사프란은 소화 시스템을 자극하고 타액과 위 분비를 증가시킵니다. 또한 사프란에는 담즙 생성을 촉진하고 콜레스테롤을 낮추는 크로세틴(적색 색소)이 포함되어 있는데 이는 소화 과정을 돕고 담낭에 결석이 생기는 것을 방지 해줍니다. 이 향신료는 월경 전 증상을 치료하는 데 매우 중요한 역할을 하는 것으로도 알려져 있으며 사프란은 자궁 경련을 예방하고 월경 흐름에 도움이 되는 것으로 증명 되어 있습니다.다."
            },
            {
              titulo: "",
              cuerpo:
                "사프란의 주성분인 크로신은 강력한 천연 항산화제입니다. 이 물질은 사프란 추출물이 당뇨병성 신경병증(혈액 내 과도한 당으로 인해 신경에서 발생하는 손상)이 생기는 것으로부터 보호해 주므로써 신체 세포의 노화를 지연시키고 심혈관 질환을 예방할 뿐만 아니라 당뇨병 환자에게 유익한 보충제입니다."
            },
            {
              titulo: "",
              cuerpo:
                "사프란은 파킨슨병이나 알츠하이머병과 같은 퇴행성 질환을 예방하는 데 도움이 됩니다. 기억력과 인지 능력도 향상 시켜 주며 스트레스와 불안으로 고생하시는 분들에게 건강 ㅍ기능식품으로 추천되고 있습니다.사프란의 향기 성분인 사프라날은 눈의 광수용기 세포의 퇴화를 늦춥니다. 망막과 혈관의 기능을 향상시킵니다."
            }
          ]
        }
      },
      cava: {
        slug: "cava",
        nombre: "까바 (Cava; Sparkling Wine)",
        intro_productos:
          "<span>멋진 순간 뒤에는 잊지 못할 추억이 남는다'</span>",
        intro_ficha: {
          titulo: "개성을 갖추고 있는",
          cuerpo:
            "<p>포도 열매에서 짜낸 포도액은 (mosto) 두 단계의 발효를 거쳐 까바로 변합니다. 포도 자체의 효모와 엄선된 우리 고유의 효모가 저희 알돈자의 4가지 종류의 까바 제품이 갖고 있는 고유의 특성과 개성을 부여 해 주고 있습니다.</p><p>원산지명칭 보호가 인증된  저희 까바(스파클링 와인)는 까딸루냐 주의 뻬네데스 (Penedés)지역에서 재배되고 바로셀로나 지방에 있는 생산센터인 산 사두르니 다노이아 (Sant Sadurní D'Anoia)에서는 샤렐로(Xarel-lo), 마까베오 (Macabeo) 및 빠레야다 (Parellada)까바가 생산되고 있습니다. 또한 뜨레팟(Trepat) 품종의 적 포도로만 사 하여 생산되고 있는 저희 로제까바는 특별한 제품이라고 할 수 있습니다.</p>"
        },
        productos: {
          reserve: {
            id: "reserva",
            nombre: "Reserve",
            tipo_uva:
              "샤르도네 | 자렐로 | 마까베오 (Chardonnay | Xarel-lo | Macabeo)",
            tipo_cava: "Brut special reserve",
            elaboracion:
              "15ºC에서 포도액 발효. 2차 발효와 숙성은(crianza) 셀러에서 최소 24개월 숙성.",
            graduacion: "11,5 - 12,5% Vol",
            cantidad: "750ml",
            servicio: "Between 6º - 8º C.",
            gastronomia:
              "고기요리, 조림 생선요리, 치즈, 푸아, 훈제요리 등 식전주로 훌륭합니다.",
            notas_cata: {
              texto:
                "그 색깔은 밀짚 노란색으로 묵주 구슬처럼 연달아 일어나는 거품. 또한 그 향기는 잘 익은 과일 향처럼 그리고 꽃의 향기처럼 다가온다. 그 맛은  입천장에서는 둥글둥글하며 조화로우면서도 건조한 맛이 오랫동안 여운으로 남는다.",
              autor: ""
            },
            premios: [
              "brut-decanter-plata-2019",
              "brut-decanter-2022",
              "brut-decanter-2022-2"
            ]
          },
          nature: {
            id: "nature",
            nombre: "Brut Nature",
            tipo_uva:
              "자렐로 | 마까베오 | 빠레야다 (Xarel-lo | Macabeo | Parellada)",
            tipo_cava: "Brut Nature",
            elaboracion:
              "19ºC 이하에서 발효하며 14-18개월 동안 지하 셀러에서 휴지 및 숙성.",
            graduacion: "11,5 - 12,5 % Vol.",
            cantidad: "750ml",
            servicio: "Between 6º - 8º C.",
            gastronomia:
              "식전주, 견과류, 해산물 요리, 적색 육류 및 백색 육류와 곁들여 드시면 좋습니다.",
            notas_cata: {
              texto:
                "약간 황금빛 반사가 있는 옅은 노란색. 병 숙성의 특징인 꽃 향과 꿀 향이 가득하며 입안에서는 건조하고 쾌적한 둥글둥굴한 느낌. 그 향기이 오래 지속된다.",
              autor: ""
            },
            premios: ""
          },
          rose: {
            id: "rose",
            nombre: "Brut - Rosé",
            tipo_uva: "뜨레팟 (Trepat)",
            tipo_cava: "Brut - rosé",
            elaboracion:
              "19ºC 이하에서 포도액 발효하며 최소 9개월 동안 지하 셀러에서 휴지 및 숙성.",
            graduacion: "11 - 12% Vol",
            cantidad: "750ml",
            servicio: "Between 6º - 8º C.",
            gastronomia:
              "샐러드, 파스타, 푸른 생선, 해산물 요리에 이상적입니다.",
            notas_cata: {
              texto:
                "강렬한 핑크 색, 선명하고 화사함. 첫인상은 상큼하고 그 향은 작은 붉은 과일을 연상시켜 주며 최종적 마지막 인상은 균형있게 조화되고 맛있는 과일 맛의 여운을 남깁니다.",
              autor: ""
            },
            premios: ""
          },
          brut: {
            id: "brut",
            nombre: "Brut",
            tipo_uva:
              "자렐로 | 마까베오 | 빠레야다 (Xarel-lo | Macabeo | Parellada)",
            tipo_cava: "Brut",
            elaboracion:
              "19ºC 이하에서 포도액을 발효하며 12-14개월 동안 지하 셀러에서 휴지 및 숙성.",
            graduacion: "11 - 12% Vol",
            cantidad: "750ml",
            servicio: "Between 6º - 8º C.",
            gastronomia:
              "햄 (하몽; jamón), 백색 육류요리, 쌀 요리와 곁들이면 좋습니다.",
            notas_cata: {
              texto:
                "황금빛 반사가 있는 옅은 노란색. 병 숙성의 전형적인 특성인 과일 노트와 우아한 아로마. 입안에서는 달콤한 끝맛과 사과맛의 힌트로 기분 좋은 풍미를 선사합니다. 산도가 좋고 지속력이 좋습니다.",
              autor: ""
            },
            premios: ""
          }
        },
        premios: {
          titulo: "Awards and recommendations",
          premios: {
            "brut-decanter-plata-2019": {
              titulo: "Brut-Reserva sparkling wine",
              posicion: "Second Prize",
              texto:
                "2018 vintage, winner of the Silver Medal at the 2019 Decanter World Wine Awards, London (United Kingdom).",
              categoria: "International",
              pais: "uk",
              anyada: "2018",
              anyo: "2019"
            },
            "brut-decanter-2022": {
              titulo: "Cava Brut 2022",
              posicion: "92 Points",
              texto:
                "2021 vintage, winner of the Silver Medal at the 2022 Decanter World Wine Awards, London (United Kingdom).",
              categoria: "International",
              pais: "uk",
              anyada: "2021",
              anyo: "2022"
            },
            "brut-decanter-2022-2": {
              titulo: "Brut-Reserva sparkling wine",
              posicion: "",
              texto:
                "2021 vintage, Silver Medal at the Concours Mondial de Bruxelles held in Anadia (Portugal).",
              categoria: "International",
              pais: "portugal",
              anyada: "2021",
              anyo: "2022"
            }
          }
        },
        banner_premios: {
          titulo: "까바 수상",
          boton: "모든 상 보기",
          premio: "brut-decanter-2022-2"
        },
        banner_beneficios: {
          titulo: "스파클링 와인의 장점과 입증된 품질",
          boton: "엑스트라 버진 올리브 오일"
        },
        banner_experiencia: {
          titulo: "더 알고 싶으십니까?",
          boton: "알돈자 체험 알아보기",
          enlace: "vive_aldonza"
        },
        beneficios: {
          titulo: "스파클링 와인의 장점과 입증된 품질",
          list: [
            {
              titulo: "",
              cuerpo:
                "까바 (Cava)는 항 산화제와 타르타르산 덕분에 피부를 해독하여 피부 톤의 균형을 맞춰주고 붉어지는 것을 방지 해 줍니다. 까바의 항균특성은 지성 피부에 좋으며, 카바를 적당히 섭취하면 기억력이 향상되고 노인성 치매와 같은 뇌의 퇴행성 질환이 지연됩니다. 여러 과학적 연구에 따르면 이러한 까바의 특징이 페놀산에 의한 것이라고 합니다."
            },
            {
              titulo: "",
              cuerpo:
                "까바는 칼로리가 적은 알코올 음료 중 하나로 브뤼 (Brut) 한 잔에는 12g 미만의 잔류 설탕이 들어 있습니다. 폴리페놀 함량이 높아 혈압을 낮추고 심혈관 질환이나 심장마비의 위험을 예방 해 주기도 하고 또한 세포재생을 자극하여 주며 비타민 E를 강화시켜 줌으로써 피부를 젊어지게 하는 항 산화제 때문에 젊음의 샘으로 간주됩니다."
            },
            {
              titulo: "",
              cuerpo:
                "까바에는 여러 영양성분이 포함되어 있는데 그 대표적인 예로는 철분, 단백질, 칼슘, 칼륨, 요오드, 미량의 아연, 탄수화물, 마그네슘, 나트륨, 미량의 비타민 B1, B2, B9, 비타민 B3 및 B6, 인 및 설탕이라고 할 수 있습니다."
            }
          ]
        }
      },
      queso: {
        slug: "queso",
        nombre: "만체고 치즈",
        intro_productos: "<span>'당신의 하루에 괄호를 하세요'</span>",
        productos: {
          enaceite: {
            id: "enaceite",
            nombre: "엑스트라 버진 올리브 유가 첨가 된 치즈",
            descripcion:
              "100% 만체고 지방 산 양젖을 저온 살균 하여 만든 엑스트라버진 올리브 유가 첨가 된 치즈.",
            curacion: "150 - 210 일",
            apariencia:
              "저온 살균된 만체고 (Manchego)산 양젖, 레닛(Rennet), 젖산 발효물, 리소자임(계란에서 추출), 염화칼슘 및 소금 그리고 엑스트라 버진 올리브 유",
            ingredientes:
              "저온 살균한 Manchegan 양 우유, 레닛, 젖산 발효물, 리소자임(계란에서 추출), 염화칼슘, 소금 및 올리브 오일. 우유의 원산지: 스페인.",
            valoresnutricionales:
              "410Kcal / 1715Kj 지방: 36,00g 포화지방: 18,70g 탄수화물: 0,50g 당: 0g 단백질: 24g 소금: 1,60g",
            conservacion: "Between 2 and 7 oC.",
            alergenos: "알레르겐 유당 및 리소자임(계란 유도체).",
            durabilidad:
              "유통기한은 생산 후 1년. 각 패키지에 표시되어 있습니다.",
            gastronomia:
              "레드 와인 (Aldonza Selección 및 Aldonza Navamarín) 및 까바(Aldonza Brut Reserva)와 함께 드시기에 이상적입니다.",
            notas_cata: {
              texto:
                "양 치즈 특유의 강한 풍미, 올리브 오일의 강렬한 풍미로 강화, 다소 매운 뒷맛"
            },
            premios: {
              premios: []
            }
          },

          semicurado: {
            id: "semicurado",
            nombre: "반 경화 치즈 (SEMICURADO)",
            descripcion:
              "100% 만체고 지방 산 양젖을 저온 살균 하여 만든 반 경화 치즈. (세미 큐어드 치즈)",
            curacion: "60 - 100 일",
            apariencia:
              "저온 살균된 만체고 (Manchego)산 양젖, 레닛(Rennet), 젖산 발효물, 리소자임(계란에서 추출), 염화칼슘 및 소금.",
            ingredientes:
              "저온 살균된 Manchegan 양 우유, 레닛, 젖산 발효물, 리소자임(계란에서 추출), 염화칼슘 및 소금. 우유의 원산지: 스페인.",
            valoresnutricionales:
              "410 Kcal / 1715 Kj 지방: 30 g 포화 지방: 18,90 g 탄수화물: 0,50 g 설탕: <0,50 g 단백질: 26 g 소금: 1,60 g",
            conservacion: "Between 2 and 7 oC.",
            alergenos: "알레르겐 유당 및 리소자임(계란 유도체).",
            durabilidad:
              "유통기한은 생산 후 1년. 각 패키지에 표시되어 있습니다.",
            gastronomia:
              "화이트 와인(Aldonza Albo), 영(Young) 레드 와인(Aldonza Clásico) 및 로제 까바(Aldonza Brut - Rosé)와 함께 드시면 좋습니다.",
            notas_cata: {
              texto:
                "양 치즈 특유의 강한 풍미, 올리브 오일의 강렬한 풍미로 강화, 다소 매운 뒷맛."
            },
            premios: {
              premios: []
            }
          },

          curado: {
            id: "curado",
            nombre: " 경화 치즈 (큐어드 치즈; CURADO)",
            descripcion:
              "100% 만체고 지방 산 양젖을 저온 살균 하여 만든 경화 치즈. (큐어드 치즈)",
            curacion: "150 - 210 일",
            apariencia:
              "Consistency: firm and compact. Colour: variable from white to ivory-yellowish. Odour: Odour: lactic, intense and persistent acidified, evolving to spicy nuances. Flavour: slightly acidic, strong and tasty.",
            ingredientes:
              "저온 살균된 Manchegan 양 우유, 레닛, 젖산 발효물, 리소자임(계란에서 추출), 염화칼슘 및 소금. 우유의 원산지: 스페인.",
            valoresnutricionales:
              "적 포도주(Aldonza Selección 및 Aldonza Navamarín) 및 까바(Aldonza Brut Nature)와 함께 드시면 이+B39상적입니다.",
            conservacion: "2에서 7 oC 사이의 보존.",
            alergenos: "알레르겐 유당 및 리소자임(계란 유도체).",
            durabilidad:
              "유통기한은 생산 후 1년. 각 패키지에 표시되어 있습니다.",
            gastronomia:
              "적 포도주(Aldonza Selección 및 Aldonza Navamarín) 및 까바(Aldonza Brut Nature)와 함께 드시면 이+B39상적입니다.",
            notas_cata: {
              texto:
                "특징이 많은 치즈, 강하고 깊숙이 침투하는 강렬한 풍미가 마지막에 약간 매운 뉘앙스로 진화합니다."
            },
            premios: {
              premios: []
            }
          }
        },
        intro_ficha: {
          titulo: "100% 만체고",
          cuerpo:
            "<p>각 치즈는 숙련된 치즈 제작자의 손에 의해 맞춤형 치료를 받습니다. 씹을 때마다 맛, 향, 질감에서 느낄 수 있는 애지중지. 경화, 반 경화 및 올리브 오일의 세 가지 품종 중 하나를 즐기십시오. 당신의 미각에 저항할 수 없는 또 하나의 경험.</p>"
        },
        banner_beneficios: {
          titulo: "치즈의 장점과 입증된 품질을 알고 계십니까?",
          boton: "엑스트라 버진 올리브 오일"
        },
        banner_experiencia: {
          titulo: "더 알고 싶으십니까?",
          boton: "알돈자 체험 알아보기",
          enlace: "vive_aldonza"
        },
        beneficios: {
          titulo: "이익 치즈의 검증된 품질",
          list: [
            {
              titulo: "",
              cuerpo:
                "치즈는 칼슘의 주요 공급원 중 하나로 적혈구 및 혈액응고에 산소수송 역할을 하는 우리 몸의 필수 과정을 조절하는 미네랄입니다.칼슘은 뼈를 만들고 강화하는 데 도움이 되므로 골다공증 및 기타 퇴행성 뼈 질환 퇴치에 좋은 효과가 있습니다."
            },
            {
              titulo: "",
              cuerpo:
                "치아를 강화하는 것 외에도 박테리아 플라크를 줄이고 타액 생성을 자극하며 구강을 자연적으로 정화 해줍니다. 비타민 B 함량이 높아 피부가 좋아지게 해 주며 시력과 면역 체계를 개선하는 데 도움이 되는 비타민 A와 D도 포함되어 있습니다."
            },
            {
              titulo: "",
              cuerpo:
                "엽산(folic acid)을 함유하고 있고 모유 생산을 촉진하기 때문에 임신 중 권고제품으로 알려져 있습니다. (살균 우유로 만든 경우). 치즈는 암과 심장병의 위험을 줄이는 데 도움이 되는 지방유의 두 가지 성분인 공액 리놀레산(CLA)과 스핑고리피드가 풍부합니다. 또한 단백질이 매우 풍부하고 체질량의 회복을 돕습니다. 운동선수에게 매우 도움이 되는 음식이며 비만의 위험을 줄여 줍니다."
            }
          ]
        }
      }
    },
    banners_experiencia: {
      vive_aldonza: {
        id: "vive-aldonza",
        titulo: "알돈자 체험",
        titulo_intro_experiencia:
          '""당신은 그 날의 날짜를 기억할 것이 아니라 그 순간의 경험을 기억할 것입니다.""',
        titulo_vivir_experiencia:
          "알돈자 체험을 하기 위해선 무엇이 필요합니까?",
        tip_maleta:
          "체험 기간동안 갖고 사용할 것들을 가지고 오는 것을 잊지 마십시오. 도착 하셨을 때 만반의 준비가 되어있어야 합니다!",
        tip_camara:
          "카메라!  체험 기간동안 발견하게 될 반복이 되지 못할 잊지 못할 순간을 포착하는 데 필수적입니다.",
        tip_corazon:
          "당신의 태도, 순간순간의 경험이 잊지 못할 체험으로 연결해 주는 바탕은 바로 당신의 태도입니다. 어떤 경로를 선택 할지는 바로 당신에게 달려 있습니다.",
        elige: "당신의 체험종류를 선택하십시오."
      },
      enoturismo: {
        id: "enoturismo",
        titulo: "와인 관광",
        cuerpo:
          "배럴룸이 있는 동굴로 내려갈 때 카메라를 준비하세요. 모든 알돈자 제품의 시음월요일부터 일요일까지 방문합니다.",
        boton: "체험해 보기",
        titulo_intro_experiencia: "와이너리 방문 요청",
        la_visita_text: "방문하기",
        reserva: "Get your tickets",
        tips_bodega: [
          {
            titulo: "위치",
            cuerpo:
              "돈끼호떼 고향의 심장부에 위치한 독특한 환경에서 엑스트라버진 올리브 유가 어떻게 만들어 지는지, 오일 밀이 어떻게 작동하는지, 주요 올리브 품종이 무엇인지, 전문적인 올리브 유 시음이 어떻게 수행되는지 배우게 됩니다.  더 이상 부가 설명을 않할테니 직접 오셔서 발견하세요!"
          }
        ],
        la_visita: [
          {
            cuerpo:
              "와이너리, 오일 밀, 사프란룸을 전부 둘러보세요. 와인, 엑스트라버진 올리브 유 및 사프란이 어떻게 만들어 지는지 배우시게 될 것입니다."
          },
          {
            cuerpo:
              "나바라민 (Navamarín), 셀렉시온 (Selección), 끌라시꼬 Clásico(적포도주), 알보 Albo(백포도주) 및 까바(cava) 엑스트라버진 올리브유 시음도 포함됩니다. 색다른 경험이 될 것입니다!"
          },
          {
            cuerpo: "대략적인 방문시간은 60분입니다. 장애인도 방문 가능합니다."
          },
          {
            cuerpo:
              "아무날이나 (월요일~일요일)방문 가능합니다. 방문시간은 방문자와 함께 상의 되어 결정 할 수 있습니다."
          }
        ],
        video: {
          titulo: "비디오/스팟",
          cuerpo:
            "함께 올 동반자만 선택하면 됩니다. 가족, 파트너 또는 친구? 와인 관광과 올리브 유 밀 관광이 함께합니다. 플레이를 누르세요!"
        }
      },
      oleoturismo: {
        id: "oleoturismo",
        titulo: "올리브 유 관광",
        cuerpo:
          "최상의 엑스트라버진 올리브 유의 향기에 빠져보세요. 알돈자 공장을 방문하여 엑스트라버진 올리브 유를 만드는 과정을 배우고 지중해 식단의 가장 전통적인 제품을 만끽해 보세요.",
        boton: "체험해 보기",
        titulo_intro_experiencia: "올리브유 관광 알아보기",
        titulo_catas: "오리브 유 시음",
        cuerpo_catas:
          "<p>올리브 유 시음은 불투명 유리잔으로 합니다. 그 이유는 오일 색깔이 품질을 결정하지 않기 때문입니다. 혹시 그렇다는 걸 알고 계셨나요? 올리브 유 관광 날짜에 등록하여 이 제품에 대해 더 많이 알아보세요.</p>"
      },
      degustacionQuesos: {
        id: "degustacionQuesos",
        titulo: "치즈 치즈 시음. 의식시음. 의식",
        cuerpo:
          "치즈 조각을 맛보기 위해 모든 감각을 활성화하십시오. 치즈 시음 의식이 시작됩니다!",
        boton: "생생한 경험",
        titulo_intro_experiencia: "의식시음. 의식",
        la_visita_text: "Maridaje con vino",
        la_visita: [
          {
            cuerpo:
              "La acidez del vino nos facilita el paso de los quesos, además, los vinos nos limpian la boca y potencian el sabor del quesos. En nuestras visitas guiadas de enoturismo, que puedes reservar aquí, te enseñamos a degustar el auténtico queso manchego."
          }
        ],
        productos: {
          vista: {
            id: "vista",
            nombre: "보다",
            descripcion:
              "치즈의 모양과 상태를 평가하는 감각입니다. 외부 껍질과 절단면을 모두 검사해야 합니다. 품종에 따라 껍질은 부드럽고 밀랍 같으며 곰팡이가 생기거나 세척되거나 엑스트라 버진 올리브 오일로 처리됩니다. 색상은 우리가 고려해야 하는 또 다른 시각적 측면입니다. 양의 우유로 만든 만체고 치즈는 일반적으로 아이보리 색조를 띠고 있습니다. 우리는 육안으로도 질감을 감상할 수 있습니다. 예를 들어, 치즈는 경화 시간에 따라 다소 갈라집니다."
          },
          tacto: {
            id: "tacto",
            nombre: "접촉",
            descripcion:
              "촉각 검사를 통해 경화된 만체고 치즈의 전형인 벗겨지기 쉬운 밀가루와 다소 부서지기 쉬운 질감을 느낄 수 있습니다."
          },
          olfato: {
            id: "olfato",
            nombre: "냄새가 나다",
            descripcion:
              "코에서 우리는 맛을 보는 사람과 치즈 제작자가 가족으로 그룹화하는 감각을 감지합니다. 젖산, 야채, 과일, 매운 등의 인상이 구별됩니다."
          },
          gusto: {
            id: "gusto",
            nombre: "맛이 나다",
            descripcion:
              "각 치즈의 풍미와 질감을 감상하는 시간! 입안에서 맛을 보려면 숨을 쉬지 않고 몇 초간 씹은 다음 입으로 조금씩 공기를 내보내는 것이 이상적입니다. 이것은 치즈의 강도와 풍미를 감지하는 데 도움이 됩니다. 단맛, 짠맛, ​​신맛, 쓴맛, 매운맛 및 완전히 개인적인 감상을 가질 수 있는 기타 뉘앙스까지."
          },
          regusto: {
            id: "regusto",
            nombre: "뒷맛",
            descripcion:
              "시음이 끝나면 뒷맛이 남습니다. 잔류 맛이라고도합니다. 이 순간 치즈를 처음 맛보았을 때와 다른 후각 미각이 남아있어 향과 맛이 완전히 새롭고 독특할 수 있습니다."
          }
        },
        maridaje: {
          id: "maridaje",
          titulo_catas: "와인과의 페어링.",
          cuerpo_catas:
            "<p>와인의 산도는 우리에게 치즈를 더 쉽게 전달할 수 있게 해주고, 와인은 입안을 맑게 해주고 치즈의 풍미를 더해줍니다. 여기에서 예약할 수 있는 가이드 와인 관광 투어에서 정통 만체고 치즈를 맛보는 방법을 알려드립니다.</p>"
        }
      },

      recetario: {
        id: "recetario",
        titulo: "레시피 북 및 미식 루트",
        cuerpo:
          "<p>저희 알돈자 제품을 맛보는 가장 좋은 방법은 함께 요리하는 것입니다. 전통적이든 혁신적이든 저희 요리책에서 가장 마음에 드는 레시피를 선택하세요.</p><p>알돈자 제품으로 최고의 스페인 요리해 보기. 이제  여행가방을 싸셔서 'Tasting Spain' 미식 루트로 오세요.</p>",
        boton: "체험해 보기",
        titulo_intro_experiencia:
          '"본인의 요리에 코멘트 할 게 있을 때 진정한 요리사가 되는 것이다."',
        cuerpo_recetario:
          "<p>저희는 엑스트라버진 올리브 유, 사프란, 와인 등 저희 제품으로 준비한 건강식 레시피 북이 있습니다. 전통적이든 혁신적이든 저희 모든 요리법은 시청각 형식으로 제공됩니다. 오늘 어떤 요리를 하시고 싶으세요?</p>",
        boton_recetario: "레시피로 이동",
        boton_tasting: "Discover tasting spain!",
        recetario: "Recipe Book",
        tasting_spain: "스페인을 맛보다! ( 'Tasting Spain' )",
        youtube: {
          titulo:
            "더 많은 레시피를 보고 저희의 루트중에  빠진 게 없는지 보시겠습니까?",
          newsletter: "YouTube 채널 구독",
          boton: "유튜브 채널로 이동"
        }
      },
      ruta_cervantina: {
        id: "ruta-cervantina",
        titulo: "세르반틴 루트",
        cuerpo:
          "돈끼호떼의 저자 세르반테스가 선호했던 경로로 간주되는 역사와 전설로 가득찬 지역. 나바마린 초원은(La Dehesa de Navamarín)주변에서 구석구석 당신을 매혹시킬 명소를 발견 하실것입니다. 여행 가방을 싸고 돈끼호떼 데 라만차의 고향에 빠져 보시러 오세요.",
        boton: "체험해 보기",
        cerrar: "Close",
        leer_mas: "더 읽어보기",
        tradicion: {
          titulo: "문학적 전통.",
          cuerpo:
            "미겔 데 세르반떼스(Miguel de Cervantes)는 데헤사 나바마린 (Dehesa de Navamarín)의 영토에서 영감을 받아 그의 국제적 명성의 작품인 라 만차의 돈끼호떼 (Don Quixote de La Mancha)의 두 편을 썼습니다. 까마쵸의 결혼식 'Las bodas de Camacho'과 몬떼시노스의 동굴 'La Cueva de Montesinos'은 저희 고향을 배경으로 하여 쓰여진 일화들입니다."
        },
        literatura: {
          cuerpo:
            "저희 고향 명산물인 포도원, 올리브 나무, 사프란이 등장하는 그의 작품에 영향을 받아 저희 브랜드가 탄생 되었습니다. 둘시네아 델 또보소(Dulcinea del Toboso)알돈자 로렌조는 돈키호테가 사랑했던 여인이었습니다. 현재 무네라시에서 이 문학 작품의 유산을 방문할 수 있습니다."
        },
        naturaleza: {
          titulo: "자연.",
          cuerpo:
            " 데헤사 데 나바마린(Dehesa de Navamarín)에서 약 40km 떨어진 세르반떼스(Cervantes)루트 중간에 광대한 깜뽀 데 몬띠엘(Campo de Montiel)의 한가운데에 물과 초목의 오아시스가 있습니다.  루이데라 호수들 (Lagunas de Ruidera)이라는 자연공원 내에는 산 뻬드로의 머리 (La Cabeza de San Pedro)라고 불리는 봉우리가 있는데 이 곳에 로차프리다 성(Castle of Rochafrida)과 몬떼시노스 동굴(Cave of Montesinos)이 있습니다.",
          more_cuerpo:
            "4.000헥타르에 이르는 면적에는 16개의 호수가 있는데 이들은 폭포와 연결 되어 있고 첫 번째 호수인 라구나 블랑까 (Laguna Blanca)에서 발산하는 급류는 낮은 지역에 위치한 호수들로 내려 와서 뻬냐로야 (Peñarroya)저수지로 이르게 됩니다.봄에는 풍부하고 다양한 색상의 식물들이 수 많은 수생조류의 방문을 받습니다.이 시기에 급류의 양은 최대 수치에 이르게 되어 한 호수로부터 다음 호수로 흐를 때 작은 폭포들을 형성합니다.",
          more_uno:
            '데헤사 나바마린 (Dehesa de Navamarín)과 알돈자 와이너리를 방문하는 사람은 문학적 전통이 가득한 땅을 방문하는 것입니다. 세르반떼스의 "Don Quixote"의 XIX, XX, XXI 장에 자세히 설명되어 있는 유명한 까마쵸의 결혼식은 무네라시에서 이루어 진 것입니다 . 주인공인 까마쵸 엘 리꼬 (Camacho el Rico), 바실리오 엘 뽀브레 (Basilio el Pobre) 그리고 라 베야 끼떼리아 (La Bella Quiteria)가 이 마을 출신이라는 것을 보여주는연구자료도 있습니다. 이 일화가 발생한 숙소는 아직도 ​보존되어 있으며 현재는 저희 알돈자 제품을 맛볼 수있는 아름다운 호스텔로 개조되어 운영되고 있습니다.',
          more_dos:
            "이 유명한 일화의 주인공 중 한명을 기리기 위해 1975년에 몰리노 데 라 베야 끼떼리아 (Molino de La Bella Quiteria)가 건설 되었습니다. 현재는 라 만차 지역의 전통가구 및 가정요품 박물관으로 사용되고 있습니다. 세르반테스 루트중 우선 하는 지역관광. 또한 무네라시에는 사진 민족학 박물관도 있는데 1861년에 지어 진 옛 풍차 제분소로 현재는 시청 박물관으로 되어 있습니다. 고전풍차 사이로 산책하고 있는 느낌을 경험 해 보세요.",
          more_tres: ""
        },
        historia: {
          titulo: "역사",
          cuerpo:
            "세르반떼스 루트에는 시에라 데 알까라즈(Sierra de Alcaraz)와 깜뽀스 데 몬띠엘(Campos de Montiel)에 위치한 역사적 장소는 포함되어 있지 않습니다. 레주자(Lezuza)시에 위치한 리비소사(Libisosa)의 고고학 유적지와 띠리에즈 민족지학 박물관(el Museo Etnográfico de Tiriez)역시 저희 농장의 역사와 라 만차(La Mancha)문화의 일부입니다.",
          more_uno:
            "T리비소사의 2.800년 이상의 역사를 지닌 고고학 유적지는 10헥타르에 이르는 면적에 숨겨져 있는데 레주자(Lezuza)시에 있는 세로 데 까스띠요 (Cerro del Castillo)의 발굴 작업은 이 지역을 까스띠야 라 만차 (Castilla-La Mancha)주에서 중요 지역으로 발전하게 만든 계기가 되었다고 할 수 있습니다. 이 발굴작업 지역은 구아디아나(Guadiana)강과 훈까르(Júcar)강 사이며 이 지역은 물자원, 사냥 및 살림 자원이 풍부한 곳입니다. 또 이 지역에서 목축업은 곡물재배 및 대규모 포도재배와 함께 항상 중요한 역할을 해 왔습니다. 당대의 무역에서 지정학적 가치가 높았던 이 곳은 또한 역사와 농업문화가 풍부한 지역이라고 할 수 있습니다.",
          more_dos:
            "띠리에즈 민족지학 박물관(el Museo Etnográfico de Tiriez)은 알바세떼 지방의 레주자(Lezuza)시에 있습니다. 저희 알돈자가 있는 고장의 역사적 건축물과 문화적 환경을 재현한 에코박물관입니다.이 박물관은 깜뽀스 데 몬띠엘(Campos de Montiel)지역 사람들의 다양한 일상 생활환경을 재현한 민족지 박물관이며  양봉도구, 농업, 가정용 장식용품, 손수레등을 볼 수 있습니다. 한편, '시골 마을의 생활'이라는 섹션에서는 단조, 대장간, 상점, 화덕, 학교, 치즈 공장 또는 마을 교회 등 과거의 전형적인 자체 장사물이 전시됩니다. 또한 에스파르토(esparto)와 같은 공예 활동을 체험 할 수 있고 사프란 해석센터와 레주자 (Lezuza)강 풍차 제분소의 복제품이 있습니다."
        },
        legado: {
          titulo: "돈끼호떼의 까딸루냐 유산",
          cuerpo:
            "저희 알도자는 저희 생산 판매품목에 까딸루냐 기원의 까바를 포함 했는데 이는 라 만차의 돈끼호떼와 까딸루냐 사이에는 특별한 연결고리가 있기 때문입니다. 이 책안에 있는 8개의 챕터에서 묘사되고 있는 돈끼호떼의 모험담은 까딸루냐 영토에서 이루어진 것이며 가장 대표적인 예가 '까딸루냐로 오다', 도적들의 모임', '바다와 항구의 비전', '까딸루냐 수도'라고 할 수 있습니다.",
          boton: "더 알아보기"
        }
      }
    },
    escucha: {
      intro: "인생에서 가장 좋은 일은 계획된 것이 아니라 우연히 일어난다.",
      cuerpo_intro: "알돈자를 느끼고 듣기 위해 필요한 것은 무엇입니까?",
      tip_volumen:
        "음악을 통해 새로운 감각을 즐기고 발견하고 싶은 욕구. 소리를 활성화하고 볼륨을 원하는 대로 두십시오!",
      tip_cascos:
        "당신은 혼자서든 혹은 동행인과 함께든 체험을 선택 하실 수 있습니다. 두 옵션 모두 알돈자가 제공하는 청취체험에 몰입 할 수 있습니다.",
      tip_dados:
        "소리가 미식체험을 향상 시키는 요소라는 것을 알고 계셨습니까? 알돈자 플레이 목록에 몸을 맡기고 음악이 당신의 미각을 강화시켜 주는 것을 느껴 보세요.",
      boton_escuchar: "Listen to",
      spotify: {
        titulo: "알돈자 스포티파이",
        cuerpo:
          "준비됐나요? 클릭 한 번이면 이 순간을 특별하게 만들어 줄 체험에 푹 빠져들 수 있습니다. 당신을 위해 특별히 선택한 다양한 환경.",
        boton: "듣기 목록"
      },
      comparte: {
        titulo: "알돈자 경험을 공유하세요.",
        cuerpo:
          "우리는 당신이 모든 알돈자 체험을 해 볼 수 있길 바라지만 무엇보다도 경험 하신 체험담을 저희와 공유해 주시길 바랍니다! 소셜 네트워크에서 여러분을 기다리고 있겠습니다."
      }
    },
    otras_experiencias: {
      titulo: "다른 체험 해 보기",
      lugares: {
        enoturismo: "와인 관광",
        oleoturismo: "올리브 유 관광",
        degustacionQuesos: "치즈 치즈 시음",

        ruta_cervantina: "C세르반테스 루트",
        recetario: "레시피 북"
      }
    },
    formulario: {
      vive_experiencia: "Live the experience",
      solicita_visita: "",
      bodega: "와이너리 방문 요청",
      almazara: "Request your visit",
      queseria: "Request your visit",
      nombre: "이름 및 성",
      nombre_apellidos: "이름 및 성",
      apellidos: "이름 및 성",
      email: "이메일",
      mensaje: "메시지",
      introduce_mensaje: "메시지를 입력하세요",
      fecha_nacimiento: "Date of birth",
      dia: "Day",
      mes: "Month",
      anyo: "Year",
      area_interes: "Your area of interest",
      trabaja_actualmente: "Are you currently working?",
      si: "Yes",
      no: "No",
      carta_presentacion: "Business card",
      meses: {
        Enero: "January",
        Febrero: "February",
        Marzo: "March",
        Abril: "April",
        Mayo: "May",
        Junio: "June",
        Julio: "July",
        Agosto: "August",
        Septiembre: "September",
        Octubre: "October",
        Noviembre: "November",
        Diciembre: "December"
      },
      archivo_adjunto: "Add file",
      adjuntar_cv: "Add CV",
      introduce_mail: "Enter your email",
      pais: "Country",
      telefono: "전화번호",
      he_leido: "나는 개인정보 보호정책을 읽고",
      y_acepto: "동의합니다.",
      texto_newsletter: "뉴스 및 업데이트를 수신하고 싶습니다.",
      enviar: "보내기",
      enviado: "Send",
      recibido:
        "We have received your message. We will get in touch with you as soon as possible.",
      concertar_visita: "전화나 이메일로 방문일정을 잡을 수도 있습니다.",
      lunes_domingo: "월요일부터 일요일까지",
      horario: "오전 8시~오후 2시, 오후 3시 30분~오후 6시",
      enlace_popup: "Click here to consult and accept the privacy policy"
    },
    popupterminos: {
      titulo: "BASIC DATA PROTECTION INFORMATION",
      titulo_dos: "DATA CONTROLLER",
      titulo_tres: "Aldonza Gourmet SAU ",
      cuerpo: [
        {
          titulo: "ADDRESS OF THE DATA CONTROLLER",
          cuerpo:
            "Parque Empresarial Ajusa, CM 332, km 2,2, calle 1, número 1., CP 02006, Albacete (Albacete)"
        },
        {
          titulo: "PURPOSE",
          cuerpo:
            "Your details will be used to process your requests and provide you with our services."
        },
        {
          titulo: "ADVERTISING",
          cuerpo:
            "We will only send you advertising if you authorize it in advance. You can do this by marking the corresponding box on the form."
        },
        {
          titulo: "LEGAL AUTHORITY",
          cuerpo:
            "We will only process your details with your prior consent. You can do this by marking the corresponding box on the form."
        },
        {
          titulo: "INTENDED RECIPIENTS",
          cuerpo:
            "Generally speaking, only duly authorized personnel at our company will be able to access the information we request from you."
        },
        {
          titulo: "RIGHTS",
          cuerpo:
            "You are entitled to know what information we hold about you, correct it and have it deleted, as explained in the additional information available on our web site."
        }
      ],
      titulo_mas: "ADDITIONAL INFORMATION",
      texto_mas: "Further information is available in the ",
      datos_seguros: "YOUR DATA SECURE",
      texto_nuestra: "section of our web site.",
      acepto: "Accept"
    },
    banner_contacto: {
      titulo: "Do you need more information?",
      cuerpo:
        "For any questions you may have, fill out the following form. We will get back to you as soon as possible:",
      boton: "See form"
    },
    banner_localizaciones: {
      titulo: "위치",
      cuerpo: "To access our facilities, go to either of these two places:",
      munera: "주소: Carretera N-430, Km. 462,3 Munera (Albacete) España",
      lezuza: "<strong>Carretera CM-313</strong>, km 56, Lezuza (Albacete)."
    },
    banner_newsletter: {
      titulo: "위치",
      cuerpo: "주소: Carretera N-430, Km. 462,3 Munera (Albacete) España",
      email: "이메일:",
      telefono: "전화번호:"
    },
    cookie_banner: {
      texto:
        "A cookie is a small information file that is stored in your browser each time you visit our website. The use of cookies is to save the history of your activity in our so that, when you visit again, you can identify and configure your content based on your browsing habits, identity and preferences. They can be accepted, rejected, blocked and deleted, as desired. In case you reject them, we can not assure you the proper functioning of our website. More information in the cookies ",
      politica: "Privacy Policy",
      boton: "Accept"
    },
    intros_legales: {
      politica_cookies: "Cookies Policy",
      politica_privacidad: "Privacy Policy",
      datos_seguros: "Secure Data",
      aviso_legal: "Legal Advise",
      mapa_web: "web map"
    },
    volver: "Go back",
    volver_a: "Go back to",
    aviso_legal: {
      terminos: "TÉRMINOS Y CONDICIONES",
      uno:
        "I.- La utilización, consulta y/o contratación de los servicios que se exponen en nuestra página Web www.aldonzagourmet.com supone por parte de los usuarios y/o clientes la aceptación plena y sin reservas de las Condiciones Generales de Contratación, que regulan la relación jurídica derivada de los procesos de contratación realizados entre los usuarios y/o clientes de la página Web www.aldonzagourmet.com propiedad de <strong>Aldonza Gourmet S.A.U</strong> (en adelante Aldonza Gourmet). Los Clientes aceptan las Condiciones Generales desde el instante que utilicen o adquieran cualquier producto. Este documento puede ser impreso para ser leído y almacenado por los Clientes, previamente a su aceptación.",
      dos:
        "II.- Las presentes Condiciones Generales, están sujetas en lo que resulte de aplicación a lo dispuesto a la Ley 7/1998, de 13 de abril, sobre Condiciones Generales de Contratación, al Real Decreto Legislativo 1/2007, de 16 de noviembre, por el que se aprueba el Texto Refundido de la Ley General para la Defensa de Consumidores y Usuarios y otras leyes complementarias, al Real Decreto 1906/1999, de 17 de diciembre de 1999, por el que se regula la Contratación Telefónica o Electrónica con condiciones generales, el Reglamento (UE) 2016/679 del Parlamento Europeo y del Consejo, de 27 de abril de 2016, relativo a la protección de las personas físicas en lo que respecta al tratamiento de datos personales y a la libre circulación de estos datos y por el que se deroga la Directiva 95/46/CE (Reglamento general de protección de datos), la Ley Orgánica 3/2018, de 5 de diciembre, de Protección de Datos Personales y garantía de los derechos digitales, la Ley 7/1996, de 15 de enero de Ordenación del Comercio Minorista, y a la Ley 34/2002 de 11 de julio, de Servicios de la Sociedad de la Información y de Comercio Electrónico.",
      tres:
        "III.- Modificación de las Condiciones Generales. Aldonza Gourmet podrá modificar las Condiciones Generales notificándolo a los Clientes con antelación suficiente, con el fin de mejorar los servicios y productos ofrecidos a través de Aldonza Gourmet. Mediante la modificación de las Condiciones Generales expuestas en la página Web de Aldonza Gourmet se entenderá por cumplido dicho deber de notificación. En todo caso, antes de utilizar los servicios o contratar productos, se pondrán consultar las Condiciones Generales.",
      cuatro:
        "IV.- Propiedad intelectual. Todos los contenidos de esta página Web (incluyendo el código fuente, imágenes, textos, gráficos, etc.) están protegidos por la normativa nacional e internacional vigente sobre propiedad intelectual, encontrándose todos los derechos reservados. Queda terminantemente prohibida la reproducción de cualquier contenido de la Web sin el consentimiento expreso de Aldonza Gourmet y de los poseedores de los derechos.",
      cuatro_dos:
        "Mediante la adquisición de un producto, Aldonza Gourmet no confiere al adquirente ningún derecho de alteración, explotación, reproducción, distribución o comunicación pública sobre el mismo, reservándose Aldonza Gourmet todos estos derechos. La cesión de los citados derechos precisará el previo consentimiento por escrito por parte de Aldonza Gourmet. La utilización no autorizada de la información contenida en esta Web, su reventa, así como la lesión de los derechos de propiedad intelectual o industrial dará lugar a las responsabilidades legalmente establecidas.",
      cinco:
        "V.- Uso del servicio y responsabilidades. Aldonza Gourmet no garantiza la disponibilidad permanente de los servicios, quedando exonerado por cualquier tipo de responsabilidad por posibles daños y perjuicios causados debido a la indisponibilidad del servicio por causas de fuerza mayor o errores en las redes telemáticas de transferencia de datos, ajenos a su voluntad. Aldonza Gourmet no se hace responsable del contenido de los enlaces a otras páginas Web que no sean titularidad suya y que, por tanto, no pueden ser controladas por ésta.",
      seis:
        "VI.- Protección de datos. En cumplimiento de lo dispuesto en el artículo 5 de la Ley Orgánica 15/1999, de 13 de diciembre, de Protección de Datos de Carácter Personal, y en la Ley 34/2002, de 11 de Julio, de Servicios de la Sociedad de la Información y de Comercio Electrónico, Aldonza Gourmet S.A.U (en adelante Aldonza Gourmet) le informa de que los datos de carácter personal proporcionados en los formularios de registro electrónico contenidos en este sitio, así como aquellos datos a los que Aldonza Gourmet acceda como consecuencia de su navegación; consulta, solicitud o contratación, o de cualquier transacción u operación realizada desde este sitio web, serán recogidos en un fichero que cumple con las exigencias de la legislación vigente aplicable y cuyo responsable es: Aldonza Gourmet S.A.U., Parque Empresarial Ajusa. Nº1 - Ctra. 332 Km 2.2. 02006 – Albacete - España. (info@aldonzagourmet.com)",
      seis_uno:
        "La finalidad de la recogida y tratamiento automatizado de los Datos Personales realizados a través de los formularios y contactos vía correo electrónico habilitados en este sitio Web, es para facilitar la prestación de servicios que Ajusa proporciona a través de estas páginas, así como para facilitarle información sobre las actividades y noticias que pudieran resultar de su interés.",
      seis_dos:
        "El envío de datos personales, mediante el uso de los formularios electrónicos de esta Web o, en su caso, el envío de mensajes de correo electrónico solicitando información o servicios, supone el consentimiento expreso del Usuario al tratamiento automatizado de los datos incluidos, así como al envío de comunicaciones vía electrónica con información acerca de nuestras actividades.",
      seis_tres:
        "Por lo tanto, el Usuario expresa su consentimiento expreso para que los Datos Personales sean incorporados al Fichero de Datos Personales y sean objeto de tratamiento automatizado por parte de Aldonza Gourmet con las finalidades antes indicadas. Asimismo, expresa la aceptación y autorización para que Aldonza Gourmet pueda ceder los Datos Personales, a las empresas que prestan servicios a Aldonza Gourmet, tales como bancos y aseguradoras.",
      seis_cuatro:
        "El Usuario garantiza que los datos personales facilitados a Aldonza Gourmet son veraces y se hace responsable de comunicar al mismo cualquier modificación de los mismos.",
      seis_cinco:
        "Aldonza Gourmet pone a disposición de los usuarios la dirección de correo electrónico info@aldonzagourmet.com y el teléfono 967 21 77 11, para que éstos revoquen el consentimiento prestado. Aldonza Gourmet declara que cumple la normativa vigente respecto a la protección de datos, en particular la Ley Orgánica 15/1999, de 13 de diciembre, de Protección de Datos de Carácter Personal y el Real Decreto 1720/2007, de 21 de diciembre, que desarrolla la citada ley orgánica, y pone a disposición de los Clientes los medios de contacto referidos en el párrafo anterior para que estos ejerzan los derechos de acceso, rectificación, cancelación y oposición garantizados por la legislación vigente.",
      seis_seis:
        "Aldonza Gourmet se compromete a tratar de forma absolutamente confidencial los datos de carácter personal y hacer uso de los mismos exclusivamente para las finalidades indicadas.",
      siete:
        "VII.- Comunicaciones electrónicas comerciales. Aldonza Gourmet pone a disposición de los usuarios, que previamente lo hayan solicitado, a través de formularios de suscripción habilitados al efecto, el servicio de envío de noticias, actividades e informaciones. El Usuario podrá darse de baja de este servicio en cualquier momento que lo considere oportuno mediante el envío de un correo electrónico a info@aldonzagourmet.com",
      ocho:
        "VIII. Información General. De conformidad con la ley 34/2.002, de 11 de julio, de Servicios de la Sociedad de la Información y de Comercio Electrónico, Aldonza Gourmet, manifiesta que ha procedido a cumplir con el deber de información en los términos que establece esta normativa, al efecto de permitir, tanto a los destinatarios del servicio como a los órganos competentes, el acceso de forma permanente, fácil, directa y gratuita a la siguiente información: Aldonza Gourmet S.A.U Parque Empresarial Ajusa. Nº1 - Ctra. CM-332 Km 2.2. 02006 - Albacete (España). www.aldonzagourmet.com. Teléfono: 967 21 77 11 Datos de inscripción en el Registro Mercantil de Albacete, Hoja nº 5031, Folio 222, Tomo 635, Libro 399, Sección 8. C.IF. Nº A-02203859.",
      nueve:
        "IX. Información sobre el uso de cookies. Este sitio Web utiliza cookies, pequeños ficheros de datos que se generan en el ordenador del Usuario y que nos permiten obtener la siguiente información: La fecha y hora de la última vez que el Usuario visitó nuestro Web, los contenidos que el Usuario escogió en su primera visita a nuestro Web, etc. Con la finalidad de realizar estadísticas globales de acceso. El Usuario consiente el uso de estas cookies, que en ningún caso permitirán su identificación, con la exclusiva finalidad de facilitar su navegación por las diferentes páginas del presente sitio Web. En cualquier caso, el Usuario podrá denegar o impedir la instalación de estas cookies modificando la configuración de su navegador.",
      diez:
        "X. Responsabilidad. El uso del Web se realizará bajo la única y exclusiva responsabilidad del Usuario. Dicha responsabilidad se extenderá al uso, por parte del usuario o de cualquier tercero, de cualquier contraseña o similares asignadas para el acceso al Web o a cualesquiera de sus servicios.",
      diez_uno:
        "Aldonza Gourmet no asume responsabilidad alguna derivada de los contenidos enlazados desde la Web, siempre que sean ajenos a la misma, ni garantiza la ausencia de virus u otros elementos en los mismos que puedan producir alteraciones en el sistema informático (hardware y software), en los documentos o los ficheros del usuario, excluyendo cualquier responsabilidad por los daños de cualquier clase causados al usuario por este motivo. Aldonza Gourmet rechaza toda responsabilidad que se derive de la mala utilización de los contenidos expuestos en estas páginas y se reserva el derecho a actualizarlos, eliminarlos, establecer limitaciones o restringir su acceso en cualquier momento, de manera temporal o permanente.",
      once:
        "XI.- Nulidad e ineficacia de las Cláusulas. Si cualquier cláusula incluida en estas Condiciones Generales fuese declarada nula o ineficaz total o parcialmente, tal nulidad o ineficacia afectará tan sólo a dicha disposición o a la parte de la misma que resulte nula o ineficaz, subsistiendo las Condiciones Generales en todo lo demás, teniéndose tal disposición, o la parte de la misma que resultase afectada, por no puesta.",
      doce:
        "XII.- Conflictos. Para cualquier controversia o conflicto suscitado, será de aplicación la legislación española, siendo competentes para la resolución de todos los conflictos derivados o relacionados con ella, los Juzgados y Tribunales de Albacete.",
      doce_uno:
        "El acceso a las páginas Web de este sitio, implica la aceptación de todas las condiciones expresadas en esta información legal. Aldonza Gourmet, podrá modificar sin previo aviso, la estructura y diseño del Web, así como cambiar o eliminar, los servicios, los contenidos y las condiciones de acceso de uso del Web y adaptarla a los cambios legislativos que se produzcan."
    },
    mejor_bodega_CM: "Chosen as the best winery in Castilla-La Mancha"
  },
  ru: {
    enlaces: {
      home: "/ru-home",
      finca: "/ru-estate",
      la_tierra: "/ru-estate/land",
      la_bodega: "/ru-estate/winery",
      proceso_cava: "/ru-estate/winery/cava-process",
      proceso_vino: "/ru-estate/winery/wine-process",
      la_almanzara: "/ru-estate/oil-mill",
      proceso_aceite: "/ru-estate/land/oil-process",
      proceso_queso: "/ru-estate/land/cheese-process",
      sala_azafran: "/ru-estate/saffron-room",
      queseria: "/ru-estate/dairy",
      proceso_azafran: "/ru-estate/saffron-room/saffron-process",
      productos: "/ru-products",
      vino: "/ru-products/wine",
      aceite: "/ru-products/olive-oil",
      azafran: "/ru-products/saffron",
      queso: "/ru-products/cheese",
      cava: "/ru-products/cava",
      productos: "/ru-products",
      premios: "/ru-awards",
      beneficios: "/ru-benefits",
      experiencias: "/ru-experiences",
      vive_aldonza: "/ru-experiences/experience-aldonza",
      oleoturismo: "/ru-experiences/experience-aldonza/oleotourism",
      degustacionQuesos: "/ru-experiences/experience-aldonza/cheese-tasting",
      ruta_cervantina: "/ru-experiences/experience-aldonza/cervantes-route",
      enoturismo: "/ru-experiences/experience-aldonza/oenotourism",
      recetario:
        "/ru-experiences/experience-aldonza/recipe-book-and-gastronomy-route",
      escucha_aldonza: "/ru-experiences/listen-to-aldonza",
      contacto: "/ru-home/contact",
      politica_proteccion: "/ru-data-protection-policy",
      politica_cookies: "/ru-cookie-policy",
      datos_seguros: "/ru-your-data-secure",
      aviso_legal: "/ru-legal-notice",
      mapa_web: "/ru-website",
      contactoid: "ru-contact",
      experiencias_13: "https://tienda.aldonzagourmet.com/13-experiencias",
      mejor_bodega_CM:
        "https://blog.aldonzagourmet.com/2024/11/mejor-bodega-de-castilla-lamancha/"
    },
    vistas: {
      inicio: "Главная",
      la_finca: "Фермерское хозяйство",
      la_tierra: "Территория",
      la_almazara: "Маслобойня",
      la_bodega: "Винодельня",
      sala_azafran: "Шафрановый зал",
      productos: "Продукты",
      queseria: "Сыроварня",
      productos_aldonza: "Продукция Альдонза",
      premios: "Наши награды",
      premio: "Награда",
      beneficios: "Преимущества",
      experiencias: "Экскурсии",
      oleoturismo: "Олеотуризм",
      degustacionQuesos: "Сырный ритуал",
      maridaje: "Сочетания вин",
      vive_aldonza: "Живая Альдонза",
      las_catas: "Дегустации:",
      experiencia_bodega: "Они уже у нас побывали:",
      ruta_cervantina: "Маршрут Сервантеса",
      enoturismo: "Энотуризм",
      recetario: "Книга рецептов и гастрономический маршрут",
      escucha_aldonza: "Слушай Альдонзу",
      blog: "Блог",
      contacto: "Контакт",
      politica_proteccion: "Политика защиты данных",
      politica_cookies: "Политика использования файлов cookie",
      mapa_web: "Веб-карта",
      datos_seguros: "Безопасность данных",
      aviso_legal: "Юридическое предупреждение"
    },
    home: {
      intro: {
        titulo_uno: "",
        titulo_dos: "Экскурсия",
        titulo_tres: "Альдонза",
        experiencia_aldonza: "Ваше путешествие начинается",
        aqui: "здесь",
        tienda: "Онлайн-магазин",
        tarifas: "ЦЕНОВЫЕ ТАРИФЫ"
      },
      comienza: {
        titulo_uno: "Начинается",
        titulo_dos: "",
        titulo_tres: "Экскурсия",
        experiencia_aldonza: "Ваше путешествие в Альдонзу",
        cuerpo:
          "Умение наслаждаться каждым легким движением природы, становится источником незабываемых ощущений, которые и пробудят в вас наши вина, кавы, оливковое масло Экстра Вирджин и шафран."
      },
      la_finca: {
        titulo_uno: "",
        titulo_dos: "Ферма",
        cuerpo:
          "Экологичность — это то, что отличает нашу продукцию. Мы приветствуем вас в Деэса-де-Навамарин.",
        aldonza_experience: "Путешествие в Альдонзу"
      },
      productos: {
        titulo: "Продукты"
      },
      experiencia: {
        titulo_uno: "",
        titulo_dos: "Экскурсия",
        aldonza_experience: "Путешествие в Альдонзу",
        escucha_aldonza: {
          cuerpo:
            "Перенеситесь с помощью музыки в неизведанные места, которые пробудят в вас новые ощущения. Просто слушай и наслаждайся свободой!"
        }
      },
      contacto: {
        titulo: "Контакт"
      }
    },
    blog: {
      titulo: "<span>Экскурсия</span> <span>продолжай</span><span>...</span>",
      subtitulo: "блог Альдонзы",
      boton: "смотреть"
    },
    newsletter: {
      titulo: "Подписывайтесь на нашу новостную рассылку",
      cuerpo: "Новости и новинки в вашей почте.",
      texto_comunicaciones:
        "Я согласен получать информационный бюллетень или другие сообщения от вашей организации",
      boton: "хочу подписаться",
      enviado: "Вы успешно подписались!"
    },
    otros_lugares: {
      titulo: "Другие места",
      lugares: {
        la_tierra: "Территория",
        la_bodega: "Винный погреб",
        la_almanzara: "маслобойня",
        sala_azafran: "шафрановый зал",
        queseria: "Сыроварня"
      }
    },
    la_tierra: {
      descubrir_proceso: "Узнайте о производстве",
      la_tierra: {
        cuadro_uno: {
          titulo: "Окружающая среда",
          texto:
            "Деэса-де-Навамарин — это природная зона на высоте более 1200 метров над уровнем моря, расположенная на северо-западе провинции Альбасете (Испания). Ее владения это 2200 гектаров высоких, средних и низких гор, усыпанных каменными дубами и ароматическими растениями. Уникальный анклав с крупнейшим в мире заповедником сабин (Juniperus Sabina), расположенный между склонами рек Гвадиана и Хукар."
        },
        cuadro_dos: {
          titulo: "Территория",
          texto_uno:
            "<strong>Территория: </strong>10 000 лет назад она была занята ледником, из-за которого образовалось большое количество валунов, препятствующих легкому испарению воды.",
          texto_dos:
            "<strong>Почва: </strong>Качество нашей продукции начинается с почвы, оптимальной для выращивания. Она характеризуется известняковой консистенцией и средней водопроницаемостью, с нейтральным или слабощелочным рН.",
          texto_tres:
            "<strong>Фауна: </strong>Деэса-де-Навамарин стал местом обитания многочисленных местных видов (оленей, кабанов и красных куропаток) и иностранных (муфлонов). Органические останки этих животных являются естественным удобрением для наших культур.",
          texto_cuatro:
            "<strong>Климат: </strong>Континентальный с холодной зимой и жарким и очень сухим летом. Суровые погодные условия, препятствующие размножению грибков и бактерий, вредных для сельскохозяйственных культур. В случае с виноградной лозой температурный контраст улучшает выработку полифенолов (танинов и антоцианов) в фазе созревания.",
          texto_cinco:
            "<strong>Можжевельник: </strong>Это тысячелетнее дерево, охраняемый вид восточного происхождения, придает нашим плодам исключительные целебные свойства."
        },
        frutos: {
          titulo: "Плоды",
          cuerpo:
            "Большая высота и суровые погодные условия напрямую влияют на качество плодов наших растений. Мы производим различные сорта винограда, оливки сортов пикуаль и арбекина и отборный шафран из Ла-Манчи."
        },
        escalera: {
          vinedo: {
            titulo: "Виноградники",
            cuerpo:
              "Деэса-де-Навамарин имеет 75 гектаров продуктивных виноградников и еще 100 гектаров недавних посадок. Мы выращиваем красные сорта раннего винограда (классика нашего региона), Каберне-Совиньон, Мерло и Сира, а также белые сорта Совиньон-Блан и Макабео. Виноградники для производства сырья для нашей кавы расположены в каталонском регионе Пенедес, в производственном центре Сант-Садурни-д'Анойя (Барселона). В этой области, известной как регион Кава, где производятся оригинальные игристые вина, мы выращиваем сорта Шарелло, Макабео и Парельяда. А также красный виноград сорта Трепат."
          },
          azafranal: {
            titulo: "Шафран",
            cuerpo:
              "Земля, выбранная для выращивания нашего шафрана, представляет собой сухую, известковую, аэрированную и ровную почву. Земля сбалансирована по органическим веществам, что снижает риск эрозии. Это также почва с относительной глубиной, которая позволяет удалять воду, чтобы луковица не была повреждена. Шафран имеет тенденцию временно истощать землю каждые 3 или 4 года, поэтому мы чередуем площади плантаций, чтобы гарантировать высокое качество шафрана из года в год."
          },
          olivos: {
            titulo: "Оливки",
            cuerpo:
              "Наши деревья полностью отвечают стандартизированным и регулярным протоколам обслуживания. 75 гектаров оливковых деревьев, которые производят два сорта оливок: пикуаль и арбекина. Первый – самый выращиваемый сорт в Испании. Он составляет более 50% продукции и отличается сильным вкусом с горьковатым и пряным оттенком. Арбекина отличается большой устойчивостью к холоду и очень низкой жизнеспособностью. Имеет сладкий и нежный вкус."
          }
        }
      },
      la_almazara: {
        cuadro_uno: {
          titulo: "Оборудование",
          texto:
            "Мы заботимся об окружающей среде, не забывая об инновациях и новых технологиях анализа, чтобы гарантировать получение оливкового масла высшего качества. Традиция наследования от отца к сыну, приверженность  и любовь к нашей земле — это ценности, которые способствуют ежедневной работе команды хозяйства Альдонза. Альдонза сертифицирована по всем правилам <a href ='/static/pdf/certificado-IFS.pdf'download ><strong><u>IFS</u></strong></a>  и  <a href ='/static/pdf/certificado-BRC.pdf'download><strong><u>BRC.</u></strong></a>"
        },
        cuadro_dos: {
          titulo: "маслобойня",
          texto:
            "<p>Мы присутствуем на протяжении всего процесса производства нашего оливкового масла первого холодного отжима. Мы балуем каждое оливковое дерево и деликатно обрабатываем плоды на собственной мельнице, оснащенной сложной техникой. Прохладные емкости из темной нержавеющей стали сохраняют чистые нюансы аромата и вкуса оливок. Мы также сохраняем твердую приверженность окружающей среде: наше оборудование получает экологический знак качества.</p><p>Не только вкус, но и здоровье. Промышленное предприятие Aldonza предназначено для упаковки, гарантирующей пищевую безопасность, что так важно для нашей продукции. Наши логистические возможности выделяются. Мы обслуживаем более 20 стран вовремя, мы ваш идеальный партнер!</p>"
        },
        proceso: {
          titulo: "Процесс",
          cuerpo:
            "Традиционный метод производства соседствует с современными, всегда с исключительным вниманием к получению высококачественного оливкового масла первого холодного отжима."
        },
        sala_catas: {
          titulo: "Дегустационный зал",
          cuerpo:
            "Фруктовый с интенсивным ароматом; Устойчивый вкус с легкой горчинкой и пряностью. Мы проводим профессиональные дегустации. Вкус оливкового масла первого холодного отжима в мероприятиях, посвященных олеотуризму с Альдонза.",
          boton_large: "Найти!",
          boton_short: "Найти!"
        }
      },
      sala_azafran: {
        cuadro_uno: {
          titulo: "Наш урожай",
          texto:
            "Только шафран выращенный в Кастилии Ла-Манча имеет <strong>Защищённое наименование места происхождения (PDO).</strong> Этот знак качества признан во всем мире благодаря тройной гарантии: оптимальные органолептические характеристики (цвет, аромат и вкус), максимальная безопасность пищевых продуктов и испанское происхождение. Погодные условия и местность, известняковые и щелочные почвы, расположенные на северо-западе провинции Альбасете, гарантируют исключительный урожай с исключительными свойствами и вкусом."
        },
        cuadro_dos: {
          titulo: "Шафрановый зал",
          texto:
            "От выращивания до упаковки в Альдонза работает команда квалифицированных специалистов, которые привержены качеству и безопасности пищевых продуктов шафрана. На наших полях и в современных условиях мы выращиваем, отбираем и вручную упаковываем шафран Альдонза. Наша компания  имеет все сертификаты и нормативные документы <a href ='/static/pdf/certificado-IFS.pdf'download ><strong><u>IFS</u></strong></a>  и  <a href ='/static/pdf/certificado-BRC.pdf'download><strong><u>BRC.</u></strong></a>"
        },
        proceso: {
          titulo: "Процесс",
          cuerpo:
            "Процесс производства шафрана такой же тонкий, как и нежные красные рыльца его цветка. Мы придерживаемся традиционных ценностей и проводим кропотливую работу на каждом из этапов процесса."
        },
        sala: {
          titulo: "Зал",
          cuerpo:
            "Шафран Альдонза принадлежит к народной культуре нашей земли. Секреты его производства являются частью наследства, которое кастильско-ламанчские семьи передавали из поколения в поколение. Этот древний процесс поддерживается в нашем шафрановом зале."
        }
      },
      la_bodega: {
        cuadro_uno: {
          titulo: "Оборудование",
          texto:
            "В самом сердце родины Дон Кихота, в городе Мунера, расположенном на северо-западе провинции Альбасете, мы производим наше вино на протяжении четырех поколений. Наша винодельня и виноградники удачно вписаны в место традиций и легенд, где Мигель де Сервантес обосновался, чтобы написать несколько глав «Дон Кихота». Наши вина, наряду с производством других традиционных продуктов Ла-Манчи, таких, как оливковое масло и шафран, являются результатом страстной отдачи и хорошо выполненной работы. Альдонза сертифицирована по всем международным по правилам.  <a href ='/static/pdf/certificado-IFS.pdf'download ><strong><u>IFS</u></strong></a>  и  <a href ='/static/pdf/certificado-BRC.pdf'download><strong><u>BRC.</u></strong></a>"
        },
        cuadro_dos: {
          titulo: "Винодельня",
          texto:
            " <p>Винодельня с семейными традициями, которая включает в себя современные помещения, оснащенные сложным оборудованием. Сельскохозяйственные традиции и инновации — идеальное сочетание для создания вин, пробуждающих новые ощущения.</p><p>Мы заботимся о каждой детали не только в виноделии, но и в дизайне. Удивителен наш стеллаж для бутылок в стиле Мондриана и наша комната для бочек из французского и американского дуба, расположенная в пещере с водопадом, где выставлены первые машины, с помощью которых давился виноград. Пространство, полностью окутывающее культурой вина всех, кто нас посещает.</p>"
        },
        proceso: {
          titulo: "Производство вина",
          cuerpo:
            "Наша цель состоит в том, чтобы извлечь все величие и качество винограда посредством тщательного производственного процесса."
        },
        proceso_cava: {
          titulo: "Производство кавы",
          cuerpo:
            "Мы поддерживаем традиционный метод приготовления кавы. В каталонском регионе Пенедес (Барселона) с Защищённое наименование места происхождения (PDO) Кава происходит сбор и производство наших четырех сортов игристых вин."
        },
        sala_barricas: {
          titulo: "Подвал с бочками",
          cuerpo:
            "Запах дерева, ароматы вина, шум водопада и тусклый свет окружающей среды перенесут вас совершенно в другое место. Бочки Альдонзы, помещенные в пещере на цокольном этаже винодельни, напоминает о качестве наших вин. Вы можете попробовать нашу продукцию, наслаждаясь уникальным пространством.",
          boton_large: "Откройте для себя винный туризм!",
          boton_short: "Найти!"
        }
      },
      queseria: {
        cuadro_uno: {
          titulo: "Наши мастера",
          texto:
            " <p>Сыры ручной работы D.O.P. Сыр Манчего, приготовлены из овечьего молока. Мы всегда стремимся предлагать сыры высшего качества, передающие любовь рук ремесленников, которые их делают. Традиционный метод сочетается с самыми передовыми технологиями, чтобы гарантировать необходимый контроль безопасности пищевых продуктов как для крупного рогатого скота, так и для качества молока. <div class='certificados'><div><a class='link-certificados queso' href='/static/pdf/certificado-SAE.pdf' download >Сертификат SAE 2021-0014</a></div></div></p>"
        },
        cuadro_dos: {
          titulo: "Сорта",
          texto:
            " <p>Альдонза Гурмэ предлагает три сорта сыров: твердые, полутвердые и на оливковом масле первого отжима, все они производятся из молока чистокровных манчеганских овец. Мы экспортируем наши ароматные вкусные сыры на пять континентов вместе и делимся традициями и культурой 100% сыра манчего. </p>"
        },
        proceso: {
          titulo: "Производство сыра",
          cuerpo: "Традиционный процесс, эксклюзивный в Кастилии Ла-Манча."
        }
      }
    },
    saber_mas: "Узнать больше",
    certificadoBRC: "сертификат BRC",
    certificadoIFS: "сертификат IFS",
    Certificados:
      "Компания сертифицирована по стандартам качества и безопасности пищевых продуктов <a href ='/static/pdf/certificado-IFS.pdf'download > IFS</a> и <a href ='/static/pdf/certificado-BRC.pdf'download>BRC.</a>",
    Certificados2:
      "Компания сертифицирована по стандартам качества и безопасности пищевых продуктов <a href ='/static/pdf/certificado-IFS.pdf'download > IFS</a> и <a href ='/static/pdf/certificado-BRC.pdf'download>BRC.</a>",
    slider_productos: {
      vino: {
        slug: "vino",
        titulo: "Вина Альдонза",
        cuerpo:
          "Вкус традиций и легенд. Вы получите новые впечатления с нашими четырьмя сортами вина Альдонза. Откройте для себя богатство их вкуса!",
        button: "вино"
      },
      aceite: {
        slug: "aceite",
        titulo: "Оливковое масло Альдонза",
        cuerpo:
          "Вы сразу же начнете чувствовать его аромат. Это прелюдия к ощущению текстуры и вкуса исключительного оливкового масла первого холодного отжима. Все это результат тщательного производственного процесса.",
        button: "масло"
      },
      azafran: {
        slug: "azafran",
        titulo: "Шафран Альдонза ",
        cuerpo:
          "Тонкая работа древнего трудоемкого процесса отбора шафрановых рылец  высоко оценена награждением продукта индивидуальной маркой. Шафран Альдонза имеет знак качества D.O.P Ла-Манча.",
        button: "Шафран"
      },
      cava: {
        slug: "cava",
        titulo: "Кава Альдонза",
        cuerpo:
          "Начинает освежать  уже с того момента, как только пузырьки напитка поднимаются со дна бокала кавы. Разнообразные ощущения ожидают вас с каждым новым глотком наших четырех сортов игристых вин. Почувствуй их!",
        button: "Кава"
      },
      queso: {
        slug: "queso",
        titulo: "Сыр Манчего D.O.P.",
        cuerpo:
          "Подлинный вкус Ла-Манчи сливается с ароматом еды, произведенной на нашей земле, и разлетается по всему миру.  D.O.P. Сыру Манчего принадлежит защищённое наименование места происхождения.",
        button: "Сыр"
      }
    },
    slider_proceso: {
      proceso_vino: {
        id: "proceso-del-vino",
        padre: "la_bodega",
        pasos: {
          vendimia: {
            titulo: "Зрелость",
            cuerpo:
              "<p>Когда виноград достигает оптимальной точки зрелости, мы начинаем сбор урожая, обычно между концом августа и началом сентября. Чтобы высокие температуры не повлияли на фрукты и процесс их ферментации, мы собираем урожай, используя традиционную ручную и ночную систему сбора урожая. Виноград транспортируется в ящиках на винодельню, и мы вручную отбираем лучшие плоды, чтобы гарантировать качество вина.</p>"
          },
          fermentacion: {
            titulo: "Ферментация и прессование",
            cuerpo:
              "<p>Как только отобранный виноград отделяется от гребней, начинается процесс ферментации в полностью компьютеризированных стальных резервуарах. Мы уделяем особое внимание прессованию вина, этапу, на котором мы отделяем жидкость от твердых остатков винограда.</p>"
          },
          crianza: {
            titulo: "Выдержка",
            cuerpo:
              "<p>Наша команда энологов определяет время, которое каждый урожай будет находиться в бочке, всегда не менее шести месяцев. Это момент, когда красные вина приобретают свою индивидуальность в бочках из американского и французского дуба, которые находятся в подвале винодельни. В бочке круглый год поддерживается сбалансированная температура и влажность. Когда вино раскрывает весь свой аромат и вкус, мы делаем купаж и далее даем бутылке отдохнуть то же самое количество время, которое оно провело в бочке. </p>"
          },
          etiquetado: {
            titulo: "Маркировка",
            cuerpo:
              "<p>Наша преданность, верность нашей земле и винам, которые мы производим, закрепляются на этапе маркировки. Именно наш отдел логистики завершает процесс, отправляя наши вина в более чем 20 стран, в которых распространяется бренд Альдонза. Мы профессиональная команда, которая контролирует и координирует все этапы производственного процесса нашего продукта.</p>"
          }
        },
        boton: "Наше вино"
      },
      proceso_cava: {
        id: "proceso-del-cava",
        padre: "la_bodega",
        pasos: {
          vendimia: {
            titulo: "Сбор винограда",
            cuerpo:
              "<p>После сбора винограда (Шарелло, Макабео, Шардоне, Парельяда и Трепат) начинается традиционный метод изготовления кавы в престижном производственном центре Сант-Садурни-д'Анойя (Барселона). Мы используем только сусло первых фракций отжима, цветочное сусло (кюве).</p>"
          },
          tiraje: {
            titulo: "Розлив",
            cuerpo:
              "<p>Это процесс заполнения бутылок базовым вином и смесью дрожжей и сахара. Это вызовет второе брожение в той же бутылке и даст пузырьки, столь характерные для этого продукта. Последующее старение требует минимум 9 месяцев.</p>"
          },
          deguelle: {
            titulo: "Дегоржаж",
            cuerpo:
              "<p>На этом этапе мы снимаем пробку с бутылки и высасываем предварительно замороженные дрожжи. Затем добавляется экспедиционный ликер, то есть, то количество сахара, которое и сделает каву натуральной, сухой (брют) или полусладкой.</p>"
          },
          etiquetado: {
            titulo: "Маркировка и логистика",
            cuerpo:
              "<p>Мы присутствуем на всех стадиях процесса производства кавы, контролируя и гарантируя высочайшие стандарты качества на всех этапах.</p>"
          }
        },
        boton: "Наша кава"
      },
      proceso_aceite: {
        id: "proceso-del-aceite",
        padre: "la_almanzara",
        pasos: {
          cosecha: {
            titulo: "Урожай",
            cuerpo:
              "<p>Важно определить оптимальный момент сбора оливок, так как созревание связано с объемом выхода, степенью кислотности и органолептическими характеристиками масла. Это и есть основа успеха и качества нашего   оливкового масла Экстра Вирджин,  а также тщательное наблюдение за процессом созревания оливок, который мы начинаем в первые дни ноября. Сбор урожая обычно стартует в конце этого месяца или начале декабря. Мы собираем только здоровые плоды, которые не упали с дерева на землю.</p>"
          },
          recepcion: {
            titulo: "Сбор и очистка",
            cuerpo:
              "<p>Мы деликатно собираем и передаем оливки на нашу мельницу и проверяем состояние здоровья плодов с помощью анализа, который определяет состав оливок и оптимизирует их переработку. Шаг, предшествующий измельчению, заключается в удалении всех примесей. Оливки проходят через очистительную машину, которая удаляет листья, соцветия и т. д. через сухую вентиляцию. Впоследствии плоды попадают на линию промывки, которая устраняет остальную грязь.</p>"
          },
          molienda: {
            titulo: "Измельчение и сбивание",
            cuerpo:
              "<p>На этапе измельчения мы вырабатываем пасту, чтобы разрушить физическую структуру оливки и провести процесс сбивания. Цель сбивания - способствовать отделению масла от остальной части оливки. Оливковую пасту подвергаем действию непрерывного перемешивания при температуре выше комнатной, но всегда ниже 25 градусов.</p>"
          },
          extraccion: {
            titulo: "Отжим и очистка масла",
            cuerpo:
              "<p>Как только оливковая паста взбита, отделяем масло от остальных компонентов. Как и все другие методы, этот также совершенствовался, и от старого способа давления жерновами и фильтрации тканями из натуральных волокон мы перешли к экстракции с использованием более быстрых и эффективных автоматических центрифуг, также называемых декантерами.</p><p>Паста подвергается действию центробежной силы, которая разделяет различные компоненты по плотности. Масло, выходящее из декантера, все еще содержит твердые примеси и некоторое количество воды. Мы используем вертикальные центрифуги для разделения этих компонентов, гораздо более быстрые и точные машины, которые сокращают время контакта масла с примесями и гарантируют более надежное разделение.</p>"
          },
          almacenamiento: {
            titulo: "Хранение и расфасовка",
            cuerpo:
              "<p>После получения оливкового масла первого холодного отжима его хранят в резервуарах из нержавеющей стали, чтобы оно содержалось в идеальном состоянии и было защищено от неблагоприятных обстоятельств, таких как свет, внешние запахи, температура воздуха и даже шум. Перед розливом проводится очищение с помощью земляного фильтра для получения более светлого и чистого масла. На линии розлива мы контролируем органолептические характеристики масла до последнего момента, чтобы убедиться, что оно соответствует требованиям наших стандартов качества.</p>"
          }
        },
        boton: "Наше масло"
      },
      proceso_azafran: {
        id: "sala-del-azafran",
        padre: "sala_azafran",
        pasos: {
          cosecha: {
            titulo: "Выращивание",
            cuerpo:
              "<p>Посадку луковиц проводят в период с июня по сентябрь, чтобы крокусы достигли своего максимального великолепия в середине осени. Наш шафран выращивается на благоприятных для его произрастания почвах: сухих, известковых, ровных и без деревьев. Почва не глубокая и позволяет отводить воду, чтобы луковица не повреждалась.</p>"
          },
          recoleccion: {
            titulo: "Сбор урожая",
            cuerpo:
              "<p>Пение и говор крестьян слышны на наших плантациях еще до восхода солнца. Сбор шафрановых соцветий производится на рассвете, чтобы рыльца не потеряли свои свойства под воздействием солнечного света. Процесс сбора проходит с конца октября по начало ноября.</p>"
          },
          monda: {
            titulo: "Очистка",
            cuerpo:
              "<p>Эта кропотливая работа считается древней традицией. Шафрановый бутон оказывается в доме, где его обработают, еще с первой утренней росой. Отделение рыльца от остальной части цветка производится вручную и называется шелушением или обрезкой. Это самая деликатная часть процесса. Очень важно, чтобы рыльце не сломалось и дошло до фазы обжарки целиком. Эта работа выполняется в срок, не превышающий 12 часов с момента ее сбора в полевых условиях.</p>"
          },
          tostado: {
            titulo: "Прожарка",
            cuerpo:
              "<p>Шафран поджаривают  на слабом огне. Этот процесс сушки или обжаривания рылец делается для того, чтобы шафран сохранился в идеальном состоянии и сберег весь свой аромат. Это решающий этап, так как он определяет такие характеристики продукта, как влажность, окрашивающая способность, аромат и устойчивость вкуса.</p>"
          },
          almacenamiento: {
            titulo: "Хранение",
            cuerpo:
              "<p>Обжаренный шафран быстро пересыпается в контейнеры, оберегающие его от влаги и света. Они также хранятся при температуре окружающей среды ниже 25ºC. Упаковывается вручную.</p>"
          }
        },
        boton: "Наш шафран"
      },
      proceso_queso: {
        id: "proceso-del-queso",
        padre: "queseria",
        pasos: {
          Ordeño: {
            titulo: "Доение и свертывание",
            cuerpo:
              "<p>Сразу после дойки овец молоко охлаждают до температуры 4ºC, чтобы сохранить все его свойства. Затем молоко переливают в специальные сквашиватели и нагревают до постоянной температуры 30ºC. Когда творог достигает нужной консистенции, его разрезают и передают на формовку сыра.</p>"
          },
          moldelado: {
            titulo: "Формование, прессование и соление",
            cuerpo:
              "<p>Творог помещается в формы традиционным способом, а пластина с казеином размещается, нумеруется и серийно маркируется для идентификации каждого кусочка сыра Манчего. Затем сыр прессуют, чтобы полностью удалить сыворотку и придать ему окончательную форму. После прессования продукт извлекается из формы и сыр солится. Во время соления сыры регулируют свой микробиотический процесс, улучшают вкус и формируют внешнюю корку.</p>"
          },
          maduracion: {
            titulo: "Созревание",
            cuerpo:
              "<p>Срок созревания наших сыров составляет от 60 до 100 дней для полутвердых и от 150 до 210 дней для твердых. В камерах для созревания поддерживаются контролируемые условия температуры и влажности, обеспечивающие правильное созревание сыра Манчего. </p>"
          }
        },
        boton: "Наши сыры"
      }
    },
    productos_banner: {
      title: "Продукты",
      productos: {
        vino: "Вина",
        aceite: "Масло",
        azafran: "Шафран",
        cava: "Кава",
        queso: "Сыры"
      }
    },
    tips_productos: {
      tipo_vino: "Тип вина:",
      tipo_uva: "Тип винограда:",
      tipo_cava: "Кава:",
      elaboracion: "Производство:",
      gastronomia: "Гастрономия:",
      notas_cata: "Описание вин:",
      premios: "Награды:",
      ingredientes: "Ингредиенты:",
      caracteristicas: "Характеристики:",
      maridaje: "Сочетание",
      descargar_ficha: "Скачать файл в формате PDF",
      curacion: "Выдержка",
      apariencia: "Внешний вид",
      valoresnutricionales: "Пищевая ценность",
      conservacion: "Хранение",
      alergenos: "Аллергены",
      durabilidad: "Долговечность"
    },
    productos: {
      vino: {
        slug: "vino",
        nombre: "Вина",
        intro_ficha: {
          titulo: "Пробуждают ощущения",
          cuerpo:
            "<p>Наше вино представляет собой квинтэссенцию особых характеристик земли и окружающей среды, в которой оно выращивается, Деэса де Навамарин. Это самоотверженность и труд умелых рук ремесленников. Отпечаток винодельческих традиций родины Дон Кихота. Вина со своей индивидуальностью, изготовленные из французских и испанских сортов винограда. Вина, сделанные со страстью  и душой. Вина, пробуждающие чувства.</p>"
        },
        intro_productos:
          "<span>Не ищите идеальный момент.<br> Просто поймай мгновение и сделай его безупречным.</span>",
        productos: {
          navamarin: {
            id: "navamarin",
            nombre: "Navamarín",
            tipo_vino:
              "Красное бочковое вино. Выдержка не менее 12 месяцев. Бочки из французского и американского дуба.",
            tipo_uva: "Каберне Совиньон, Мерло, Сира, Темпранильо",
            elaboracion:
              "Вино производится в Деэса-де-Навамарин, территории с самым большим запасом можжевельника в мире, что придает вину исключительные свойства и ароматы. Тщательный отбор винограда в производстве, не превышающем 2 кг с лозы. Купаж производится после выдержки в бочках.",
            graduacion:
              "13,5 - 14,5% об. (варьируется в зависимости от урожая).",
            cantidad: "750мл",
            servicio: "От 16º до 18º С.",
            gastronomia:
              "Хорошо сочетается с мясом, тушеными блюдами, дичью и сырами.",
            notas_cata: {
              texto:
                "Оттенки красных фруктов и трав с табачными нотами. С телом. Мягкие и округлые танины, ароматные в конце. Идеально подходит как для питья сразу после откупоривания, так и для дальнейшего хранения.",
              autor: "Джеймс Саклинг"
            },
            premios: [
              "navamarin-pswc-2011",
              "navamarin-berliner-2015",
              "navamarin-china-wine-2015",
              "navamarin-china-wine-2016",
              "navamarin-corea-wine-2015",
              "navamarin-corea-wine-2016",
              "navamarin-bruselas-2013",
              "navamarin-zarcillo-2007",
              "navamarin-testing-2014",
              "navamarin-wswa-2014",
              "navamarin-houston-2015",
              "navamarin-vinalies-2011",
              "navamarin-londres-2013",
              "navamarin-decanter-2013",
              "navamarin-mundus-2018",
              "navamarin-suckling-2018",
              "navamarin-suckling-2019",
              "navamarin-decanter-bronce-2019",
              "navamarin-mundus-2020",
              "navamarin-mundus-2021",
              "navamarin-penin-2023",
              "navamarin-bruselas-2022",
              "navamarin-londres-2022-2",
              "navamarin-bruxelles-2023"
            ]
          },
          seleccion: {
            id: "seleccion",
            nombre: "Selection",
            tipo_vino:
              "Красное бочковое вино. Выдержка не менее 9 месяцев. Бочки из американского и французского дуба.",
            tipo_uva: "Каберне Совиньон, Мерло, Сира, Темпранильо",
            elaboracion:
              "Произведено из тщательно отобранного винограда с малоурожайных лоз и собрано в одночасье при оптимальной зрелости. Купаж выполняется после завершения старения ствола для идеального сбора урожая. Хранение в бутылке 12 месяцев в темном винном подвале.",
            graduacion: "13,5–14% об. (варьируется в зависимости от урожая).",
            cantidad: "750мл",
            servicio: "От 16º до 18º С.",
            gastronomia:
              "Хорошо сочетается с мясом, тушеными блюдами, дичью и сырами.",
            notas_cata: {
              texto:
                "Цвет вишнево-красный. Интенсивный аромат спелых красных плодов с жареными, ванильными и нотами сухофруктами. Вкус широкий, с хорошим телом и идеальным сочетанием. По ощущениям оставляет длительное, интенсивное и устойчивое послевкусие.",
              autor: ""
            },
            premios: [
              "seleccion-pswc-2011",
              "seleccion-testing-2014",
              "seleccion-wswa-2014",
              "seleccion-burdeos-2008",
              "seleccion-vinalies-2009",
              "seleccion-vinalies-2012",
              "seleccion-decanter-2017",
              "seleccion-suckling-2019",
              "seleccion-decanter-bronce-2019",
              "seleccion-2022"
            ]
          },
          clasico: {
            id: "clasico",
            nombre: "Classic",
            tipo_vino:
              "Красное бочковое вино, выдержанное не менее 6 месяцев. Бочки из французского и американского дуба.",
            tipo_uva: "Каберне Совиньон, Мерло, Сира, Темпранильо",
            elaboracion:
              "Традиционная технология, основанная на классическом процессе виноделия, который раньше производился в регионе Кастилия-ла-Манча. Тщательный отбор винограда высочайшего качества. После выдержки выдержка в бутылке не менее 6 месяцев перед продажей.",
            graduacion: "13–14% об. (варьируется в зависимости от урожая).",
            cantidad: "750мл",
            servicio: "От 16º до 18º С.",
            gastronomia:
              "Идеально подходит для всех видов колбас, мяса, тушеных блюд, риса и макарон.",
            notas_cata: {
              texto:
                "Очень богат ароматами лесных ягод. Во вкусе присутствуют ноты красной лакрицы. Вкус насыщенный, с тонким оттенком танина. Идеально для употребления сразу после откупорки.",
              autor: "Джеймс Саклинг"
            },
            premios: [
              "clasico-testing-2014",
              "clasico-wswa-2014",
              "clasico-houston-2015",
              "clasico-decanter-2017",
              "clasico-berliner-2018",
              "clasico-bacchus-2018",
              "clasico-suckling-2018",
              "clasico-suckling-2019",
              "clasico-cwsa-2018",
              "clasico-mundus-2021",
              "clasico-penin-2023"
            ]
          },
          albo: {
            id: "albo",
            nombre: "Albo",
            tipo_vino: "Молодое белое",
            tipo_uva: "Совиньон Блан, Макабео",
            elaboracion:
              "После сбора урожая проводится легкая мацерация с контролем дрожжей и температуры брожения, что позволяет получить насыщенный аромат и изысканный фруктовый вкус.",
            graduacion: "12 - 13% об. (варьируется в зависимости от урожая).",
            cantidad: "750мл",
            servicio: "От 4º до 6ºС.",
            gastronomia: "Идеально сочетается с моллюсками, рыбой и десертами.",
            notas_cata: {
              texto:
                "Чистый и яркий цвет, с бледно-желтым оттенком. Аромат богат фруктовыми нотами (банан, персик и маракуйя) и цветочным букетом: цветы апельсина и жасмин, и нежный на вкус. Вино имеет сбалансированную кислотность, которая придает ему свежесть и длительное приятное послевкусие.",
              autor: ""
            },
            premios: [
              "albo-berliner-2016",
              "albo-testing-2014",
              "albo-suckling-2019"
            ]
          }
        },
        banner_premios: {
          titulo: "Вина удостоенные наград",
          boton: "Посмотреть все награды",
          premio: "navamarin-bruxelles-2023"
        },
        premios: {
          titulo: "Международные награды и отзывы престижных сомелье.",
          premios: {
            "navamarin-pswc-2011": {
              titulo: "Aldonza Navamarín",
              posicion: "Вторая премия",
              texto:
                "Винтаж 2006 года, награжден Серебряной медалью на Pro Wein PSWC в 2011 году, Майнц (Германия)..",
              categoria: "Международные",
              pais: "alemania",
              anyada: "2006",
              anyo: "2011"
            },
            "seleccion-pswc-2011": {
              titulo: "Aldonza Selección",
              posicion: "Вторая премия",
              texto:
                "Винтаж 2006 года, награжден Серебряной медалью на Pro Wein PSWC в 2011 году, Майнц (Германия)..",
              categoria: "Международные",
              pais: "alemania",
              anyada: "2006",
              anyo: "2011"
            },
            "navamarin-berliner-2015": {
              titulo: "Aldonza Navamarín",
              posicion: "Первая премия",
              texto:
                "Винтаж 2009 года, награжден Золотой медалью на Berliner Wein Trophy в 2015 году, Берлин (Германия).",
              categoria: "Международные",
              pais: "alemania",
              anyada: "2009",
              anyo: "2015",
              doble: true
            },
            "albo-berliner-2016": {
              titulo: "Aldonza Albo",
              posicion: "Первая премия",
              texto:
                "Винтаж 2015 года, награжден Золотой медалью на Berliner Wein Trophy в 2016 году, Берлин (Германия).",
              categoria: "Международные",
              pais: "alemania",
              anyada: "2015",
              anyo: "2016",
              doble: true
            },
            "pisces-mondiales-2008": {
              titulo: "Aldonza Pisces",
              posicion: "Вторая премия",
              texto:
                "Винтаж 2006 года, награжден Серебряной медалью на выставке Selections Mondiales des Vins в 2008 году, Квебек (Канада).",
              categoria: "Международные",
              pais: "canada",
              anyada: "2006",
              anyo: "2008"
            },
            "navamarin-china-wine-2015": {
              titulo: "Aldonza Navamarín",
              posicion: "Первая премия",
              texto:
                "Винтаж 2009 года, награжден Золотой медалью на церемонии вручения наград China Wine & Spirit Awards в 2015 году, Гонконг (Китай).",
              categoria: "Международные",
              pais: "china",
              anyada: "2009",
              anyo: "2015"
            },
            "navamarin-china-wine-2016": {
              titulo: "Aldonza Navamarín",
              posicion: "Первая премия",
              texto:
                "Винтаж 2010 года, награжден Золотой медалью на церемонии China Wine & Spirit Awards в 2016 году, Гонконг (Китай).",
              categoria: "Международные",
              pais: "china",
              anyada: "2010",
              anyo: "2016"
            },
            "navamarin-corea-wine-2015": {
              titulo: "Aldonza Navamarín",
              posicion: "Первая премия",
              texto:
                "Винтаж 2009 года, награжден Золотой медалью на Asia WineTrophy в 2015 году, Тэджон (Южная Корея).",
              categoria: "Международные",
              pais: "corea",
              anyada: "2009",
              anyo: "2015",
              doble: true
            },
            "navamarin-corea-wine-2016": {
              titulo: "Aldonza Classic",
              posicion: "Вторая премия",
              texto:
                "Винтаж 2008 года, награжден Серебряной медалью на Asia WineTrophy в 2016 году, Тэджон (Южная Корея).",
              categoria: "Международные",
              pais: "corea",
              anyada: "2008",
              anyo: "2016",
              doble: true
            },
            "navamarin-bruselas-2013": {
              titulo: "Aldonza Navamarín",
              posicion: "Первая премия",
              texto:
                "Винтаж 2008 года, награжден Золотой медалью на Concours Mondial de Bruxelles в 2013 году, Братислава (Словакия).",
              categoria: "Международные",
              pais: "eslovaquina",
              anyada: "2008",
              anyo: "2013"
            },
            "pisces-ljubljana-2008": {
              titulo: "Aldonza Pisces",
              posicion: "Вторая премия",
              texto:
                "Винтаж 2006 года награжден Серебряной медалью на Люблянском международном конкурсе вин в 2008 году, Любляна (Словения).",
              categoria: "Международные",
              pais: "eslovenia",
              anyada: "2006",
              anyo: "2008"
            },
            "pisces-bacchus-2006": {
              titulo: "Aldonza Pisces",
              posicion: "Вторая премия",
              texto:
                "Винтаж 2004 награжден Серебряной медалью на Bacchus Internacional 2006 года, Мадрид (Испания).",
              categoria: "Международные",
              pais: "espana",
              anyada: "2004",
              anyo: "2006"
            },
            "navamarin-zarcillo-2007": {
              titulo: "Aldonza Navamarín",
              posicion: "Первая премия",
              texto:
                "Винтаж 2004 года награжден Золотой медалью на Zarcillo в 2007 году, Вальядолид (Испания).",
              categoria: "Национальные",
              pais: "espana",
              anyada: "2004",
              anyo: "2007"
            },
            "pisces-bacchus-2008": {
              titulo: "Aldonza Pisces",
              posicion: "Вторая премия",
              texto:
                "Винтаж 2006 награжден Серебряной медалью на конкурсе Bacchus Internacional в 2008 году, Мадрид (Испания).",
              categoria: "Международные",
              pais: "espana",
              anyada: "2006",
              anyo: "2008"
            },
            "navamarin-testing-2014": {
              titulo: "Aldonza Navamarín",
              posicion: "Первая премия",
              texto:
                "Винтаж 2007 года, награжден Золотой медалью на Beverage Testing Institute в 2014 году, Чикаго (США).",
              categoria: "Международные",
              pais: "eeuu",
              anyada: "2007",
              anyo: "2014"
            },
            "seleccion-testing-2014": {
              titulo: "Ассортимент Альдонза",
              posicion: "Первая премия",
              texto:
                "Винтаж 2007 года, награжден Золотой медалью на Beverage Testing Institute в 2014 году, Чикаго (США).",
              categoria: "Международные",
              pais: "eeuu",
              anyada: "2007",
              anyo: "2014"
            },
            "clasico-testing-2014": {
              titulo: "Aldonza Classic",
              posicion: "Первая премия",
              texto:
                "Винтаж 2007 года, награжден Золотой медалью на Beverage Testing Institute в 2014 году, Чикаго (США).",
              categoria: "Международные",
              pais: "eeuu",
              anyada: "2007",
              anyo: "2014"
            },
            "albo-testing-2014": {
              titulo: "Aldonza Albo",
              posicion: "Первая премия",
              texto:
                "Винтаж 2013 года, награжден Золотой медалью на Beverage Testing Institute в 2014 году, Чикаго (США).",
              categoria: "Международные",
              pais: "eeuu",
              anyada: "2013",
              anyo: "2014"
            },
            "navamarin-wswa-2014": {
              titulo: "Aldonza Navamarín",
              posicion: "Первая премия",
              texto:
                "Винтаж 2008 года, награжден Золотой медалью на Absolute Gold на 71-й ежегодной выставке WSWA в 2014 году в Лас-Вегасе (США).",
              categoria: "Международные",
              pais: "eeuu",
              anyada: "2008",
              anyo: "2014"
            },
            "clasico-wswa-2014": {
              titulo: "Aldonza Classic",
              posicion: "Вторая премия",
              texto:
                "Винтаж 2008 года, награжден Серебряной медалью на 71-й ежегодной выставке WSWA в 2014 году в Лас-Вегасе.",
              categoria: "Международные",
              pais: "eeuu",
              anyada: "2008",
              anyo: "2014"
            },
            "seleccion-wswa-2014": {
              titulo: "Ассортимент Альдонза",
              posicion: "Вторая премия",
              texto:
                "Винтаж 2008 года, награжден Серебряной медалью на 71-й ежегодной выставке WSWA в 2014 году, Лас-Вегас (США).",
              categoria: "Международные",
              pais: "eeuu",
              anyada: "2008",
              anyo: "2014"
            },
            "navamarin-houston-2015": {
              titulo: "Aldonza Navamarín",
              posicion: "Третья премия",
              texto:
                "Винтаж 2008 г., награжден Бронзовой медалью на выставке Houston Livestock Show and Rodeo в 2015 г., Хьюстон (США).",
              categoria: "Международные",
              pais: "eeuu",
              anyada: "2008",
              anyo: "2015"
            },
            "clasico-houston-2015": {
              titulo: "Aldonza Clásico",
              posicion: "Третья премия",
              texto:
                "Винтаж 2007 года, награжден Бронзовой медалью на выставке Houston Livestock Show and Rodeo в 2015 году, Хьюстон (США).",
              categoria: "Международные",
              pais: "eeuu",
              anyada: "2007",
              anyo: "2015"
            },
            "seleccion-burdeos-2008": {
              titulo: "Ассортимент Альдонза",
              posicion: "Вторая премия",
              texto:
                "Винтаж 2005 года награжден Серебряной медалью на Всемирном конкурсе вин в 2008 году издания, Бордо (Франция).",
              categoria: "Международные",
              pais: "francia",
              anyada: "2005",
              anyo: "2008"
            },
            "seleccion-vinalies-2009": {
              titulo: "Ассортимент Альдонза",
              posicion: "Вторая премия",
              texto:
                "Винтаж 2006 года, награжден Золотой медалью на Vinalies Internationales, 2-м по важности конкурсе в мире в 2009 году, Париж (Франция).",
              categoria: "Международные",
              pais: "francia",
              anyada: "2006",
              anyo: "2009"
            },
            "navamarin-vinalies-2011": {
              titulo: "Aldonza Navamarín",
              posicion: "Вторая премия",
              texto:
                "Винтаж 2007 года, награжденный Серебряной медалью на Vinalies Internationales в 2011 году, Париж (Франция).",
              categoria: "Международные",
              pais: "francia",
              anyada: "2007",
              anyo: "2011"
            },
            "navamarion-citadelles-2006": {
              titulo: "Aldonza Navamarín",
              posicion: "Вторая премия",
              texto:
                "Винтаж 2006 года, награжденный Серебряной медалью на конкурсе Les Citadelles du Vin в 2011 году, Бордо (Франция).",
              categoria: "Международные",
              pais: "francia",
              anyada: "2006",
              anyo: "2011"
            },
            "seleccion-vinalies-2012": {
              titulo: "Ассортимент Альдонза",
              posicion: "Вторая премия",
              texto:
                "Винтаж 2007 года, награжден Серебряной медалью на Vinalies Internationales в 2012 году, Париж (Франция).",
              categoria: "Международные",
              pais: "francia",
              anyada: "2007",
              anyo: "2012"
            },
            "pisces-tokio-2008": {
              titulo: "Aldonza Pisces",
              posicion: "Вторая премия",
              texto:
                "Винтаж 2006 года награжден Серебряной медалью на самом престижном Международном конкурсе в Азии, издание 2008 года, Токио (Япония).",
              categoria: "Международные",
              pais: "japon",
              anyada: "2006",
              anyo: "2008"
            },
            "navamarin-londres-2013": {
              titulo: "Aldonza Navamarín",
              posicion: "Третья премия",
              texto:
                "Винтаж 2008 года, награжден Бронзовой медалью на Международном конкурсе вин в 2013 году, Лондон (Великобритания).",
              categoria: "Международные",
              pais: "uk",
              anyada: "2008",
              anyo: "2013"
            },
            "navamarin-decanter-2013": {
              titulo: "Aldonza Navamarín",
              posicion: "Рекомендованные вина",
              texto:
                "Винтаж 2008 года, рекомендованное вино на Decanter World Wine Awards, 2013 Edition, Лондон (Великобритания).",
              categoria: "Международные",
              pais: "uk",
              anyada: "2008",
              anyo: "2013"
            },
            "pisces-decanter-2013": {
              titulo: "Aldonza Pisces",
              posicion: "Рекомендованные вина",
              texto:
                "Винтаж 2008 года, рекомендованное вино на Decanter World Wine Awards, 2013 Edition, Лондон (Великобритания).",
              categoria: "Международные",
              pais: "uk",
              anyada: "2008",
              anyo: "2013"
            },
            "clasico-decanter-2017": {
              titulo: "Aldonza Classic",
              posicion: "Рекомендованные вина",
              texto:
                "Винтаж 2011 года, рекомендованное вино на Decanter Asia Wine Awards 2017 Edition, Гонконг (Китай).",
              categoria: "Международные",
              pais: "china",
              anyada: "2011",
              anyo: "2017"
            },
            "seleccion-decanter-2017": {
              titulo: "Ассортимент Альдонза",
              posicion: "Рекомендованные вина",
              texto:
                "Винтаж 2011 года, рекомендованное вино на Decanter Asia Wine Awards 2017 Edition, Гонконг (Китай).",
              categoria: "Международные",
              pais: "china",
              anyada: "2011",
              anyo: "2017"
            },
            "clasico-berliner-2018": {
              titulo: "Aldonza Classic",
              posicion: "Первая премия",
              texto:
                "Винтаж 2011 года, награжден Золотой медалью на Berliner Wein Trophy в 2018 году, Берлин (Германия))",
              categoria: "Международные",
              pais: "alemania",
              anyada: "2011",
              anyo: "2018",
              doble: true
            },
            "navamarin-mundus-2018": {
              titulo: "Aldonza Navamarín",
              posicion: "Первая премия",
              texto:
                "Винтаж 2012 года, награжден Золотой медалью на Международном винном Гран-при Mundus Vini, в издании 2018 года, Берлин (Германия)",
              categoria: "Международные",
              pais: "alemania",
              anyada: "2012",
              anyo: "2018"
            },
            "clasico-bacchus-2018": {
              titulo: "Aldonza Classic",
              posicion: "Вторая премия",
              texto:
                "Винтаж 2011, награждена Международным Серебряным Вакхом на XVI Международном конкурсе вин в 2018 году, Мадрид (Испания)",
              categoria: "Международные",
              pais: "espana",
              anyada: "2011",
              anyo: "2018"
            },
            "navamarin-suckling-2018": {
              titulo: "Aldonza Navamarín",
              posicion: "90 баллов",
              texto:
                "Винтаж 2012 года, отмечено Джеймсом Саклингом (США) на дегустации, проведенной в 2018 году в Эль-Приорато (Испания).",
              categoria: "Международные",
              pais: "eeuu",
              anyada: "2012",
              anyo: "2018"
            },
            "clasico-suckling-2018": {
              titulo: "Aldonza Classic",
              posicion: "90 баллов",
              texto:
                "Винтаж 2011 года,отмечено Джеймсом Саклингом (США) на дегустации, проведенной в 2018 году в Эль-Приорато (Испания).",
              categoria: "Международные",
              pais: "eeuu",
              anyada: "2011",
              anyo: "2018"
            },
            "clasico-cwsa-2018": {
              titulo: "Aldonza Classic",
              posicion: "Первая премия",
              texto:
                "Винтаж 2011 года, награжден Золотой медалью на China Wine & Spirits Award в 2018 году, Гонконг (Китай)",
              categoria: "Международные",
              pais: "china",
              anyada: "2011",
              anyo: "2018"
            },
            "navamarin-decanter-bronce-2019": {
              titulo: "Aldonza Navamarín",
              posicion: "Третья премия",
              texto:
                "Винтаж 2012 года, награжденный Бронзовой медалью на Decanter World Wine Awards, в издании 2019 года, Лондон (Великобритания).",
              categoria: "Международные",
              pais: "uk",
              anyada: "2012",
              anyo: "2019"
            },
            "seleccion-decanter-bronce-2019": {
              titulo: "Ассортимент Альдонза",
              posicion: "Третья премия",
              texto:
                "Винтаж 2012 года, награжденный Бронзовой медалью на Decanter World Wine Awards, в издании 2019 года, Лондон (Великобритания).",
              categoria: "Международные",
              pais: "uk",
              anyada: "2012",
              anyo: "2019"
            },
            "navamarin-suckling-2019": {
              titulo: "Aldonza Navamarín",
              posicion: "91 балл",
              texto:
                "Винтаж 2013 года, отмечено Джеймсом Саклингом (США) на дегустации, проведенной в 2019 году в Ла-Риохе (Испания).",
              categoria: "Международные",
              pais: "eeuu",
              anyada: "2013",
              anyo: "2019"
            },
            "clasico-suckling-2019": {
              titulo: "Aldonza Classic",
              posicion: "90 балл",
              texto:
                "Винтаж 2014 года, отмечено Джеймсом Саклингом (США) на дегустации, проведенной в 2019 году в Ла-Риохе (Испания).",
              categoria: "Международные",
              pais: "eeuu",
              anyada: "2014",
              anyo: "2019"
            },
            "seleccion-suckling-2019": {
              titulo: "Ассортимент Альдонза",
              posicion: "89 балл",
              texto:
                "Винтаж 2014 года, отмечено Джеймсом Саклингом (США) на дегустации, проведенной в 2019 году в Ла-Риохе (Испания).",
              categoria: "Международные",
              pais: "eeuu",
              anyada: "2014",
              anyo: "2019"
            },
            "albo-suckling-2019": {
              titulo: "Aldonza Albo",
              posicion: "87 балл",
              texto:
                "Винтаж 2018 года, отмечено Джеймсом Саклингом (США) на дегустации, проведенной в 2019 году в Ла-Риохе (Испания).",
              categoria: "Международные",
              pais: "eeuu",
              anyada: "2018",
              anyo: "2019"
            },
            "navamarin-mundus-2020": {
              titulo: "Aldonza Navamarín",
              posicion: "Серебряная медаль",
              texto:
                "Винтаж 2013 года, награжден Серебряной медалью на Международном винном Гран-при Mundus Vini в 2020 году, Нойштадт (Германия).",
              categoria: "Международные",
              pais: "alemania",
              anyada: "2013",
              anyo: "2020"
            },
            "navamarin-mundus-2021": {
              titulo: "Aldonza Navamarín",
              posicion: "Золотая медаль",
              texto:
                "Винтаж 2013 года, награжден Золотой медалью на Международном винном Гран-при Mundus Vini в 2021 году, Нойштадт (Германия).",
              categoria: "Международные",
              pais: "alemania",
              anyada: "2013",
              anyo: "2021"
            },
            "clasico-mundus-2021": {
              titulo: "Aldonza Classic",
              posicion: "Золотая медаль",
              texto:
                "Винтаж 2015 года, награжден Золотой медалью на Международном винном Гран-при Mundus Vini в 2021 году, Нойштадт (Германия).",
              categoria: "Международные",
              pais: "alemania",
              anyada: "2013",
              anyo: "2021"
            },

            "clasico-penin-2023": {
              titulo: "Aldonza Classic",
              posicion: "Гид Пенина 2023",
              texto:
                "Винтаж 2015 года, получивший оценку в соответствии с Гидом Пенина на дегустации, состоявшейся в феврале 2022 года в Испании.",
              categoria: "Nacional",
              pais: "España",
              anyada: "2022",
              anyo: "2022"
            },
            "navamarin-penin-2023": {
              titulo: "Aldonza Navamarín",
              posicion: "Гид Пенина 2023",
              texto:
                "Винтаж 2013 года, получивший оценку в соответствии с Гидом Пенина на дегустации, состоявшейся в феврале 2022 года в Испании.",
              categoria: "Nacional",
              pais: "España",
              anyada: "2022",
              anyo: "2022"
            },
            "navamarin-bruselas-2022": {
              titulo: "Aldonza Navamarín",
              posicion: "Большая золотая медаль 2022 г.",
              texto:
                "Винтаж 2013 года, награжден Большой Золотой медалью на межуднародном конкурсе Concurso Mundial de Bruselas в 2022 году, проходившем в Козенце (Италия).",
              categoria: "Международные",
              pais: "Bruselas",
              anyada: "2022",
              anyo: "2022"
            },
            "navamarin-londres-2022-2": {
              titulo: "Aldonza Navamarín",
              posicion: "91 балл",
              texto:
                "Винтаж 2013 года, удостоенный Серебряной медали на Decanter World Wine Awards, в 2022 году, Лондон (Великобритания).",
              categoria: "Международные",
              pais: "uk",
              anyada: "2013",
              anyo: "2022"
            },
            "navamarin-bruxelles-2023": {
              titulo: "Aldonza Navamarín",
              posicion: "91 Puntos",
              texto:
                "Винтаж 2014 года, обладатель Золотой медали на Concours Mondial de Bruxelles 2023, Истрия (Хорватия).",
              categoria: "Internacional",
              pais: "uk",
              anyada: "2014",
              anyo: "2023"
            },
            "seleccion-2022": {
              titulo: "Aldonza Selección",
              posicion: "91 Puntos",
              texto:
                "Винтаж 2015 года, обладатель Серебряной медали на Concours Mondial de Bruxelles 2023, Истрия (Хорватия).",
              categoria: "Internacional",
              pais: "uk",
              anyada: "2015",
              anyo: "2023"
            }
          }
        },
        banner_beneficios: {
          titulo: "Знаете ли вы о пользе и научно доказанных свойствах вина?",
          boton: "Откройте для себя преимущества"
        },
        banner_experiencia: {
          titulo: "Хотите узнать больше?",
          boton: "Откройте для себя винный туризм",
          enlace: "enoturismo",
          reserva: "Забронировать"
        },
        beneficios: {
          titulo: "Преимущества<br>и полезные свойства вина",
          list: [
            {
              titulo: "Похудение",
              cuerpo:
                "Употребление красного вина активирует функцию гена, который предотвращает образование новых жировых клеток и помогает мобилизовать существующие."
            },
            {
              titulo: "Здоровье зубов",
              cuerpo:
                "Некоторые соединения, присутствующие в вине, останавливают рост стрептококков и бактерий, связанных с кариесом. Это также предотвращает гингивит и боль в горле."
            },
            {
              titulo: "Скрытые функции",
              cuerpo:
                "Высокое содержание антиоксидантов в вине предотвращает затвердевание артерий и препятствует свертыванию крови, улучшая мозговой кровоток."
            },
            {
              titulo: "Наслаждение",
              cuerpo:
                "Во время дегустации вина в двух областях мозга высвобождаются эндорфины, вызывающие усиление ощущения удовольствия."
            },
            {
              titulo: "Упражнения",
              cuerpo:
                "Ресвератрол винограда уменьшает негативные последствия малоподвижного образа жизни."
            },
            {
              titulo: "Гигиена ротовой полости",
              cuerpo:
                "Выпиваемое во время еды вино способствует лучшему восприятию ароматов. Это связано с его вяжущими свойствами, которые предотвращают чрезмерное ощущение жира, вызванное такими продуктами, как красное мясо, и улучшают вкус пищи."
            },
            {
              titulo: "Профилактика рака",
              cuerpo:
                "Вино, особенно красное, помогает снизить риск развития рака легких у мужчин. Он также блокирует рост клеток, ответственных за рак молочной железы у женщин. Опять же, за такое исключительное качество отвечает ресвератрол."
            },
            {
              titulo: "Сердце",
              cuerpo:
                "Один-два бокала вина в день помогают повысить уровень хорошего холестерина в крови и предотвратить сердечно-сосудистые осложнения."
            },
            {
              titulo: "Простата",
              cuerpo:
                "Было доказано, что семь бокалов вина в неделю после 40 лет снижают риск рака простаты более чем наполовину."
            },
            {
              titulo: "Полезные привычки",
              cuerpo:
                "С социальной точки зрения, различные статистические данные показывают, что энофилы, любители вина, имеют более здоровые привычки в еде, чем любители других напитков, таких как потребители пива или безалкогольных напитков. Поклонники вина, как правило, потребляют больше оливок, фруктов, овощей, нежирных сыров, молока и здорового мяса."
            }
          ]
        }
      },
      aceite: {
        slug: "aceite",
        nombre: "Масло",
        intro_productos:
          "<span>Сделайте что-то удивительное уже сегодня</span>",
        intro_ficha: {
          titulo: "Когда ты любишь то, что делаешь",
          cuerpo:
            "<p>Получается оливковое масло Экстра Вирджин, которое выражает все ароматические качества и вкус сортов пикуаль и арбекина. Благодаря множеству целебных свойств, приписываемых оливковому маслу первого холодного отжима.</p> <p>Оливковое масло первого холодного отжима, являющееся основой средиземноморской диеты, используется с древних времен. Доказательством этого является культурное наследие, которое сохранилась до наших дней благодаря оливковому дереву, его выращиванию и способу производства. Многие древние цивилизации дали ему название жидкого золота.</p>"
        },
        productos: {
          vidrio: {
            id: "vidrio",
            nombre: "Бутылки",
            descripcion:
              "Оливковое масло первого холодного отжима, изготовленное из оливок сортов пикуаль и арбекина с помощью механического процесса холодного отжима.",
            ingredientes:
              "100% оливковое масло Экстра Вирджин. Оно не содержит каких-либо пищевых добавок.",
            notas_cata: {
              texto:
                "Масло с ярко выраженным характером, очень устойчивым во времени, со средним фруктовым вкусом, в котором выделяются зеленые ноты томатов, свежей травы и орехов. Сладкий привкус инжира и банана. Это масло с очень нежным средним букетом, который отличается балансом кислотности и сладости, заканчивающимся пряным оттенком, сохраняющимся на корне языка при глотании."
            },
            cantidades: ["750мл", "500мл", "250мл"],
            premios: [
              "granprestigio-mendoza-2016",
              "olivinus-mendoza-2016",
              "olivinusninos-mendoza-2016",
              "feria-habana-2016"
            ]
          },
          metal: {
            id: "metal",
            nombre: "Металл",
            descripcion:
              "Оливковое масло первого холодного отжима, изготовленное из оливок сортов пикуаль и арбекина с помощью механического процесса холодного отжима.",
            ingredientes:
              "100% оливковое масло Экстра Вирджин. Оно не содержит каких-либо пищевых добавок.",
            notas_cata: {
              texto:
                "Масло с ярко выраженным характером, очень устойчивым во времени, со средним фруктовым вкусом, в котором выделяются зеленые ноты томатов, свежей травы и орехов. Сладкий привкус инжира и банана. Это масло с очень нежным средним букетом, который отличается балансом кислотности и сладости, заканчивающимся пряным оттенком, сохраняющимся на корне языка при глотании."
            },
            cantidades: ["1L", "5L"],
            premios: [
              "granprestigio-mendoza-2016",
              "olivinus-mendoza-2016",
              "olivinusninos-mendoza-2016",
              "feria-habana-2016"
            ]
          }
        },
        banner_premios: {
          titulo: "Масло с премией",
          boton: "Посмотреть все награды",
          premio: "granprestigio-mendoza-2016"
        },
        premios: {
          titulo: "Награды и знаки отличия",
          premios: {
            "granprestigio-mendoza-2016": {
              titulo: "Международный конкурс оливкового масла",
              posicion: "",
              texto:
                "Золотой гран-при на Международном конкурсе масел «Оливинус 2016» в Мендосе (Аргентина).",
              categoria: "Международные",
              pais: "argentina",
              anyada: "",
              anyo: "2016"
            },
            "olivinus-mendoza-2016": {
              titulo: "Международный конкурс оливкового масла",
              posicion: "",
              texto:
                "93 балла на Международном конкурсе оливкового масла «Оливинус 2016» в Мендосе (Аргентина). ",
              categoria: "Международные",
              pais: "argentina",
              anyada: "",
              anyo: "2016"
            },
            "olivinusninos-mendoza-2016": {
              titulo: "Concurso Международные de Aceite de Oliva",
              posicion: "",
              texto:
                "Детский конкурс «Оливинус 2016», продукт, выбранный детьми, в Мендосе (Аргентина).",
              categoria: "Международные",
              pais: "argentina",
              anyada: "",
              anyo: "2016"
            },
            "feria-habana-2016": {
              titulo: "Feria Международные de la Habana",
              posicion: "",
              texto:
                "Награда за качество продукции на выставке FIHAV 2016 в Гаване (Куба).",
              categoria: "Международные",
              pais: "argentina",
              anyada: "",
              anyo: "2016",
              doble: true
            }
          }
        },
        banner_beneficios: {
          titulo:
            "Знаете ли вы о пользе и лечебных свойствах оливкового масла?",
          boton: "Откройте для себя преимущества"
        },
        banner_experiencia: {
          titulo: "Хотите узнать больше?",
          boton: "Откройте для себя олеотуризм",
          enlace: "oleoturismo"
        },
        beneficios: {
          titulo:
            "Преимущества и доказанные свойства<br>оливкового масла первого холодного отжима",
          list: [
            {
              titulo: "Остеопороз",
              cuerpo:
                "Оливковое масло первого холодного отжима играет важную роль в профилактике остеопороза, так как способствует усвоению кальция костной системой."
            },
            {
              titulo: "Кровяное давление",
              cuerpo:
                "Помогает резко снизить систолическое и диастолическое артериальное давление."
            },
            {
              titulo: "Ожирение",
              cuerpo:
                "Оливковое масло Экстра Вирджин полностью показано в низкокалорийных диетах для приготовления пищи и заправок, так как его гликемический индекс намного ниже, чем у других жиров."
            },
            {
              titulo: "Окислительный стресс",
              cuerpo:
                "Среди растительных масел оливковое масло первого холодного отжима отличается самым высоким содержанием мононенасыщенных жиров. В отличие от других жиров, он не окисляется в организме и содержит очень низкий процент полиненасыщенных жиров. Он также богат витамином Е."
            },
            {
              titulo: "Раковые болезни",
              cuerpo:
                "Научно доказано, что фитонутриенты в оливковом масле первого холодного отжима могут снизить риск рака молочной железы. Сквален и лигнаны — другие компоненты, которые изучаются на предмет их возможного воздействия на рак."
            },
            {
              titulo: "Диабет",
              cuerpo:
                "Диабетики находят в потреблении оливкового масла первого отжима отличного союзника в борьбе с болезнью, потому что оно помогает им снизить уровень глюкозы и инсулина в крови."
            },
            {
              titulo: "Артрит",
              cuerpo:
                "Регулярное употребление оливкового масла первого холодного отжима помогает снизить вероятность развития ревматоидного артрита."
            },
            {
              titulo: "Холестерин",
              cuerpo:
                "Оливковое масло Экстра Вирджин помогает снизить уровень холестерина в крови, свойство, которое может предотвратить развитие сердечных заболеваний. Это также способствует тому, что плохой холестериин, который напрямую влияет на развитие коронарных заболеваний, не окисляется."
            },
            {
              titulo: "Болезнь Альцгеймера",
              cuerpo:
                "Его регулярное употребление предотвращает ухудшение когнитивных функций."
            }
          ]
        }
      },
      azafran: {
        slug: "azafran",
        nombre: "Шафран",
        intro_productos:
          "<span>Маленькие детали, которые имеют большое значение</span>",
        productos: {
          caja: {
            id: "caja-1g",
            nombre: "Коробка 1г",
            descripcion:
              "Шафран D.O.P. Ла-Манча. Признание мирового качества, гарантирующее высочайший уровень безопасности пищевых продуктов,  по органолептическим характеристикам (цвет, аромат и вкус) и происхождение в Испании (Кастилия-Ла-Манча).",
            caracteristicas:
              "Шафран в рыльцах, никогда не молотый. Гибкие и прочные волокна",
            maridaje:
              "Идеально подходит в качестве красителя, ароматизатора и пряности для любой пищи. Максимального раскрытия вкуса шафран достигает при приготовлении блюд, используемых в качестве приправы: жареного мяса, рыбы, супов, моллюсков и блюд из риса.",
            peso: ["1г", "Коробка 12 шт."],
            premios: {
              premios: []
            }
          }
        },
        intro_ficha: {
          titulo: "Шафран из<br>Ла-Манчи",
          cuerpo:
            "<p><strong>Красное золото.</strong> Эта изысканная и нежная специя, почитаемая с древних времен античными цивилизациями, такими как египтяне или греки, теперь стала звездным ингредиентом международной кухни благодаря своему аромату, вкусу и цвету. Шафран также используется в качестве лекарственного средства благодаря своим многочисленным лечебным свойствам.</p><p>Шафран Альдонза производится в Кастилии Ла-Манча (Испания), стране, отмеченной знаком качества <strong>Original. Шафран из Ла-Манчи.</strong> Признанное качество во всем мире благодаря тройной гарантии: испанское происхождение, оптимальные органолептические характеристики и безопасность пищевого продукта.</p>"
        },
        banner_denominacion: {
          titulo: "D.O.P. ",
          subtitulo: "Шафран из Ла-Манчи",
          cuerpo: "Защищённое наименование места происхождения D.O.P. Ла-Манча"
        },
        banner_beneficios: {
          titulo: "Знаете ли вы о пользе и признанных свойствах шафрана?",
          boton: "Откройте для себя преимущества"
        },
        banner_experiencia: {
          titulo: "Хотите узнать больше?",
          boton: "Откройте для себя путешествие в Альдонзу",
          enlace: "vive_aldonza"
        },
        beneficios: {
          titulo: "Полезные качества<br>и доказанные свойства шафрана",
          list: [
            {
              titulo: "Пищеварение",
              cuerpo:
                "Благодаря своим ароматическим и горьким компонентам (пикрокроцину) он стимулирует работу пищеварительной системы и увеличивает слюноотделение и желудочную секрецию. Кроме того, шафран содержит кроцетин (красные пигменты) и разжижает кожу. Первый стимулирует выработку желчи, а жидкость помогает процессу пищеварения и предотвращает образование камней в желчном пузыре."
            },
            {
              titulo: "Менструальная боль",
              cuerpo:
                "Шафран играет очень важную роль в лечении предменструальных симптомов. Было показано, что шафран способствует менструальному циклу, предотвращает спазмы матки и способствует течению менструации."
            },
            {
              titulo: "Антиоксидант",
              cuerpo:
                "Кроцин, основной компонент шафрана, является мощным природным антиоксидантом. Это вещество задерживает старение клеток организма."
            },
            {
              titulo: "Память",
              cuerpo:
                "Шафран улучшает память и умственные способности. Его защитный эффект при дегенеративных заболеваниях, таких как болезнь Паркинсона и болезнь Альцгеймера, доказаны. Он также рекомендуется в качестве пищевой добавки тем, кто страдает от стресса."
            },
            {
              titulo: "Зрение",
              cuerpo:
                "Сафранал, ароматический компонент шафрана, замедляет дегенерацию фоторецепторных клеток в глазах, улучшает функцию сетчатки и зрительных сосудов."
            },
            {
              titulo: "Сердечно-сосудистые заболевания",
              cuerpo:
                "Шафран — это ароматная специя, очень богатая антиоксидантами. Она действует как профилактика сердечно-сосудистых заболеваний. Кроме того, кроцетин, красный пигмент шафрана, помогает снизить уровень холестерина."
            },
            {
              titulo: "Диабет",
              cuerpo:
                "Благодаря своей высокой антиоксидантной способности шафран является полезной добавкой для людей с диабетом. Экстракт шафрана защищает таких пациентов от диабетической невропатии, повреждения нервов из-за избытка сахара в крови."
            },
            {
              titulo: "Профилактика рака",
              cuerpo:
                "Шафран содержит бета-каротин и флавоноиды, которые помогают замедлить рост опухоли, увеличивая продолжительность жизни."
            },
            {
              titulo: "Антидепрессант",
              cuerpo:
                "Шафран в случаях легкой и умеренной депрессии может быть столь же эффективным, как и некоторые лекарства от депрессии."
            },
            {
              titulo: "Успокоительное",
              cuerpo:
                "Шафран содержит успокаивающие ароматические вещества, помогающие бороться с нервозностью и беспокойством."
            }
          ]
        }
      },
      cava: {
        slug: "cava",
        nombre: "Кава",
        intro_productos:
          "<span>После великих моментов<br>остаются незабываемые воспоминания </span>",
        intro_ficha: {
          titulo: "С особым шармом",
          cuerpo:
            "<p>Сусло получают из плодов винограда, которые после двух ферментаций превращаются в каву. Собственные и тщательно отобранные дрожжи, которые придают нашим четырем сортам игристых вин свою индивидуальность. </p><p>Кава с D.O.P.  Игристые вина, выращенные в регионе Пенедес и изготовленные в центре Сант-Сандурни-д'Анойя в Барселоне из сортов винограда Шарелло, Макабео и Парельяда. Отдельного упоминания заслуживает наша розовая кава, приготовленная только из красных сортов винограда сорта Трепат.</p>"
        },
        productos: {
          reserva: {
            id: "reserva",
            nombre: "Reserva",
            tipo_uva:
              "Шардоне, Шарелло, Макабео с виноградников, принадлежащих D.O.P. Кава",
            tipo_cava: "Brut reserva especial",
            elaboracion:
              "После сбора урожая сусло получают с помощью пневматического пресса или динамического слива. Обязательное брожение при температуре 15ºC и последующая ферментация. Вторая ферментация и минимальная выдержка 24 месяца в винных подвалах.",
            graduacion: "11,5 - 12,5% об.",
            cantidad: "750мл",
            servicio: "От 6º до 8º С.",
            gastronomia:
              "Яркая особенность этой кавы подчеркнет любое блюдо интернациональной кухни: мясо, тушеную рыбу, сыры, фуа-гра и копчености, а также она превосходна в качестве аперитива.",
            notas_cata: {
              texto:
                "Соломенно-желтый цвет и хорошее образование пузырьков, которые заканчиваются так бусами. Он выделяется ароматом выдержки, спелыми фруктами и цветами. Вкус мягкий, гармоничный, сухой и с длительной устойчивостью.",
              autor: ""
            },
            premios: [
              "brut-decanter-plata-2019",
              "brut-decanter-2022",
              "brut-decanter-2022-2"
            ]
          },
          nature: {
            id: "nature",
            nombre: "Brut Nature",
            tipo_uva: "Шарелло, Макабео, Парельяда",
            tipo_cava: "Brut Nature",
            elaboracion:
              "После сбора винограда его разделяют по сортам и качеству. Затем сусло получают с помощью пневматического пресса или динамического слива. Обязательное брожение при температуре ниже 19ºC и контроль за этим. Покой и выдержка в погребе от 12 до 14 месяцев.",
            graduacion: "11,5 - 12,5% об.",
            cantidad: "750мл",
            servicio: "От 6º до 8º С.",
            gastronomia:
              "Сочетается с закусками, орехами, моллюсками, красным и белым мясом.",
            notas_cata: {
              texto:
                "Бледно-желтого цвета с легкими золотистыми отблесками и отделением пузырьков, которые поднимаются бусами, образуя корону. Отличаются цветочные и медовые ароматы, характерные для бутылочной выдержки. Во рту сухой, приятный и мягкий привкус; с очень хорошей ароматической стойкостью.",
              autor: ""
            },
            premios: ""
          },
          rose: {
            id: "rose",
            nombre: "Brut - Rosé",
            tipo_uva: "Трепат",
            tipo_cava: "Brut - rosé",
            elaboracion:
              "После сбора урожая виноград скатывается и выдерживается в бочках с легкой мацерацией до тех пор, пока он не достигнет оптимального цвета и остальных характеристик. Обязательное брожение при температуре ниже 19ºC. Выдержка в погребе (минимум 9 месяцев).",
            graduacion: "11 - 12% об.",
            cantidad: "750мл",
            servicio: "От 6º до 8º С.",
            gastronomia:
              "Идеально сочетается с салатами, пастой, жирной рыбой и морепродуктами.",
            notas_cata: {
              texto:
                "Интенсивный, живой и блестящий розовый цвет. Стойкое и хорошее отделение мелких пузырьков, которые поднимаются бусами, образуя корону. Первое впечатление приятное, можно различить ароматы, напоминающие лесные ягоды. Впоследствии окончательное впечатление оставляет сбалансированный, приятный и очень фруктовый вкус.",
              autor: ""
            },
            premios: ""
          },
          brut: {
            id: "brut",
            nombre: "Brut",
            tipo_uva: "Xarel-lo, Macabeo, Parellada",
            tipo_cava: "Brut",
            elaboracion:
              "После сбора винограда его делят по сортам и качеству. Затем сусло получают с помощью пневматического пресса или динамического слива. Обязательное брожение при температуре ниже 19ºC и контроль за этим. Выдержка в погребе от 12 до 14 месяцев.",
            graduacion: "11 - 12% об.",
            cantidad: "750мл",
            servicio: "От 6º до 8º С.",
            gastronomia: "Идеально сочетается с ветчиной, белым мясом и рисом.",
            notas_cata: {
              texto:
                "Очень бледно-желтого цвета с легкими золотистыми отблесками и хорошим отделением мелких пузырьков, которые в итоге образуют крону. Элегантный аромат с фруктовыми нотками, который дает бутылочная выдержка. Во рту он создает приятный аромат со сладкими нотками и нижними оттенками яблока. Хорошая кислотность и устойчивость вкуса.",
              autor: ""
            },
            premios: ""
          }
        },
        premios: {
          titulo: "Награды и знаки отличия",
          premios: {
            "brut-decanter-plata-2019": {
              titulo: "Кава Brut Reserva",
              posicion: "Вторая премия",
              texto:
                "Винтаж 2018 года, награжден Серебряной медалью на Decanter World Wine Awards, в 2019 году, Лондон (Великобритания).",
              categoria: "Международные",
              pais: "uk",
              anyada: "2018",
              anyo: "2019"
            },
            "brut-decanter-2022": {
              titulo: "Кава Brut Reserva",
              posicion: "92 балла",
              texto:
                "Винтаж 2021 года, удостоенный Серебряной медали на Decanter World Wine Awards, в 2022 году, Лондон (Великобритания).",
              categoria: "Международные",
              pais: "uk",
              anyada: "2021",
              anyo: "2022"
            },
            "brut-decanter-2022-2": {
              titulo: "Кава Brut Reserva",
              posicion: "",
              texto:
                "Винтаж 2021 года, серебряная медаль на конкурсе Concours Mondial de Bruxelles в Анадии (Португалия).",
              categoria: "Международные",
              pais: "portugal",
              anyada: "2021",
              anyo: "2022"
            }
          }
        },
        banner_premios: {
          titulo: "Кава, удостоенная премии",
          boton: "Посмотреть все награды",
          premio: "brut-decanter-2022-2"
        },
        banner_beneficios: {
          titulo: "Знаете ли вы о преимуществах и полезных свойствах кавы?",
          boton: "Откройте для себя ее пользу"
        },
        banner_experiencia: {
          titulo: "Хотите узнать больше?",
          boton: "Откройте для себя путешествие в Альдонзу",
          enlace: "vive_aldonza"
        },
        beneficios: {
          titulo: "Преимущества<br>и полезные свойства кавы",
          list: [
            {
              titulo: "Поставляет питательные вещества",
              cuerpo:
                "Кава, как мы упоминали в начале, относится к обезжиренным напиткам, обладающим к тому же питательными свойствами. В этом напитке содержится железо, белок, кальций, калий, йод, следы цинка, углеводы, магний, натрий, витамины B1, B2, B9, витамины B3 и B6, фосфор и сахара."
            },
            {
              titulo: "Омолаживающий эффект",
              cuerpo:
                "Кава считается источником молодости, так как содержит антиоксиданты, стимулирующие обновление клеток и повышающие уровень витамина Е. Эти свойства омолаживают кожу, особенно женскую."
            },
            {
              titulo: "Полезно для сердца",
              cuerpo:
                "Благодаря высокому содержанию полифенолов снижает кровяное давление и предотвращает риск сердечно-сосудистых заболеваний или сердечных приступов."
            },
            {
              titulo: "Бодрит",
              cuerpo:
                "Некоторые компоненты этого напитка поднимают настроение. Этот продукт содержит натуральные микроэлементы, улучшающие наше настроение."
            },
            {
              titulo: "Улучшение памяти",
              cuerpo:
                "Умеренное потребление кавы, один стакан в день, способно улучшить память и отсрочить некоторые дегенеративные заболевания головного мозга, например старческое слабоумие. Научные исследования определяют, что ключом к этому свойству является фенольная кислота."
            },
            {
              titulo: "Помогает следить за весом",
              cuerpo:
                "Кава – один из самых низкокалорийных алкогольных напитков. Стакан брюта содержит менее 12 граммов остаточного сахара на литр, то есть от 80 до 100 калорий, в то время как пиво или ромовая смесь, например, содержат более 150 калорий."
            },
            {
              titulo: "Защищает кожу",
              cuerpo:
                "Кава очищает кожу антиоксидантами и винной кислотой, помогая сбалансировать ее тон и предотвратить покраснение. Людям со склонностью к жирности кожи антибактериальные свойства этого напитка помогают сделать ее более свежей и здоровой."
            }
          ]
        }
      },
      queso: {
        slug: "queso",
        nombre: "Сыр",
        intro_productos:
          "<span>Сделай приятную паузу в своей ежедневной рутине!</span>",
        productos: {
          enaceite: {
            id: "enaceite",
            nombre: "В масле",
            descripcion:
              "Сыр в оливковом масле из 100% пастеризованного молока овец манчега. ",
            curacion: "Не менее 150-210 дней.",
            apariencia:
              "Консистенция: твердая и плотная. Цвет: оттенок от белого до цвета слоновой кости - желтоватого. Запах: молочнокислый, интенсивный и стойкий, кисловатый, переходящий в пряные оттенки. Вкус: слабокислый, крепкий и устойчивый.",
            ingredientes:
              "Пастеризованное молоко овец манчега, сычужный фермент, молочные ферменты, лизоцим (полученный из яиц), хлорид кальция, соль и оливковое масло. Происхождение молока: Испания.",
            valoresnutricionales:
              "Энергетическая ценность: 410 ккал / 1715 кДж Жиры: 36 г Насыщенные жиры: 18,70 г Углеводы: 0,50 г Сахара: 0 г Белки: 24 г Соль: 1,60 г",
            conservacion: "От 2 до 7ºC.",
            alergenos: "Лактоза и лизосома (полученные из яйца)",
            durabilidad:
              "1 год с момента изготовления. Указан на каждой упаковке",
            gastronomia:
              "Идеально сочетается с красными винами (Aldonza Selección и Aldonza Navamarín) и кавой (Aldonza Brut Reserva).",
            notas_cata: {
              texto:
                "Характерный сильный вкус овечьего сыра, усиленный интенсивным ароматом оливкового масла, с довольно пряным послевкусием."
            },
            premios: {
              premios: []
            }
          },

          semicurado: {
            id: "semicurado",
            nombre: "Полутвердый",
            descripcion:
              "Полутвердый сыр из 100% пастеризованного молока овец Ла-Манчи.",
            curacion: "От 60 до 100 дней.",
            apariencia:
              "Консистенция: твердая и плотная. Цвет: оттенки от белого до цвета слоновой кости - желтоватого. Запах: молочный, интенсивный и стойкий кисловатый. Вкус: слабокислый, крепкий и устойчивый.",
            ingredientes:
              "Пастеризованное молоко овец манчега, сычужный фермент, молочные ферменты, лизоцим (полученный из яиц), хлорид кальция и соль. Происхождение молока: Испания",
            valoresnutricionales:
              "Энергетическая ценность: 410 ккал / 1715 кДж Жиры: 30 г Насыщенные жиры: 18,90 г Углеводы: 0,50 г Сахара: <0,50 г Белки: 26 г Соль: 1,60 г",
            conservacion: "От 2 до 7ºC.",
            alergenos: "Лактоза и лизосома (полученные из яйца)",
            durabilidad:
              "1 год с момента изготовления. Указано на каждой упаковке",
            gastronomia:
              "Идеально сочетается с белыми винами (Aldonza Albo), молодыми красными винами (Aldonza Clásico) и розовыми винами (Aldonza Brut - Rosé).",
            notas_cata: {
              texto:
                "Нежный вкус. Довольно кремовая текстура. Очень своеобразное послевкусие благодаря овечьему молоку. Сбалансированный молочный вкус с кислинкой в ​​конце."
            },
            premios: {
              premios: []
            }
          },

          curado: {
            id: "curado",
            nombre: "Твердый",
            descripcion:
              "Твердый сыр из 100% пастеризованного молока овец Ла-Манчи.",
            curacion: "От 150 до 210 дней.",
            apariencia:
              "Консистенция: твердая и плотная. Цвет: оттенки от белого до цвета слоновой кости - желтоватого. Запах: молочнокислый, интенсивный и стойкий, кисловатый, переходящий в пряные оттенки. Вкус: слабокислый, крепкий и устойчивый.",
            ingredientes:
              "Пастеризованное молоко овец манчега, сычужный фермент, молочные ферменты, лизоцим (полученный из яиц), хлорид кальция и соль. Происхождение молока: Испания.",
            valoresnutricionales:
              "Энергетическая ценность: 410 ккал / 1715 кДж Жиры: 36 г Насыщенные жиры: 18,70 г Углеводы: 0,50 г Сахара: 0 г Белки: 24 г Соль: 1,60 г",
            conservacion: "От 2 до 7ºC.",
            alergenos: "Лактоза и лизосома (полученные из яйца)",
            durabilidad:
              "1 год с момента изготовления. Указано на каждой упаковке",
            gastronomia:
              "Идеально сочетается с красными винами (Aldonza Selección и Aldonza Navamarín) и кавой (Aldonza Brut Nature).",
            notas_cata: {
              texto:
                "Сыр с сильным характером, с устойчивым, проникающим, интенсивным вкусом, который в конце превращается в слегка пряные оттенки."
            },
            premios: {
              premios: []
            }
          }
        },
        intro_ficha: {
          titulo: "100% манчего",
          cuerpo:
            "<p>Каждый сыр подвергается ручной обработке нашими сыроделами-ремесленниками. Наслаждение, которое можно оценить по вкусу, аромату и в текстуре каждого кусочка. Получайте удовольствие от любого из наших трех сортов сыра: твердого, полутвердого и в оливковом масле. Еще одно впечатление, перед которым невозможно устоять.<br><a target='_blank' href='/static/pdf/certificado-SAE.pdf'><u>Сертификат <strong>SAE 2021-0014</strong></u></a></p>"
        },
        banner_beneficios: {
          titulo: "Знаете ли вы о пользе и проверенных качествах сыра?",
          boton: "Откройте для себя преимущества"
        },
        banner_experiencia: {
          titulo: "Хотите узнать больше?",
          boton: "Откройте для себя впечатления с Альдонзой",
          enlace: "vive_aldonza"
        },
        beneficios: {
          titulo: "Преимущества<br>и полезные качества сыра",
          list: [
            {
              titulo: "Источник кальция",
              cuerpo:
                "Сыр является одним из основных источников кальция, минерала, который регулирует основные процессы в нашем организме, такие как транспорт кислорода красными кровяными тельцами или свертывание крови."
            },
            {
              titulo: "Здоровье ротовой полости",
              cuerpo:
                "Помимо укрепления наших зубов, он уменьшает бактериальный налет, стимулирует выработку слюны и естественным образом очищает рот."
            },
            {
              titulo: "Защищает кожу",
              cuerpo:
                "Он имеет высокое содержание витамина В, что благоприятного для внешнего вида нашей кожи."
            },
            {
              titulo: "Улучшает зрение",
              cuerpo:
                "Содержит витамины А и D, которые помогают улучшить зрение и иммунную систему."
            },
            {
              titulo: "Рекомендуется при беременности",
              cuerpo:
                "Он содержит фолиевую кислоту, поэтому его настоятельно рекомендуется принимать во время беременности и вскармливания, так как он также способствует выработке грудного молока."
            },
            {
              titulo: "Предотвращает болезни",
              cuerpo:
                "Сыр богат конъюгированной линолевой кислотой (CLA) и сфинголипидами, двумя компонентами жирного молока, которые помогают снизить риск развития рака и сердечных заболеваний."
            },
            {
              titulo: "Восстанавливает массу тела",
              cuerpo:
                "Он очень богат белком и способствует восстановлению массы тела. Это пища, которая очень помогает спортсменам и снижает риск ожирения."
            }
          ]
        }
      }
    },
    banners_experiencia: {
      vive_aldonza: {
        id: "vive-aldonza",
        titulo: "Живая Альдонза",
        titulo_intro_experiencia:
          '"Вы будете помнить не столько дни свой жизни, сколько впечатления, которыми вы проживаете каждое мгновение"',
        titulo_vivir_experiencia:
          "Что вам понадобится, чтобы осуществить свое путешествие в Альдонзу?",
        tip_maleta:
          "Не забудьте положить <strong>в чемодан</strong> все, что вы хотите иметь с собой во время этого увлекательного приключения. Вы должны быть готовы!",
        tip_camara:
          "<strong>фотокамера! </strong>Необходимо увековечить каждый из неповторимых моментов, которые вы получите в Альдонзе",
        tip_corazon:
          "<strong>Ваше настроение,</strong>, основной ингредиент для того, чтобы каждое впечатление стало незабываемым. Путь зависит только от вас!",
        elige: "Выберите свое впечатление с Альдонза"
      },
      enoturismo: {
        id: "enoturismo",
        titulo: "Винный туризм",
        cuerpo:
          "Держите камеру наготове, когда будете спускаться в подвал-пещеру, где хранятся наши бочки. Сенсорный энотуризм, включает дегустацию всех продуктов Альдонза. Бесплатное посещение с Посещения с понедельника по воскресенье.",
        boton: "Живые впечатления",
        titulo_intro_experiencia: "Познакомьтесь и посетите нашу винодельню",
        la_visita_text: "Посещение",
        reserva: "купить билеты",
        tips_bodega: [
          {
            titulo: "Расположение",
            cuerpo:
              "Винный туризм в самом сердце земли Дон Кихота. Наша винодельня расположена в муниципалитете Мунера,  который находится на северо-западе провинции Альбасете."
          }
        ],
        la_visita: [
          {
            cuerpo:
              "Полный тур по нашим объектам: винодельне, мельнице и шафрановому залу. Вы узнаете, как делают вино, оливковое масло первого холодного отжима и шафран."
          },
          {
            cuerpo:
              "Дегустация наших вин: Navamarín, Selection, Classic (красные вина), Albo (белые вина) и кавы. Включает дегустацию оливкового масла первого холодного отжима. Изысканные впечатления!"
          },
          {
            cuerpo:
              "Ориентировочная продолжительность 60 минут. Доступно для людей с ограниченными возможностями."
          },
          {
            cuerpo:
              "Приходите к нам в любой день недели (с понедельника по воскресенье)."
          },
          {
            cuerpo: "Забронируйте свои впечатления винного туризма с Альдонзой!"
          }
        ],
        video: {
          titulo: "видео/ролик",
          cuerpo:
            "Вам останется только выбрать компанию. <strong>Семья, ваша вторая половинка или друзья?</strong> Энотуризм и олеотуризм идут рука об руку. Начинаем!"
        }
      },

      degustacionQuesos: {
        id: "degustacionQuesos",
        titulo: "Сырный ритуал",
        cuerpo:
          "Включите все чувства, чтобы насладиться кусочком сыра. Ритуал дегустации сыра начинается!",
        boton: "Живые впечатления",
        titulo_intro_experiencia: "Ритуал",
        productos: {
          vista: {
            id: "vista",
            nombre: "Зрение",
            descripcion:
              "Именно это чувство оценивает внешний вид и состояние сыра. Мы должны осмотреть как внешнюю корочку, так и поверхность среза. В зависимости от сорта кожура будет гладкой и восковой, покрытой плесенью, промытой или обработанной, например, оливковым маслом первого холодного отжима. Цвет — это еще один визуальный аспект, который мы должны учитывать. Сыры манчего, приготовленные из овечьего молока, обычно имеют оттенок слоновой кости. С помощью зрения мы также можем оценить текстуру. Например, сыр будет более или менее растрескиваться в зависимости от времени созревания. "
          },
          tacto: {
            id: "tacto",
            nombre: "Тактильные ощущения",
            descripcion:
              "Тактильный осмотр позволяет почувствовать хлопьевидную, мучнистую и несколько ломкую текстуру, типичную для выдержанных сыров Манчего."
          },
          olfato: {
            id: "olfato",
            nombre: "Обоняние",
            descripcion:
              "Наш нос воспринимает запахи и ощущения, которые дегустаторы и сыроделы объединяют в семейства. Различают молочные, овощные, фруктовые, пряные и др. ощущения."
          },
          gusto: {
            id: "gusto",
            nombre: "Вкус",
            descripcion:
              "Пришло время оценить вкус и текстуру каждого сыра! Для дегустации во рту идеальным является жевание в течение нескольких секунд без дыхания, а затем постепенное высвобождение воздуха через рот. Это помогает определить интенсивность и вкус сыра; сладкий, соленый, кислый, горький, пряный и даже другие нюансы, которые могут иметь совершенно субъективное значение."
          },
          regusto: {
            id: "regusto",
            nombre: "Послевкусие",
            descripcion:
              "В конце дегустации остается послевкусие, также известное как остаточный вкус. В этот момент остается другое обонятельно-вкусовое ощущение, чем при первой дегустации сыра, так что ароматы и вкусы могут быть совершенно новыми и уникальными."
          }
        },
        maridaje: {
          id: "maridaje",
          titulo_catas: "Винное сочетание",
          cuerpo_catas:
            "<p>Кислотность вина облегчает нам прохождение сыров, кроме того, вина очищают рот и усиливают вкус сыра.</p>"
        }
      },

      oleoturismo: {
        id: "oleoturismo",
        titulo: "Олеотуризм",
        cuerpo:
          "Позвольте себе соблазниться ароматом хорошего оливкового масла Экстра Вирджин. Посетите нашу мельницу, изучите процесс производства оливкового масла первого холодного отжима и насладитесь свойствами самого традиционного продукта средиземноморской диеты.",
        boton: "Живые впечатления",
        titulo_intro_experiencia: "Познакомьтесь и посетите нашу маслобойню",
        titulo_catas: "Наши дегустации масел",
        cuerpo_catas:
          "<p>Дегустация оливкового масла проводится в непрозрачных стаканах. Причина в том, что цвет этого продукта не определяет его качество. Вы знали? Запишитесь на день олеотуризма в Альдонзе, чтобы узнать больше об этом продукте.</p><p>В уникальной обстановке, в самом сердце родины Дон Кихота, вы узнаете, как производится оливковое масло первого холодного отжима, как работает маслобойня, какие бывают основные сорта оливок и как провести профессиональную дегустацию оливкового масла. Больше не будем открывать секреты, узнайте сами!</p>"
      },
      recetario: {
        id: "recetario",
        titulo: "Книга рецептов и<br>Гастрономический маршрут",
        cuerpo:
          "<p>Лучший способ насладиться нашими продуктами – это приготовить их вместе с ними. Традиционный или инновационный, выберите рецепт, который вам больше всего нравится, из нашей книги рецептов.</p><p>Лучшее из испанской кухни с продуктами Альдонза. Берите чемодан и отправляйтесь в гастрономический тур «Tasting Spain» (Вкусы Испании).</p>",
        boton: "Живые впечатления",
        titulo_intro_experiencia:
          '"Человек становится поваром, когда ему есть что сказать через свои блюда."',
        cuerpo_recetario:
          "<p>У Альдонза есть собственная книга рецептов полезных блюд, приготовленных из ее продуктов: оливкового масла первого холодного отжима, шафрана и вина. Традиционные или инновационные, все наши рецепты доступны в аудиовизуальном формате. Что бы вы хотели приготовить сегодня?</p><p>Команда Альдонзы и шеф-повара кулинарного центра HEB посещают главные рестораны и гастрономические центры Испании, чтобы подготовить новую книгу рецептов, которая объединит испанскую и техасскую кухню. Оживите с нашими видео гастрономический маршрут «Tasting Spain».</p>",
        boton_recetario: "Загляните в нашу книгу рецептов!",
        boton_tasting: "Откройте для себя вкусы Испании!",
        recetario: "Книга рецептов",
        tasting_spain: "Tasting Spain - Вкусы Испании",
        youtube: {
          titulo:
            "Хотите видеть больше рецептов или не пропустить ни один из наших туров?",
          newsletter: "Подпишитесь на наш Youtube-канал",
          boton: "Перейти на канал Youtube"
        }
      },
      ruta_cervantina: {
        id: "ruta-cervantina",
        titulo: "Маршрут Сервантеса",
        cuerpo:
          "Территория, полная истории и легенд, считается излюбленным маршрутом Сервантеса. Есть много очаровательных уголков, которые окружают Деэса-де-Навамарин. Берите чемодан и отдайтесь соблазну земли Дон Кихота Ламанчского.",
        boton: "Живые впечатления",
        cerrar: "Закрыть",
        leer_mas: "Читать далее",
        tradicion: {
          titulo: "Литературная традиция",
          cuerpo:
            "Мигель де Сервантес был вдохновлен территориями Деэса-де-Навамарин, чтобы написать две главы своего самого международного произведения «Дон Кихот Ламанчский». Истории, рассказанные в «Свадьбе Камачо» и «Пещере Монтесинос», происходят на наших землях."
        },
        literatura: {
          cuerpo:
            "Влияние этого произведения, рассказывающее о работах на наших виноградниках, оливковых рощах и шафрановых полях, дало имя нашему бренду. Альдонса Лоренцо, Дульсинея Тобосская в книге, была девушкой, которую любил Дон Кихот. В настоящее время вы можете посетить наследие этого литературного произведения в муниципалитете Мунера."
        },
        naturaleza: {
          titulo: "Природа",
          cuerpo:
            "В середине маршрута Сервантеса, примерно в 40 км от Деэса-де-Навамарин и посреди обширной Кампо-де-Монтьель, мы обнаружим оазис воды и растительности: природный парк Лагунас-де-Руйдера, в самой высокой точке которого находится голова Сан-Педро – это замок Рошафрида и пещера Монтесинос.",
          more_cuerpo:
            "На площади 4000 гектаров находится шестнадцать лагун, которые постепенно образуют водопады и потоки. Они идут от первых источников, вытекающих из залива Бланка, до нижних лагун и водохранилища Пеньярройя. Весной буйный цвет обильной и разнообразной растительности приветствует бесчисленное количество водоплавающих птиц. Вода в это время достигает максимального уровня и перетекает из одной лагуны в другую, образуя в некоторых случаях небольшие водопады.",
          more_uno:
            "Тот, кто посещает винодельни Деэса-де-Навамарин и Альдонза, увидит страну с описанными в литературе традициями. Некоторые из них  <strong>Свадьба Камачо</strong>, описанные в главах XIX, XX, XXI произведения «Дон Кихот» Сервантеса, проходили в Мунере. Есть несколько научных исследований и совпадений, которые показывают, что главные герои, Камачо эль Рико, Базилио эль Побре и Ла Белла Китерия, были выходцами из этого города. Гостиница, где произошел этот эпизод, до сих пор сохранилась в муниципалитете, сегодня она превратилась в красивый отель, где можно попробовать продукцию Альдонза.",
          more_dos:
            "В честь одного из главных героев этого знаменитого эпизода в 1975 году была построена мельница Белла Куитерия. Сегодня в ней находится музей мебели и предметов быта, типичных для Ла-Манчи. Сельский туризм расположен в районах приближенных к маршруту Сервантеса.",
          more_tres:
            "Кроме того, в Мунере есть Фотоэтнологический музей. Это старая ветряная мельница, построенная в 1861 году и подаренная городскому совету для реконструкции и превращения ее в музей. Невероятное впечатление от прогулки среди классических ветряных мельниц Ла-Манчи."
        },
        historia: {
          titulo: "История",
          cuerpo:
            "Маршрут Сервантеса не проходит мимо исторических мест, расположенных в горах Сьерра-де-Алькарас и Кампос-де-Монтьель. Археологические раскопки Либисосы и <strong>Этнографический музей Тириеса</strong>, расположенный в муниципалитете Лезуза, также являются частью истории наших плантаций и культуры Ла-Манчи.",
          more_uno:
            "Археологическая резервация Либисоза скрывает более 2800 лет истории на десяти гектарах земли. Эти раскопки, расположенные в районе Лезуса, известном как Серро-дель-Кастильо, стали одним из самых важных анклавов в Кастилии-Ла-Манча. Они расположены между бассейнами рек Гвадиана и Хукар, землями с обильными водными, охотничьими и лесными ресурсами. В этой области животноводство всегда играло важную роль, наряду с выращиванием зерновых и большими плантациями виноградников. Этот участок, имевший в то время большое геостратегическое значение для торговли, представляет собой территорию с богатой историей и сельскохозяйственной культурой.",
          more_dos:
            "Этнографический музей Тириеса расположен в этом районе, расположенном в муниципалитете Лезуса, в провинции Альбасете. Это экомузей, в котором воссозданы исторические здания и культурная среда региона, где расположена территория Альдонзы. Этнографический музей, гда воспроизведены различные аспекты повседневной жизни жителей региона Кампо-де-Монтьель. Вы сможете увидеть инструменты для пчеловодства, сельского хозяйства, предметы домашнего обихода, автомобили и т.д. С другой стороны, в разделе под названием «Жизнь в деревне» представлены типичные ремесла прошлых лет, такие как кузница, магазин, пекарня, школа, сыроварня или деревенская церковь. Он также демонстрирует другие виды ремесел таких ​​​​как ткачество, и имеет зал видов обработки шафрана и копии мельниц с реки Лезуза."
        },
        legado: {
          titulo: "Каталонское наследие Дон Кихота",
          cuerpo:
            "Марка Альдонза расширила свой ассортимент, включив в него каву. И она сделала это, потому что между Дон Кихотом Ламанчским и Каталонией существует тесная связь. Восемь глав его приключений происходят на каталонской территории, наиболее значимыми из которых являются «Приход в Каталонию и встреча бандитов», «Видение моря и порта» и «Каталонская столица».",
          boton: "Узнать больше!"
        }
      }
    },
    escucha: {
      intro: "Лучшие впечатления в жизни не планируются, они случаются",
      cuerpo_intro: "Что нужно, чтобы почувствовать и услышать Альдонзу?",
      tip_volumen:
        "Тяга к наслаждению и открытию новых горизонтов через музыку. Включите звук и поставьте громкость на свое усмотрение!",
      tip_cascos:
        "Выберете сами, как хотите получить впечатления: в одиночку или в компании друзей. Оба варианта подходят для того, чтобы погрузиться в мир музыки, который предлагает вам Альдонза.",
      tip_dados:
        "Знаете ли вы, что звук — это важный ингредиент, улучшающий гастрономические впечатления? Позвольте себе насладиться плейлистом Альдонзы и усилить каждый вкус.",
      boton_escuchar: "Слушать",
      spotify: {
        titulo: "Альдонза на Spotify",
        cuerpo:
          "Готовы? Вы в одном клике от погружения во впечатления, которые сделают этот момент уникальным. Различные атмосферы и настроения, подобранные специально для вас.",
        boton: "Плейлист"
      },
      comparte: {
        titulo: "Поделитесь своими впечатлениями о посещении Альдонзы",
        cuerpo:
          "Мы хотим, чтобы вы получили наслаждение от каждого #ВпечатленияАльдонзы. Но, больше всего мы хотим, чтобы вы разделили их с нами!<br>Ждем вас в наших социальных сетях."
      }
    },
    otras_experiencias: {
      titulo: "Другие впечатления",
      lugares: {
        enoturismo: "Винный туризм",
        oleoturismo: "Олеотуризм",
        degustacionQuesos: "Сырный ритуал",
        ruta_cervantina: "Маршрут Сервантеса",
        recetario: "Книга рецептов"
      }
    },
    formulario: {
      vive_experiencia: "Живые впечатления",
      solicita_visita: "",
      bodega: "Забронируйте посещение нашей винодельни",
      almazara: "Запросить ваш визит",
      queseria: "Запросить ваш визит",
      nombre: "Имя",
      nombre_apellidos: "Имя и фамилия",
      apellidos: "Фамилии",
      email: "Эл. почта",
      mensaje: "Сообщение",
      introduce_mensaje: "Введите сообщение",
      fecha_nacimiento: "Дата рождения",
      dia: "День",
      mes: "Месяц",
      anyo: "Год",
      area_interes: "Область ваших интересов",
      trabaja_actualmente: "Вы работаете в настоящее время?",
      si: "Да",
      no: "Нет",
      carta_presentacion: "Презентационное письмо",
      meses: {
        Enero: "Январь",
        Febrero: "Февраль",
        Marzo: "Март",
        Abril: "Апрель",
        Mayo: "Май",
        Junio: "Июнь",
        Julio: "Июль",
        Agosto: "Август",
        Septiembre: "Сентябрь",
        Octubre: "Октябрь",
        Noviembre: "Ноябрь",
        Diciembre: "Декабрь"
      },
      archivo_adjunto: "Прикрепить файл",
      adjuntar_cv: "Прикрепить резюме",
      introduce_mail: "Введите адрес электронной почты",
      pais: "Страна",
      telefono: "Телефон",
      he_leido:
        "Я даю согласие на использование моих данных для целей, указанных в",
      y_acepto: "Политика конфиденциальности",
      texto_newsletter: "Я хочу подписаться на рассылку новостей",
      enviar: "Отправить",
      enviado: "Отправлено",
      recibido:
        "Ваше сообщение получено. Мы свяжемся с вами в самое ближайшее время.",
      concertar_visita:
        "Вы также можете договориться о посещении по телефону или электронной почте:",
      lunes_domingo: "С понедельника по воскресенье",
      horario: "С 8:00 до 14:00 и с 15:30 до 18:00.",
      enlace_popup:
        "Нажмите здесь, чтобы ознакомиться и принять политику конфиденциальности"
    },
    popupterminos: {
      titulo: "Основная информация о защите данных",
      titulo_dos: "Ответственный за лечение",
      titulo_tres: "АЛДОНЗА ГУРМЭ С.А.У.",
      cuerpo: [
        {
          titulo: "Адрес ответственного лица",
          cuerpo:
            "Ajusa Business Park Nº1 – Crta CM 332, Km 2.2, CP 02006, Albacete (España)"
        },
        {
          titulo: "Цель",
          cuerpo:
            "Ваши данные будут использоваться для удовлетворения ваших запросов и предоставления вам наших услуг."
        },
        {
          titulo: "Реклама",
          cuerpo:
            "Мы будем отправлять вам рекламные сообщения только с вашего предварительного разрешения, которое вы можете предоставить нам, поставив галочку в соответствующем пункте, установленном для этой цели."
        },
        {
          titulo: "Юридическое соглашение",
          cuerpo:
            "Мы будем обрабатывать ваши данные только с вашего предварительного согласия, которое вы можете предоставить нам, поставив галочку в соответствующем пункте, установленном для этой цели."
        },
        {
          titulo: "Получатели",
          cuerpo:
            "Как правило, только должным образом уполномоченный персонал нашей организации может располагать информацией, которую мы запрашиваем."
        },
        {
          titulo: "Права",
          cuerpo:
            "Вы имеете право знать, какая информация о вас у нас есть, исправлять и удалять ее, как описано в дополнительной информации, доступной на нашем веб-сайте."
        }
      ],
      titulo_mas: "Дополнительная информация",
      texto_mas: "Дополнительная информации в разделе",
      datos_seguros: "БЕЗОПАСНОСТЬ ВАШИХ ДАННЫХ",
      texto_nuestra: "на нашем сайте.",
      acepto: "Я даю согласие"
    },

    banner_contacto: {
      titulo: "Вам нужно больше информации?",
      cuerpo:
        "По любым вопросам, вы можете обратиться, заполнив следующую форму, и мы ответим в самое ближайшее время:",
      boton: "Посмотреть форму"
    },
    banner_localizaciones: {
      titulo: "Где мы находимся?",
      cuerpo:
        "Чтобы получить доступ к нашему местоположению, перейдите в любой из этих двух пунктов:",
      munera: "Crta. N-430  Km 462,3, 02612 Munera (Albacete)",
      lezuza: "<strong>Carretera CM-313</strong>, km 56, Lezuza (Albacete)."
    },
    banner_newsletter: {
      titulo: "Где мы находимся?",
      cuerpo: "Адрес: Crta. N-430  Km 462,3, 02612 Munera (Albacete)",
      email: "Эл. адрес:",
      telefono: "Контактный телефон:"
    },
    cookie_banner: {
      texto:
        "Файл cookie — это небольшой информационный файл, который сохраняется в вашем браузере каждый раз, когда вы посещаете наш веб-сайт. Целью файлов cookie является сохранение истории вашей активности в нашем веб-сайте, чтобы при повторном посещении он мог идентифицировать вас и настроить его содержимое на основе ваших привычек просмотра, личности и предпочтений. Их можно принимать, отклонять, блокировать и удалять по вашему желанию. Если вы отклоните их, мы не сможем гарантировать надлежащее функционирование нашего веб-сайта. Больше информации в разделе",
      politica: "Политика использования файлов cookie.",
      boton: "Я даю согласие"
    },
    intros_legales: {
      politica_cookies: "Политика использования файлов cookie",
      politica_privacidad: "Политика конфиденциальности",
      datos_seguros: "безопасные данные",
      aviso_legal: "Юридическое предупреждение",
      mapa_web: "Веб-карта"
    },
    volver: "Назад",
    volver_a: "Вернуться к",
    aviso_legal: {
      terminos: "УСЛОВИЯ И ПОЛОЖЕНИЯ",
      uno:
        "I.- Использование, консультирование и/или заключение договоров на услуги, представленные на нашей веб-странице www.aldonzagourmet.com, предполагают со стороны пользователей и/или клиентов полное и безоговорочное принятие Общих условий договора, которые регулируют правовые отношения, возникающие в результате договорных процессов, осуществляемых между пользователями и/или клиентами веб-сайта www.aldonzagourmet.com, принадлежащего <strong>Aldonza Gourmet S.A.U</strong> (далее Альдонза Гурмэ). Клиенты принимают Общие условия с момента использования или покупки любого продукта. Этот документ может быть распечатан для чтения и хранения Клиентами до его принятия.",
      dos:
        "II.- Настоящие Общие условия регулируются тем, что применимо к положениям Закона 7/1998 от 13 апреля «Об общих условиях контракта» и к Королевскому законодательному указу 1/2007 от 16 ноября, которым утверждается Сводный текст Общего закона о защите прав потребителей и пользователей и другие законы, дополняющие Королевский указ 1906/1999 от 17 декабря 1999 г., регулирующий заключение договоров по телефону или электронным способом на общих условиях, Регламент (ЕС) 2016/679 Европейского парламента и Совет от 27 апреля 2016 г. о защите физических лиц в отношении обработки персональных данных и свободного обращения этих данных, которым отменяется Директива 95/46/CE (Общее положение о защите данных), Органический закон 3 /2018, от 5 декабря, Защита персональных данных и гарантия цифровых прав, Закон 7/1996, от 15 января, Постановление Розничная торговля и Закон 34/2002 от 11 июля об услугах информационного общества и электронной коммерции.",
      tres:
        "III.- Изменение Общих условий. Альдонза Гурмэ может изменить Общие условия, уведомив Клиентов заблаговременно, чтобы улучшить услуги и продукты, предлагаемые через Альдонза Гурмэ. При изменении Общих условий, размещенных на веб-сайте Альдонза Гурмэ, указанное обязательство по уведомлению считается выполненной. В любом случае, прежде чем пользоваться услугами или заключать контракты, необходимо ознакомиться с Общими условиями.",
      cuatro:
        "IV.- Интеллектуальная собственность. Все содержимое этого веб-сайта (включая исходный код, изображения, тексты, графику и т. д.) защищено действующими национальными и международными нормами интеллектуальной собственности, все права защищены. Воспроизведение любого контента в Интернете без явного согласия Альдонза Гурмэ и правообладателей строго запрещено.",
      cuatro_dos:
        "Приобретая продукт, Альдонза Гурмэ не предоставляет покупателю никаких прав на изменение, использование, воспроизведение, распространение или публичное сообщение о нем, Альдонза Гурмэ оставляет за собой все эти права. Передача вышеупомянутых прав требует предварительного письменного согласия Альдонза Гурмэ. Несанкционированное использование информации, содержащейся на этом веб-сайте, ее перепродажа, а также нарушение прав интеллектуальной или промышленной собственности влекут за собой установленную законом ответственность.",
      cinco:
        "V.- Использование услуг и обязательства. Альдонза Гурмэ не гарантирует постоянную доступность услуг, освобождаясь от любой ответственности за возможный ущерб, причиненный в связи с недоступностью услуги из-за форс-мажорных обстоятельств или ошибок в телематических сетях передачи данных, не зависящих от нее. Альдонза Гурмэ не несет ответственности за содержание ссылок на другие веб-страницы, которые ему не принадлежат и, следовательно, не могут быть под ее контролем.",
      seis:
        "VI.- Защита данных. В соответствии с положениями статьи 5 Органического закона 15/1999 от 13 декабря «О защите персональных данных» и Закона 34/2002 от 11 июля «Об услугах Общества информации и электронной коммерции» Aldonza Gourmet S.A.U. (далее Альдонза Гурмэ) информирует вас о том, что персональные данные, указанные в электронных регистрационных формах, содержащихся на этом сайте, а также данные, к которым Альдонза Гурмэ получает доступ в результате вашей навигации; консультация, запрос или заключение контракта, а также любая транзакция или операция, выполненная с этого веб-сайта, будут собраны в файл, который соответствует требованиям применимого действующего законодательства и за который отвечает: Aldonza Gourmet S.A.U., Parque Empresarial Ajusa. №1 -  Ctra. 332 Km 2.2. 02006 – Albacete - España (info@aldonzagourmet.com).",
      seis_uno:
        "Целью сбора и автоматизированной обработки Персональных данных, осуществляемых через формы и контакты по электронной почте на этом веб-сайте, является облегчение предоставления услуг, которые Ajusa предоставляет через эти страницы. А также предоставление вам информации о деятельности и новостях, которые могут вас заинтересовать.",
      seis_dos:
        "Отправка персональных данных с использованием электронных форм на этом веб-сайте или, при необходимости, отправка сообщений электронной почты с запросом информации или услуг подразумевает прямое согласие Пользователя на автоматизированную обработку включенных данных, а также на отправку электронных сообщений с информацией о нашей деятельности.",
      seis_tres:
        "Таким образом, Пользователь выражает свое прямое согласие на включение Персональных данных в Файл персональных данных и их автоматическую обработку компанией Альдонза Гурмэ для вышеупомянутых целей. Кроме того, он выражает согласие и разрешение, чтобы Альдонза Гурмэ могла передавать Персональные данные компаниям, которые предоставляют услуги Альдонза Гурмэ, таким как банки и страховые компании.",
      seis_cuatro:
        "Пользователь гарантирует, что персональные данные, предоставленные Альдонза Гурмэ, соответствуют действительности, и несет ответственность за уведомление Пользователя о любых изменениях в них.",
      seis_cinco:
        "Альдонза Гурмэ предоставляет пользователям адрес электронной почты info@aldonzagourmet.com и номер телефона 967 21 77 11, чтобы они могли отозвать данное согласие. Альдонза Гурмэ заявляет, что соблюдает действующие положения о защите данных, в частности Органический закон 15/1999 от 13 декабря о защите персональных данных и Королевский указ 1720/2007 от 21 декабря, который развивает вышеупомянутый органический закон, и предоставляет Клиентам средства связи, указанные в предыдущем абзаце, чтобы они могли осуществлять права доступа, исправления, отмены и возражения, гарантированные действующим законодательством.",
      seis_seis:
        "Альдонза Гурмэ обязуется обращаться с персональными данными абсолютно конфиденциально и использовать их исключительно в указанных целях.",
      siete:
        "VII.- Коммерческие электронные коммуникации. Альдонза Гурмэ предоставляет пользователям, которые предварительно запросили это, через формы подписки, разрешенные для этой цели, услугу для отправки новостей, мероприятий и информации. Пользователь может отказаться от подписки на эту услугу в любое время, когда сочтет это целесообразным, отправив электронное письмо на адрес info@aldonzagourmet.com.",
      ocho:
        "VIII. Главная Информация. В соответствии с Законом 34/2002 от 11 июля об услугах информационного общества и электронной коммерции Альдонза Гурмэ заявляет, что она приступила к выполнению обязанностей по предоставлению информации в сроки, установленные настоящим постановлением, путем разрешения как получателем услуги, так и компетентными органами имеющими постоянный, легкий, прямой и свободный доступ к следующей информации: Aldonza Gourmet S.A.U. Parque Empresarial Ajusa. №1 - Ctra. CM-332 Km 2.2. 02006 - Albacete (España). www.aldonzagourmet.com. Телефон: 967 21 77 11 Регистрационные данные в торговом реестре Альбасете, лист № 5031, страница 222, том 635, книга 399, раздел 8. C.IF. № А-02203859.",
      nueve:
        "IX. Информация об использовании файлов cookie. Этот веб-сайт использует файлы cookie, небольшие файлы данных, которые генерируются на компьютере Пользователя и позволяют нам получать следующую информацию: дату и время последнего посещения Пользователем нашего веб-сайта, содержимое, которое Пользователь выбрал при первом посещении нашего сайта и т.д. Для того, чтобы сделать глобальную статистику доступа. Пользователь соглашается на использование этих файлов cookie, которые ни в коем случае не позволяют их идентифицировать, с единственной целью облегчить им навигацию по различным страницам этого веб-сайта. В любом случае Пользователь может отклонить или предотвратить установку этих файлов cookie, изменив настройки своего браузера.",
      diez:
        "Х. Ответственность. Использование Интернета будет осуществляться под исключительную ответственность Пользователя. Указанная ответственность будет распространяться на использование Пользователем или любой третьей стороной любого пароля или аналогичного, назначенного для доступа к сети или любой из ее служб.",
      diez_uno:
        "Альдонза Гурмэ не берет на себя никакой ответственности, связанной с содержанием, связанным с Интернетом, если оно не имеет отношения к нему, а также не гарантирует отсутствие в нем вирусов или других элементов, которые могут вызвать изменения в компьютерной системе (техническое и программное обеспечение). ), в документах или файлах Пользователя, исключая любую ответственность за ущерб любого рода, причиненный Пользователю по этой причине. Альдонза Гурмэ отказывается от любой ответственности, связанной с неправильным использованием контента, отображаемого на этих страницах, и оставляет за собой право обновлять, удалять, устанавливать ограничения или ограничивать доступ в любое время, временно или постоянно.",
      once:
        "XI.- Недействительность и неправомерность пунктов. Если какой-либо пункт, включенный в настоящие Общие условия, будет объявлен полностью или частично недействительным или неправомерным, такая недействительность или неправомерность повлияет только на указанное положение или его часть, которая является недействительной или неправомерной, при этом во всем остальном действуют Общие условия.",
      doce:
        "XII.- Споры. Для любых разногласий или споров, которые возникают, будет применяться испанское законодательство, будучи компетентным для разрешения всех споров, вытекающих из него или связанных с ним, судебные органы и администрация Альбасете.",
      doce_uno:
        "Доступ к веб-страницам этого сайта подразумевает принятие всех условий, изложенных в этой правовой информации. Альдонза Гурмэ может без предварительного уведомления изменять структуру и дизайн Интернета, а также изменять или исключать услуги, содержание и условия доступа к использованию Интернета и адаптировать его к происходящим законодательным изменениям."
    },
    datos_seguros: {
      p1:
        "В Европе и Испании существуют правила защиты данных, предназначенные для защиты вашей личной информации, которые являются обязательными для нашей организации.",
      p2:
        "Поэтому для нас очень важно, чтобы вы полностью понимали, что мы собираемся делать с персональными данными, которые мы запрашиваем.",
      p3:
        "Таким образом, мы будем прозрачными и предоставим вам контроль над вашими данными, используя простой язык, который позволят вам понимать, что мы будем делать с вашими персональными данными.",
      p4:
        "Пожалуйста, если после прочтения этой информации у вас возникнут вопросы, не стесняйтесь задать их нам.",
      p5: "Большое спасибо за Вашу помощь",
      h21: "<strong>О нас</strong>",
      p6: "Название организации: <strong>АЛДОНЗА ГУРМЭ С.А.У.</strong>",
      p7: "Наш CIF/NIF: <strong>A02203859</strong>",
      p8:
        "Наша основная деятельность: <strong>Производство и продажа вина, оливкового масла первого холодного отжима, шафрана и кавы.</strong> ",
      p9:
        "Наш адрес: <strong>Ajusa Business Park, nº1 – Crta CM 332, Km 2.2 / CP:02006, Albacete (España)</strong>",
      p10: "Наш контактный телефон: <strong>967 21 77 11</strong>",
      p11:
        "Наш контактный адрес электронной почты: <strong>info@aldonzagourmet.com</strong>",
      p12: "Наш сайт: <strong>www.adonzagourmet.com</strong>",
      p13:
        "Для вашей конфиденциальности и безопасности мы сообщаем вам, что мы являемся юридическим лицом, зарегистрированным в следующем торговом реестре / списке государственного реестра № 5031, страница 222, том 635, книга 399, раздел 8 — CIF № A-02203859.",
      h22: "<strong>Для чего мы будем использовать ваши данные? </strong>",
      p14:
        "Как правило, ваши персональные данные будут использоваться для взаимодействия с вами и предоставления вам наших услуг.",
      p15:
        "Кроме того, они также могут использоваться для других действий, таких как отправка вам рекламы или продвижение нашей деятельности.",
      h23: "Зачем нам нужно использовать ваши данные?",
      p16:
        "Ваши личные данные необходимы для того, чтобы иметь возможность взаимодействовать с вами и предоставлять вам наши услуги. В этом смысле мы предоставим в ваше распоряжение список пунктов, отметив которые вы сможете четко и легко принимать решения об использовании вашей личной информации.",
      h24:
        "<strong>Кто будет знать информацию, которую мы запрашиваем?</strong>",
      p17:
        "Как правило, только должным образом уполномоченный персонал нашей организации может располагать информацией, которую мы запрашиваем.",
      p18:
        "Также те лица, которым необходим доступ к ней, могут знать вашу личную информацию, чтобы мы могли предоставлять вам наши услуги. ",
      p181:
        "Таким образом, например, наш банк узнает ваши данные, если оплата наших услуг производится картой или посредством банковского перевода.",
      p19:
        "Также те государственные или частные организации, которым мы обязаны предоставлять ваши личные данные в связи с соблюдением любого закона, будут знать вашу информацию. Например, Закон о налогах обязывает вас предоставлять налоговому органу определенную информацию об экономических операциях, превышающих определенную сумму.",
      p20:
        "В случае, если, помимо вышеупомянутых предположений, нам необходимо раскрыть вашу личную информацию другим лицам, мы предварительно запросим ваше разрешение с помощью четкого объяснения, которое позволит вам принять решение в отношении этого вопроса.",
      h25: "<strong>Как мы будем защищать ваши данные?</strong>",
      p21:
        "Мы защитим ваши данные с помощью эффективных мер безопасности, учитывая риски, связанные с использованием вашей информации.",
      p22:
        "Для этого наша организация утвердила Политику защиты данных, и проводятся ежегодные проверки и аудиты, чтобы убедиться, что ваши личные данные находятся в безопасности в любое время.",
      h26: "<strong>Отправляем ли мы ваши данные в другие страны?</strong>",
      p23:
        "В мире есть страны безопасные для ваших данных и другие не очень. Например, Европейский Союз — безопасная среда для ваших данных. Наша политика заключается в том, чтобы не отправлять вашу личную информацию в любую страну, которая не является безопасной с точки зрения защиты ваших данных.",
      p24:
        "В случае, если для предоставления вам услуги необходимо отправить ваши данные в страну, которая не так безопасна, как Испания, мы всегда заранее запрашиваем ваше разрешение и применяем эффективные меры безопасности, снижающие риски отправки вашей персональной информации в другую страну.",
      h27: "<strong>Как долго мы будем хранить ваши данные?</strong>",
      p25:
        "Мы будем хранить ваши данные во время наших отношений и до тех пор, пока это требуется по закону. По истечении установленных законом сроков мы приступим к их устранению безопасным и экологически чистым способом.",
      h28: "<strong>Каковы ваши права на защиту данных?</strong>",
      p26:
        "В любое время вы можете связаться с нами, чтобы узнать, какая информация о вас у нас содержится, исправить ее, если она неверна, и удалить ее после прекращения наших отношений, если закон это позволяет. ",
      p27:
        "Вы также имеете право запросить передачу вашей информации другому лицу. Это право называется «переносом» и может быть полезно в определенных ситуациях.",
      p28:
        "Чтобы запросить любое из этих прав, вы должны сделать письменный запрос на наш адрес вместе с ксерокопией вашего удостоверения личности, чтобы идентифицировать вас. ",
      p29:
        "В офисах нашей организации у нас есть специальные формы для запроса указанных прав, и мы предлагаем свою помощь в их заполнении.",
      p30:
        "Чтобы узнать больше о своих правах на защиту данных, посетите веб-сайт Испанского агентства по защите данных (www.agpd.es).",
      h29:
        "<strong>Можете ли вы отозвать свое согласие, если позже передумаете?</strong>",
      p31:
        "Вы можете отозвать свое согласие, если передумаете использовать свои данные в любое время. ",
      p32:
        "Так, например, если вы когда-то были заинтересованы в получении рекламы наших продуктов или услуг, но больше не хотите получать рекламу в дальнейшем, вы можете сообщить нам об этом через форму возражения против обработки, доступную в офисах нашей организации.",
      h210:
        "<strong>Если вы понимаете, что ваши права не соблюдаются, куда вы можете обратиться с претензией?</strong>",
      p33:
        "Если вы понимаете, что наша организация не соблюдает ваши права, вы можете подать иск в Испанское агентство по защите данных одним из следующих способов:",
      p333: "или через электронную систему:  www.agpd.es",
      p34: "или отправив его на почтовый адрес:",
      p35: "Испанское агентство по защите данных ",
      p36: "C/ Jorge Juan, 6",
      p37: "28001-Madrid ",
      p38: "или по телефону:",
      p39: "Телефон 901 100 099",
      p40: "Телефон 91 266 35 17",
      p41:
        "Составление претензии в Испанское агентство по защите данных не требует никаких затрат, а помощь юриста или адвоката не требуется. ",
      h211: "<strong>Будем ли мы создавать ваш профиль?</strong>",
      p42:
        "Наша политика заключается в том, чтобы не создавать профили пользователей наших услуг.",
      p43:
        "Однако могут возникнуть ситуации, когда для предоставления услуг, коммерческих или других целей нам необходимо создать профиль с информацией о вас.",
      p44:
        "Примером может быть использование вашей истории покупок или обслуживания, чтобы иметь возможность предлагать вам продукты или услуги, адаптированные к вашим вкусам или потребностям.",
      p45:
        "В таком случае мы будем применять эффективные меры безопасности, которые всегда защищают вашу информацию от неуполномоченных лиц, которые намереваются использовать ее в своих интересах. ",
      h212:
        "<strong>Будем ли мы использовать ваши данные для других целей?</strong>",
      p46:
        "Наша политика заключается в том, чтобы не использовать ваши данные в целях, отличных от тех, которые мы вам разъяснили. Однако, если нам необходимо использовать ваши данные для различных действий, мы всегда заранее запрашиваем ваше разрешение с помощью четких опций, которые позволят вам принять решение в этом отношении."
    },
    mejor_bodega_CM: "Chosen as the best winery in Castilla-La Mancha"
  }
};


// WEBPACK FOOTER //
// ./src/translations/index.js